(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './core-core-api.js', './kotlinx-serialization-kotlinx-serialization-json.js', './core-core-stl.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./core-core-api.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./core-core-stl.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'core-core-range-dynamic-range'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'core-core-range-dynamic-range'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'core-core-range-dynamic-range'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'core-core-range-dynamic-range'.");
    }
    if (typeof this['core-core-api'] === 'undefined') {
      throw new Error("Error loading module 'core-core-range-dynamic-range'. Its dependency 'core-core-api' was not found. Please, check whether 'core-core-api' is loaded prior to 'core-core-range-dynamic-range'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'core-core-range-dynamic-range'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'core-core-range-dynamic-range'.");
    }
    if (typeof this['core-core-stl'] === 'undefined') {
      throw new Error("Error loading module 'core-core-range-dynamic-range'. Its dependency 'core-core-stl' was not found. Please, check whether 'core-core-stl' is loaded prior to 'core-core-range-dynamic-range'.");
    }
    root['core-core-range-dynamic-range'] = factory(typeof this['core-core-range-dynamic-range'] === 'undefined' ? {} : this['core-core-range-dynamic-range'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['core-core-api'], this['kotlinx-serialization-kotlinx-serialization-json'], this['core-core-stl']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_core_core_api, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_core_core_stl) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var Companion_instance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var toString = kotlin_kotlin.$_$.z9;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.f1;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w2;
  var protoOf = kotlin_kotlin.$_$.u9;
  var THROW_CCE = kotlin_kotlin.$_$.ad;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var objectMeta = kotlin_kotlin.$_$.t9;
  var setMetadataFor = kotlin_kotlin.$_$.v9;
  var VOID = kotlin_kotlin.$_$.e;
  var getStringHashCode = kotlin_kotlin.$_$.z8;
  var classMeta = kotlin_kotlin.$_$.q8;
  var defineProp = kotlin_kotlin.$_$.s8;
  var charSequenceLength = kotlin_kotlin.$_$.o8;
  var LoggerState_getInstance = kotlin_core_core_api.$_$.fb;
  var Exception = kotlin_kotlin.$_$.uc;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var JsonElementSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.c;
  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var Unit_instance = kotlin_kotlin.$_$.x3;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
  var objectCreate = kotlin_kotlin.$_$.s9;
  var hashCode = kotlin_kotlin.$_$.a9;
  var equals = kotlin_kotlin.$_$.t8;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.q;
  var reversedArray = kotlin_kotlin.$_$.g7;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.z;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.v4;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.g;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.h;
  var AssemblyStructureComponent = kotlin_core_core_api.$_$.i;
  var AssemblyPartsComponent = kotlin_core_core_api.$_$.g;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.s;
  var mapCapacity = kotlin_kotlin.$_$.q6;
  var coerceAtLeast = kotlin_kotlin.$_$.fa;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.p;
  var copyToArray = kotlin_kotlin.$_$.l5;
  var emptyList = kotlin_kotlin.$_$.o5;
  var toString_0 = kotlin_kotlin.$_$.ae;
  var Error_0 = kotlin_kotlin.$_$.tc;
  var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.h;
  var to = kotlin_kotlin.$_$.be;
  var toMap = kotlin_kotlin.$_$.w7;
  var emptyMap = kotlin_kotlin.$_$.p5;
  var Companion_getInstance = kotlin_core_core_api.$_$.k9;
  var toMutableList = kotlin_kotlin.$_$.y7;
  var Pair = kotlin_kotlin.$_$.yc;
  var createCustomAssembly = kotlin_core_core_api.$_$.o;
  var createCustomAssemblySpecification = kotlin_core_core_api.$_$.n;
  var ProductCatalog = kotlin_core_core_api.$_$.p;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var getKClassFromExpression = kotlin_kotlin.$_$.c;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.n3;
  var ReferenceArraySerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
  var ComponentIds_instance = kotlin_core_core_api.$_$.w9;
  var get_serializable = kotlin_core_core_api.$_$.w2;
  var get_doStoreInSnapshot = kotlin_core_core_api.$_$.v2;
  var Component = kotlin_core_core_api.$_$.x2;
  var $serializer_getInstance = kotlin_core_core_api.$_$.sb;
  var $serializer_getInstance_0 = kotlin_core_core_api.$_$.pb;
  var getKClass = kotlin_kotlin.$_$.d;
  var $serializer_getInstance_1 = kotlin_core_core_api.$_$.hb;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var getBooleanHashCode = kotlin_kotlin.$_$.v8;
  var ConnectorVisualizationData = kotlin_core_core_stl.$_$.j3;
  var get_hierarchySequence = kotlin_core_core_api.$_$.c4;
  var mapNotNull = kotlin_kotlin.$_$.ya;
  var Companion_instance_0 = kotlin_core_core_api.$_$.yb;
  var Comparator = kotlin_kotlin.$_$.pc;
  var EntityConnectorVisualizationComponent = kotlin_core_core_stl.$_$.m3;
  var compareValues = kotlin_kotlin.$_$.d8;
  var Collection = kotlin_kotlin.$_$.z3;
  var isInterface = kotlin_kotlin.$_$.j9;
  var plus = kotlin_kotlin.$_$.b7;
  var toMutableList_0 = kotlin_kotlin.$_$.x7;
  var sortWith = kotlin_kotlin.$_$.k7;
  var sortWith_0 = kotlin_kotlin.$_$.l7;
  var SizeFromVector = kotlin_core_core_api.$_$.d9;
  var ColliderShapeComponent = kotlin_core_core_api.$_$.y;
  var ConnectorsComponent = kotlin_core_core_api.$_$.u1;
  var contains = kotlin_kotlin.$_$.x4;
  var filter = kotlin_kotlin.$_$.ua;
  var Map = kotlin_kotlin.$_$.g4;
  var toList = kotlin_kotlin.$_$.v7;
  var listOf = kotlin_kotlin.$_$.p6;
  var plus_0 = kotlin_kotlin.$_$.z6;
  var ProductSpecification = kotlin_core_core_api.$_$.s;
  var ModelInfoComponent = kotlin_core_core_api.$_$.o5;
  var RelativeConnectorsComponent = kotlin_core_core_api.$_$.d2;
  var SelectableComponent = kotlin_core_core_api.$_$.f6;
  var DraggableComponent = kotlin_core_core_api.$_$.q2;
  var ConnectionRootComponent = kotlin_core_core_api.$_$.k1;
  var DisplayNameComponent = kotlin_core_core_api.$_$.e5;
  var Vector = kotlin_core_core_api.$_$.c5;
  var TemplateDataComponent = kotlin_core_core_api.$_$.f5;
  var AlwaysHangDownComponent_instance = kotlin_core_core_api.$_$.zc;
  var UnserializableEntityComponent = kotlin_core_core_api.$_$.q6;
  var OutlineableComponent = kotlin_core_core_api.$_$.q5;
  var RecommendedInitialPositionFromFloorComponent = kotlin_core_core_stl.$_$.j2;
  var FunctionalMarginShapeComponent = kotlin_core_core_stl.$_$.p1;
  var FunctionalZonesLocalComponent = kotlin_core_core_stl.$_$.s1;
  var PlacementZoneByHeightComponent = kotlin_core_core_stl.$_$.i2;
  var AutoAdaptHostComponent = kotlin_core_core_stl.$_$.l;
  var isBlank = kotlin_kotlin.$_$.nb;
  var ModelTransformComponent = kotlin_core_core_api.$_$.p5;
  var AllowedDoorPairsComponent = kotlin_core_core_stl.$_$.g;
  var sortedWith = kotlin_kotlin.$_$.m7;
  var AutoAdaptGuestComponent = kotlin_core_core_stl.$_$.k;
  var CommunicationSizeComponent = kotlin_core_core_stl.$_$.n2;
  var LegComponent_getInstance = kotlin_core_core_stl.$_$.v4;
  var FrameComponent_getInstance = kotlin_core_core_stl.$_$.t4;
  var DoorComponent_getInstance = kotlin_core_core_stl.$_$.q4;
  var DoorFrontComponent_getInstance = kotlin_core_core_stl.$_$.r4;
  var HandleComponent_getInstance = kotlin_core_core_stl.$_$.u4;
  var DrawerComponent_getInstance = kotlin_core_core_stl.$_$.s4;
  var LightComponent = kotlin_core_core_stl.$_$.o2;
  var plus_1 = kotlin_kotlin.$_$.y6;
  var ProppingComponent_instance = kotlin_core_core_api.$_$.xb;
  var DragSurfacesComponent = kotlin_core_core_api.$_$.n2;
  var Companion_getInstance_0 = kotlin_core_core_api.$_$.pc;
  var DragProjectionPointComponent = kotlin_core_core_stl.$_$.c1;
  var ProductStructureConnection = kotlin_core_core_api.$_$.u;
  var ProductStructureItem = kotlin_core_core_api.$_$.v;
  var ProductStructureComponent = kotlin_core_core_api.$_$.t;
  var interfaceMeta = kotlin_kotlin.$_$.b9;
  var FunctionalZone = kotlin_core_core_stl.$_$.u1;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var AssemblyPartSnapInfo = kotlin_core_core_api.$_$.f;
  var Companion_getInstance_1 = kotlin_core_core_api.$_$.rb;
  var AssemblyPart = kotlin_core_core_api.$_$.h;
  var Companion_getInstance_2 = kotlin_core_core_api.$_$.kb;
  var Degrees = kotlin_core_core_api.$_$.s4;
  var Transform = kotlin_core_core_api.$_$.b5;
  var plus_2 = kotlin_kotlin.$_$.x6;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h1;
  var buildClassSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n1;
  var PolyhedronUtils_getInstance = kotlin_core_core_api.$_$.qc;
  var Margin = kotlin_core_core_api.$_$.t4;
  var ensureNotNull = kotlin_kotlin.$_$.qd;
  var Size = kotlin_core_core_api.$_$.a5;
  var isArray = kotlin_kotlin.$_$.c9;
  var addAll = kotlin_kotlin.$_$.m4;
  var merge = kotlin_core_core_api.$_$.v6;
  var DOUBLE_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
  var isNaN_0 = kotlin_kotlin.$_$.ud;
  var DoubleCompanionObject_instance = kotlin_kotlin.$_$.h3;
  var getNumberHashCode = kotlin_kotlin.$_$.x8;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.l3;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
  var ArraySerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
  var BOOLEAN_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f;
  var INT_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h;
  var Companion_getInstance_3 = kotlin_core_core_api.$_$.tb;
  var ConnectorType_instance = kotlin_core_core_api.$_$.fa;
  var Companion_instance_1 = kotlin_core_core_api.$_$.da;
  var NotImplementedError = kotlin_kotlin.$_$.xc;
  var RotationDegreeOfFreedom_ONE_getInstance = kotlin_core_core_api.$_$.z7;
  var RotationDegreeOfFreedom_NONE_getInstance = kotlin_core_core_api.$_$.y7;
  var PointConnector = kotlin_core_core_api.$_$.z1;
  var PointSeriesConnector = kotlin_core_core_api.$_$.a2;
  var EdgeConnector = kotlin_core_core_api.$_$.y1;
  var SurfaceConnector = kotlin_core_core_api.$_$.g2;
  var Companion_instance_2 = kotlin_core_core_api.$_$.ib;
  var RelativeConnectorRepositioner_instance = kotlin_core_core_api.$_$.ja;
  var ConnectorTagConstants_instance = kotlin_core_core_api.$_$.ea;
  var numberToInt = kotlin_kotlin.$_$.q9;
  var RelationOrigin = kotlin_core_core_api.$_$.y4;
  var firstOrNull = kotlin_kotlin.$_$.u5;
  var RelativeBoxOffset = kotlin_core_core_api.$_$.z4;
  var RelativeConnectorData = kotlin_core_core_api.$_$.c2;
  var CuboidFromSizeAndCenter = kotlin_core_core_api.$_$.g9;
  var DragSurface = kotlin_core_core_api.$_$.o2;
  var arrayOf = kotlin_kotlin.$_$.nd;
  var createKType = kotlin_kotlin.$_$.a;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a3;
  var listSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var serializer_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b3;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var get_jsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.n;
  var get_double = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
  var Companion_instance_3 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.b;
  var get_jsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.l;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
  var Companion_getInstance_4 = kotlin_core_core_api.$_$.lb;
  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.g;
  var get_jsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
  var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.d;
  var lazy = kotlin_kotlin.$_$.wd;
  var KProperty1 = kotlin_kotlin.$_$.na;
  var getPropertyCallableRef = kotlin_kotlin.$_$.y8;
  var createAnnotatedEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.f;
  var lazy_0 = kotlin_kotlin.$_$.vd;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
  var THROW_IAE = kotlin_kotlin.$_$.bd;
  var Enum = kotlin_kotlin.$_$.sc;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.i1;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l2;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w;
  var charSequenceGet = kotlin_kotlin.$_$.n8;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.o1;
  var toDouble = kotlin_kotlin.$_$.cc;
  var contains_0 = kotlin_kotlin.$_$.ib;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.xd;
  var round = kotlin_kotlin.$_$.ca;
  var $serializer_getInstance_2 = kotlin_core_core_api.$_$.jb;
  var get_doubleOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.k;
  var joinToString = kotlin_kotlin.$_$.e6;
  var RelationOriginAlongX_CENTER_getInstance = kotlin_core_core_api.$_$.e8;
  var RelationOriginAlongX_RIGHT_getInstance = kotlin_core_core_api.$_$.g8;
  var contains_1 = kotlin_kotlin.$_$.hb;
  var RelationOriginAlongX_LEFT_getInstance = kotlin_core_core_api.$_$.f8;
  var RelationOriginAlongY_CENTER_getInstance = kotlin_core_core_api.$_$.i8;
  var RelationOriginAlongY_BOTTOM_getInstance = kotlin_core_core_api.$_$.h8;
  var RelationOriginAlongY_TOP_getInstance = kotlin_core_core_api.$_$.j8;
  var RelationOriginAlongZ_CENTER_getInstance = kotlin_core_core_api.$_$.l8;
  var RelationOriginAlongZ_BACK_getInstance = kotlin_core_core_api.$_$.k8;
  var RelationOriginAlongZ_FRONT_getInstance = kotlin_core_core_api.$_$.m8;
  var valueOf = kotlin_core_core_api.$_$.e2;
  var RotationDegreeOfFreedom = kotlin_core_core_api.$_$.f2;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.a1;
  var captureStack = kotlin_kotlin.$_$.k8;
  var serializer_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var JsonDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.e;
  var SerializationException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var trimIndent = kotlin_kotlin.$_$.lc;
  var joinToString_0 = kotlin_kotlin.$_$.f6;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.k1;
  var get_lastIndex = kotlin_kotlin.$_$.i6;
  //endregion
  //region block: pre-declaration
  setMetadataFor(CustomSerializer, 'CustomSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(AutoAdaptGroup, 'AutoAdaptGroup', classMeta, VOID, VOID, VOID, VOID, {0: CustomSerializer_getInstance});
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(DynamicComponentResolver, 'DynamicComponentResolver', classMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(DynamicProduct, 'DynamicProduct', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(DynamicProductCatalog$generateAssemblyComponents$1, VOID, classMeta);
  setMetadataFor(DynamicProductCatalog, 'DynamicProductCatalog', classMeta, VOID, [ProductCatalog]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(PackedProductData, 'PackedProductData', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(DynamicProductData, 'DynamicProductData', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(DynamicTemplateData, 'DynamicTemplateData', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(PackedProduct, 'PackedProduct', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductTemplate, 'ProductTemplate', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(MetaDataComponent, 'MetaDataComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(VisualLightSourceComponent, 'VisualLightSourceComponent', classMeta, VOID, [Component], VisualLightSourceComponent);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Bounds, 'Bounds', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(CatalogTemplateData, 'CatalogTemplateData', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ModelRenderInfo, 'ModelRenderInfo', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
  setMetadataFor(Companion_11, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Part, 'Part', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor($serializer_9, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductComponent, 'ProductComponent', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
  setMetadataFor(TemplateEditorConnectorData, 'TemplateEditorConnectorData', classMeta, VOID, [ConnectorVisualizationData]);
  setMetadataFor(ProductTemplateDTO, 'ProductTemplateDTO', classMeta);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(TemplateEditorService$runOnFilteredSceneEntities$1$1$1$1, VOID, classMeta);
  setMetadataFor(TemplateEditorService, 'TemplateEditorService', classMeta);
  setMetadataFor(DynamicProductSpecifier, 'DynamicProductSpecifier', interfaceMeta);
  setMetadataFor(DynamicComponentBuilder, 'DynamicComponentBuilder', classMeta, VOID, [DynamicProductSpecifier]);
  setMetadataFor(DynamicAssembly, 'DynamicAssembly', classMeta, DynamicComponentBuilder);
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(Companion_15, 'Companion', objectMeta);
  setMetadataFor(DynamicShape, 'DynamicShape', classMeta, DynamicComponentBuilder);
  setMetadataFor(Companion_16, 'Companion', objectMeta);
  setMetadataFor($serializer_10, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(AssemblyChild, 'AssemblyChild', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
  setMetadataFor(Companion_17, 'Companion', objectMeta);
  setMetadataFor($serializer_11, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(AssemblyTemplate, 'AssemblyTemplate', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
  setMetadataFor(CustomSerializer_0, 'CustomSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(AutoAdaptHostTemplate, 'AutoAdaptHostTemplate', classMeta, VOID, VOID, AutoAdaptHostTemplate, VOID, {0: CustomSerializer_getInstance_0});
  setMetadataFor(Companion_18, 'Companion', objectMeta, VOID, [KSerializer]);
  setMetadataFor(BoundItemTemplate, 'BoundItemTemplate', classMeta, VOID, VOID, VOID, VOID, {0: Companion_getInstance_24});
  setMetadataFor(Companion_19, 'Companion', objectMeta, VOID, [KSerializer]);
  setMetadataFor(Compartment, 'Compartment', classMeta, VOID, VOID, Compartment, VOID, {0: Companion_getInstance_25});
  setMetadataFor(Companion_20, 'Companion', objectMeta);
  setMetadataFor($serializer_12, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ComponentsTemplate, 'ComponentsTemplate', classMeta, VOID, VOID, ComponentsTemplate, VOID, {0: $serializer_getInstance_16});
  setMetadataFor(Companion_21, 'Companion', objectMeta, VOID, [KSerializer]);
  setMetadataFor(ConnectorItemTemplate, 'ConnectorItemTemplate', classMeta, VOID, VOID, VOID, VOID, {0: Companion_getInstance_27});
  setMetadataFor(Companion_22, 'Companion', objectMeta, VOID, [KSerializer]);
  setMetadataFor(Dimension, 'Dimension', classMeta, VOID, VOID, Dimension, VOID, {0: Companion_getInstance_28});
  setMetadataFor(Companion_23, 'Companion', objectMeta);
  setMetadataFor($serializer_13, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(DragSurfaceTemplate, 'DragSurfaceTemplate', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
  setMetadataFor(CustomSerializer_1, 'CustomSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(DragSurfacesTemplate, 'DragSurfacesTemplate', classMeta, VOID, VOID, VOID, VOID, {0: CustomSerializer_getInstance_1});
  setMetadataFor(Companion_24, 'Companion', objectMeta);
  setMetadataFor(DynamicRangeUtils, 'DynamicRangeUtils', classMeta, VOID, VOID, DynamicRangeUtils);
  setMetadataFor(Companion_25, 'Companion', objectMeta);
  setMetadataFor($serializer_14, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(LightTemplate, 'LightTemplate', classMeta, VOID, VOID, LightTemplate, VOID, {0: $serializer_getInstance_18});
  setMetadataFor(MarginTemplateSerializer, 'MarginTemplateSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(MarginTemplate, 'MarginTemplate', classMeta, VOID, VOID, MarginTemplate, VOID, {0: MarginTemplateSerializer_getInstance});
  setMetadataFor(Companion_26, 'Companion', objectMeta);
  setMetadataFor($serializer_15, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Model3DTemplate, 'Model3DTemplate', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
  setMetadataFor(CustomSerializer_2, 'CustomSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(OriginTemplate, 'OriginTemplate', classMeta, VOID, VOID, VOID, VOID, {0: CustomSerializer_getInstance_2});
  setMetadataFor(Companion_27, 'Companion', objectMeta);
  setMetadataFor($serializer_16, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(PlacementZoneByHeightTemplate, 'PlacementZoneByHeightTemplate', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
  setMetadataFor(PositionTemplateSerializer, 'PositionTemplateSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(PositionTemplate, 'PositionTemplate', classMeta, VOID, VOID, VOID, VOID, {0: PositionTemplateSerializer_getInstance});
  setMetadataFor(Companion_28, 'Companion', objectMeta);
  setMetadataFor($serializer_17, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(VisualLightSourceTemplate, 'VisualLightSourceTemplate', classMeta, VOID, VOID, VisualLightSourceTemplate, VOID, {0: $serializer_getInstance_21});
  setMetadataFor(Companion_29, 'Companion', objectMeta);
  setMetadataFor($serializer_18, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductStructureConnectionTemplate, 'ProductStructureConnectionTemplate', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_22});
  setMetadataFor(Companion_30, 'Companion', objectMeta);
  setMetadataFor($serializer_19, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(ProductStructureItemTemplate, 'ProductStructureItemTemplate', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
  setMetadataFor(Companion_31, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(OriginRelativeTo, 'OriginRelativeTo', classMeta, Enum, VOID, VOID, VOID, {0: Companion_getInstance_37});
  setMetadataFor(OriginRelativeToImpostor, 'OriginRelativeToImpostor', objectMeta);
  setMetadataFor(Companion_32, 'Companion', objectMeta);
  setMetadataFor(PositionType, 'PositionType', classMeta, Enum);
  setMetadataFor(PositionTypeImpostor, 'PositionTypeImpostor', objectMeta);
  setMetadataFor(Companion_33, 'Companion', objectMeta);
  setMetadataFor($serializer_20, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(PositionValue, 'PositionValue', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
  setMetadataFor(Companion_34, 'Companion', objectMeta, VOID, [KSerializer]);
  setMetadataFor(RelativePosition, 'RelativePosition', classMeta, VOID, VOID, VOID, VOID, {0: Companion_getInstance_40});
  setMetadataFor(RelativeTransformSerializer, 'RelativeTransformSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(RelativeTransform, 'RelativeTransform', classMeta, VOID, VOID, RelativeTransform, VOID, {0: RelativeTransformSerializer_getInstance});
  setMetadataFor(NamedTransformObjectDeserializer, 'NamedTransformObjectDeserializer', objectMeta);
  setMetadataFor(RelationOriginSerializer, 'RelationOriginSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(RelativeTransformDeserializer, 'RelativeTransformDeserializer', objectMeta);
  setMetadataFor(RotationDegreeOfFreedomSerializer, 'RotationDegreeOfFreedomSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(DynamicRangeParseError, 'DynamicRangeParseError', classMeta, Exception);
  setMetadataFor(SizeSerializer, 'SizeSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(SpacingSerializer, 'SpacingSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(CatalogGenerator, 'CatalogGenerator', classMeta, VOID, VOID, CatalogGenerator);
  setMetadataFor(parseMeta$result$1, VOID, classMeta);
  //endregion
  function CustomSerializer() {
    CustomSerializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.AutoAdaptGroup', null, 2);
    tmp0_serialDesc.cv('key', false);
    tmp0_serialDesc.cv('priority', false);
    this.j3x_1 = tmp0_serialDesc;
  }
  protoOf(CustomSerializer).qk = function (decoder) {
    try {
      var key = decoder.in();
      return new AutoAdaptGroup(key, 0);
    } catch ($p) {
      if ($p instanceof SerializationException) {
        var e = $p;
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = decoder.nn(this.j3x_1);
        var key_0 = null;
        var priority = null;
        $l$loop: while (true) {
          var index = $this$run.eo(CustomSerializer_getInstance().j3x_1);
          if (index === -1)
            break $l$loop;
          switch (index) {
            case 0:
              key_0 = $this$run.xn(CustomSerializer_getInstance().j3x_1, 0);
              break;
            case 1:
              priority = $this$run.sn(CustomSerializer_getInstance().j3x_1, 1);
              break;
            default:
              // Inline function 'kotlin.error' call

              var message = 'AutoAdaptGroup: unexpected index: ' + index;
              throw IllegalStateException_init_$Create$(toString(message));
          }
        }
        $this$run.on(CustomSerializer_getInstance().j3x_1);
        if (key_0 == null) {
          // Inline function 'kotlin.error' call
          var message_0 = 'AutoAdaptGroup: key must be specified';
          throw IllegalStateException_init_$Create$(toString(message_0));
        }
        var tmp = key_0;
        var tmp1_elvis_lhs = priority;
        return new AutoAdaptGroup(tmp, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs);
      } else {
        throw $p;
      }
    }
  };
  protoOf(CustomSerializer).ok = function () {
    return this.j3x_1;
  };
  protoOf(CustomSerializer).k3x = function (encoder, value) {
    var tmp0_desc = this.j3x_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.key);
    tmp1_output.xo(tmp0_desc, 1, value.priority);
    tmp1_output.on(tmp0_desc);
  };
  protoOf(CustomSerializer).pk = function (encoder, value) {
    return this.k3x(encoder, value instanceof AutoAdaptGroup ? value : THROW_CCE());
  };
  protoOf(CustomSerializer).l17 = function () {
    return CustomSerializer_getInstance();
  };
  var CustomSerializer_instance;
  function CustomSerializer_getInstance() {
    if (CustomSerializer_instance == null)
      new CustomSerializer();
    return CustomSerializer_instance;
  }
  function AutoAdaptGroup(key, priority) {
    CustomSerializer_getInstance();
    this.key = key;
    this.priority = priority;
  }
  protoOf(AutoAdaptGroup).t2 = function () {
    return this.key;
  };
  protoOf(AutoAdaptGroup).v1v = function () {
    return this.priority;
  };
  protoOf(AutoAdaptGroup).af = function () {
    return this.key;
  };
  protoOf(AutoAdaptGroup).bf = function () {
    return this.priority;
  };
  protoOf(AutoAdaptGroup).w2o = function (key, priority) {
    return new AutoAdaptGroup(key, priority);
  };
  protoOf(AutoAdaptGroup).copy = function (key, priority, $super) {
    key = key === VOID ? this.key : key;
    priority = priority === VOID ? this.priority : priority;
    return this.w2o(key, priority);
  };
  protoOf(AutoAdaptGroup).toString = function () {
    return 'AutoAdaptGroup(key=' + this.key + ', priority=' + this.priority + ')';
  };
  protoOf(AutoAdaptGroup).hashCode = function () {
    var result = getStringHashCode(this.key);
    result = imul(result, 31) + this.priority | 0;
    return result;
  };
  protoOf(AutoAdaptGroup).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AutoAdaptGroup))
      return false;
    var tmp0_other_with_cast = other instanceof AutoAdaptGroup ? other : THROW_CCE();
    if (!(this.key === tmp0_other_with_cast.key))
      return false;
    if (!(this.priority === tmp0_other_with_cast.priority))
      return false;
    return true;
  };
  function modelRenderInfo($this, dynamicProduct) {
    // Inline function 'kotlin.text.isNullOrEmpty' call
    var this_0 = dynamicProduct.modelURI;
    // Inline function 'kotlin.contracts.contract' call
    if (this_0 == null ? true : charSequenceLength(this_0) === 0)
      return null;
    return new ModelRenderInfo($this.l3x_1, dynamicProduct.modelURI, '');
  }
  function Companion() {
    Companion_instance_4 = this;
    this.logger = LoggerState_getInstance().m1m('DynamicComponentResolver');
  }
  protoOf(Companion).x1i = function () {
    return this.logger;
  };
  var Companion_instance_4;
  function Companion_getInstance_5() {
    if (Companion_instance_4 == null)
      new Companion();
    return Companion_instance_4;
  }
  function DynamicComponentResolver$builder$lambda($templateId) {
    return function () {
      return "No template found for for '" + $templateId + "'.";
    };
  }
  function DynamicComponentResolver$builder$lambda_0($templateId, $e) {
    return function () {
      return "There are errors in the loaded data for '" + $templateId + "'. (" + $e.message + ')';
    };
  }
  function DynamicComponentResolver(catalog, modelRootUrl) {
    Companion_getInstance_5();
    modelRootUrl = modelRootUrl === VOID ? null : modelRootUrl;
    this.catalog = catalog;
    this.l3x_1 = modelRootUrl;
  }
  protoOf(DynamicComponentResolver).m3x = function () {
    return this.catalog;
  };
  protoOf(DynamicComponentResolver).builder = function (productInfo) {
    var templateId = productInfo.template.id;
    var tmp;
    try {
      var productTemplate = this.catalog.findTemplateDTO(templateId);
      var tmp_0;
      if (!(productTemplate == null)) {
        var tmp_1;
        if (!(productTemplate.components.assembly == null)) {
          tmp_1 = new DynamicAssembly(productInfo, productInfo.template, productTemplate, this.catalog);
        } else {
          tmp_1 = new DynamicShape(productInfo, productInfo.template, modelRenderInfo(this, productInfo), productTemplate, this.catalog);
        }
        tmp_0 = tmp_1;
      } else {
        var tmp_2 = Companion_getInstance_5().logger;
        tmp_2.warn(DynamicComponentResolver$builder$lambda(templateId));
        tmp_0 = null;
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_3;
      if ($p instanceof Exception) {
        var e = $p;
        var tmp_4 = Companion_getInstance_5().logger;
        tmp_4.warn(DynamicComponentResolver$builder$lambda_0(templateId, e));
        tmp_3 = null;
      } else {
        throw $p;
      }
      tmp = tmp_3;
    }
    return tmp;
  };
  function Companion_0() {
    Companion_instance_5 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p3x_1 = [null, null, null, null, null, null, null, null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonElementSerializer_getInstance()), null];
  }
  protoOf(Companion_0).fromPackedProduct = function (packed) {
    var tmp0_safe_receiver = packed.components.product;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.catalog.Companion.fromPackedProduct.<anonymous>' call
      var tmp0_safe_receiver_0 = packed.components.model3D;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.catalog.Companion.fromPackedProduct.<anonymous>.<anonymous>' call
        tmp_0 = new ModelRenderInfo(tmp0_safe_receiver_0.modelRootURL, tmp0_safe_receiver_0.modelURI, null);
      }
      var modelInfo = tmp_0;
      var tmp1_safe_receiver = packed.components.model3D;
      var template = new CatalogTemplateData(tmp0_safe_receiver.productGroup, tmp0_safe_receiver.size, tmp0_safe_receiver.comSize, '', tmp0_safe_receiver.parts, modelInfo, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.modelTransform);
      var tmp2_elvis_lhs = tmp0_safe_receiver.dexfId;
      var tmp_1 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
      var tmp_2 = modelInfo == null ? null : modelInfo.model;
      var tmp4_elvis_lhs = tmp0_safe_receiver.description;
      var tmp_3 = tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs;
      var tmp5_safe_receiver = tmp0_safe_receiver.autoAdaptGroup;
      var tmp_4;
      if (tmp5_safe_receiver == null) {
        tmp_4 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.catalog.Companion.fromPackedProduct.<anonymous>.<anonymous>' call
        tmp_4 = new AutoAdaptGroup(tmp5_safe_receiver, 0);
      }
      tmp = new DynamicProduct(tmp0_safe_receiver.id, tmp0_safe_receiver.type, tmp_1, tmp_2, tmp_3, template, tmp0_safe_receiver.typeCode, tmp0_safe_receiver.partsInPackage, tmp_4, tmp0_safe_receiver.meta);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_5;
    if (tmp1_elvis_lhs == null) {
      var message = 'Space product ' + packed.id + ' is missing product component';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_5 = tmp1_elvis_lhs;
    }
    return tmp_5;
  };
  protoOf(Companion_0).l17 = function () {
    return $serializer_getInstance_3();
  };
  var Companion_instance_5;
  function Companion_getInstance_6() {
    if (Companion_instance_5 == null)
      new Companion_0();
    return Companion_instance_5;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.DynamicProduct', this, 11);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('type', true);
    tmp0_serialDesc.cv('dexf', true);
    tmp0_serialDesc.cv('modelURI', true);
    tmp0_serialDesc.cv('desc', true);
    tmp0_serialDesc.cv('template', false);
    tmp0_serialDesc.cv('typeCode', true);
    tmp0_serialDesc.cv('partsInPackage', true);
    tmp0_serialDesc.cv('autoAdaptGroup', true);
    tmp0_serialDesc.cv('meta', true);
    tmp0_serialDesc.cv('dexfAssetName', true);
    this.q3x_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ok = function () {
    return this.q3x_1;
  };
  protoOf($serializer).rv = function () {
    var tmp0_cached = Companion_getInstance_6().p3x_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), $serializer_getInstance_10(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(CustomSerializer_getInstance()), get_nullable(tmp0_cached[9]), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer).qk = function (decoder) {
    var tmp0_desc = this.q3x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.nn(tmp0_desc);
    var tmp16_cached = Companion_getInstance_6().p3x_1;
    if (tmp15_input.do()) {
      tmp4_local0 = tmp15_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.bo(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.xn(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.zn(tmp0_desc, 5, $serializer_getInstance_10(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.bo(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.bo(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.bo(tmp0_desc, 8, CustomSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.bo(tmp0_desc, 9, tmp16_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.bo(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.bo(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.xn(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.zn(tmp0_desc, 5, $serializer_getInstance_10(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.bo(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.bo(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.bo(tmp0_desc, 8, CustomSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.bo(tmp0_desc, 9, tmp16_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.bo(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.on(tmp0_desc);
    return DynamicProduct_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer).r3x = function (encoder, value) {
    var tmp0_desc = this.q3x_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_6().p3x_1;
    tmp1_output.cp(tmp0_desc, 0, value.id);
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.type == null)) {
      tmp1_output.gp(tmp0_desc, 1, StringSerializer_getInstance(), value.type);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.dexf == null)) {
      tmp1_output.gp(tmp0_desc, 2, StringSerializer_getInstance(), value.dexf);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.modelURI == null)) {
      tmp1_output.gp(tmp0_desc, 3, StringSerializer_getInstance(), value.modelURI);
    }
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.desc === '')) {
      tmp1_output.cp(tmp0_desc, 4, value.desc);
    }
    tmp1_output.ep(tmp0_desc, 5, $serializer_getInstance_10(), value.template);
    if (tmp1_output.kp(tmp0_desc, 6) ? true : !(value.typeCode == null)) {
      tmp1_output.gp(tmp0_desc, 6, IntSerializer_getInstance(), value.typeCode);
    }
    if (tmp1_output.kp(tmp0_desc, 7) ? true : !(value.partsInPackage == null)) {
      tmp1_output.gp(tmp0_desc, 7, IntSerializer_getInstance(), value.partsInPackage);
    }
    if (tmp1_output.kp(tmp0_desc, 8) ? true : !(value.autoAdaptGroup == null)) {
      tmp1_output.gp(tmp0_desc, 8, CustomSerializer_getInstance(), value.autoAdaptGroup);
    }
    if (tmp1_output.kp(tmp0_desc, 9) ? true : !(value.meta == null)) {
      tmp1_output.gp(tmp0_desc, 9, tmp2_cached[9], value.meta);
    }
    if (tmp1_output.kp(tmp0_desc, 10) ? true : !(value.dexfAssetName == null)) {
      tmp1_output.gp(tmp0_desc, 10, StringSerializer_getInstance(), value.dexfAssetName);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer).pk = function (encoder, value) {
    return this.r3x(encoder, value instanceof DynamicProduct ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_3() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function DynamicProduct_init_$Init$(seen1, id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, meta, dexfAssetName, serializationConstructorMarker, $this) {
    if (!(33 === (33 & seen1))) {
      throwMissingFieldException(seen1, 33, $serializer_getInstance_3().q3x_1);
    }
    $this.id = id;
    if (0 === (seen1 & 2))
      $this.type = null;
    else
      $this.type = type;
    if (0 === (seen1 & 4))
      $this.dexf = null;
    else
      $this.dexf = dexf;
    if (0 === (seen1 & 8))
      $this.modelURI = null;
    else
      $this.modelURI = modelURI;
    if (0 === (seen1 & 16))
      $this.desc = '';
    else
      $this.desc = desc;
    $this.template = template;
    if (0 === (seen1 & 64))
      $this.typeCode = null;
    else
      $this.typeCode = typeCode;
    if (0 === (seen1 & 128))
      $this.partsInPackage = null;
    else
      $this.partsInPackage = partsInPackage;
    if (0 === (seen1 & 256))
      $this.autoAdaptGroup = null;
    else
      $this.autoAdaptGroup = autoAdaptGroup;
    if (0 === (seen1 & 512))
      $this.meta = null;
    else
      $this.meta = meta;
    if (0 === (seen1 & 1024))
      $this.dexfAssetName = null;
    else
      $this.dexfAssetName = dexfAssetName;
    return $this;
  }
  function DynamicProduct_init_$Create$(seen1, id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, meta, dexfAssetName, serializationConstructorMarker) {
    return DynamicProduct_init_$Init$(seen1, id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, meta, dexfAssetName, serializationConstructorMarker, objectCreate(protoOf(DynamicProduct)));
  }
  function DynamicProduct(id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, meta, dexfAssetName) {
    Companion_getInstance_6();
    type = type === VOID ? null : type;
    dexf = dexf === VOID ? null : dexf;
    modelURI = modelURI === VOID ? null : modelURI;
    desc = desc === VOID ? '' : desc;
    typeCode = typeCode === VOID ? null : typeCode;
    partsInPackage = partsInPackage === VOID ? null : partsInPackage;
    autoAdaptGroup = autoAdaptGroup === VOID ? null : autoAdaptGroup;
    meta = meta === VOID ? null : meta;
    dexfAssetName = dexfAssetName === VOID ? null : dexfAssetName;
    this.id = id;
    this.type = type;
    this.dexf = dexf;
    this.modelURI = modelURI;
    this.desc = desc;
    this.template = template;
    this.typeCode = typeCode;
    this.partsInPackage = partsInPackage;
    this.autoAdaptGroup = autoAdaptGroup;
    this.meta = meta;
    this.dexfAssetName = dexfAssetName;
  }
  protoOf(DynamicProduct).s1k = function () {
    return this.id;
  };
  protoOf(DynamicProduct).a1x = function () {
    return this.type;
  };
  protoOf(DynamicProduct).s3x = function () {
    return this.dexf;
  };
  protoOf(DynamicProduct).t3x = function () {
    return this.modelURI;
  };
  protoOf(DynamicProduct).u3x = function () {
    return this.desc;
  };
  protoOf(DynamicProduct).v3x = function () {
    return this.template;
  };
  protoOf(DynamicProduct).w3x = function () {
    return this.typeCode;
  };
  protoOf(DynamicProduct).x3x = function () {
    return this.partsInPackage;
  };
  protoOf(DynamicProduct).y3x = function () {
    return this.autoAdaptGroup;
  };
  protoOf(DynamicProduct).z3x = function () {
    return this.meta;
  };
  protoOf(DynamicProduct).a3y = function () {
    return this.dexfAssetName;
  };
  protoOf(DynamicProduct).isMultipartAssembly = function () {
    var tmp0_safe_receiver = this.template.parts;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      tmp = !(tmp0_safe_receiver.length === 0);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(DynamicProduct).af = function () {
    return this.id;
  };
  protoOf(DynamicProduct).bf = function () {
    return this.type;
  };
  protoOf(DynamicProduct).g1k = function () {
    return this.dexf;
  };
  protoOf(DynamicProduct).h1k = function () {
    return this.modelURI;
  };
  protoOf(DynamicProduct).i1k = function () {
    return this.desc;
  };
  protoOf(DynamicProduct).j1k = function () {
    return this.template;
  };
  protoOf(DynamicProduct).k1k = function () {
    return this.typeCode;
  };
  protoOf(DynamicProduct).p1z = function () {
    return this.partsInPackage;
  };
  protoOf(DynamicProduct).q1z = function () {
    return this.autoAdaptGroup;
  };
  protoOf(DynamicProduct).r1z = function () {
    return this.meta;
  };
  protoOf(DynamicProduct).s1z = function () {
    return this.dexfAssetName;
  };
  protoOf(DynamicProduct).b3y = function (id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, meta, dexfAssetName) {
    return new DynamicProduct(id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, meta, dexfAssetName);
  };
  protoOf(DynamicProduct).copy = function (id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, meta, dexfAssetName, $super) {
    id = id === VOID ? this.id : id;
    type = type === VOID ? this.type : type;
    dexf = dexf === VOID ? this.dexf : dexf;
    modelURI = modelURI === VOID ? this.modelURI : modelURI;
    desc = desc === VOID ? this.desc : desc;
    template = template === VOID ? this.template : template;
    typeCode = typeCode === VOID ? this.typeCode : typeCode;
    partsInPackage = partsInPackage === VOID ? this.partsInPackage : partsInPackage;
    autoAdaptGroup = autoAdaptGroup === VOID ? this.autoAdaptGroup : autoAdaptGroup;
    meta = meta === VOID ? this.meta : meta;
    dexfAssetName = dexfAssetName === VOID ? this.dexfAssetName : dexfAssetName;
    return this.b3y(id, type, dexf, modelURI, desc, template, typeCode, partsInPackage, autoAdaptGroup, meta, dexfAssetName);
  };
  protoOf(DynamicProduct).toString = function () {
    return 'DynamicProduct(id=' + this.id + ', type=' + this.type + ', dexf=' + this.dexf + ', modelURI=' + this.modelURI + ', desc=' + this.desc + ', template=' + this.template + ', typeCode=' + this.typeCode + ', partsInPackage=' + this.partsInPackage + ', autoAdaptGroup=' + this.autoAdaptGroup + ', meta=' + this.meta + ', dexfAssetName=' + this.dexfAssetName + ')';
  };
  protoOf(DynamicProduct).hashCode = function () {
    var result = getStringHashCode(this.id);
    result = imul(result, 31) + (this.type == null ? 0 : getStringHashCode(this.type)) | 0;
    result = imul(result, 31) + (this.dexf == null ? 0 : getStringHashCode(this.dexf)) | 0;
    result = imul(result, 31) + (this.modelURI == null ? 0 : getStringHashCode(this.modelURI)) | 0;
    result = imul(result, 31) + getStringHashCode(this.desc) | 0;
    result = imul(result, 31) + this.template.hashCode() | 0;
    result = imul(result, 31) + (this.typeCode == null ? 0 : this.typeCode) | 0;
    result = imul(result, 31) + (this.partsInPackage == null ? 0 : this.partsInPackage) | 0;
    result = imul(result, 31) + (this.autoAdaptGroup == null ? 0 : this.autoAdaptGroup.hashCode()) | 0;
    result = imul(result, 31) + (this.meta == null ? 0 : hashCode(this.meta)) | 0;
    result = imul(result, 31) + (this.dexfAssetName == null ? 0 : getStringHashCode(this.dexfAssetName)) | 0;
    return result;
  };
  protoOf(DynamicProduct).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DynamicProduct))
      return false;
    var tmp0_other_with_cast = other instanceof DynamicProduct ? other : THROW_CCE();
    if (!(this.id === tmp0_other_with_cast.id))
      return false;
    if (!(this.type == tmp0_other_with_cast.type))
      return false;
    if (!(this.dexf == tmp0_other_with_cast.dexf))
      return false;
    if (!(this.modelURI == tmp0_other_with_cast.modelURI))
      return false;
    if (!(this.desc === tmp0_other_with_cast.desc))
      return false;
    if (!this.template.equals(tmp0_other_with_cast.template))
      return false;
    if (!(this.typeCode == tmp0_other_with_cast.typeCode))
      return false;
    if (!(this.partsInPackage == tmp0_other_with_cast.partsInPackage))
      return false;
    if (!equals(this.autoAdaptGroup, tmp0_other_with_cast.autoAdaptGroup))
      return false;
    if (!equals(this.meta, tmp0_other_with_cast.meta))
      return false;
    if (!(this.dexfAssetName == tmp0_other_with_cast.dexfAssetName))
      return false;
    return true;
  };
  function DynamicProductCatalog$Companion$jsonParser$lambda($this$Json) {
    $this$Json.f16_1 = true;
    $this$Json.e16_1 = true;
    return Unit_instance;
  }
  function getProductInfo($this, productId) {
    return $this.d3y_1.b3(productId);
  }
  function parseTemplates($this, json) {
    var templates = Companion_getInstance_7().jsonParser.j15(Companion_getInstance_10().l17(), json).templates;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = templates.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.parseTemplates.<anonymous>' call
      var tmp0_safe_receiver = element.components.bounds;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element_0 = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.parseTemplates.<anonymous>.<anonymous>' call
          element_0.sourceTemplateId = element.templateId;
        }
      }
      var tmp1_safe_receiver = element.components.connectors;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp1_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_1 = tmp1_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.parseTemplates.<anonymous>.<anonymous>' call
          element_1.sourceTemplateId = element.templateId;
        }
      }
    }
    return resolveTemplateInheritance($this, templates);
  }
  function resolveTemplateInheritance($this, templates) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var resolved = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = templates.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.resolveTemplateInheritance.<anonymous>' call
      if (resolved.b3(element.templateId) == null) {
        resolve($this, element, resolved, templates);
      }
    }
    return resolved;
  }
  function resolve($this, productTemplate, resolved, unresolved) {
    if (productTemplate.inherits == null) {
      // Inline function 'kotlin.collections.set' call
      var key = productTemplate.templateId;
      resolved.r2(key, productTemplate);
      return productTemplate;
    } else {
      var resultingTemplate = productTemplate;
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = reversedArray(productTemplate.inherits);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.resolve.<anonymous>' call
        var extended = resolved.b3(element);
        if (extended == null) {
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator = unresolved.t();
            while (tmp0_iterator.u()) {
              var element_0 = tmp0_iterator.w();
              // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.resolve.<anonymous>.<anonymous>' call
              if (element_0.templateId === element) {
                tmp$ret$1 = element_0;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw Exception_init_$Create$("Template '" + productTemplate.templateId + "' extends '" + element + "' that cannot be found");
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var unresolvedExtended = tmp;
          extended = resolve($this, unresolvedExtended, resolved, unresolved);
        }
        resultingTemplate = resultingTemplate.inherit(extended);
      }
      // Inline function 'kotlin.collections.set' call
      var key_0 = resultingTemplate.templateId;
      var value = resultingTemplate;
      resolved.r2(key_0, value);
      return resultingTemplate;
    }
  }
  function parseInfo($this, json) {
    var parsed = Companion_getInstance_7().jsonParser.j15(Companion_getInstance_9().l17(), json);
    $this.g3y_1 = parsed.range;
    $this.h3y_1 = parsed.rangeVersion;
    return parsed.products;
  }
  function parseAndAddPackage($this, json) {
    var parsed = Companion_getInstance_7().jsonParser.j15(Companion_getInstance_8().l17(), json);
    // Inline function 'kotlin.collections.map' call
    var this_0 = parsed.products;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      var product = Companion_getInstance_6().fromPackedProduct(item);
      var template = Companion_getInstance_12().fromPackedProduct(item);
      // Inline function 'kotlin.collections.set' call
      var this_1 = $this.d3y_1;
      var key = product.id;
      this_1.r2(key, product);
      var this_2 = $this.f3y_1;
      var key_0 = template.templateId;
      this_2.r2(key_0, template);
      destination.q(Unit_instance);
    }
    $this.g3y_1 = parsed.range;
    $this.h3y_1 = parsed.rangeVersion;
  }
  function Companion_1() {
    Companion_instance_6 = this;
    var tmp = this;
    tmp.jsonParser = Json(VOID, DynamicProductCatalog$Companion$jsonParser$lambda);
  }
  protoOf(Companion_1).q3y = function () {
    return this.jsonParser;
  };
  var Companion_instance_6;
  function Companion_getInstance_7() {
    if (Companion_instance_6 == null)
      new Companion_1();
    return Companion_instance_6;
  }
  function DynamicProductCatalog$generateAssemblyComponents$1($assemblyComponents) {
    this.structure = new AssemblyStructureComponent($assemblyComponents.ye_1);
    this.parts = new AssemblyPartsComponent($assemblyComponents.ze_1);
  }
  function DynamicProductCatalog(productInfoJson, templatesJson, modelRootUrl) {
    Companion_getInstance_7();
    templatesJson = templatesJson === VOID ? null : templatesJson;
    modelRootUrl = modelRootUrl === VOID ? null : modelRootUrl;
    this.c3y_1 = true;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.d3y_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.f3y_1 = LinkedHashMap_init_$Create$();
    this.g3y_1 = 'dynamic';
    this.h3y_1 = '0';
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_1.i3y_1 = LinkedHashSet_init_$Create$();
    if (!(templatesJson == null)) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_0 = this.d3y_1;
      // Inline function 'kotlin.collections.associateBy' call
      var this_1 = parseInfo(this, productInfoJson);
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination = LinkedHashMap_init_$Create$_0(capacity);
      var tmp0_iterator = this_1.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.<anonymous>' call
        var tmp$ret$3 = element.id;
        destination.r2(tmp$ret$3, element);
      }
      this_0.s2(destination);
      this.f3y_1.s2(parseTemplates(this, templatesJson));
    } else {
      parseAndAddPackage(this, productInfoJson);
    }
    this.e3y_1 = new DynamicComponentResolver(this, modelRootUrl);
  }
  protoOf(DynamicProductCatalog).a1m = function () {
    return this.c3y_1;
  };
  protoOf(DynamicProductCatalog).addInterceptor = function (interceptor) {
    this.i3y_1.q(interceptor);
  };
  protoOf(DynamicProductCatalog).removeInterceptor = function (interceptor) {
    this.i3y_1.r(interceptor);
  };
  protoOf(DynamicProductCatalog).rangeId = function () {
    return this.g3y_1;
  };
  protoOf(DynamicProductCatalog).rangeVersion = function () {
    return this.h3y_1;
  };
  protoOf(DynamicProductCatalog).beforeDeserialize = function (json, catalogVersion) {
    var res = json;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.i3y_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.beforeDeserialize.<anonymous>' call
      res = element.beforeDeserialize(res, catalogVersion);
    }
    return res;
  };
  protoOf(DynamicProductCatalog).beforeBuildingEntities = function (serializableTree, catalogVersion) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.i3y_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.beforeBuildingEntities.<anonymous>' call
      element.beforeBuildingEntities(serializableTree, catalogVersion);
    }
  };
  protoOf(DynamicProductCatalog).beforeParsingComponents = function (serializableTree, catalogVersion) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.i3y_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.beforeParsingComponents.<anonymous>' call
      element.beforeParsingComponents(serializableTree, catalogVersion);
    }
  };
  protoOf(DynamicProductCatalog).afterDeserializeComplete = function (root, catalogVersion) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.i3y_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.afterDeserializeComplete.<anonymous>' call
      element.afterDeserializeComplete(root, catalogVersion);
    }
  };
  protoOf(DynamicProductCatalog).allProductRefs = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.d3y_1.o2();
    return copyToArray(this_0);
  };
  protoOf(DynamicProductCatalog).findProductDTO = function (id) {
    return getProductInfo(this, id);
  };
  protoOf(DynamicProductCatalog).productDTOs = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.d3y_1.p2();
    return copyToArray(this_0);
  };
  protoOf(DynamicProductCatalog).findTemplateDTO = function (id) {
    return this.f3y_1.b3(id);
  };
  protoOf(DynamicProductCatalog).findTemplateDTOFromProductRef = function (productRef) {
    var product = this.findProductDTO(productRef);
    var tmp;
    if (product == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.findTemplateDTOFromProductRef.<anonymous>' call
      tmp = this.f3y_1.b3(product.template.id);
    }
    return tmp;
  };
  protoOf(DynamicProductCatalog).templateDTOs = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.f3y_1.p2();
    return copyToArray(this_0);
  };
  protoOf(DynamicProductCatalog).productSpecification = function (productRef) {
    var product = this.findProductDTO(productRef);
    var tmp;
    if (product == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.productSpecification.<anonymous>' call
      var tmp0_safe_receiver = this.e3y_1.builder(product);
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.buildSpecification();
    }
    return tmp;
  };
  protoOf(DynamicProductCatalog).setTemplate = function (templatesJson) {
    try {
      resolve(this, Companion_getInstance_7().jsonParser.j15(Companion_getInstance_12().l17(), templatesJson), this.f3y_1, emptyList());
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        // Inline function 'kotlin.error' call
        var message = toString_0(e.message);
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        throw $p;
      }
    }
  };
  protoOf(DynamicProductCatalog).setTemplateObject = function (template) {
    try {
      resolve(this, template, this.f3y_1, emptyList());
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        // Inline function 'kotlin.error' call
        var message = toString_0(e.message);
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        throw $p;
      }
    }
  };
  protoOf(DynamicProductCatalog).setMultipleTemplates = function (templatesJson) {
    try {
      var unresolved = Companion_getInstance_7().jsonParser.j15(ListSerializer(Companion_getInstance_12().l17()), templatesJson);
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = unresolved.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.setMultipleTemplates.<anonymous>' call
        resolve(this, element, this.f3y_1, unresolved);
      }
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        // Inline function 'kotlin.error' call
        var message = toString_0(e.message);
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        throw $p;
      }
    }
  };
  protoOf(DynamicProductCatalog).setProduct = function (productJson) {
    try {
      var tmp0_safe_receiver = Companion_getInstance_7().jsonParser.j15(Companion_getInstance_6().l17(), productJson);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var this_0 = this.d3y_1;
        var key = tmp0_safe_receiver.id;
        this_0.r2(key, tmp0_safe_receiver);
      }
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        // Inline function 'kotlin.error' call
        var message = toString_0(e.message);
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        throw $p;
      }
    }
  };
  protoOf(DynamicProductCatalog).setMultipleProducts = function (productsJson) {
    try {
      // Inline function 'kotlin.collections.map' call
      var this_0 = Companion_getInstance_7().jsonParser.j15(ListSerializer(Companion_getInstance_6().l17()), productsJson);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        var this_1 = this.d3y_1;
        var key = item.id;
        this_1.r2(key, item);
        destination.q(Unit_instance);
      }
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        // Inline function 'kotlin.error' call
        var message = toString_0(e.message);
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        throw $p;
      }
    }
  };
  protoOf(DynamicProductCatalog).setFromPackedProducts = function (packedJson) {
    try {
      // Inline function 'kotlin.collections.map' call
      var this_0 = Companion_getInstance_7().jsonParser.j15(ListSerializer(Companion_getInstance_11().l17()), packedJson);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        var product = Companion_getInstance_6().fromPackedProduct(item);
        var template = Companion_getInstance_12().fromPackedProduct(item);
        // Inline function 'kotlin.collections.set' call
        var this_1 = this.d3y_1;
        var key = product.id;
        this_1.r2(key, product);
        var this_2 = this.f3y_1;
        var key_0 = template.templateId;
        this_2.r2(key_0, template);
        destination.q(Unit_instance);
      }
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        // Inline function 'kotlin.error' call
        var message = toString_0(e.message);
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        throw $p;
      }
    }
  };
  protoOf(DynamicProductCatalog).hasTemplateFor = function (templateId) {
    return this.f3y_1.y2(templateId);
  };
  protoOf(DynamicProductCatalog).createCustomAssemblyWithOtherParts = function (originalProduct, parts) {
    var tmp0_elvis_lhs = this.findProductDTO(originalProduct);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var originalDynamicProduct = tmp;
    var oldParts = originalDynamicProduct.template.parts;
    var tmp_0;
    if (oldParts == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = oldParts.length;
      while (inductionVariable < last) {
        var element = oldParts[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        var tmp$ret$0;
        $l$block: {
          // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.createCustomAssembly.<anonymous>' call
          var tmp0_safe_receiver = getProductInfo(this, element.id);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.template;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.id;
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            tmp$ret$0 = null;
            break $l$block;
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var templateForOldPart = tmp_1;
          tmp$ret$0 = to(templateForOldPart, element.id);
        }
        var tmp0_safe_receiver_0 = tmp$ret$0;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.q(tmp0_safe_receiver_0);
        }
      }
      tmp_0 = destination;
    }
    var tmp2_safe_receiver = tmp_0;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toMap(tmp2_safe_receiver);
    var oldPartsTemplates = tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = parts.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = parts[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.createCustomAssembly.<anonymous>' call
        var tmp0_safe_receiver_1 = getProductInfo(this, element_0);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.template;
        var tmp2_elvis_lhs_0 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.id;
        var tmp_2;
        if (tmp2_elvis_lhs_0 == null) {
          tmp$ret$4 = null;
          break $l$block_1;
        } else {
          tmp_2 = tmp2_elvis_lhs_0;
        }
        var templateForNewPart = tmp_2;
        var tmp3_elvis_lhs_0 = oldPartsTemplates.b3(templateForNewPart);
        var tmp_3;
        if (tmp3_elvis_lhs_0 == null) {
          tmp$ret$4 = null;
          break $l$block_1;
        } else {
          tmp_3 = tmp3_elvis_lhs_0;
        }
        var oldPartWithSameTemplate = tmp_3;
        tmp$ret$4 = to(oldPartWithSameTemplate, element_0);
      }
      var tmp0_safe_receiver_2 = tmp$ret$4;
      if (tmp0_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.q(tmp0_safe_receiver_2);
      }
    }
    var replaceMap = toMap(destination_0);
    var specification = this.productSpecification(originalProduct);
    var tmp_4;
    if (specification == null) {
      tmp_4 = null;
    } else {
      Companion_getInstance();
      tmp_4 = specification._findComponentKt(43);
    }
    var partsComponent = tmp_4;
    var tmp6_safe_receiver = partsComponent == null ? null : partsComponent.i1l_1;
    var tmp_5;
    if (tmp6_safe_receiver == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$(tmp6_safe_receiver.n());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = tmp6_safe_receiver.q2().t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.createCustomAssembly.<anonymous>' call
        var newPartProductRef = replaceMap.b3(item.u2());
        var tmp_6;
        if (!(newPartProductRef == null)) {
          tmp_6 = to(item.t2(), newPartProductRef);
        } else {
          tmp_6 = to(item.t2(), item.u2());
        }
        var tmp$ret$9 = tmp_6;
        destination_1.q(tmp$ret$9);
      }
      tmp_5 = destination_1;
    }
    var tmp7_safe_receiver = tmp_5;
    var newPartsMap = tmp7_safe_receiver == null ? null : toMap(tmp7_safe_receiver);
    var tmp_7;
    if (!(newPartsMap == null)) {
      tmp_7 = specification.addComponent(new AssemblyPartsComponent(newPartsMap));
    } else {
      tmp_7 = specification;
    }
    return tmp_7;
  };
  protoOf(DynamicProductCatalog).generateAssemblyComponents = function (assemblyJson, productRef) {
    var tmp0_safe_receiver = this.findProductDTO(productRef);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.generateAssemblyComponents.<anonymous>' call
      var tmp_0;
      if (!(tmp0_safe_receiver.template.parts == null)) {
        var template = Companion_getInstance_7().jsonParser.j15(Companion_getInstance_23().l17(), assemblyJson);
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.catalog.DynamicProductCatalog.generateAssemblyComponents.<anonymous>.<anonymous>' call
        var templateChildren = template.children;
        tmp_0 = Companion_getInstance_23().mapGeneratorPartsToTemplateChildren(this, toMutableList(tmp0_safe_receiver.template.parts), templateChildren, tmp0_safe_receiver.template.size);
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$4 = [];
      tmp_1 = new Pair(tmp$ret$4, emptyMap());
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var assemblyComponents = tmp_1;
    return new DynamicProductCatalog$generateAssemblyComponents$1(assemblyComponents);
  };
  protoOf(DynamicProductCatalog).toString = function () {
    return 'Dynamic Range';
  };
  function Companion_2() {
    Companion_instance_7 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p3y_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_7()), null];
  }
  protoOf(Companion_2).l17 = function () {
    return $serializer_getInstance_4();
  };
  var Companion_instance_7;
  function Companion_getInstance_8() {
    if (Companion_instance_7 == null)
      new Companion_2();
    return Companion_instance_7;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.PackedProductData', this, 5);
    tmp0_serialDesc.cv('range', false);
    tmp0_serialDesc.cv('schemaVersion', false);
    tmp0_serialDesc.cv('rangeVersion', false);
    tmp0_serialDesc.cv('products', false);
    tmp0_serialDesc.cv('assetSource', true);
    this.v3y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ok = function () {
    return this.v3y_1;
  };
  protoOf($serializer_0).rv = function () {
    var tmp0_cached = Companion_getInstance_8().p3y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3], get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_0).qk = function (decoder) {
    var tmp0_desc = this.v3y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.nn(tmp0_desc);
    var tmp10_cached = Companion_getInstance_8().p3y_1;
    if (tmp9_input.do()) {
      tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.xn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zn(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.bo(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.xn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zn(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.bo(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.on(tmp0_desc);
    return PackedProductData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_0).w3y = function (encoder, value) {
    var tmp0_desc = this.v3y_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_8().p3y_1;
    tmp1_output.cp(tmp0_desc, 0, value.range);
    tmp1_output.cp(tmp0_desc, 1, value.schemaVersion);
    tmp1_output.cp(tmp0_desc, 2, value.rangeVersion);
    tmp1_output.ep(tmp0_desc, 3, tmp2_cached[3], value.products);
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.assetSource == null)) {
      tmp1_output.gp(tmp0_desc, 4, StringSerializer_getInstance(), value.assetSource);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_0).pk = function (encoder, value) {
    return this.w3y(encoder, value instanceof PackedProductData ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_4() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function PackedProductData_init_$Init$(seen1, range, schemaVersion, rangeVersion, products, assetSource, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_4().v3y_1);
    }
    $this.range = range;
    $this.schemaVersion = schemaVersion;
    $this.rangeVersion = rangeVersion;
    $this.products = products;
    if (0 === (seen1 & 16))
      $this.assetSource = null;
    else
      $this.assetSource = assetSource;
    return $this;
  }
  function PackedProductData_init_$Create$(seen1, range, schemaVersion, rangeVersion, products, assetSource, serializationConstructorMarker) {
    return PackedProductData_init_$Init$(seen1, range, schemaVersion, rangeVersion, products, assetSource, serializationConstructorMarker, objectCreate(protoOf(PackedProductData)));
  }
  function PackedProductData(range, schemaVersion, rangeVersion, products, assetSource) {
    Companion_getInstance_8();
    assetSource = assetSource === VOID ? null : assetSource;
    this.range = range;
    this.schemaVersion = schemaVersion;
    this.rangeVersion = rangeVersion;
    this.products = products;
    this.assetSource = assetSource;
  }
  protoOf(PackedProductData).x3y = function () {
    return this.range;
  };
  protoOf(PackedProductData).y3y = function () {
    return this.schemaVersion;
  };
  protoOf(PackedProductData).z3y = function () {
    return this.rangeVersion;
  };
  protoOf(PackedProductData).n1m = function () {
    return this.products;
  };
  protoOf(PackedProductData).a3z = function () {
    return this.assetSource;
  };
  protoOf(PackedProductData).af = function () {
    return this.range;
  };
  protoOf(PackedProductData).bf = function () {
    return this.schemaVersion;
  };
  protoOf(PackedProductData).g1k = function () {
    return this.rangeVersion;
  };
  protoOf(PackedProductData).h1k = function () {
    return this.products;
  };
  protoOf(PackedProductData).i1k = function () {
    return this.assetSource;
  };
  protoOf(PackedProductData).b3z = function (range, schemaVersion, rangeVersion, products, assetSource) {
    return new PackedProductData(range, schemaVersion, rangeVersion, products, assetSource);
  };
  protoOf(PackedProductData).copy = function (range, schemaVersion, rangeVersion, products, assetSource, $super) {
    range = range === VOID ? this.range : range;
    schemaVersion = schemaVersion === VOID ? this.schemaVersion : schemaVersion;
    rangeVersion = rangeVersion === VOID ? this.rangeVersion : rangeVersion;
    products = products === VOID ? this.products : products;
    assetSource = assetSource === VOID ? this.assetSource : assetSource;
    return this.b3z(range, schemaVersion, rangeVersion, products, assetSource);
  };
  protoOf(PackedProductData).toString = function () {
    return 'PackedProductData(range=' + this.range + ', schemaVersion=' + this.schemaVersion + ', rangeVersion=' + this.rangeVersion + ', products=' + this.products + ', assetSource=' + this.assetSource + ')';
  };
  protoOf(PackedProductData).hashCode = function () {
    var result = getStringHashCode(this.range);
    result = imul(result, 31) + getStringHashCode(this.schemaVersion) | 0;
    result = imul(result, 31) + getStringHashCode(this.rangeVersion) | 0;
    result = imul(result, 31) + hashCode(this.products) | 0;
    result = imul(result, 31) + (this.assetSource == null ? 0 : getStringHashCode(this.assetSource)) | 0;
    return result;
  };
  protoOf(PackedProductData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PackedProductData))
      return false;
    var tmp0_other_with_cast = other instanceof PackedProductData ? other : THROW_CCE();
    if (!(this.range === tmp0_other_with_cast.range))
      return false;
    if (!(this.schemaVersion === tmp0_other_with_cast.schemaVersion))
      return false;
    if (!(this.rangeVersion === tmp0_other_with_cast.rangeVersion))
      return false;
    if (!equals(this.products, tmp0_other_with_cast.products))
      return false;
    if (!(this.assetSource == tmp0_other_with_cast.assetSource))
      return false;
    return true;
  };
  function Companion_3() {
    Companion_instance_8 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o3y_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_3())];
  }
  protoOf(Companion_3).l17 = function () {
    return $serializer_getInstance_5();
  };
  var Companion_instance_8;
  function Companion_getInstance_9() {
    if (Companion_instance_8 == null)
      new Companion_3();
    return Companion_instance_8;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.DynamicProductData', this, 4);
    tmp0_serialDesc.cv('range', false);
    tmp0_serialDesc.cv('schemaVersion', false);
    tmp0_serialDesc.cv('rangeVersion', false);
    tmp0_serialDesc.cv('products', false);
    this.c3z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ok = function () {
    return this.c3z_1;
  };
  protoOf($serializer_1).rv = function () {
    var tmp0_cached = Companion_getInstance_9().o3y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3]];
  };
  protoOf($serializer_1).qk = function (decoder) {
    var tmp0_desc = this.c3z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.nn(tmp0_desc);
    var tmp9_cached = Companion_getInstance_9().o3y_1;
    if (tmp8_input.do()) {
      tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.xn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zn(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.xn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zn(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.on(tmp0_desc);
    return DynamicProductData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_1).d3z = function (encoder, value) {
    var tmp0_desc = this.c3z_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().o3y_1;
    tmp1_output.cp(tmp0_desc, 0, value.range);
    tmp1_output.cp(tmp0_desc, 1, value.schemaVersion);
    tmp1_output.cp(tmp0_desc, 2, value.rangeVersion);
    tmp1_output.ep(tmp0_desc, 3, tmp2_cached[3], value.products);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_1).pk = function (encoder, value) {
    return this.d3z(encoder, value instanceof DynamicProductData ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_5() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function DynamicProductData_init_$Init$(seen1, range, schemaVersion, rangeVersion, products, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_5().c3z_1);
    }
    $this.range = range;
    $this.schemaVersion = schemaVersion;
    $this.rangeVersion = rangeVersion;
    $this.products = products;
    return $this;
  }
  function DynamicProductData_init_$Create$(seen1, range, schemaVersion, rangeVersion, products, serializationConstructorMarker) {
    return DynamicProductData_init_$Init$(seen1, range, schemaVersion, rangeVersion, products, serializationConstructorMarker, objectCreate(protoOf(DynamicProductData)));
  }
  function DynamicProductData(range, schemaVersion, rangeVersion, products) {
    Companion_getInstance_9();
    this.range = range;
    this.schemaVersion = schemaVersion;
    this.rangeVersion = rangeVersion;
    this.products = products;
  }
  protoOf(DynamicProductData).x3y = function () {
    return this.range;
  };
  protoOf(DynamicProductData).y3y = function () {
    return this.schemaVersion;
  };
  protoOf(DynamicProductData).z3y = function () {
    return this.rangeVersion;
  };
  protoOf(DynamicProductData).n1m = function () {
    return this.products;
  };
  protoOf(DynamicProductData).af = function () {
    return this.range;
  };
  protoOf(DynamicProductData).bf = function () {
    return this.schemaVersion;
  };
  protoOf(DynamicProductData).g1k = function () {
    return this.rangeVersion;
  };
  protoOf(DynamicProductData).h1k = function () {
    return this.products;
  };
  protoOf(DynamicProductData).e3z = function (range, schemaVersion, rangeVersion, products) {
    return new DynamicProductData(range, schemaVersion, rangeVersion, products);
  };
  protoOf(DynamicProductData).copy = function (range, schemaVersion, rangeVersion, products, $super) {
    range = range === VOID ? this.range : range;
    schemaVersion = schemaVersion === VOID ? this.schemaVersion : schemaVersion;
    rangeVersion = rangeVersion === VOID ? this.rangeVersion : rangeVersion;
    products = products === VOID ? this.products : products;
    return this.e3z(range, schemaVersion, rangeVersion, products);
  };
  protoOf(DynamicProductData).toString = function () {
    return 'DynamicProductData(range=' + this.range + ', schemaVersion=' + this.schemaVersion + ', rangeVersion=' + this.rangeVersion + ', products=' + this.products + ')';
  };
  protoOf(DynamicProductData).hashCode = function () {
    var result = getStringHashCode(this.range);
    result = imul(result, 31) + getStringHashCode(this.schemaVersion) | 0;
    result = imul(result, 31) + getStringHashCode(this.rangeVersion) | 0;
    result = imul(result, 31) + hashCode(this.products) | 0;
    return result;
  };
  protoOf(DynamicProductData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DynamicProductData))
      return false;
    var tmp0_other_with_cast = other instanceof DynamicProductData ? other : THROW_CCE();
    if (!(this.range === tmp0_other_with_cast.range))
      return false;
    if (!(this.schemaVersion === tmp0_other_with_cast.schemaVersion))
      return false;
    if (!(this.rangeVersion === tmp0_other_with_cast.rangeVersion))
      return false;
    if (!equals(this.products, tmp0_other_with_cast.products))
      return false;
    return true;
  };
  function Companion_4() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j3y_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_8()), null];
  }
  protoOf(Companion_4).l17 = function () {
    return $serializer_getInstance_6();
  };
  var Companion_instance_9;
  function Companion_getInstance_10() {
    if (Companion_instance_9 == null)
      new Companion_4();
    return Companion_instance_9;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.DynamicTemplateData', this, 5);
    tmp0_serialDesc.cv('range', false);
    tmp0_serialDesc.cv('rangeVersion', false);
    tmp0_serialDesc.cv('schemaVersion', false);
    tmp0_serialDesc.cv('templates', false);
    tmp0_serialDesc.cv('assetSource', true);
    this.f3z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ok = function () {
    return this.f3z_1;
  };
  protoOf($serializer_2).rv = function () {
    var tmp0_cached = Companion_getInstance_10().j3y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3], get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_2).qk = function (decoder) {
    var tmp0_desc = this.f3z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.nn(tmp0_desc);
    var tmp10_cached = Companion_getInstance_10().j3y_1;
    if (tmp9_input.do()) {
      tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.xn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zn(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.bo(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.xn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zn(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.bo(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.on(tmp0_desc);
    return DynamicTemplateData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_2).g3z = function (encoder, value) {
    var tmp0_desc = this.f3z_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().j3y_1;
    tmp1_output.cp(tmp0_desc, 0, value.range);
    tmp1_output.cp(tmp0_desc, 1, value.rangeVersion);
    tmp1_output.cp(tmp0_desc, 2, value.schemaVersion);
    tmp1_output.ep(tmp0_desc, 3, tmp2_cached[3], value.templates);
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.assetSource == null)) {
      tmp1_output.gp(tmp0_desc, 4, StringSerializer_getInstance(), value.assetSource);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_2).pk = function (encoder, value) {
    return this.g3z(encoder, value instanceof DynamicTemplateData ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_6() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function DynamicTemplateData_init_$Init$(seen1, range, rangeVersion, schemaVersion, templates, assetSource, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_6().f3z_1);
    }
    $this.range = range;
    $this.rangeVersion = rangeVersion;
    $this.schemaVersion = schemaVersion;
    $this.templates = templates;
    if (0 === (seen1 & 16))
      $this.assetSource = null;
    else
      $this.assetSource = assetSource;
    return $this;
  }
  function DynamicTemplateData_init_$Create$(seen1, range, rangeVersion, schemaVersion, templates, assetSource, serializationConstructorMarker) {
    return DynamicTemplateData_init_$Init$(seen1, range, rangeVersion, schemaVersion, templates, assetSource, serializationConstructorMarker, objectCreate(protoOf(DynamicTemplateData)));
  }
  function DynamicTemplateData(range, rangeVersion, schemaVersion, templates, assetSource) {
    Companion_getInstance_10();
    assetSource = assetSource === VOID ? null : assetSource;
    this.range = range;
    this.rangeVersion = rangeVersion;
    this.schemaVersion = schemaVersion;
    this.templates = templates;
    this.assetSource = assetSource;
  }
  protoOf(DynamicTemplateData).x3y = function () {
    return this.range;
  };
  protoOf(DynamicTemplateData).z3y = function () {
    return this.rangeVersion;
  };
  protoOf(DynamicTemplateData).y3y = function () {
    return this.schemaVersion;
  };
  protoOf(DynamicTemplateData).h3z = function () {
    return this.templates;
  };
  protoOf(DynamicTemplateData).a3z = function () {
    return this.assetSource;
  };
  protoOf(DynamicTemplateData).af = function () {
    return this.range;
  };
  protoOf(DynamicTemplateData).bf = function () {
    return this.rangeVersion;
  };
  protoOf(DynamicTemplateData).g1k = function () {
    return this.schemaVersion;
  };
  protoOf(DynamicTemplateData).h1k = function () {
    return this.templates;
  };
  protoOf(DynamicTemplateData).i1k = function () {
    return this.assetSource;
  };
  protoOf(DynamicTemplateData).i3z = function (range, rangeVersion, schemaVersion, templates, assetSource) {
    return new DynamicTemplateData(range, rangeVersion, schemaVersion, templates, assetSource);
  };
  protoOf(DynamicTemplateData).copy = function (range, rangeVersion, schemaVersion, templates, assetSource, $super) {
    range = range === VOID ? this.range : range;
    rangeVersion = rangeVersion === VOID ? this.rangeVersion : rangeVersion;
    schemaVersion = schemaVersion === VOID ? this.schemaVersion : schemaVersion;
    templates = templates === VOID ? this.templates : templates;
    assetSource = assetSource === VOID ? this.assetSource : assetSource;
    return this.i3z(range, rangeVersion, schemaVersion, templates, assetSource);
  };
  protoOf(DynamicTemplateData).toString = function () {
    return 'DynamicTemplateData(range=' + this.range + ', rangeVersion=' + this.rangeVersion + ', schemaVersion=' + this.schemaVersion + ', templates=' + this.templates + ', assetSource=' + this.assetSource + ')';
  };
  protoOf(DynamicTemplateData).hashCode = function () {
    var result = getStringHashCode(this.range);
    result = imul(result, 31) + getStringHashCode(this.rangeVersion) | 0;
    result = imul(result, 31) + getStringHashCode(this.schemaVersion) | 0;
    result = imul(result, 31) + hashCode(this.templates) | 0;
    result = imul(result, 31) + (this.assetSource == null ? 0 : getStringHashCode(this.assetSource)) | 0;
    return result;
  };
  protoOf(DynamicTemplateData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DynamicTemplateData))
      return false;
    var tmp0_other_with_cast = other instanceof DynamicTemplateData ? other : THROW_CCE();
    if (!(this.range === tmp0_other_with_cast.range))
      return false;
    if (!(this.rangeVersion === tmp0_other_with_cast.rangeVersion))
      return false;
    if (!(this.schemaVersion === tmp0_other_with_cast.schemaVersion))
      return false;
    if (!equals(this.templates, tmp0_other_with_cast.templates))
      return false;
    if (!(this.assetSource == tmp0_other_with_cast.assetSource))
      return false;
    return true;
  };
  function Companion_5() {
    Companion_instance_10 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s3y_1 = [null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), null];
  }
  protoOf(Companion_5).l17 = function () {
    return $serializer_getInstance_7();
  };
  var Companion_instance_10;
  function Companion_getInstance_11() {
    if (Companion_instance_10 == null)
      new Companion_5();
    return Companion_instance_10;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.PackedProduct', this, 4);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('name', false);
    tmp0_serialDesc.cv('config', true);
    tmp0_serialDesc.cv('components', false);
    this.j3z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ok = function () {
    return this.j3z_1;
  };
  protoOf($serializer_3).rv = function () {
    var tmp0_cached = Companion_getInstance_11().s3y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[2]), $serializer_getInstance_16()];
  };
  protoOf($serializer_3).qk = function (decoder) {
    var tmp0_desc = this.j3z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.nn(tmp0_desc);
    var tmp9_cached = Companion_getInstance_11().s3y_1;
    if (tmp8_input.do()) {
      tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.bo(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zn(tmp0_desc, 3, $serializer_getInstance_16(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.bo(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zn(tmp0_desc, 3, $serializer_getInstance_16(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.on(tmp0_desc);
    return PackedProduct_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_3).k3z = function (encoder, value) {
    var tmp0_desc = this.j3z_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_11().s3y_1;
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.gp(tmp0_desc, 1, StringSerializer_getInstance(), value.name);
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.config == null)) {
      tmp1_output.gp(tmp0_desc, 2, tmp2_cached[2], value.config);
    }
    tmp1_output.ep(tmp0_desc, 3, $serializer_getInstance_16(), value.components);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_3).pk = function (encoder, value) {
    return this.k3z(encoder, value instanceof PackedProduct ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_7() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function PackedProduct_init_$Init$(seen1, id, name, config, components, serializationConstructorMarker, $this) {
    if (!(11 === (11 & seen1))) {
      throwMissingFieldException(seen1, 11, $serializer_getInstance_7().j3z_1);
    }
    $this.id = id;
    $this.name = name;
    if (0 === (seen1 & 4))
      $this.config = null;
    else
      $this.config = config;
    $this.components = components;
    return $this;
  }
  function PackedProduct_init_$Create$(seen1, id, name, config, components, serializationConstructorMarker) {
    return PackedProduct_init_$Init$(seen1, id, name, config, components, serializationConstructorMarker, objectCreate(protoOf(PackedProduct)));
  }
  function PackedProduct(id, name, config, components) {
    Companion_getInstance_11();
    config = config === VOID ? null : config;
    this.id = id;
    this.name = name;
    this.config = config;
    this.components = components;
  }
  protoOf(PackedProduct).s1k = function () {
    return this.id;
  };
  protoOf(PackedProduct).mb = function () {
    return this.name;
  };
  protoOf(PackedProduct).l3z = function () {
    return this.config;
  };
  protoOf(PackedProduct).j1m = function () {
    return this.components;
  };
  protoOf(PackedProduct).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof PackedProduct))
      THROW_CCE();
    if (!(this.id === other.id))
      return false;
    return true;
  };
  protoOf(PackedProduct).hashCode = function () {
    return getStringHashCode(this.id);
  };
  protoOf(PackedProduct).af = function () {
    return this.id;
  };
  protoOf(PackedProduct).bf = function () {
    return this.name;
  };
  protoOf(PackedProduct).g1k = function () {
    return this.config;
  };
  protoOf(PackedProduct).h1k = function () {
    return this.components;
  };
  protoOf(PackedProduct).m3z = function (id, name, config, components) {
    return new PackedProduct(id, name, config, components);
  };
  protoOf(PackedProduct).copy = function (id, name, config, components, $super) {
    id = id === VOID ? this.id : id;
    name = name === VOID ? this.name : name;
    config = config === VOID ? this.config : config;
    components = components === VOID ? this.components : components;
    return this.m3z(id, name, config, components);
  };
  protoOf(PackedProduct).toString = function () {
    return 'PackedProduct(id=' + this.id + ', name=' + this.name + ', config=' + this.config + ', components=' + this.components + ')';
  };
  function Companion_6() {
    Companion_instance_11 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r3y_1 = [null, null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().u7(), StringSerializer_getInstance())];
  }
  protoOf(Companion_6).fromPackedProduct = function (packed) {
    var tmp0_elvis_lhs = packed.components.product;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Space product ' + packed.id;
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var product = tmp;
    var template = new ProductTemplate(product.productGroup, product.productGroup, packed.components);
    template.components.product = null;
    return template;
  };
  protoOf(Companion_6).l17 = function () {
    return $serializer_getInstance_8();
  };
  var Companion_instance_11;
  function Companion_getInstance_12() {
    if (Companion_instance_11 == null)
      new Companion_6();
    return Companion_instance_11;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.catalog.ProductTemplate', this, 4);
    tmp0_serialDesc.cv('templateId', false);
    tmp0_serialDesc.cv('name', true);
    tmp0_serialDesc.cv('components', false);
    tmp0_serialDesc.cv('inherits', true);
    this.n3z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ok = function () {
    return this.n3z_1;
  };
  protoOf($serializer_4).rv = function () {
    var tmp0_cached = Companion_getInstance_12().r3y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), $serializer_getInstance_16(), get_nullable(tmp0_cached[3])];
  };
  protoOf($serializer_4).qk = function (decoder) {
    var tmp0_desc = this.n3z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp9_input = decoder.nn(tmp0_desc);
    var tmp10_cached = Companion_getInstance_12().r3y_1;
    if (tmp9_input.do()) {
      tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.zn(tmp0_desc, 2, $serializer_getInstance_16(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.bo(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.zn(tmp0_desc, 2, $serializer_getInstance_16(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.bo(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.on(tmp0_desc);
    return ProductTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_4).o3z = function (encoder, value) {
    var tmp0_desc = this.n3z_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_12().r3y_1;
    tmp1_output.cp(tmp0_desc, 0, value.templateId);
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.name === '')) {
      tmp1_output.gp(tmp0_desc, 1, StringSerializer_getInstance(), value.name);
    }
    tmp1_output.ep(tmp0_desc, 2, $serializer_getInstance_16(), value.components);
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.inherits == null)) {
      tmp1_output.gp(tmp0_desc, 3, tmp2_cached[3], value.inherits);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_4).pk = function (encoder, value) {
    return this.o3z(encoder, value instanceof ProductTemplate ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_8() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function ProductTemplate_init_$Init$(seen1, templateId, name, components, inherits, serializationConstructorMarker, $this) {
    if (!(5 === (5 & seen1))) {
      throwMissingFieldException(seen1, 5, $serializer_getInstance_8().n3z_1);
    }
    $this.templateId = templateId;
    if (0 === (seen1 & 2))
      $this.name = '';
    else
      $this.name = name;
    $this.components = components;
    if (0 === (seen1 & 8))
      $this.inherits = null;
    else
      $this.inherits = inherits;
    $this.o3x_1 = 0;
    return $this;
  }
  function ProductTemplate_init_$Create$(seen1, templateId, name, components, inherits, serializationConstructorMarker) {
    return ProductTemplate_init_$Init$(seen1, templateId, name, components, inherits, serializationConstructorMarker, objectCreate(protoOf(ProductTemplate)));
  }
  function ProductTemplate(templateId, name, components, inherits) {
    Companion_getInstance_12();
    name = name === VOID ? '' : name;
    inherits = inherits === VOID ? null : inherits;
    this.templateId = templateId;
    this.name = name;
    this.components = components;
    this.inherits = inherits;
    this.o3x_1 = 0;
  }
  protoOf(ProductTemplate).f2h = function () {
    return this.templateId;
  };
  protoOf(ProductTemplate).mb = function () {
    return this.name;
  };
  protoOf(ProductTemplate).j1m = function () {
    return this.components;
  };
  protoOf(ProductTemplate).p3z = function () {
    return this.inherits;
  };
  protoOf(ProductTemplate).q3z = function (templateData, overrideSize) {
    var tmp;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    var this_0 = this.components.connectors;
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    if (this_0 == null) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.collections.isEmpty' call
      tmp_0 = this_0.length === 0;
    }
    if (tmp_0) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      var tmp2_safe_receiver = this.components.connectors;
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        var tmp_2 = overrideSize == null ? templateData.size : overrideSize;
        var tmp1_elvis_lhs = templateData.family;
        tmp_1 = getConnectorsForSize(tmp2_safe_receiver, tmp_2, templateData.comSize, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs, templateData.id);
      }
      var tmp3_elvis_lhs = tmp_1;
      var tmp_3;
      if (tmp3_elvis_lhs == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_3 = [];
      } else {
        tmp_3 = tmp3_elvis_lhs;
      }
      tmp = tmp_3;
    }
    return tmp;
  };
  protoOf(ProductTemplate).getConnectors = function (templateData, overrideSize, $super) {
    overrideSize = overrideSize === VOID ? null : overrideSize;
    return this.q3z(templateData, overrideSize);
  };
  protoOf(ProductTemplate).getRelativeConnectorData = function (size) {
    var tmp0_safe_receiver = this.components.connectors;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$_0();
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.catalog.ProductTemplate.getRelativeConnectorData.<anonymous>' call
        if (element.isRelativeToBounds()) {
          destination.q(element);
        }
      }
      tmp = destination;
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(tmp1_safe_receiver, 10));
      var tmp0_iterator = tmp1_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        // Inline function 'com.ikea.range.dynamic.catalog.ProductTemplate.getRelativeConnectorData.<anonymous>' call
        var tmp$ret$3 = item.createRelativeConnectorData(size);
        destination_0.q(tmp$ret$3);
      }
      tmp_0 = destination_0;
    }
    var tmp2_safe_receiver = tmp_0;
    var tmp_1;
    if (tmp2_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_1 = copyToArray(tmp2_safe_receiver);
    }
    return tmp_1;
  };
  protoOf(ProductTemplate).inherit = function (extended) {
    var components = this.components.inherit(extended.components);
    return new ProductTemplate(this.templateId, this.name, components, null);
  };
  protoOf(ProductTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ProductTemplate))
      THROW_CCE();
    if (!(this.templateId === other.templateId))
      return false;
    if (!(this.name == other.name))
      return false;
    return true;
  };
  protoOf(ProductTemplate).hashCode = function () {
    if (this.o3x_1 === 0) {
      var tmp = this;
      var tmp_0 = imul(31, getStringHashCode(this.templateId));
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = this.name;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      tmp.o3x_1 = tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    return this.o3x_1;
  };
  protoOf(ProductTemplate).af = function () {
    return this.templateId;
  };
  protoOf(ProductTemplate).bf = function () {
    return this.name;
  };
  protoOf(ProductTemplate).g1k = function () {
    return this.components;
  };
  protoOf(ProductTemplate).h1k = function () {
    return this.inherits;
  };
  protoOf(ProductTemplate).r3z = function (templateId, name, components, inherits) {
    return new ProductTemplate(templateId, name, components, inherits);
  };
  protoOf(ProductTemplate).copy = function (templateId, name, components, inherits, $super) {
    templateId = templateId === VOID ? this.templateId : templateId;
    name = name === VOID ? this.name : name;
    components = components === VOID ? this.components : components;
    inherits = inherits === VOID ? this.inherits : inherits;
    return this.r3z(templateId, name, components, inherits);
  };
  protoOf(ProductTemplate).toString = function () {
    return 'ProductTemplate(templateId=' + this.templateId + ', name=' + this.name + ', components=' + this.components + ', inherits=' + toString(this.inherits) + ')';
  };
  function MetaDataComponent(data) {
    this.data = data;
    this.s3z_1 = this.id;
  }
  protoOf(MetaDataComponent).v3r = function () {
    return this.data;
  };
  protoOf(MetaDataComponent).x1k = function () {
    return this.s3z_1;
  };
  protoOf(MetaDataComponent).s1k = function () {
    return 40;
  };
  protoOf(MetaDataComponent).t3z = function () {
    return parseMeta(this.data);
  };
  protoOf(MetaDataComponent).eq = function (other) {
    return equals((other instanceof MetaDataComponent ? other : THROW_CCE()).data, this.data);
  };
  protoOf(MetaDataComponent).af = function () {
    return this.data;
  };
  protoOf(MetaDataComponent).u3z = function (data) {
    return new MetaDataComponent(data);
  };
  protoOf(MetaDataComponent).copy = function (data, $super) {
    data = data === VOID ? this.data : data;
    return this.u3z(data);
  };
  protoOf(MetaDataComponent).toString = function () {
    return 'MetaDataComponent(data=' + this.data + ')';
  };
  protoOf(MetaDataComponent).hashCode = function () {
    return hashCode(this.data);
  };
  protoOf(MetaDataComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MetaDataComponent))
      return false;
    var tmp0_other_with_cast = other instanceof MetaDataComponent ? other : THROW_CCE();
    if (!equals(this.data, tmp0_other_with_cast.data))
      return false;
    return true;
  };
  function Companion_7() {
    this.id = 72;
  }
  protoOf(Companion_7).s1k = function () {
    return this.id;
  };
  var Companion_instance_12;
  function Companion_getInstance_13() {
    return Companion_instance_12;
  }
  function VisualLightSourceComponent(type, intensity, colorTemperature) {
    type = type === VOID ? null : type;
    intensity = intensity === VOID ? null : intensity;
    colorTemperature = colorTemperature === VOID ? null : colorTemperature;
    this.type = type;
    this.intensity = intensity;
    this.colorTemperature = colorTemperature;
    this.v3z_1 = 72;
  }
  protoOf(VisualLightSourceComponent).a1x = function () {
    return this.type;
  };
  protoOf(VisualLightSourceComponent).w3z = function () {
    return this.intensity;
  };
  protoOf(VisualLightSourceComponent).x3z = function () {
    return this.colorTemperature;
  };
  protoOf(VisualLightSourceComponent).x1k = function () {
    return this.v3z_1;
  };
  protoOf(VisualLightSourceComponent).eq = function (other) {
    var o = other instanceof VisualLightSourceComponent ? other : THROW_CCE();
    return (this.v3z_1 === o.v3z_1 ? this.intensity == other.intensity : false) ? this.colorTemperature == o.colorTemperature : false;
  };
  function Bounds$Companion$parse$lambda($this$Json) {
    $this$Json.f16_1 = true;
    return Unit_instance;
  }
  function Companion_8() {
  }
  protoOf(Companion_8).parse = function (json) {
    var jsons = Json(VOID, Bounds$Companion$parse$lambda);
    return jsons.j15(this.l17(), json);
  };
  protoOf(Companion_8).l17 = function () {
    return $serializer_getInstance_9();
  };
  var Companion_instance_13;
  function Companion_getInstance_14() {
    return Companion_instance_13;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.productdata.Bounds', this, 3);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('pivot', false);
    tmp0_serialDesc.cv('size', false);
    this.y3z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ok = function () {
    return this.y3z_1;
  };
  protoOf($serializer_5).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance(), $serializer_getInstance_0()];
  };
  protoOf($serializer_5).qk = function (decoder) {
    var tmp0_desc = this.y3z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zn(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zn(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return Bounds_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_5).z3z = function (encoder, value) {
    var tmp0_desc = this.y3z_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance(), value.pivot);
    tmp1_output.ep(tmp0_desc, 2, $serializer_getInstance_0(), value.size);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_5).pk = function (encoder, value) {
    return this.z3z(encoder, value instanceof Bounds ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_9() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function Bounds_init_$Init$(seen1, id, pivot, size, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_9().y3z_1);
    }
    $this.id = id;
    $this.pivot = pivot;
    $this.size = size;
    return $this;
  }
  function Bounds_init_$Create$(seen1, id, pivot, size, serializationConstructorMarker) {
    return Bounds_init_$Init$(seen1, id, pivot, size, serializationConstructorMarker, objectCreate(protoOf(Bounds)));
  }
  function Bounds(id, pivot, size) {
    this.id = id;
    this.pivot = pivot;
    this.size = size;
  }
  protoOf(Bounds).s1k = function () {
    return this.id;
  };
  protoOf(Bounds).a40 = function () {
    return this.pivot;
  };
  protoOf(Bounds).n = function () {
    return this.size;
  };
  protoOf(Bounds).af = function () {
    return this.id;
  };
  protoOf(Bounds).bf = function () {
    return this.pivot;
  };
  protoOf(Bounds).g1k = function () {
    return this.size;
  };
  protoOf(Bounds).b40 = function (id, pivot, size) {
    return new Bounds(id, pivot, size);
  };
  protoOf(Bounds).copy = function (id, pivot, size, $super) {
    id = id === VOID ? this.id : id;
    pivot = pivot === VOID ? this.pivot : pivot;
    size = size === VOID ? this.size : size;
    return this.b40(id, pivot, size);
  };
  protoOf(Bounds).toString = function () {
    return 'Bounds(id=' + this.id + ', pivot=' + this.pivot + ', size=' + this.size + ')';
  };
  protoOf(Bounds).hashCode = function () {
    var result = getStringHashCode(this.id);
    result = imul(result, 31) + this.pivot.hashCode() | 0;
    result = imul(result, 31) + this.size.hashCode() | 0;
    return result;
  };
  protoOf(Bounds).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Bounds))
      return false;
    var tmp0_other_with_cast = other instanceof Bounds ? other : THROW_CCE();
    if (!(this.id === tmp0_other_with_cast.id))
      return false;
    if (!this.pivot.equals(tmp0_other_with_cast.pivot))
      return false;
    if (!this.size.equals(tmp0_other_with_cast.size))
      return false;
    return true;
  };
  function Companion_9() {
    Companion_instance_14 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c40_1 = [null, null, null, null, new ReferenceArraySerializer(getKClass(Part), $serializer_getInstance_12()), null, null, null, null, null];
  }
  protoOf(Companion_9).l17 = function () {
    return $serializer_getInstance_10();
  };
  var Companion_instance_14;
  function Companion_getInstance_15() {
    if (Companion_instance_14 == null)
      new Companion_9();
    return Companion_instance_14;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.productdata.CatalogTemplateData', this, 10);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('size', false);
    tmp0_serialDesc.cv('comSize', false);
    tmp0_serialDesc.cv('family', true);
    tmp0_serialDesc.cv('parts', true);
    tmp0_serialDesc.cv('modelInfo', true);
    tmp0_serialDesc.cv('modelTransform', true);
    tmp0_serialDesc.cv('isExterior', true);
    tmp0_serialDesc.cv('isInterior', true);
    tmp0_serialDesc.cv('variant', true);
    this.d40_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ok = function () {
    return this.d40_1;
  };
  protoOf($serializer_6).rv = function () {
    var tmp0_cached = Companion_getInstance_15().c40_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_0(), $serializer_getInstance_0(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[4]), get_nullable($serializer_getInstance_11()), get_nullable($serializer_getInstance_1()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_6).qk = function (decoder) {
    var tmp0_desc = this.d40_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_local8 = false;
    var tmp13_local9 = null;
    var tmp14_input = decoder.nn(tmp0_desc);
    var tmp15_cached = Companion_getInstance_15().c40_1;
    if (tmp14_input.do()) {
      tmp4_local0 = tmp14_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.zn(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.zn(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.bo(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.bo(tmp0_desc, 4, tmp15_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.bo(tmp0_desc, 5, $serializer_getInstance_11(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.bo(tmp0_desc, 6, $serializer_getInstance_1(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.pn(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.pn(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.bo(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.zn(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.zn(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.bo(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.bo(tmp0_desc, 4, tmp15_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.bo(tmp0_desc, 5, $serializer_getInstance_11(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.bo(tmp0_desc, 6, $serializer_getInstance_1(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.pn(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.pn(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.bo(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.on(tmp0_desc);
    return CatalogTemplateData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_6).e40 = function (encoder, value) {
    var tmp0_desc = this.d40_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_15().c40_1;
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance_0(), value.size);
    tmp1_output.ep(tmp0_desc, 2, $serializer_getInstance_0(), value.comSize);
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.family === '')) {
      tmp1_output.gp(tmp0_desc, 3, StringSerializer_getInstance(), value.family);
    }
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.parts == null)) {
      tmp1_output.gp(tmp0_desc, 4, tmp2_cached[4], value.parts);
    }
    if (tmp1_output.kp(tmp0_desc, 5) ? true : !(value.modelInfo == null)) {
      tmp1_output.gp(tmp0_desc, 5, $serializer_getInstance_11(), value.modelInfo);
    }
    if (tmp1_output.kp(tmp0_desc, 6) ? true : !(value.modelTransform == null)) {
      tmp1_output.gp(tmp0_desc, 6, $serializer_getInstance_1(), value.modelTransform);
    }
    if (tmp1_output.kp(tmp0_desc, 7) ? true : !(value.isExterior === false)) {
      tmp1_output.uo(tmp0_desc, 7, value.isExterior);
    }
    if (tmp1_output.kp(tmp0_desc, 8) ? true : !(value.isInterior === false)) {
      tmp1_output.uo(tmp0_desc, 8, value.isInterior);
    }
    if (tmp1_output.kp(tmp0_desc, 9) ? true : !(value.variant == null)) {
      tmp1_output.gp(tmp0_desc, 9, StringSerializer_getInstance(), value.variant);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_6).pk = function (encoder, value) {
    return this.e40(encoder, value instanceof CatalogTemplateData ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_10() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function CatalogTemplateData_init_$Init$(seen1, id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_10().d40_1);
    }
    $this.id = id;
    $this.size = size;
    $this.comSize = comSize;
    if (0 === (seen1 & 8))
      $this.family = '';
    else
      $this.family = family;
    if (0 === (seen1 & 16))
      $this.parts = null;
    else
      $this.parts = parts;
    if (0 === (seen1 & 32))
      $this.modelInfo = null;
    else
      $this.modelInfo = modelInfo;
    if (0 === (seen1 & 64))
      $this.modelTransform = null;
    else
      $this.modelTransform = modelTransform;
    if (0 === (seen1 & 128))
      $this.isExterior = false;
    else
      $this.isExterior = isExterior;
    if (0 === (seen1 & 256))
      $this.isInterior = false;
    else
      $this.isInterior = isInterior;
    if (0 === (seen1 & 512))
      $this.variant = null;
    else
      $this.variant = variant;
    return $this;
  }
  function CatalogTemplateData_init_$Create$(seen1, id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant, serializationConstructorMarker) {
    return CatalogTemplateData_init_$Init$(seen1, id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant, serializationConstructorMarker, objectCreate(protoOf(CatalogTemplateData)));
  }
  function CatalogTemplateData(id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant) {
    Companion_getInstance_15();
    family = family === VOID ? '' : family;
    parts = parts === VOID ? null : parts;
    modelInfo = modelInfo === VOID ? null : modelInfo;
    modelTransform = modelTransform === VOID ? null : modelTransform;
    isExterior = isExterior === VOID ? false : isExterior;
    isInterior = isInterior === VOID ? false : isInterior;
    variant = variant === VOID ? null : variant;
    this.id = id;
    this.size = size;
    this.comSize = comSize;
    this.family = family;
    this.parts = parts;
    this.modelInfo = modelInfo;
    this.modelTransform = modelTransform;
    this.isExterior = isExterior;
    this.isInterior = isInterior;
    this.variant = variant;
  }
  protoOf(CatalogTemplateData).s1k = function () {
    return this.id;
  };
  protoOf(CatalogTemplateData).n = function () {
    return this.size;
  };
  protoOf(CatalogTemplateData).g2h = function () {
    return this.comSize;
  };
  protoOf(CatalogTemplateData).h2h = function () {
    return this.family;
  };
  protoOf(CatalogTemplateData).w1k = function () {
    return this.parts;
  };
  protoOf(CatalogTemplateData).f40 = function (_set____db54di) {
    this.modelInfo = _set____db54di;
  };
  protoOf(CatalogTemplateData).g40 = function () {
    return this.modelInfo;
  };
  protoOf(CatalogTemplateData).h40 = function () {
    return this.modelTransform;
  };
  protoOf(CatalogTemplateData).i40 = function () {
    return this.isExterior;
  };
  protoOf(CatalogTemplateData).j40 = function () {
    return this.isInterior;
  };
  protoOf(CatalogTemplateData).e1k = function () {
    return this.variant;
  };
  protoOf(CatalogTemplateData).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof CatalogTemplateData))
      THROW_CCE();
    if (!(this.id === other.id))
      return false;
    return true;
  };
  protoOf(CatalogTemplateData).hashCode = function () {
    return getStringHashCode(this.id);
  };
  protoOf(CatalogTemplateData).af = function () {
    return this.id;
  };
  protoOf(CatalogTemplateData).bf = function () {
    return this.size;
  };
  protoOf(CatalogTemplateData).g1k = function () {
    return this.comSize;
  };
  protoOf(CatalogTemplateData).h1k = function () {
    return this.family;
  };
  protoOf(CatalogTemplateData).i1k = function () {
    return this.parts;
  };
  protoOf(CatalogTemplateData).j1k = function () {
    return this.modelInfo;
  };
  protoOf(CatalogTemplateData).k1k = function () {
    return this.modelTransform;
  };
  protoOf(CatalogTemplateData).p1z = function () {
    return this.isExterior;
  };
  protoOf(CatalogTemplateData).q1z = function () {
    return this.isInterior;
  };
  protoOf(CatalogTemplateData).r1z = function () {
    return this.variant;
  };
  protoOf(CatalogTemplateData).k40 = function (id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant) {
    return new CatalogTemplateData(id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant);
  };
  protoOf(CatalogTemplateData).copy = function (id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant, $super) {
    id = id === VOID ? this.id : id;
    size = size === VOID ? this.size : size;
    comSize = comSize === VOID ? this.comSize : comSize;
    family = family === VOID ? this.family : family;
    parts = parts === VOID ? this.parts : parts;
    modelInfo = modelInfo === VOID ? this.modelInfo : modelInfo;
    modelTransform = modelTransform === VOID ? this.modelTransform : modelTransform;
    isExterior = isExterior === VOID ? this.isExterior : isExterior;
    isInterior = isInterior === VOID ? this.isInterior : isInterior;
    variant = variant === VOID ? this.variant : variant;
    return this.k40(id, size, comSize, family, parts, modelInfo, modelTransform, isExterior, isInterior, variant);
  };
  protoOf(CatalogTemplateData).toString = function () {
    return 'CatalogTemplateData(id=' + this.id + ', size=' + this.size + ', comSize=' + this.comSize + ', family=' + this.family + ', parts=' + toString(this.parts) + ', modelInfo=' + this.modelInfo + ', modelTransform=' + this.modelTransform + ', isExterior=' + this.isExterior + ', isInterior=' + this.isInterior + ', variant=' + this.variant + ')';
  };
  function Companion_10() {
  }
  protoOf(Companion_10).l17 = function () {
    return $serializer_getInstance_11();
  };
  var Companion_instance_15;
  function Companion_getInstance_16() {
    return Companion_instance_15;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.productdata.ModelRenderInfo', this, 3);
    tmp0_serialDesc.cv('modelRootUrl', false);
    tmp0_serialDesc.cv('model', false);
    tmp0_serialDesc.cv('texture', false);
    this.l40_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ok = function () {
    return this.l40_1;
  };
  protoOf($serializer_7).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_7).qk = function (decoder) {
    var tmp0_desc = this.l40_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.bo(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.bo(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return ModelRenderInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_7).m40 = function (encoder, value) {
    var tmp0_desc = this.l40_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.gp(tmp0_desc, 0, StringSerializer_getInstance(), value.modelRootUrl);
    tmp1_output.gp(tmp0_desc, 1, StringSerializer_getInstance(), value.model);
    tmp1_output.gp(tmp0_desc, 2, StringSerializer_getInstance(), value.texture);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_7).pk = function (encoder, value) {
    return this.m40(encoder, value instanceof ModelRenderInfo ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_11() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function ModelRenderInfo_init_$Init$(seen1, modelRootUrl, model, texture, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_11().l40_1);
    }
    $this.modelRootUrl = modelRootUrl;
    $this.model = model;
    $this.texture = texture;
    return $this;
  }
  function ModelRenderInfo_init_$Create$(seen1, modelRootUrl, model, texture, serializationConstructorMarker) {
    return ModelRenderInfo_init_$Init$(seen1, modelRootUrl, model, texture, serializationConstructorMarker, objectCreate(protoOf(ModelRenderInfo)));
  }
  function ModelRenderInfo(modelRootUrl, model, texture) {
    this.modelRootUrl = modelRootUrl;
    this.model = model;
    this.texture = texture;
  }
  protoOf(ModelRenderInfo).t2h = function () {
    return this.modelRootUrl;
  };
  protoOf(ModelRenderInfo).u2h = function () {
    return this.model;
  };
  protoOf(ModelRenderInfo).v2h = function () {
    return this.texture;
  };
  protoOf(ModelRenderInfo).af = function () {
    return this.modelRootUrl;
  };
  protoOf(ModelRenderInfo).bf = function () {
    return this.model;
  };
  protoOf(ModelRenderInfo).g1k = function () {
    return this.texture;
  };
  protoOf(ModelRenderInfo).x2h = function (modelRootUrl, model, texture) {
    return new ModelRenderInfo(modelRootUrl, model, texture);
  };
  protoOf(ModelRenderInfo).copy = function (modelRootUrl, model, texture, $super) {
    modelRootUrl = modelRootUrl === VOID ? this.modelRootUrl : modelRootUrl;
    model = model === VOID ? this.model : model;
    texture = texture === VOID ? this.texture : texture;
    return this.x2h(modelRootUrl, model, texture);
  };
  protoOf(ModelRenderInfo).toString = function () {
    return 'ModelRenderInfo(modelRootUrl=' + this.modelRootUrl + ', model=' + this.model + ', texture=' + this.texture + ')';
  };
  protoOf(ModelRenderInfo).hashCode = function () {
    var result = this.modelRootUrl == null ? 0 : getStringHashCode(this.modelRootUrl);
    result = imul(result, 31) + (this.model == null ? 0 : getStringHashCode(this.model)) | 0;
    result = imul(result, 31) + (this.texture == null ? 0 : getStringHashCode(this.texture)) | 0;
    return result;
  };
  protoOf(ModelRenderInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ModelRenderInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ModelRenderInfo ? other : THROW_CCE();
    if (!(this.modelRootUrl == tmp0_other_with_cast.modelRootUrl))
      return false;
    if (!(this.model == tmp0_other_with_cast.model))
      return false;
    if (!(this.texture == tmp0_other_with_cast.texture))
      return false;
    return true;
  };
  function Companion_11() {
  }
  protoOf(Companion_11).l17 = function () {
    return $serializer_getInstance_12();
  };
  var Companion_instance_16;
  function Companion_getInstance_17() {
    return Companion_instance_16;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.productdata.Part', this, 4);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('partKey', false);
    tmp0_serialDesc.cv('main', true);
    tmp0_serialDesc.cv('included', true);
    this.n40_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ok = function () {
    return this.n40_1;
  };
  protoOf($serializer_8).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  protoOf($serializer_8).qk = function (decoder) {
    var tmp0_desc = this.n40_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = false;
    var tmp8_input = decoder.nn(tmp0_desc);
    if (tmp8_input.do()) {
      tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.pn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.pn(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.pn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.pn(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.on(tmp0_desc);
    return Part_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_8).o40 = function (encoder, value) {
    var tmp0_desc = this.n40_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.cp(tmp0_desc, 1, value.partKey);
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.main === false)) {
      tmp1_output.uo(tmp0_desc, 2, value.main);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.included === false)) {
      tmp1_output.uo(tmp0_desc, 3, value.included);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_8).pk = function (encoder, value) {
    return this.o40(encoder, value instanceof Part ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_12() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function Part_init_$Init$(seen1, id, partKey, main, included, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_12().n40_1);
    }
    $this.id = id;
    $this.partKey = partKey;
    if (0 === (seen1 & 4))
      $this.main = false;
    else
      $this.main = main;
    if (0 === (seen1 & 8))
      $this.included = false;
    else
      $this.included = included;
    return $this;
  }
  function Part_init_$Create$(seen1, id, partKey, main, included, serializationConstructorMarker) {
    return Part_init_$Init$(seen1, id, partKey, main, included, serializationConstructorMarker, objectCreate(protoOf(Part)));
  }
  function Part(id, partKey, main, included) {
    main = main === VOID ? false : main;
    included = included === VOID ? false : included;
    this.id = id;
    this.partKey = partKey;
    this.main = main;
    this.included = included;
  }
  protoOf(Part).s1k = function () {
    return this.id;
  };
  protoOf(Part).z1j = function () {
    return this.partKey;
  };
  protoOf(Part).t1k = function () {
    return this.main;
  };
  protoOf(Part).p40 = function () {
    return this.included;
  };
  protoOf(Part).af = function () {
    return this.id;
  };
  protoOf(Part).bf = function () {
    return this.partKey;
  };
  protoOf(Part).g1k = function () {
    return this.main;
  };
  protoOf(Part).h1k = function () {
    return this.included;
  };
  protoOf(Part).q40 = function (id, partKey, main, included) {
    return new Part(id, partKey, main, included);
  };
  protoOf(Part).copy = function (id, partKey, main, included, $super) {
    id = id === VOID ? this.id : id;
    partKey = partKey === VOID ? this.partKey : partKey;
    main = main === VOID ? this.main : main;
    included = included === VOID ? this.included : included;
    return this.q40(id, partKey, main, included);
  };
  protoOf(Part).toString = function () {
    return 'Part(id=' + this.id + ', partKey=' + this.partKey + ', main=' + this.main + ', included=' + this.included + ')';
  };
  protoOf(Part).hashCode = function () {
    var result = getStringHashCode(this.id);
    result = imul(result, 31) + getStringHashCode(this.partKey) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.main) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.included) | 0;
    return result;
  };
  protoOf(Part).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Part))
      return false;
    var tmp0_other_with_cast = other instanceof Part ? other : THROW_CCE();
    if (!(this.id === tmp0_other_with_cast.id))
      return false;
    if (!(this.partKey === tmp0_other_with_cast.partKey))
      return false;
    if (!(this.main === tmp0_other_with_cast.main))
      return false;
    if (!(this.included === tmp0_other_with_cast.included))
      return false;
    return true;
  };
  function Companion_12() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r40_1 = [null, null, null, null, null, null, null, null, null, null, null, new ReferenceArraySerializer(getKClass(Part), $serializer_getInstance_12()), new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonElementSerializer_getInstance())];
  }
  protoOf(Companion_12).l17 = function () {
    return $serializer_getInstance_13();
  };
  var Companion_instance_17;
  function Companion_getInstance_18() {
    if (Companion_instance_17 == null)
      new Companion_12();
    return Companion_instance_17;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.productdata.ProductComponent', this, 13);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('range', false);
    tmp0_serialDesc.cv('description', true);
    tmp0_serialDesc.cv('dexfId', true);
    tmp0_serialDesc.cv('size', false);
    tmp0_serialDesc.cv('comSize', false);
    tmp0_serialDesc.cv('productGroup', false);
    tmp0_serialDesc.cv('autoAdaptGroup', true);
    tmp0_serialDesc.cv('type', true);
    tmp0_serialDesc.cv('typeCode', true);
    tmp0_serialDesc.cv('partsInPackage', true);
    tmp0_serialDesc.cv('parts', true);
    tmp0_serialDesc.cv('meta', true);
    this.s40_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).ok = function () {
    return this.s40_1;
  };
  protoOf($serializer_9).rv = function () {
    var tmp0_cached = Companion_getInstance_18().r40_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), $serializer_getInstance_0(), $serializer_getInstance_0(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(tmp0_cached[11]), get_nullable(tmp0_cached[12])];
  };
  protoOf($serializer_9).qk = function (decoder) {
    var tmp0_desc = this.s40_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_input = decoder.nn(tmp0_desc);
    var tmp18_cached = Companion_getInstance_18().r40_1;
    if (tmp17_input.do()) {
      tmp4_local0 = tmp17_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.bo(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.zn(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.zn(tmp0_desc, 5, $serializer_getInstance_0(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.xn(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.bo(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.xn(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.bo(tmp0_desc, 9, IntSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.bo(tmp0_desc, 10, IntSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.bo(tmp0_desc, 11, tmp18_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.bo(tmp0_desc, 12, tmp18_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.bo(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.zn(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.zn(tmp0_desc, 5, $serializer_getInstance_0(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.xn(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.bo(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.xn(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.bo(tmp0_desc, 9, IntSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.bo(tmp0_desc, 10, IntSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.bo(tmp0_desc, 11, tmp18_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.bo(tmp0_desc, 12, tmp18_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp17_input.on(tmp0_desc);
    return ProductComponent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  };
  protoOf($serializer_9).t40 = function (encoder, value) {
    var tmp0_desc = this.s40_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_18().r40_1;
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.cp(tmp0_desc, 1, value.range);
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.description == null)) {
      tmp1_output.gp(tmp0_desc, 2, StringSerializer_getInstance(), value.description);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.dexfId == null)) {
      tmp1_output.gp(tmp0_desc, 3, StringSerializer_getInstance(), value.dexfId);
    }
    tmp1_output.ep(tmp0_desc, 4, $serializer_getInstance_0(), value.size);
    tmp1_output.ep(tmp0_desc, 5, $serializer_getInstance_0(), value.comSize);
    tmp1_output.cp(tmp0_desc, 6, value.productGroup);
    if (tmp1_output.kp(tmp0_desc, 7) ? true : !(value.autoAdaptGroup == null)) {
      tmp1_output.gp(tmp0_desc, 7, StringSerializer_getInstance(), value.autoAdaptGroup);
    }
    if (tmp1_output.kp(tmp0_desc, 8) ? true : !(value.type === '')) {
      tmp1_output.cp(tmp0_desc, 8, value.type);
    }
    if (tmp1_output.kp(tmp0_desc, 9) ? true : !(value.typeCode == null)) {
      tmp1_output.gp(tmp0_desc, 9, IntSerializer_getInstance(), value.typeCode);
    }
    if (tmp1_output.kp(tmp0_desc, 10) ? true : !(value.partsInPackage === 1)) {
      tmp1_output.gp(tmp0_desc, 10, IntSerializer_getInstance(), value.partsInPackage);
    }
    if (tmp1_output.kp(tmp0_desc, 11) ? true : !(value.parts == null)) {
      tmp1_output.gp(tmp0_desc, 11, tmp2_cached[11], value.parts);
    }
    if (tmp1_output.kp(tmp0_desc, 12) ? true : !(value.meta == null)) {
      tmp1_output.gp(tmp0_desc, 12, tmp2_cached[12], value.meta);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_9).pk = function (encoder, value) {
    return this.t40(encoder, value instanceof ProductComponent ? value : THROW_CCE());
  };
  var $serializer_instance_9;
  function $serializer_getInstance_13() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function ProductComponent_init_$Init$(seen1, id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, meta, serializationConstructorMarker, $this) {
    if (!(115 === (115 & seen1))) {
      throwMissingFieldException(seen1, 115, $serializer_getInstance_13().s40_1);
    }
    $this.id = id;
    $this.range = range;
    if (0 === (seen1 & 4))
      $this.description = null;
    else
      $this.description = description;
    if (0 === (seen1 & 8))
      $this.dexfId = null;
    else
      $this.dexfId = dexfId;
    $this.size = size;
    $this.comSize = comSize;
    $this.productGroup = productGroup;
    if (0 === (seen1 & 128))
      $this.autoAdaptGroup = null;
    else
      $this.autoAdaptGroup = autoAdaptGroup;
    if (0 === (seen1 & 256))
      $this.type = '';
    else
      $this.type = type;
    if (0 === (seen1 & 512))
      $this.typeCode = null;
    else
      $this.typeCode = typeCode;
    if (0 === (seen1 & 1024))
      $this.partsInPackage = 1;
    else
      $this.partsInPackage = partsInPackage;
    if (0 === (seen1 & 2048))
      $this.parts = null;
    else
      $this.parts = parts;
    if (0 === (seen1 & 4096))
      $this.meta = null;
    else
      $this.meta = meta;
    return $this;
  }
  function ProductComponent_init_$Create$(seen1, id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, meta, serializationConstructorMarker) {
    return ProductComponent_init_$Init$(seen1, id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, meta, serializationConstructorMarker, objectCreate(protoOf(ProductComponent)));
  }
  function ProductComponent(id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, meta) {
    Companion_getInstance_18();
    description = description === VOID ? null : description;
    dexfId = dexfId === VOID ? null : dexfId;
    autoAdaptGroup = autoAdaptGroup === VOID ? null : autoAdaptGroup;
    type = type === VOID ? '' : type;
    typeCode = typeCode === VOID ? null : typeCode;
    partsInPackage = partsInPackage === VOID ? 1 : partsInPackage;
    parts = parts === VOID ? null : parts;
    meta = meta === VOID ? null : meta;
    this.id = id;
    this.range = range;
    this.description = description;
    this.dexfId = dexfId;
    this.size = size;
    this.comSize = comSize;
    this.productGroup = productGroup;
    this.autoAdaptGroup = autoAdaptGroup;
    this.type = type;
    this.typeCode = typeCode;
    this.partsInPackage = partsInPackage;
    this.parts = parts;
    this.meta = meta;
  }
  protoOf(ProductComponent).s1k = function () {
    return this.id;
  };
  protoOf(ProductComponent).x3y = function () {
    return this.range;
  };
  protoOf(ProductComponent).u40 = function () {
    return this.description;
  };
  protoOf(ProductComponent).v40 = function () {
    return this.dexfId;
  };
  protoOf(ProductComponent).n = function () {
    return this.size;
  };
  protoOf(ProductComponent).g2h = function () {
    return this.comSize;
  };
  protoOf(ProductComponent).w40 = function () {
    return this.productGroup;
  };
  protoOf(ProductComponent).y3x = function () {
    return this.autoAdaptGroup;
  };
  protoOf(ProductComponent).a1x = function () {
    return this.type;
  };
  protoOf(ProductComponent).w3x = function () {
    return this.typeCode;
  };
  protoOf(ProductComponent).x3x = function () {
    return this.partsInPackage;
  };
  protoOf(ProductComponent).w1k = function () {
    return this.parts;
  };
  protoOf(ProductComponent).z3x = function () {
    return this.meta;
  };
  protoOf(ProductComponent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ProductComponent))
      THROW_CCE();
    if (!(this.id === other.id))
      return false;
    return true;
  };
  protoOf(ProductComponent).hashCode = function () {
    return getStringHashCode(this.id);
  };
  protoOf(ProductComponent).af = function () {
    return this.id;
  };
  protoOf(ProductComponent).bf = function () {
    return this.range;
  };
  protoOf(ProductComponent).g1k = function () {
    return this.description;
  };
  protoOf(ProductComponent).h1k = function () {
    return this.dexfId;
  };
  protoOf(ProductComponent).i1k = function () {
    return this.size;
  };
  protoOf(ProductComponent).j1k = function () {
    return this.comSize;
  };
  protoOf(ProductComponent).k1k = function () {
    return this.productGroup;
  };
  protoOf(ProductComponent).p1z = function () {
    return this.autoAdaptGroup;
  };
  protoOf(ProductComponent).q1z = function () {
    return this.type;
  };
  protoOf(ProductComponent).r1z = function () {
    return this.typeCode;
  };
  protoOf(ProductComponent).s1z = function () {
    return this.partsInPackage;
  };
  protoOf(ProductComponent).t1z = function () {
    return this.parts;
  };
  protoOf(ProductComponent).s21 = function () {
    return this.meta;
  };
  protoOf(ProductComponent).x40 = function (id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, meta) {
    return new ProductComponent(id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, meta);
  };
  protoOf(ProductComponent).copy = function (id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, meta, $super) {
    id = id === VOID ? this.id : id;
    range = range === VOID ? this.range : range;
    description = description === VOID ? this.description : description;
    dexfId = dexfId === VOID ? this.dexfId : dexfId;
    size = size === VOID ? this.size : size;
    comSize = comSize === VOID ? this.comSize : comSize;
    productGroup = productGroup === VOID ? this.productGroup : productGroup;
    autoAdaptGroup = autoAdaptGroup === VOID ? this.autoAdaptGroup : autoAdaptGroup;
    type = type === VOID ? this.type : type;
    typeCode = typeCode === VOID ? this.typeCode : typeCode;
    partsInPackage = partsInPackage === VOID ? this.partsInPackage : partsInPackage;
    parts = parts === VOID ? this.parts : parts;
    meta = meta === VOID ? this.meta : meta;
    return this.x40(id, range, description, dexfId, size, comSize, productGroup, autoAdaptGroup, type, typeCode, partsInPackage, parts, meta);
  };
  protoOf(ProductComponent).toString = function () {
    return 'ProductComponent(id=' + this.id + ', range=' + this.range + ', description=' + this.description + ', dexfId=' + this.dexfId + ', size=' + this.size + ', comSize=' + this.comSize + ', productGroup=' + this.productGroup + ', autoAdaptGroup=' + this.autoAdaptGroup + ', type=' + this.type + ', typeCode=' + this.typeCode + ', partsInPackage=' + this.partsInPackage + ', parts=' + toString(this.parts) + ', meta=' + this.meta + ')';
  };
  function TemplateEditorConnectorData(connectorKey, style, selected, visible, active, showActivationDistance, showTransform, connector) {
    this.y40_1 = connectorKey;
    this.z40_1 = style;
    this.a41_1 = selected;
    this.b41_1 = visible;
    this.c41_1 = active;
    this.d41_1 = showActivationDistance;
    this.e41_1 = showTransform;
    this.connector = connector;
  }
  protoOf(TemplateEditorConnectorData).z21 = function () {
    return this.y40_1;
  };
  protoOf(TemplateEditorConnectorData).l3s = function () {
    return this.z40_1;
  };
  protoOf(TemplateEditorConnectorData).m3s = function () {
    return this.a41_1;
  };
  protoOf(TemplateEditorConnectorData).n3s = function () {
    return this.b41_1;
  };
  protoOf(TemplateEditorConnectorData).o3s = function () {
    return this.c41_1;
  };
  protoOf(TemplateEditorConnectorData).f41 = function (_set____db54di) {
    this.d41_1 = _set____db54di;
  };
  protoOf(TemplateEditorConnectorData).p3s = function () {
    return this.d41_1;
  };
  protoOf(TemplateEditorConnectorData).g41 = function (_set____db54di) {
    this.e41_1 = _set____db54di;
  };
  protoOf(TemplateEditorConnectorData).q3s = function () {
    return this.e41_1;
  };
  protoOf(TemplateEditorConnectorData).h41 = function (_set____db54di) {
    this.connector = _set____db54di;
  };
  protoOf(TemplateEditorConnectorData).n1k = function () {
    return this.connector;
  };
  function ProductTemplateDTO(template, dirty) {
    dirty = dirty === VOID ? false : dirty;
    this.template = template;
    this.dirty = dirty;
  }
  protoOf(ProductTemplateDTO).v3x = function () {
    return this.template;
  };
  protoOf(ProductTemplateDTO).i41 = function (_set____db54di) {
    this.dirty = _set____db54di;
  };
  protoOf(ProductTemplateDTO).j41 = function () {
    return this.dirty;
  };
  protoOf(ProductTemplateDTO).af = function () {
    return this.template;
  };
  protoOf(ProductTemplateDTO).bf = function () {
    return this.dirty;
  };
  protoOf(ProductTemplateDTO).k41 = function (template, dirty) {
    return new ProductTemplateDTO(template, dirty);
  };
  protoOf(ProductTemplateDTO).copy = function (template, dirty, $super) {
    template = template === VOID ? this.template : template;
    dirty = dirty === VOID ? this.dirty : dirty;
    return this.k41(template, dirty);
  };
  protoOf(ProductTemplateDTO).toString = function () {
    return 'ProductTemplateDTO(template=' + this.template + ', dirty=' + this.dirty + ')';
  };
  protoOf(ProductTemplateDTO).hashCode = function () {
    var result = this.template.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.dirty) | 0;
    return result;
  };
  protoOf(ProductTemplateDTO).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProductTemplateDTO))
      return false;
    var tmp0_other_with_cast = other instanceof ProductTemplateDTO ? other : THROW_CCE();
    if (!this.template.equals(tmp0_other_with_cast.template))
      return false;
    if (!(this.dirty === tmp0_other_with_cast.dirty))
      return false;
    return true;
  };
  function generateConnectorsData($this, template) {
    var tmp0_safe_receiver = template.components.connectors;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(tmp0_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.service.Companion.generateConnectorsData.<anonymous>' call
        var tmp$ret$0 = new TemplateEditorConnectorData(item.name, 'default', false, true, true, false, true, item);
        destination.q(tmp$ret$0);
      }
      tmp = destination;
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.service.Companion.generateConnectorsData.<anonymous>' call
      var tmp_2 = Companion_getInstance_19().l41_1;
      tmp_2.warn(TemplateEditorService$Companion$generateConnectorsData$lambda(template));
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    return tmp_1;
  }
  function TemplateEditorService$Companion$generateConnectorsData$lambda($template) {
    return function () {
      return "Visualization error: No connectors in template '" + $template + ".templateId'";
    };
  }
  function _get_sceneManager__lxhb6y($this) {
    return $this.coreServices.sceneManager;
  }
  function runOnFilteredSceneEntities($this, templateIds, runner) {
    // Inline function 'kotlin.sequences.forEach' call
    var tmp = get_hierarchySequence(_get_sceneManager__lxhb6y($this).root);
    var tmp0_iterator = mapNotNull(tmp, TemplateEditorService$runOnFilteredSceneEntities$lambda($this, templateIds)).t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.runOnFilteredSceneEntities.<anonymous>' call
      runner(element.template, element.templateData, element.entity);
    }
  }
  function Companion_13() {
    Companion_instance_18 = this;
    this.l41_1 = LoggerState_getInstance().m1m('TemplateEditorService');
  }
  var Companion_instance_18;
  function Companion_getInstance_19() {
    if (Companion_instance_18 == null)
      new Companion_13();
    return Companion_instance_18;
  }
  function _get_templateDataSafe__803856(_this__u8e3s4, $this) {
    var tmp;
    if (!_this__u8e3s4.isDisposed) {
      tmp = _this__u8e3s4.__getComponentForKotlin(49);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.r41_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).u1j = function (a, b) {
    return this.r41_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function sam$kotlin_Comparator$0_0(function_0) {
    this.s41_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).u1j = function (a, b) {
    return this.s41_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function sam$kotlin_Comparator$0_1(function_0) {
    this.t41_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_1).u1j = function (a, b) {
    return this.t41_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function TemplateEditorService$visualizeConnectors$lambda($it) {
    return function (entity) {
      entity.addComponent(new EntityConnectorVisualizationComponent($it));
      return Unit_instance;
    };
  }
  function TemplateEditorService$visualizeConnectors$lambda_0($templateId) {
    return function () {
      return "Visualization error: Template '" + $templateId + "' not found in catalog";
    };
  }
  function TemplateEditorService$visualizeConnectors$lambda_1(entity) {
    entity.removeComponent(77);
    return Unit_instance;
  }
  function TemplateEditorService$selectConnector$lambda($it) {
    return function (entity) {
      entity.addComponent(new EntityConnectorVisualizationComponent($it));
      return Unit_instance;
    };
  }
  function TemplateEditorService$selectConnector$lambda_0($templateId) {
    return function () {
      return "Visualization error: Template '" + $templateId + "' not found in catalog";
    };
  }
  function TemplateEditorService$openTemplate$lambda($templateId) {
    return function () {
      return "Open error: Template '" + $templateId + "' not found in catalog";
    };
  }
  function TemplateEditorService$updateConnectors$lambda$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateConnectors.<anonymous>.<anonymous>.<anonymous>' call
    var tmp = a.name;
    // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateConnectors.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$1 = b.name;
    return compareValues(tmp, tmp$ret$1);
  }
  function TemplateEditorService$updateConnectors$lambda(this$0, $group) {
    return function (template) {
      this$0.openTemplate(template.templateId, true);
      var tmp0_safe_receiver = template.components.connectors;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$_0();
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateConnectors.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var this_0 = $group.u2();
            var tmp_0;
            if (isInterface(this_0, Collection)) {
              tmp_0 = this_0.b1();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var tmp0_iterator = this_0.t();
            while (tmp0_iterator.u()) {
              var element_0 = tmp0_iterator.w();
              // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateConnectors.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              if (element.name === element_0.name) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          if (!tmp$ret$0) {
            destination.q(element);
          }
        }
        tmp = destination;
      }
      var tmp1_safe_receiver = tmp;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : plus(tmp1_safe_receiver, $group.u2());
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toMutableList_0(tmp2_safe_receiver);
      var connectors = tmp3_elvis_lhs == null ? toMutableList_0($group.u2()) : tmp3_elvis_lhs;
      var tmp_1;
      if (connectors.n() > 1) {
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_2 = TemplateEditorService$updateConnectors$lambda$lambda;
        var tmp$ret$5 = new sam$kotlin_Comparator$0(tmp_2);
        sortWith(connectors, tmp$ret$5);
        tmp_1 = Unit_instance;
      }
      var tmp_3 = template.components;
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_3.connectors = copyToArray(connectors);
      return Unit_instance;
    };
  }
  function TemplateEditorService$addConnector$lambda$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.addConnector.<anonymous>.<anonymous>.<anonymous>' call
    var tmp = a.name;
    // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.addConnector.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$1 = b.name;
    return compareValues(tmp, tmp$ret$1);
  }
  function TemplateEditorService$addConnector$lambda(this$0, $connectorItemTemplate, $data, $updateScene) {
    return function (template) {
      this$0.openTemplate(template.templateId, true);
      var tmp0_safe_receiver = template.components.connectors;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var c = toMutableList(tmp0_safe_receiver);
        c.q($connectorItemTemplate);
        // Inline function 'kotlin.collections.sortBy' call
        if (c.n() > 1) {
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp = TemplateEditorService$addConnector$lambda$lambda;
          var tmp$ret$0 = new sam$kotlin_Comparator$0_0(tmp);
          sortWith(c, tmp$ret$0);
        }
        var tmp_0 = template.components;
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp_0.connectors = copyToArray(c);
        var tmp_1;
        if (!($data == null)) {
          var tmp0_safe_receiver_0 = this$0.o41_1.b3(template.templateId);
          var tmp_2;
          if (tmp0_safe_receiver_0 == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.addConnector.<anonymous>.<anonymous>.<anonymous>' call
            var d = toMutableList(tmp0_safe_receiver_0);
            $data.connector = $connectorItemTemplate;
            tmp_2 = d.q($data);
          }
          if (tmp_2 == null) {
            // Inline function 'kotlin.run' call
            // Inline function 'kotlin.contracts.contract' call
            var $this$run = this$0;
            $data.connector = $connectorItemTemplate;
            var this_0 = $this$run.o41_1;
            var key = template.templateId;
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var value = [$data];
            this_0.r2(key, value);
          }
          var tmp_3;
          if ($updateScene) {
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$10 = [template.templateId];
            this$0.updateSceneWithConnectors(tmp$ret$10);
            tmp_3 = Unit_instance;
          }
          tmp_1 = tmp_3;
        }
      }
      return Unit_instance;
    };
  }
  function TemplateEditorService$updateConnector$lambda$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateConnector.<anonymous>.<anonymous>' call
    var tmp = a.name;
    // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateConnector.<anonymous>.<anonymous>' call
    var tmp$ret$1 = b.name;
    return compareValues(tmp, tmp$ret$1);
  }
  function TemplateEditorService$updateConnector$lambda(this$0, $connectorItemTemplate, $updateScene) {
    return function (template) {
      this$0.openTemplate(template.templateId, true);
      var tmp0_safe_receiver = template.components.connectors;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(tmp0_safe_receiver.length);
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateConnector.<anonymous>.<anonymous>' call
          var tmp_0;
          if (item.name === $connectorItemTemplate.name) {
            tmp_0 = $connectorItemTemplate;
          } else {
            tmp_0 = item;
          }
          var tmp$ret$0 = tmp_0;
          destination.q(tmp$ret$0);
        }
        tmp = destination;
      }
      var tmp1_safe_receiver = tmp;
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp_1 = copyToArray(tmp1_safe_receiver);
      }
      var tmp2_elvis_lhs = tmp_1;
      var tmp_2;
      if (tmp2_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_2 = [];
      } else {
        tmp_2 = tmp2_elvis_lhs;
      }
      var connectors = tmp_2;
      var tmp_3;
      if (connectors.length > 1) {
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_4 = TemplateEditorService$updateConnector$lambda$lambda;
        var tmp$ret$5 = new sam$kotlin_Comparator$0_1(tmp_4);
        sortWith_0(connectors, tmp$ret$5);
        tmp_3 = Unit_instance;
      }
      var tmp3_safe_receiver = this$0.o41_1.b3(template.templateId);
      var tmp_5;
      if (tmp3_safe_receiver == null) {
        tmp_5 = null;
      } else {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$7;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var inductionVariable_0 = 0;
          var last_0 = tmp3_safe_receiver.length;
          while (inductionVariable_0 < last_0) {
            var element = tmp3_safe_receiver[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateConnector.<anonymous>.<anonymous>' call
            if (element.y40_1 === $connectorItemTemplate.name) {
              tmp$ret$7 = element;
              break $l$block;
            }
          }
          tmp$ret$7 = null;
        }
        tmp_5 = tmp$ret$7;
      }
      var tmp4_safe_receiver = tmp_5;
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp4_safe_receiver.connector = $connectorItemTemplate;
      }
      template.components.connectors = connectors;
      var tmp_6;
      if ($updateScene) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$12 = [template.templateId];
        this$0.updateSceneWithConnectors(tmp$ret$12);
        tmp_6 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function TemplateEditorService$renameConnector$lambda(this$0, $connectorName, $newConnector, $newConnectorName) {
    return function (template) {
      this$0.openTemplate(template.templateId, true);
      var tmp = template.components;
      var tmp0_safe_receiver = template.components.connectors;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(tmp0_safe_receiver.length);
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.renameConnector.<anonymous>.<anonymous>' call
          var tmp_1;
          if (item.name === $connectorName) {
            $newConnector._v = new ConnectorItemTemplate(item.lastPosition, $newConnectorName, item.position, item.vertices, item.priority, item.spacing, item.activationDistance, item.tags, item.demands, item.offers, item.type, item.axis, item.angle, item.required, item.requireUpwardParent, item.requireDownwardParent, item.sourceTemplateId);
            var tmp0_elvis_lhs = $newConnector._v;
            tmp_1 = tmp0_elvis_lhs == null ? item : tmp0_elvis_lhs;
          } else {
            tmp_1 = item;
          }
          var tmp$ret$0 = tmp_1;
          destination.q(tmp$ret$0);
        }
        tmp_0 = destination;
      }
      var tmp1_safe_receiver = tmp_0;
      var tmp_2;
      if (tmp1_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp_2 = copyToArray(tmp1_safe_receiver);
      }
      tmp.connectors = tmp_2;
      return Unit_instance;
    };
  }
  function TemplateEditorService$deleteConnector$lambda(this$0, $connectorItemTemplate) {
    return function (template) {
      this$0.openTemplate(template.templateId, true);
      var tmp0_safe_receiver = template.components.connectors;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$_0();
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.deleteConnector.<anonymous>.<anonymous>' call
          if (!(element.name === $connectorItemTemplate.name)) {
            destination.q(element);
          }
        }
        tmp = destination;
      }
      var tmp1_safe_receiver = tmp;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp_0 = copyToArray(tmp1_safe_receiver);
      }
      var connectors = tmp_0;
      var tmp_1 = template.components;
      var tmp_2;
      var tmp_3;
      if (!(connectors == null)) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        // Inline function 'kotlin.collections.isEmpty' call
        tmp_3 = !(connectors.length === 0);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = connectors;
      } else {
        tmp_2 = null;
      }
      tmp_1.connectors = tmp_2;
      return Unit_instance;
    };
  }
  function TemplateEditorService$updateSceneWithBounds$lambda($entities) {
    return function (template, templateData, entity) {
      var tmp0_safe_receiver = template.components.bounds;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp0_safe_receiver_0 = getPolyhedronForSize(tmp0_safe_receiver, SizeFromVector(templateData.size));
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          entity.addComponent(new ColliderShapeComponent(tmp0_safe_receiver_0.ye_1, tmp0_safe_receiver_0.ze_1));
          $entities.q(entity);
        }
      }
      return Unit_instance;
    };
  }
  function TemplateEditorService$updateSceneWithConnectors$lambda($entities) {
    return function (template, templateData, entity) {
      var tmp0_safe_receiver = template.components.connectors;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp = SizeFromVector(templateData.size);
        var tmp_0 = SizeFromVector(templateData.comSize);
        var tmp0_elvis_lhs = templateData.family;
        var connectors = getConnectorsForSize(tmp0_safe_receiver, tmp, tmp_0, tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, template.templateId);
        entity.addComponent(new ConnectorsComponent(connectors));
        $entities.q(entity);
      }
      return Unit_instance;
    };
  }
  function TemplateEditorService$runOnFilteredSceneEntities$1$1$1$1($it, $templateData, $entity) {
    this.template = $it;
    this.templateData = $templateData;
    this.entity = $entity;
  }
  function TemplateEditorService$runOnFilteredSceneEntities$lambda(this$0, $templateIds) {
    return function (entity) {
      var tmp0_safe_receiver = _get_templateDataSafe__803856(entity, this$0);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.runOnFilteredSceneEntities.<anonymous>.<anonymous>' call
        var tmp_0;
        if (contains($templateIds, tmp0_safe_receiver.templateId)) {
          var tmp0_safe_receiver_0 = this$0.dynamicCatalog.findTemplateDTO(tmp0_safe_receiver.templateId);
          var tmp_1;
          if (tmp0_safe_receiver_0 == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.runOnFilteredSceneEntities.<anonymous>.<anonymous>.<anonymous>' call
            tmp_1 = new TemplateEditorService$runOnFilteredSceneEntities$1$1$1$1(tmp0_safe_receiver_0, tmp0_safe_receiver, entity);
          }
          tmp_0 = tmp_1;
        } else {
          tmp_0 = null;
        }
        tmp = tmp_0;
      }
      return tmp;
    };
  }
  function TemplateEditorService$runOnTemplate$lambda(this$0) {
    return function (templateId, runner) {
      var tmp0_safe_receiver = this$0.dynamicCatalog.findTemplateDTO(templateId);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.runOnTemplate.<anonymous>.<anonymous>' call
        runner(tmp0_safe_receiver);
        tmp = tmp0_safe_receiver;
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var message = 'Template ' + templateId + ' does not exist in catalog';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      return tmp_0;
    };
  }
  function TemplateEditorService$runOnEntitiesBasedOn$lambda$lambda(this$0, $templateId) {
    return function (it) {
      var tmp0_safe_receiver = _get_templateDataSafe__803856(it, this$0);
      return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.templateId) === $templateId;
    };
  }
  function TemplateEditorService$runOnEntitiesBasedOn$lambda(this$0) {
    return function (templateId, runner) {
      var tmp = get_hierarchySequence(_get_sceneManager__lxhb6y(this$0).root);
      var tmp0_iterator = filter(tmp, TemplateEditorService$runOnEntitiesBasedOn$lambda$lambda(this$0, templateId)).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.runOnEntitiesBasedOn.<anonymous>.<anonymous>' call
        runner(element);
      }
      return Unit_instance;
    };
  }
  function TemplateEditorService$initializeFromCatalog$lambda(this$0, $templateComponent) {
    return function (it) {
      var tmp0_safe_receiver = _get_templateDataSafe__803856(it, this$0);
      return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.templateId) === $templateComponent.templateId;
    };
  }
  function TemplateEditorService(coreServices, dynamicCatalog) {
    Companion_getInstance_19();
    this.coreServices = coreServices;
    this.dynamicCatalog = dynamicCatalog;
    this.m41_1 = this.coreServices.entityManager;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.n41_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.o41_1 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    tmp_1.p41_1 = TemplateEditorService$runOnTemplate$lambda(this);
    var tmp_2 = this;
    tmp_2.q41_1 = TemplateEditorService$runOnEntitiesBasedOn$lambda(this);
  }
  protoOf(TemplateEditorService).k2z = function () {
    return this.coreServices;
  };
  protoOf(TemplateEditorService).u41 = function (_set____db54di) {
    this.dynamicCatalog = _set____db54di;
  };
  protoOf(TemplateEditorService).v41 = function () {
    return this.dynamicCatalog;
  };
  protoOf(TemplateEditorService).templateDTOs = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.n41_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(this_0.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.q2().t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.templateDTOs.<anonymous>' call
      var tmp$ret$1 = item.u2();
      destination.q(tmp$ret$1);
    }
    return copyToArray(destination);
  };
  protoOf(TemplateEditorService).setCatalog = function (catalog) {
    this.dynamicCatalog = catalog;
  };
  protoOf(TemplateEditorService).hasConnectorsData = function (entity) {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = _get_templateDataSafe__803856(entity, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.hasConnectorsData.<anonymous>' call
    var it = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.templateId;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.o41_1;
    return (isInterface(this_0, Map) ? this_0 : THROW_CCE()).y2(it);
  };
  protoOf(TemplateEditorService).getConnectorsData = function (entity) {
    var tmp0_safe_receiver = _get_templateDataSafe__803856(entity, this);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.getConnectorsData.<anonymous>' call
      var tmp0_elvis_lhs = this.o41_1.b3(tmp0_safe_receiver.templateId);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.getConnectorsData.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_0 = this.dynamicCatalog.findTemplateDTO(tmp0_safe_receiver.templateId);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var this_0 = this.o41_1;
          var key = tmp0_safe_receiver.templateId;
          var value = generateConnectorsData(Companion_getInstance_19(), tmp0_safe_receiver_0);
          this_0.r2(key, value);
        }
        tmp_0 = this.o41_1.b3(tmp0_safe_receiver.templateId);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  };
  protoOf(TemplateEditorService).getConnectors = function (entity) {
    var tmp0_safe_receiver = _get_templateDataSafe__803856(entity, this);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.getConnectors.<anonymous>' call
      var tmp0_safe_receiver_0 = this.dynamicCatalog.findTemplateDTO(tmp0_safe_receiver.templateId);
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.components;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.connectors;
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_0 = [];
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  };
  protoOf(TemplateEditorService).getBounds = function (entity) {
    var tmp0_safe_receiver = _get_templateDataSafe__803856(entity, this);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.getBounds.<anonymous>' call
      var tmp0_safe_receiver_0 = this.dynamicCatalog.findTemplateDTO(tmp0_safe_receiver.templateId);
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.components;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.bounds;
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_0 = [];
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  };
  protoOf(TemplateEditorService).w41 = function (entity, show, data) {
    var tmp0_safe_receiver = _get_templateDataSafe__803856(entity, this);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.visualizeConnectors(tmp0_safe_receiver.templateId, show, data);
      var tmp0_elvis_lhs = this.o41_1.b3(tmp0_safe_receiver.templateId);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_0 = [];
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      return tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  };
  protoOf(TemplateEditorService).visualizeConnectorsOf = function (entity, show, data, $super) {
    data = data === VOID ? null : data;
    return this.w41(entity, show, data);
  };
  protoOf(TemplateEditorService).x41 = function (templateId, show, data) {
    if (!(data == null)) {
      // Inline function 'kotlin.collections.set' call
      var this_0 = this.o41_1;
      var tmp0_safe_receiver = this.o41_1.b3(templateId);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.visualizeConnectors.<anonymous>' call
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(tmp0_safe_receiver.length);
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.visualizeConnectors.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable_0 = 0;
            var last_0 = data.length;
            while (inductionVariable_0 < last_0) {
              var element = data[inductionVariable_0];
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.visualizeConnectors.<anonymous>.<anonymous>.<anonymous>' call
              if (element.y40_1 === item.y40_1) {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$1;
          var tmp$ret$3 = tmp0_elvis_lhs == null ? item : tmp0_elvis_lhs;
          destination.q(tmp$ret$3);
        }
        tmp = copyToArray(destination);
      }
      var tmp1_elvis_lhs = tmp;
      var value = tmp1_elvis_lhs == null ? data : tmp1_elvis_lhs;
      this_0.r2(templateId, value);
    } else {
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_1 = this.o41_1;
      if (!(isInterface(this_1, Map) ? this_1 : THROW_CCE()).y2(templateId)) {
        var tmp2_safe_receiver = this.dynamicCatalog.findTemplateDTO(templateId);
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var this_2 = this.o41_1;
          var value_0 = generateConnectorsData(Companion_getInstance_19(), tmp2_safe_receiver);
          this_2.r2(templateId, value_0);
        }
      }
    }
    if (show) {
      var tmp3_safe_receiver = this.o41_1.b3(templateId);
      var tmp_0;
      if (tmp3_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.q41_1(templateId, TemplateEditorService$visualizeConnectors$lambda(tmp3_safe_receiver));
        tmp_0 = Unit_instance;
      }
      if (tmp_0 == null) {
        var tmp_1 = Companion_getInstance_19().l41_1;
        tmp_1.warn(TemplateEditorService$visualizeConnectors$lambda_0(templateId));
      }
    } else {
      this.q41_1(templateId, TemplateEditorService$visualizeConnectors$lambda_1);
    }
    var tmp5_elvis_lhs = this.o41_1.b3(templateId);
    var tmp_2;
    if (tmp5_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_2 = [];
    } else {
      tmp_2 = tmp5_elvis_lhs;
    }
    return tmp_2;
  };
  protoOf(TemplateEditorService).visualizeConnectors = function (templateId, show, data, $super) {
    data = data === VOID ? null : data;
    return this.x41(templateId, show, data);
  };
  protoOf(TemplateEditorService).y41 = function (entity, key) {
    var tmp0_safe_receiver = _get_templateDataSafe__803856(entity, this);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return this.selectConnector(tmp0_safe_receiver.templateId, key, entity.hasComponent(77));
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(TemplateEditorService).selectConnectorOf = function (entity, key, $super) {
    key = key === VOID ? null : key;
    return this.y41(entity, key);
  };
  protoOf(TemplateEditorService).z41 = function (templateId, key, show) {
    var tmp0_safe_receiver = this.o41_1.b3(templateId);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var this_0 = this.o41_1;
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(tmp0_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.selectConnector.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new TemplateEditorConnectorData(item.y40_1, item.z40_1, item.y40_1 === key, item.b41_1, item.c41_1, item.d41_1, true, item.connector);
        destination.q(tmp$ret$0);
      }
      var value = copyToArray(destination);
      this_0.r2(templateId, value);
    }
    if (show) {
      var tmp1_safe_receiver = this.o41_1.b3(templateId);
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.q41_1(templateId, TemplateEditorService$selectConnector$lambda(tmp1_safe_receiver));
        tmp = Unit_instance;
      }
      if (tmp == null) {
        var tmp_0 = Companion_getInstance_19().l41_1;
        tmp_0.warn(TemplateEditorService$selectConnector$lambda_0(templateId));
      }
    }
    var tmp3_elvis_lhs = this.o41_1.b3(templateId);
    var tmp_1;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    return tmp_1;
  };
  protoOf(TemplateEditorService).selectConnector = function (templateId, key, show, $super) {
    key = key === VOID ? null : key;
    return this.z41(templateId, key, show);
  };
  protoOf(TemplateEditorService).a42 = function (templateId, isDirty) {
    if (!this.n41_1.y2(templateId)) {
      var tmp0_safe_receiver = this.dynamicCatalog.findTemplateDTO(templateId);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var clone = Companion_getInstance_7().jsonParser.j15(Companion_getInstance_12().l17(), Companion_getInstance_30().productTemplateToJson(tmp0_safe_receiver));
        var this_0 = this.n41_1;
        var value = new ProductTemplateDTO(clone, isDirty);
        this_0.r2(templateId, value);
        tmp = Unit_instance;
      }
      if (tmp == null) {
        var tmp_0 = Companion_getInstance_19().l41_1;
        tmp_0.warn(TemplateEditorService$openTemplate$lambda(templateId));
      }
    } else {
      var tmp2_safe_receiver = this.n41_1.b3(templateId);
      if (tmp2_safe_receiver != null)
        tmp2_safe_receiver.dirty = isDirty;
    }
  };
  protoOf(TemplateEditorService).openTemplate = function (templateId, isDirty, $super) {
    isDirty = isDirty === VOID ? false : isDirty;
    return this.a42(templateId, isDirty);
  };
  protoOf(TemplateEditorService).b42 = function (entity, boundsTemplate, updateScene) {
    var tmp0_safe_receiver = _get_templateDataSafe__803856(entity, this);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateBounds.<anonymous>' call
      var tmp0_safe_receiver_0 = this.dynamicCatalog.findTemplateDTO(tmp0_safe_receiver.templateId);
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateBounds.<anonymous>.<anonymous>' call
        this.openTemplate(tmp0_safe_receiver_0.templateId, true);
        tmp0_safe_receiver_0.components.bounds = boundsTemplate;
        tmp_0 = tmp0_safe_receiver_0;
      }
      tmp = tmp_0;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      var tmp1_safe_receiver = _get_templateDataSafe__803856(entity, this);
      var message = 'Template ' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.templateId) + ' does not exist in catalog';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var template = tmp_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var templateIds = [template.templateId];
    if (updateScene) {
      this.updateSceneWithBounds(templateIds);
    }
    return templateIds;
  };
  protoOf(TemplateEditorService).updateBounds = function (entity, boundsTemplate, updateScene, $super) {
    updateScene = updateScene === VOID ? true : updateScene;
    return this.b42(entity, boundsTemplate, updateScene);
  };
  protoOf(TemplateEditorService).c42 = function (connectorsTemplate, updateScene) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var this_0 = toList(connectorsTemplate);
    var destination = LinkedHashMap_init_$Create$();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateConnectors.<anonymous>' call
      var key = element.sourceTemplateId;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.b3(key);
      var tmp;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList_init_$Create$_0();
        destination.r2(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.q(element);
    }
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = destination.q2().t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateConnectors.<anonymous>' call
      var tmp_0 = element_0.t2();
      var template = this.p41_1(tmp_0, TemplateEditorService$updateConnectors$lambda(this, element_0));
      if (template == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.q(template);
      }
    }
    var templates = destination_0;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(templates, 10));
    var tmp0_iterator_1 = templates.t();
    while (tmp0_iterator_1.u()) {
      var item = tmp0_iterator_1.w();
      // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.updateConnectors.<anonymous>' call
      var tmp$ret$10 = item.templateId;
      destination_1.q(tmp$ret$10);
    }
    var templateIds = copyToArray(destination_1);
    if (updateScene) {
      this.updateSceneWithConnectors(templateIds);
    }
    return templateIds;
  };
  protoOf(TemplateEditorService).updateConnectors = function (connectorsTemplate, updateScene, $super) {
    updateScene = updateScene === VOID ? true : updateScene;
    return this.c42(connectorsTemplate, updateScene);
  };
  protoOf(TemplateEditorService).d42 = function (connectorItemTemplate, updateScene, data) {
    var tmp = connectorItemTemplate.sourceTemplateId;
    this.p41_1(tmp, TemplateEditorService$addConnector$lambda(this, connectorItemTemplate, data, updateScene));
    var tmp0_elvis_lhs = this.o41_1.b3(connectorItemTemplate.sourceTemplateId);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(TemplateEditorService).addConnector = function (connectorItemTemplate, updateScene, data, $super) {
    updateScene = updateScene === VOID ? true : updateScene;
    data = data === VOID ? null : data;
    return this.d42(connectorItemTemplate, updateScene, data);
  };
  protoOf(TemplateEditorService).e42 = function (connectorItemTemplate, updateScene) {
    var tmp = connectorItemTemplate.sourceTemplateId;
    this.p41_1(tmp, TemplateEditorService$updateConnector$lambda(this, connectorItemTemplate, updateScene));
    var tmp0_elvis_lhs = this.o41_1.b3(connectorItemTemplate.sourceTemplateId);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(TemplateEditorService).updateConnector = function (connectorItemTemplate, updateScene, $super) {
    updateScene = updateScene === VOID ? true : updateScene;
    return this.e42(connectorItemTemplate, updateScene);
  };
  protoOf(TemplateEditorService).renameConnector = function (templateId, connectorName, newConnectorName) {
    var newConnector = {_v: null};
    var template = this.p41_1(templateId, TemplateEditorService$renameConnector$lambda(this, connectorName, newConnector, newConnectorName));
    var tmp0_safe_receiver = newConnector._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.renameConnector.<anonymous>' call
      var tmp0_safe_receiver_0 = this.o41_1.b3(template.templateId);
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var inductionVariable = 0;
          var last = tmp0_safe_receiver_0.length;
          while (inductionVariable < last) {
            var element = tmp0_safe_receiver_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.renameConnector.<anonymous>.<anonymous>' call
            if (element.y40_1 === connectorName) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp = tmp$ret$1;
      }
      var tmp1_safe_receiver = tmp;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp1_safe_receiver.connector = tmp0_safe_receiver;
        tmp_0 = Unit_instance;
      }
    }
    var tmp1_elvis_lhs = this.o41_1.b3(templateId);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  };
  protoOf(TemplateEditorService).f42 = function (connectorItemTemplate, updateScene) {
    var tmp = connectorItemTemplate.sourceTemplateId;
    var template = this.p41_1(tmp, TemplateEditorService$deleteConnector$lambda(this, connectorItemTemplate));
    var tmp_0;
    if (updateScene) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [template.templateId];
      tmp_0 = this.updateSceneWithConnectors(tmp$ret$2);
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  };
  protoOf(TemplateEditorService).deleteConnector = function (connectorItemTemplate, updateScene, $super) {
    updateScene = updateScene === VOID ? true : updateScene;
    return this.f42(connectorItemTemplate, updateScene);
  };
  protoOf(TemplateEditorService).updateSceneWithBounds = function (templateIds) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var entities = ArrayList_init_$Create$_0();
    runOnFilteredSceneEntities(this, templateIds, TemplateEditorService$updateSceneWithBounds$lambda(entities));
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(entities);
  };
  protoOf(TemplateEditorService).updateSceneWithConnectors = function (templateIds) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var entities = ArrayList_init_$Create$_0();
    runOnFilteredSceneEntities(this, templateIds, TemplateEditorService$updateSceneWithConnectors$lambda(entities));
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(entities);
  };
  protoOf(TemplateEditorService).initializeFromCatalog = function (entity, initializer) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(49);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.initializeFromCatalog.<anonymous>' call
      var tmp0_safe_receiver_0 = this.dynamicCatalog.findTemplateDTO(tmp0_safe_receiver.templateId);
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0 = get_hierarchySequence(_get_sceneManager__lxhb6y(this).root);
        var tmp0_iterator = filter(tmp_0, TemplateEditorService$initializeFromCatalog$lambda(this, tmp0_safe_receiver)).t();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.w();
          // Inline function 'com.ikea.range.dynamic.service.TemplateEditorService.initializeFromCatalog.<anonymous>.<anonymous>.<anonymous>' call
          initializer(element, tmp0_safe_receiver_0);
        }
        tmp = Unit_instance;
      }
    }
  };
  function assemblyComponents($this) {
    var tmp0_safe_receiver = $this.h42_1.parts;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toMutableList(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicAssembly.assemblyComponents.<anonymous>' call
      var tmp0_safe_receiver_0 = $this.i42_1.components.assembly;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.children;
      var tmp_0;
      if (tmp1_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.shape.DynamicAssembly.assemblyComponents.<anonymous>.<anonymous>' call
        tmp_0 = Companion_getInstance_23().mapGeneratorPartsToTemplateChildren($this.j42_1, tmp1_safe_receiver, tmp1_safe_receiver_0, $this.h42_1.size);
      }
      tmp = tmp_0;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$4 = [];
      tmp_1 = new Pair(tmp$ret$4, emptyMap());
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var tmp3_container = tmp_1;
    var assemblyParts = tmp3_container.af();
    var partsMap = tmp3_container.bf();
    return listOf([new AssemblyStructureComponent(assemblyParts), new AssemblyPartsComponent(partsMap)]);
  }
  function DynamicAssembly(product, templateData, template, catalog) {
    DynamicComponentBuilder.call(this);
    this.g42_1 = product;
    this.h42_1 = templateData;
    this.i42_1 = template;
    this.j42_1 = catalog;
    var tmp = this;
    var tmp0_elvis_lhs = this.h42_1.family;
    tmp.k42_1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp0_elvis_lhs_0 = this.i42_1.name;
    tmp_0.l42_1 = tmp0_elvis_lhs_0 == null ? this.i42_1.templateId : tmp0_elvis_lhs_0;
    this.m42_1 = null;
  }
  protoOf(DynamicAssembly).n42 = function () {
    return this.g42_1;
  };
  protoOf(DynamicAssembly).o42 = function () {
    return this.h42_1;
  };
  protoOf(DynamicAssembly).v3x = function () {
    return this.i42_1;
  };
  protoOf(DynamicAssembly).m3x = function () {
    return this.j42_1;
  };
  protoOf(DynamicAssembly).h2h = function () {
    return this.k42_1;
  };
  protoOf(DynamicAssembly).p42 = function (_set____db54di) {
    this.l42_1 = _set____db54di;
  };
  protoOf(DynamicAssembly).mb = function () {
    return this.l42_1;
  };
  protoOf(DynamicAssembly).g40 = function () {
    return this.m42_1;
  };
  protoOf(DynamicAssembly).boundIds = function () {
    return null;
  };
  protoOf(DynamicAssembly).colliders = function () {
    return null;
  };
  protoOf(DynamicAssembly).functionalZones = function () {
    return null;
  };
  protoOf(DynamicAssembly).connections = function () {
    return this.i42_1.getConnectors(this.h42_1);
  };
  protoOf(DynamicAssembly).buildSpecification = function () {
    var components = plus_0(assemblyComponents(this), this.componentsFromTemplate());
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(components);
    return new ProductSpecification(tmp$ret$0);
  };
  function createModelInfoComponent($this, modelInfo) {
    return new ModelInfoComponent(modelInfo.modelRootUrl, modelInfo.model, '');
  }
  function overrideComponent($this, keep, component, productSpecification) {
    var tmp;
    if (keep ? !productSpecification.hasComponent(component.typeId) : false) {
      tmp = productSpecification.addComponent(component);
    } else if (!keep ? productSpecification.hasComponent(component.typeId) : false) {
      tmp = productSpecification.removeComponent(component.typeId);
    } else {
      tmp = productSpecification;
    }
    return tmp;
  }
  function descriptiveName($this) {
    if ((!($this.templateData.comSize.s2e_1 === 0.0) ? true : !($this.templateData.comSize.t2e_1 === 0.0)) ? true : !($this.templateData.comSize.u2e_1 === 0.0))
      return $this.product.id + ' ' + $this.templateData.comSize.s2e_1 + 'x' + $this.templateData.comSize.t2e_1 + 'x' + $this.templateData.comSize.u2e_1;
    return $this.family + ' ' + $this.name;
  }
  function relativeConnectors($this, size) {
    var relativeConnectors = $this.template.getRelativeConnectorData(size);
    var tmp;
    if (!(relativeConnectors == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      tmp = !(relativeConnectors.length === 0);
    } else {
      tmp = false;
    }
    if (tmp) {
      return new RelativeConnectorsComponent(relativeConnectors);
    }
    return null;
  }
  function Companion_14() {
  }
  protoOf(Companion_14).overrideComponentsFromTemplate = function (productSpecification, componentsTemplate) {
    var tmp0_elvis_lhs = componentsTemplate.selectable;
    var tmp = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
    var tmp_0 = new SelectableComponent();
    var tmp1_elvis_lhs = componentsTemplate.draggable;
    return overrideComponent(this, tmp, tmp_0, overrideComponent(this, tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs, new DraggableComponent(), productSpecification));
  };
  protoOf(Companion_14).removeTemplateComponents = function (productSpecification) {
    // Inline function 'kotlin.collections.filterNot' call
    // Inline function 'kotlin.collections.filterNotTo' call
    var this_0 = productSpecification.components;
    var destination = ArrayList_init_$Create$_0();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.shape.Companion.removeTemplateComponents.<anonymous>' call
      var tmp;
      var tmp_0;
      if (element instanceof DraggableComponent) {
        tmp_0 = true;
      } else {
        tmp_0 = element instanceof SelectableComponent;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        tmp = element instanceof ConnectionRootComponent;
      }
      if (!tmp) {
        destination.q(element);
      }
    }
    var filteredComponents = destination;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3 = copyToArray(filteredComponents);
    return new ProductSpecification(tmp$ret$3);
  };
  var Companion_instance_19;
  function Companion_getInstance_20() {
    return Companion_instance_19;
  }
  function sam$kotlin_Comparator$0_2(function_0) {
    this.q42_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_2).u1j = function (a, b) {
    return this.q42_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_2).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function DynamicComponentBuilder$componentsFromTemplate$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
    var tmp0_safe_receiver = b.autoAdaptGroup;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.priority;
    // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
    var tmp0_safe_receiver_0 = a.autoAdaptGroup;
    var tmp$ret$1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.priority;
    return compareValues(tmp, tmp$ret$1);
  }
  function DynamicComponentBuilder() {
  }
  protoOf(DynamicComponentBuilder).componentsFromTemplate = function () {
    // Inline function 'kotlin.collections.mutableListOf' call
    var components = ArrayList_init_$Create$_0();
    components.q(new DisplayNameComponent(descriptiveName(this)));
    components.q(new ConnectionRootComponent());
    components.q(new TemplateDataComponent(this.templateData.id, new Vector(this.templateData.size.s2e_1, this.templateData.size.t2e_1, this.templateData.size.u2e_1), new Vector(this.templateData.comSize.s2e_1, this.templateData.comSize.t2e_1, this.templateData.comSize.u2e_1), this.templateData.family, this.templateData.variant));
    if (this.template.components.draggable === true) {
      components.q(new DraggableComponent());
    }
    if (this.template.components.alwaysHangDown === true) {
      components.q(AlwaysHangDownComponent_instance);
    }
    if (this.template.components.serializeEntity === false) {
      components.q(new UnserializableEntityComponent());
    }
    if (this.template.components.selectable === true) {
      components.q(new SelectableComponent());
    }
    if (this.template.components.outlineable === true) {
      components.q(new OutlineableComponent());
    }
    var tmp0_safe_receiver = this.connections();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      components.q(new ConnectorsComponent(tmp0_safe_receiver));
    }
    var tmp1_safe_receiver = this.colliders();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      components.q(new ColliderShapeComponent(tmp1_safe_receiver.ye_1, tmp1_safe_receiver.ze_1));
      tmp = tmp1_safe_receiver.ye_1;
    }
    var collider = tmp;
    var tmp2_safe_receiver = this.template.components.recommendedInitialPositionFromFloor;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      components.q(new RecommendedInitialPositionFromFloorComponent(tmp2_safe_receiver));
    }
    var tmp3_safe_receiver = this.template.components.functionalMargin;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      components.q(new FunctionalMarginShapeComponent(tmp3_safe_receiver.toMargin()));
    }
    var tmp4_safe_receiver = this.functionalZones();
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      components.q(new FunctionalZonesLocalComponent(tmp4_safe_receiver));
    }
    var tmp5_safe_receiver = this.template.components.placementZoneByHeight;
    if (tmp5_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      components.q(new PlacementZoneByHeightComponent(tmp5_safe_receiver.minY, tmp5_safe_receiver.maxY));
    }
    var tmp6_safe_receiver = relativeConnectors(this, this.templateData.size);
    if (tmp6_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      components.q(tmp6_safe_receiver);
    }
    var tmp7_safe_receiver = this.template.components.autoAdaptHost;
    if (tmp7_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      var tmp0_safe_receiver_0 = tmp7_safe_receiver.hostZone;
      var tmp2_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.getPolyhedronForSize(this.templateData.size);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp1_safe_receiver_0 = this.colliders();
        tmp_0 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.ye_1;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      var hostZone = tmp_0;
      var tmp_1;
      if (hostZone == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
        components.q(new AutoAdaptHostComponent(hostZone));
        tmp_1 = hostZone;
      }
    }
    var tmp8_safe_receiver = this.modelInfo;
    if (tmp8_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      var tmp0_safe_receiver_1 = tmp8_safe_receiver.model;
      var tmp_2;
      if (tmp0_safe_receiver_1 == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.text.isNotBlank' call
        tmp_2 = !isBlank(tmp0_safe_receiver_1);
      }
      if (tmp_2 === true) {
        components.q(createModelInfoComponent(Companion_instance_19, tmp8_safe_receiver));
      }
      var tmp1_safe_receiver_1 = this.templateData.modelTransform;
      var tmp_3;
      if (tmp1_safe_receiver_1 == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
        tmp_3 = components.q(new ModelTransformComponent(tmp1_safe_receiver_1));
      }
    }
    var tmp9_safe_receiver = this.template.components.allowedDoorPairs;
    if (tmp9_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp9_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp9_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_2 = element.length === 2 ? element[0] === 0 ? new Pair(element[1], null) : element[1] === 0 ? new Pair(element[0], null) : new Pair(element[0], element[1]) : null;
        if (tmp0_safe_receiver_2 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.q(tmp0_safe_receiver_2);
        }
      }
      var doorPairs = destination;
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$27 = copyToArray(doorPairs);
      components.q(new AllowedDoorPairsComponent(tmp$ret$27));
    }
    var tmp10_safe_receiver = this.product.autoAdaptGroup;
    if (tmp10_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.sortedByDescending' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this.catalog.productDTOs();
      var destination_0 = ArrayList_init_$Create$_0();
      var inductionVariable_0 = 0;
      var last_0 = this_0.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = this_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_3 = element_0.autoAdaptGroup;
        if ((tmp0_safe_receiver_3 == null ? null : tmp0_safe_receiver_3.key) === tmp10_safe_receiver.key) {
          destination_0.q(element_0);
        }
      }
      // Inline function 'kotlin.comparisons.compareByDescending' call
      var tmp_4 = DynamicComponentBuilder$componentsFromTemplate$lambda;
      var tmp$ret$32 = new sam$kotlin_Comparator$0_2(tmp_4);
      var this_1 = sortedWith(destination_0, tmp$ret$32);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
        var tmp$ret$34 = item.id;
        destination_1.q(tmp$ret$34);
      }
      var variants = copyToArray(destination_1);
      components.q(new AutoAdaptGuestComponent(variants, tmp10_safe_receiver.key));
    }
    var tmp11_safe_receiver = this.template.components.communicationSize;
    var tmp_5;
    if (tmp11_safe_receiver == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      components.q(new CommunicationSizeComponent(tmp11_safe_receiver));
      tmp_5 = tmp11_safe_receiver;
    }
    if (tmp_5 == null)
      components.q(new CommunicationSizeComponent(this.templateData.comSize));
    if (this.template.components.leg === true) {
      components.q(LegComponent_getInstance());
    }
    if (this.template.components.frame === true) {
      components.q(FrameComponent_getInstance());
    }
    if (this.template.components.door === true) {
      components.q(DoorComponent_getInstance());
    }
    if (this.template.components.doorFront === true) {
      components.q(DoorFrontComponent_getInstance());
    }
    if (this.template.components.handle === true) {
      components.q(HandleComponent_getInstance());
    }
    if (this.template.components.drawer === true) {
      components.q(DrawerComponent_getInstance());
    }
    var tmp13_safe_receiver = this.template.components.light;
    if (tmp13_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      components.q(new LightComponent(tmp13_safe_receiver.type));
    }
    var tmp14_safe_receiver = this.template.components.visualLightSource;
    if (tmp14_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      components.q(new VisualLightSourceComponent(tmp14_safe_receiver.type, tmp14_safe_receiver.intensity, tmp14_safe_receiver.colorTemperature));
    }
    var tmp16_elvis_lhs = this.template.components.meta;
    var tmp_6 = tmp16_elvis_lhs == null ? emptyMap() : tmp16_elvis_lhs;
    var tmp15_elvis_lhs = this.product.meta;
    var mergedMeta = plus_1(tmp_6, tmp15_elvis_lhs == null ? emptyMap() : tmp15_elvis_lhs);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!mergedMeta.b1()) {
      components.q(new MetaDataComponent(mergedMeta));
    }
    var tmp17_elvis_lhs = this.template.components.propping;
    if (tmp17_elvis_lhs == null ? false : tmp17_elvis_lhs) {
      components.q(ProppingComponent_instance);
    }
    var tmp18_safe_receiver = this.template.components.dragSurfaces;
    if (tmp18_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      var dragSurfaces = tmp18_safe_receiver.generateDragSurface(this.templateData.size, collider);
      var tmp_7;
      if (dragSurfaces == null) {
        tmp_7 = null;
      } else {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
        components.q(new DragSurfacesComponent(dragSurfaces, false));
        tmp_7 = dragSurfaces;
      }
    }
    var tmp19_safe_receiver = this.template.components.dragProjectionPoint;
    if (tmp19_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      var point = tmp19_safe_receiver.applyToBox(Companion_getInstance_0().fromSize(this.templateData.size.vector)).position;
      components.q(new DragProjectionPointComponent(point));
    }
    var tmp20_safe_receiver = this.template.components.productStructure;
    if (tmp20_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>' call
      var sizeAABB = Companion_getInstance_0().fromSize(this.templateData.size.vector);
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_2 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = 0;
      var last_1 = tmp20_safe_receiver.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = tmp20_safe_receiver[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        var tmp$ret$54;
        $l$block_0: {
          // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>' call
          var tmp0_safe_receiver_4 = this.product.template.parts;
          var tmp_8;
          if (tmp0_safe_receiver_4 == null) {
            tmp_8 = null;
          } else {
            // Inline function 'kotlin.collections.find' call
            var tmp$ret$52;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var inductionVariable_2 = 0;
              var last_2 = tmp0_safe_receiver_4.length;
              while (inductionVariable_2 < last_2) {
                var element_2 = tmp0_safe_receiver_4[inductionVariable_2];
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>.<anonymous>' call
                if (element_2.partKey === element_1.partKey) {
                  tmp$ret$52 = element_2;
                  break $l$block;
                }
              }
              tmp$ret$52 = null;
            }
            tmp_8 = tmp$ret$52;
          }
          var tmp1_safe_receiver_2 = tmp_8;
          var tmp2_elvis_lhs_0 = tmp1_safe_receiver_2 == null ? null : tmp1_safe_receiver_2.id;
          var tmp_9;
          if (tmp2_elvis_lhs_0 == null) {
            tmp$ret$54 = null;
            break $l$block_0;
          } else {
            tmp_9 = tmp2_elvis_lhs_0;
          }
          var productRef = tmp_9;
          var tmp3_safe_receiver_0 = element_1.snap;
          var tmp_10;
          if (tmp3_safe_receiver_0 == null) {
            tmp_10 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'com.ikea.range.dynamic.shape.DynamicComponentBuilder.componentsFromTemplate.<anonymous>.<anonymous>.<anonymous>' call
            tmp_10 = new ProductStructureConnection(tmp3_safe_receiver_0.offeringPartKey, tmp3_safe_receiver_0.demandingConnector, tmp3_safe_receiver_0.offeringConnector);
          }
          tmp$ret$54 = new ProductStructureItem(element_1.partKey, productRef, tmp_10, element_1.transform.applyToBox(sizeAABB));
        }
        var tmp0_safe_receiver_5 = tmp$ret$54;
        if (tmp0_safe_receiver_5 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_2.q(tmp0_safe_receiver_5);
        }
      }
      var tmp$ret$60 = copyToArray(destination_2);
      components.q(new ProductStructureComponent(tmp$ret$60));
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(components);
  };
  function DynamicProductSpecifier() {
  }
  function Companion_15() {
    this.TYPENAME_IDENTIFIER = 'DynamicShape';
  }
  protoOf(Companion_15).r42 = function () {
    return this.TYPENAME_IDENTIFIER;
  };
  var Companion_instance_20;
  function Companion_getInstance_21() {
    return Companion_instance_20;
  }
  function DynamicShape(product, templateData, modelInfo, template, catalog) {
    DynamicComponentBuilder.call(this);
    this.s42_1 = product;
    this.t42_1 = templateData;
    this.u42_1 = modelInfo;
    this.v42_1 = template;
    this.w42_1 = catalog;
    var tmp = this;
    var tmp0_elvis_lhs = this.t42_1.family;
    tmp.x42_1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp0_elvis_lhs_0 = this.v42_1.name;
    tmp_0.y42_1 = tmp0_elvis_lhs_0 == null ? this.v42_1.templateId : tmp0_elvis_lhs_0;
  }
  protoOf(DynamicShape).n42 = function () {
    return this.s42_1;
  };
  protoOf(DynamicShape).o42 = function () {
    return this.t42_1;
  };
  protoOf(DynamicShape).g40 = function () {
    return this.u42_1;
  };
  protoOf(DynamicShape).v3x = function () {
    return this.v42_1;
  };
  protoOf(DynamicShape).m3x = function () {
    return this.w42_1;
  };
  protoOf(DynamicShape).h2h = function () {
    return this.x42_1;
  };
  protoOf(DynamicShape).p42 = function (_set____db54di) {
    this.y42_1 = _set____db54di;
  };
  protoOf(DynamicShape).mb = function () {
    return this.y42_1;
  };
  protoOf(DynamicShape).boundIds = function () {
    var tmp0_safe_receiver = this.v42_1.components.bounds;
    return tmp0_safe_receiver == null ? null : getBoundIds(tmp0_safe_receiver);
  };
  protoOf(DynamicShape).colliders = function () {
    var tmp0_safe_receiver = this.v42_1.components.bounds;
    return tmp0_safe_receiver == null ? null : getPolyhedronForSize(tmp0_safe_receiver, this.t42_1.size);
  };
  protoOf(DynamicShape).functionalZones = function () {
    var tmp0_safe_receiver = this.v42_1.components.functionalZones;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(tmp0_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.shape.DynamicShape.functionalZones.<anonymous>' call
        var tmp$ret$0 = new FunctionalZone(item.id, item.layer, item.getPolyhedronForSize(this.t42_1.size));
        destination.q(tmp$ret$0);
      }
      tmp = destination;
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp1_safe_receiver);
    }
    return tmp_0;
  };
  protoOf(DynamicShape).connections = function () {
    return this.v42_1.getConnectors(this.t42_1);
  };
  protoOf(DynamicShape).buildSpecification = function () {
    return new ProductSpecification(this.componentsFromTemplate());
  };
  protoOf(DynamicShape).af = function () {
    return this.s42_1;
  };
  protoOf(DynamicShape).bf = function () {
    return this.t42_1;
  };
  protoOf(DynamicShape).g1k = function () {
    return this.u42_1;
  };
  protoOf(DynamicShape).h1k = function () {
    return this.v42_1;
  };
  protoOf(DynamicShape).i1k = function () {
    return this.w42_1;
  };
  protoOf(DynamicShape).z42 = function (product, templateData, modelInfo, template, catalog) {
    return new DynamicShape(product, templateData, modelInfo, template, catalog);
  };
  protoOf(DynamicShape).copy = function (product, templateData, modelInfo, template, catalog, $super) {
    product = product === VOID ? this.s42_1 : product;
    templateData = templateData === VOID ? this.t42_1 : templateData;
    modelInfo = modelInfo === VOID ? this.u42_1 : modelInfo;
    template = template === VOID ? this.v42_1 : template;
    catalog = catalog === VOID ? this.w42_1 : catalog;
    return this.z42(product, templateData, modelInfo, template, catalog);
  };
  protoOf(DynamicShape).toString = function () {
    return 'DynamicShape(product=' + this.s42_1 + ', templateData=' + this.t42_1 + ', modelInfo=' + this.u42_1 + ', template=' + this.v42_1 + ', catalog=' + this.w42_1 + ')';
  };
  protoOf(DynamicShape).hashCode = function () {
    var result = this.s42_1.hashCode();
    result = imul(result, 31) + this.t42_1.hashCode() | 0;
    result = imul(result, 31) + (this.u42_1 == null ? 0 : this.u42_1.hashCode()) | 0;
    result = imul(result, 31) + this.v42_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.w42_1) | 0;
    return result;
  };
  protoOf(DynamicShape).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DynamicShape))
      return false;
    var tmp0_other_with_cast = other instanceof DynamicShape ? other : THROW_CCE();
    if (!this.s42_1.equals(tmp0_other_with_cast.s42_1))
      return false;
    if (!this.t42_1.equals(tmp0_other_with_cast.t42_1))
      return false;
    if (!equals(this.u42_1, tmp0_other_with_cast.u42_1))
      return false;
    if (!this.v42_1.equals(tmp0_other_with_cast.v42_1))
      return false;
    if (!equals(this.w42_1, tmp0_other_with_cast.w42_1))
      return false;
    return true;
  };
  function extractHash($this) {
    var tmp0_safe_receiver = $this.templateId;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    result = imul(31, result) + getStringHashCode($this.partKey) | 0;
    return result;
  }
  function Companion_16() {
    Companion_instance_21 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b43_1 = [null, null, null, null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().s7(), DoubleSerializer_getInstance()), null, null, null];
  }
  protoOf(Companion_16).l17 = function () {
    return $serializer_getInstance_14();
  };
  var Companion_instance_21;
  function Companion_getInstance_22() {
    if (Companion_instance_21 == null)
      new Companion_16();
    return Companion_instance_21;
  }
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.AssemblyChild', this, 9);
    tmp0_serialDesc.cv('templateId', true);
    tmp0_serialDesc.cv('partKey', false);
    tmp0_serialDesc.cv('connector', true);
    tmp0_serialDesc.cv('connectorOnHost', true);
    tmp0_serialDesc.cv('position', true);
    tmp0_serialDesc.cv('transform', true);
    tmp0_serialDesc.cv('components', true);
    tmp0_serialDesc.cv('children', true);
    tmp0_serialDesc.cv('locked', true);
    this.c43_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).ok = function () {
    return this.c43_1;
  };
  protoOf($serializer_10).rv = function () {
    var tmp0_cached = Companion_getInstance_22().b43_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(PositionTemplateSerializer_getInstance()), get_nullable(tmp0_cached[5]), get_nullable($serializer_getInstance_16()), get_nullable(new ReferenceArraySerializer(getKClass(AssemblyChild), $serializer_getInstance_14())), get_nullable(BooleanSerializer_getInstance())];
  };
  protoOf($serializer_10).qk = function (decoder) {
    var tmp0_desc = this.c43_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp14_input = decoder.nn(tmp0_desc);
    var tmp15_cached = Companion_getInstance_22().b43_1;
    if (tmp14_input.do()) {
      tmp4_local0 = tmp14_input.bo(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.bo(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.bo(tmp0_desc, 4, PositionTemplateSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.bo(tmp0_desc, 5, tmp15_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.bo(tmp0_desc, 6, $serializer_getInstance_16(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.bo(tmp0_desc, 7, new ReferenceArraySerializer(getKClass(AssemblyChild), $serializer_getInstance_14()), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.bo(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.bo(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.bo(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.bo(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.bo(tmp0_desc, 4, PositionTemplateSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.bo(tmp0_desc, 5, tmp15_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.bo(tmp0_desc, 6, $serializer_getInstance_16(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.bo(tmp0_desc, 7, new ReferenceArraySerializer(getKClass(AssemblyChild), $serializer_getInstance_14()), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.bo(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.on(tmp0_desc);
    return AssemblyChild_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_10).d43 = function (encoder, value) {
    var tmp0_desc = this.c43_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_22().b43_1;
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !(value.templateId === '')) {
      tmp1_output.gp(tmp0_desc, 0, StringSerializer_getInstance(), value.templateId);
    }
    tmp1_output.cp(tmp0_desc, 1, value.partKey);
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.connector == null)) {
      tmp1_output.gp(tmp0_desc, 2, StringSerializer_getInstance(), value.connector);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.connectorOnHost == null)) {
      tmp1_output.gp(tmp0_desc, 3, StringSerializer_getInstance(), value.connectorOnHost);
    }
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.position == null)) {
      tmp1_output.gp(tmp0_desc, 4, PositionTemplateSerializer_getInstance(), value.position);
    }
    if (tmp1_output.kp(tmp0_desc, 5) ? true : !(value.transform == null)) {
      tmp1_output.gp(tmp0_desc, 5, tmp2_cached[5], value.transform);
    }
    if (tmp1_output.kp(tmp0_desc, 6) ? true : !(value.components == null)) {
      tmp1_output.gp(tmp0_desc, 6, $serializer_getInstance_16(), value.components);
    }
    if (tmp1_output.kp(tmp0_desc, 7) ? true : !(value.children == null)) {
      tmp1_output.gp(tmp0_desc, 7, new ReferenceArraySerializer(getKClass(AssemblyChild), $serializer_getInstance_14()), value.children);
    }
    if (tmp1_output.kp(tmp0_desc, 8) ? true : !(value.locked === true)) {
      tmp1_output.gp(tmp0_desc, 8, BooleanSerializer_getInstance(), value.locked);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_10).pk = function (encoder, value) {
    return this.d43(encoder, value instanceof AssemblyChild ? value : THROW_CCE());
  };
  var $serializer_instance_10;
  function $serializer_getInstance_14() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function AssemblyChild_init_$Init$(seen1, templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked, serializationConstructorMarker, $this) {
    if (!(2 === (2 & seen1))) {
      throwMissingFieldException(seen1, 2, $serializer_getInstance_14().c43_1);
    }
    if (0 === (seen1 & 1))
      $this.templateId = '';
    else
      $this.templateId = templateId;
    $this.partKey = partKey;
    if (0 === (seen1 & 4))
      $this.connector = null;
    else
      $this.connector = connector;
    if (0 === (seen1 & 8))
      $this.connectorOnHost = null;
    else
      $this.connectorOnHost = connectorOnHost;
    if (0 === (seen1 & 16))
      $this.position = null;
    else
      $this.position = position;
    if (0 === (seen1 & 32))
      $this.transform = null;
    else
      $this.transform = transform;
    if (0 === (seen1 & 64))
      $this.components = null;
    else
      $this.components = components;
    if (0 === (seen1 & 128))
      $this.children = null;
    else
      $this.children = children;
    if (0 === (seen1 & 256))
      $this.locked = true;
    else
      $this.locked = locked;
    $this.a43_1 = extractHash($this);
    return $this;
  }
  function AssemblyChild_init_$Create$(seen1, templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked, serializationConstructorMarker) {
    return AssemblyChild_init_$Init$(seen1, templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked, serializationConstructorMarker, objectCreate(protoOf(AssemblyChild)));
  }
  function AssemblyChild(templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked) {
    Companion_getInstance_22();
    templateId = templateId === VOID ? '' : templateId;
    connector = connector === VOID ? null : connector;
    connectorOnHost = connectorOnHost === VOID ? null : connectorOnHost;
    position = position === VOID ? null : position;
    transform = transform === VOID ? null : transform;
    components = components === VOID ? null : components;
    children = children === VOID ? null : children;
    locked = locked === VOID ? true : locked;
    this.templateId = templateId;
    this.partKey = partKey;
    this.connector = connector;
    this.connectorOnHost = connectorOnHost;
    this.position = position;
    this.transform = transform;
    this.components = components;
    this.children = children;
    this.locked = locked;
    this.a43_1 = extractHash(this);
  }
  protoOf(AssemblyChild).f2h = function () {
    return this.templateId;
  };
  protoOf(AssemblyChild).z1j = function () {
    return this.partKey;
  };
  protoOf(AssemblyChild).n1k = function () {
    return this.connector;
  };
  protoOf(AssemblyChild).m1k = function () {
    return this.connectorOnHost;
  };
  protoOf(AssemblyChild).ct = function () {
    return this.position;
  };
  protoOf(AssemblyChild).d1x = function () {
    return this.transform;
  };
  protoOf(AssemblyChild).j1m = function () {
    return this.components;
  };
  protoOf(AssemblyChild).c1k = function () {
    return this.children;
  };
  protoOf(AssemblyChild).d1k = function () {
    return this.locked;
  };
  protoOf(AssemblyChild).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof AssemblyChild))
      THROW_CCE();
    if (!(this.templateId == other.templateId))
      return false;
    if (!(this.partKey === other.partKey))
      return false;
    return true;
  };
  protoOf(AssemblyChild).hashCode = function () {
    return this.a43_1;
  };
  protoOf(AssemblyChild).af = function () {
    return this.templateId;
  };
  protoOf(AssemblyChild).bf = function () {
    return this.partKey;
  };
  protoOf(AssemblyChild).g1k = function () {
    return this.connector;
  };
  protoOf(AssemblyChild).h1k = function () {
    return this.connectorOnHost;
  };
  protoOf(AssemblyChild).i1k = function () {
    return this.position;
  };
  protoOf(AssemblyChild).j1k = function () {
    return this.transform;
  };
  protoOf(AssemblyChild).k1k = function () {
    return this.components;
  };
  protoOf(AssemblyChild).p1z = function () {
    return this.children;
  };
  protoOf(AssemblyChild).q1z = function () {
    return this.locked;
  };
  protoOf(AssemblyChild).e43 = function (templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked) {
    return new AssemblyChild(templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked);
  };
  protoOf(AssemblyChild).copy = function (templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked, $super) {
    templateId = templateId === VOID ? this.templateId : templateId;
    partKey = partKey === VOID ? this.partKey : partKey;
    connector = connector === VOID ? this.connector : connector;
    connectorOnHost = connectorOnHost === VOID ? this.connectorOnHost : connectorOnHost;
    position = position === VOID ? this.position : position;
    transform = transform === VOID ? this.transform : transform;
    components = components === VOID ? this.components : components;
    children = children === VOID ? this.children : children;
    locked = locked === VOID ? this.locked : locked;
    return this.e43(templateId, partKey, connector, connectorOnHost, position, transform, components, children, locked);
  };
  protoOf(AssemblyChild).toString = function () {
    return 'AssemblyChild(templateId=' + this.templateId + ', partKey=' + this.partKey + ', connector=' + this.connector + ', connectorOnHost=' + this.connectorOnHost + ', position=' + this.position + ', transform=' + toString(this.transform) + ', components=' + this.components + ', children=' + toString(this.children) + ', locked=' + this.locked + ')';
  };
  function Companion_17() {
    Companion_instance_22 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t3y_1 = [new ReferenceArraySerializer(getKClass(AssemblyChild), $serializer_getInstance_14())];
  }
  protoOf(Companion_17).mapGeneratorPartsToTemplateChildren = function (catalog, catalogParts, templateChildren, catalogSize) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var assemblyParts = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var partsMap = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = templateChildren.length;
    while (inductionVariable < last) {
      var element = templateChildren[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.Companion.mapGeneratorPartsToTemplateChildren.<anonymous>' call
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var index = 0;
        var tmp0_iterator = catalogParts.t();
        while (tmp0_iterator.u()) {
          var item = tmp0_iterator.w();
          // Inline function 'com.ikea.range.dynamic.template.Companion.mapGeneratorPartsToTemplateChildren.<anonymous>.<anonymous>' call
          if (item.partKey === element.partKey) {
            tmp$ret$3 = index;
            break $l$block;
          }
          index = index + 1 | 0;
        }
        tmp$ret$3 = -1;
      }
      var generatorPartIndex = tmp$ret$3;
      var tmp;
      if (!(element.connector == null) ? !(element.connectorOnHost == null) : false) {
        tmp = new AssemblyPartSnapInfo(element.connectorOnHost, element.connector);
      } else {
        tmp = null;
      }
      var snapInfo = tmp;
      if (generatorPartIndex > -1) {
        var generatorPart = catalogParts.h1(generatorPartIndex);
        var tmp_0;
        if (!(element.children == null)) {
          var tmp0_safe_receiver = catalog.findProductDTO(generatorPart.id);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.template;
          var childCatalogSize = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.size;
          tmp_0 = Companion_getInstance_23().mapGeneratorPartsToTemplateChildren(catalog, catalogParts, element.children, childCatalogSize);
        } else {
          tmp_0 = new Pair(null, null);
        }
        var tmp2_container = tmp_0;
        var children = tmp2_container.af();
        var childrenParts = tmp2_container.bf();
        if (childrenParts == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          partsMap.s2(childrenParts);
        }
        var tmp_1;
        if (!(element.position == null)) {
          var tmp_2;
          if (!(catalogSize == null)) {
            tmp_2 = element.position.applyToBox(Companion_getInstance_0().fromSize(catalogSize.vector));
          } else {
            tmp_2 = element.position.absoluteTransform;
          }
          tmp_1 = tmp_2;
        } else if (!(element.transform == null)) {
          tmp_1 = new Transform(new Vector(element.transform[0], element.transform[1], element.transform[2]), Companion_getInstance_2().fromEulerDegrees(new Degrees(element.transform[3]), new Degrees(element.transform[4]), new Degrees(element.transform[5])));
        } else {
          tmp_1 = Companion_getInstance_1().IDENTITY;
        }
        var transform = tmp_1;
        var tmp4_elvis_lhs = element.locked;
        var assemblyPart = new AssemblyPart(element.partKey, transform, snapInfo, children, tmp4_elvis_lhs == null ? true : tmp4_elvis_lhs);
        // Inline function 'kotlin.collections.set' call
        var key = element.partKey;
        var value = generatorPart.id;
        partsMap.r2(key, value);
        assemblyParts.q(assemblyPart);
      } else {
        var tmp5_safe_receiver = element.position;
        var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.absoluteTransform;
        var transform_0 = tmp6_elvis_lhs == null ? Companion_getInstance_1().IDENTITY : tmp6_elvis_lhs;
        var tmp7_elvis_lhs = element.locked;
        var assemblyPart_0 = new AssemblyPart(element.partKey, transform_0, snapInfo, null, tmp7_elvis_lhs == null ? true : tmp7_elvis_lhs);
        // Inline function 'kotlin.collections.set' call
        var key_0 = element.partKey;
        partsMap.r2(key_0, '');
        assemblyParts.q(assemblyPart_0);
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$5 = copyToArray(assemblyParts);
    return new Pair(tmp$ret$5, partsMap);
  };
  protoOf(Companion_17).l17 = function () {
    return $serializer_getInstance_15();
  };
  var Companion_instance_22;
  function Companion_getInstance_23() {
    if (Companion_instance_22 == null)
      new Companion_17();
    return Companion_instance_22;
  }
  function $serializer_11() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.AssemblyTemplate', this, 1);
    tmp0_serialDesc.cv('children', false);
    this.f43_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).ok = function () {
    return this.f43_1;
  };
  protoOf($serializer_11).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_23().t3y_1[0]];
  };
  protoOf($serializer_11).qk = function (decoder) {
    var tmp0_desc = this.f43_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp6_input = decoder.nn(tmp0_desc);
    var tmp7_cached = Companion_getInstance_23().t3y_1;
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return AssemblyTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_11).g43 = function (encoder, value) {
    var tmp0_desc = this.f43_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_23().t3y_1;
    tmp1_output.ep(tmp0_desc, 0, tmp2_cached[0], value.children);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_11).pk = function (encoder, value) {
    return this.g43(encoder, value instanceof AssemblyTemplate ? value : THROW_CCE());
  };
  var $serializer_instance_11;
  function $serializer_getInstance_15() {
    if ($serializer_instance_11 == null)
      new $serializer_11();
    return $serializer_instance_11;
  }
  function AssemblyTemplate_init_$Init$(seen1, children, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_15().f43_1);
    }
    $this.children = children;
    var tmp = $this;
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var indexedObject = $this.children;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_0 = sum;
      // Inline function 'com.ikea.range.dynamic.template.AssemblyTemplate.<init>.<anonymous>' call
      sum = tmp_0 + element.hashCode() | 0;
    }
    tmp.u3y_1 = sum;
    return $this;
  }
  function AssemblyTemplate_init_$Create$(seen1, children, serializationConstructorMarker) {
    return AssemblyTemplate_init_$Init$(seen1, children, serializationConstructorMarker, objectCreate(protoOf(AssemblyTemplate)));
  }
  function AssemblyTemplate(children) {
    Companion_getInstance_23();
    this.children = children;
    var tmp = this;
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var indexedObject = this.children;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_0 = sum;
      // Inline function 'com.ikea.range.dynamic.template.AssemblyTemplate._hashCode.<anonymous>' call
      sum = tmp_0 + element.hashCode() | 0;
    }
    tmp.u3y_1 = sum;
  }
  protoOf(AssemblyTemplate).c1k = function () {
    return this.children;
  };
  protoOf(AssemblyTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof AssemblyTemplate))
      THROW_CCE();
    if (!(other.children.length === this.children.length))
      return false;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var indexedObject = this.children;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.AssemblyTemplate.equals.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      if (!item.equals(other.children[tmp1]))
        return false;
    }
    return true;
  };
  protoOf(AssemblyTemplate).hashCode = function () {
    return this.u3y_1;
  };
  protoOf(AssemblyTemplate).inherit = function (extendedAssembly) {
    var tmp;
    if (extendedAssembly == null) {
      tmp = this;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = extendedAssembly.children;
      var destination = ArrayList_init_$Create$_0();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.template.AssemblyTemplate.inherit.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.none' call
          var indexedObject = this.children;
          var inductionVariable_0 = 0;
          var last_0 = indexedObject.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.range.dynamic.template.AssemblyTemplate.inherit.<anonymous>.<anonymous>' call
            if (element_0.partKey === element.partKey) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          destination.q(element);
        }
      }
      var combinedChildren = plus_2(this.children, destination);
      tmp = new AssemblyTemplate(combinedChildren);
    }
    return tmp;
  };
  protoOf(AssemblyTemplate).af = function () {
    return this.children;
  };
  protoOf(AssemblyTemplate).h43 = function (children) {
    return new AssemblyTemplate(children);
  };
  protoOf(AssemblyTemplate).copy = function (children, $super) {
    children = children === VOID ? this.children : children;
    return this.h43(children);
  };
  protoOf(AssemblyTemplate).toString = function () {
    return 'AssemblyTemplate(children=' + toString(this.children) + ')';
  };
  function CustomSerializer_0() {
    CustomSerializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.AutoAdaptHostTemplate', null, 1);
    tmp0_serialDesc.cv('hostZone', true);
    this.i43_1 = tmp0_serialDesc;
  }
  protoOf(CustomSerializer_0).qk = function (decoder) {
    var template = null;
    try {
      var value = decoder.an();
      if (value) {
        template = new AutoAdaptHostTemplate(new Dimension(0.0, 0.0, VOID, 0.0, VOID, 0.0, 0.0, 0.0));
      }
    } catch ($p) {
      if ($p instanceof SerializationException) {
        var e = $p;
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = decoder.nn(this.i43_1);
        var i = $this$run.eo(CustomSerializer_getInstance_0().i43_1);
        if (!(i === -1)) {
          var hostZone = $this$run.ao(CustomSerializer_getInstance_0().i43_1, i, Companion_getInstance_28().l17());
          template = new AutoAdaptHostTemplate(hostZone);
        } else {
          // Inline function 'kotlin.error' call
          var message = 'AutoAdaptHost: error found in JSON.';
          throw IllegalStateException_init_$Create$(toString(message));
        }
        $this$run.on(CustomSerializer_getInstance_0().i43_1);
      } else {
        throw $p;
      }
    }
    return template;
  };
  protoOf(CustomSerializer_0).ok = function () {
    return this.i43_1;
  };
  protoOf(CustomSerializer_0).k43 = function (encoder, value) {
    var tmp0_desc = this.i43_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !(value.hostZone == null)) {
      tmp1_output.gp(tmp0_desc, 0, Companion_getInstance_28(), value.hostZone);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf(CustomSerializer_0).pk = function (encoder, value) {
    return this.k43(encoder, (value == null ? true : value instanceof AutoAdaptHostTemplate) ? value : THROW_CCE());
  };
  protoOf(CustomSerializer_0).l17 = function () {
    return CustomSerializer_getInstance_0();
  };
  var CustomSerializer_instance_0;
  function CustomSerializer_getInstance_0() {
    if (CustomSerializer_instance_0 == null)
      new CustomSerializer_0();
    return CustomSerializer_instance_0;
  }
  function AutoAdaptHostTemplate(hostZone) {
    CustomSerializer_getInstance_0();
    hostZone = hostZone === VOID ? null : hostZone;
    this.hostZone = hostZone;
  }
  protoOf(AutoAdaptHostTemplate).h31 = function () {
    return this.hostZone;
  };
  protoOf(AutoAdaptHostTemplate).af = function () {
    return this.hostZone;
  };
  protoOf(AutoAdaptHostTemplate).l43 = function (hostZone) {
    return new AutoAdaptHostTemplate(hostZone);
  };
  protoOf(AutoAdaptHostTemplate).copy = function (hostZone, $super) {
    hostZone = hostZone === VOID ? this.hostZone : hostZone;
    return this.l43(hostZone);
  };
  protoOf(AutoAdaptHostTemplate).toString = function () {
    return 'AutoAdaptHostTemplate(hostZone=' + this.hostZone + ')';
  };
  protoOf(AutoAdaptHostTemplate).hashCode = function () {
    return this.hostZone == null ? 0 : this.hostZone.hashCode();
  };
  protoOf(AutoAdaptHostTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AutoAdaptHostTemplate))
      return false;
    var tmp0_other_with_cast = other instanceof AutoAdaptHostTemplate ? other : THROW_CCE();
    if (!equals(this.hostZone, tmp0_other_with_cast.hostZone))
      return false;
    return true;
  };
  function BoundItemTemplate$Companion$descriptor$lambda($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.cl('id', PrimitiveSerialDescriptor('id', STRING_getInstance()));
    $this$buildClassSerialDescriptor.cl('type', PrimitiveSerialDescriptor('type', STRING_getInstance()));
    $this$buildClassSerialDescriptor.cl('layer', PrimitiveSerialDescriptor('layer', STRING_getInstance()));
    $this$buildClassSerialDescriptor.cl('dimension', Companion_getInstance_28().j43_1);
    $this$buildClassSerialDescriptor.cl('margin', MarginTemplateSerializer_getInstance().m43_1);
    $this$buildClassSerialDescriptor.cl('padding', MarginTemplateSerializer_getInstance().m43_1);
    $this$buildClassSerialDescriptor.cl('compartment', Companion_getInstance_25().n43_1);
    return Unit_instance;
  }
  function Companion_18() {
    Companion_instance_23 = this;
    var tmp = this;
    tmp.o43_1 = buildClassSerialDescriptor('BoundItemTemplate', [], BoundItemTemplate$Companion$descriptor$lambda);
  }
  protoOf(Companion_18).ok = function () {
    return this.o43_1;
  };
  protoOf(Companion_18).qk = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.o43_1;
    var composite = decoder.nn(descriptor);
    // Inline function 'com.ikea.range.dynamic.template.Companion.deserialize.<anonymous>' call
    var id = '';
    var type = 'box';
    var layer = 'collision';
    var dimension = null;
    var margin = null;
    var padding = null;
    var compartment = null;
    loop: while (true) {
      var index = composite.eo(Companion_getInstance_24().o43_1);
      if (index === 0)
        id = composite.xn(Companion_getInstance_24().o43_1, 0);
      else {
        if (index === 1)
          type = composite.xn(Companion_getInstance_24().o43_1, 1);
        else {
          if (index === 2)
            layer = composite.xn(Companion_getInstance_24().o43_1, 2);
          else {
            if (index === 3)
              dimension = composite.ao(Companion_getInstance_24().o43_1, 3, Companion_getInstance_28().l17());
            else {
              if (index === 4)
                margin = composite.ao(Companion_getInstance_24().o43_1, 4, MarginTemplateSerializer_getInstance().l17());
              else {
                if (index === 5)
                  padding = composite.ao(Companion_getInstance_24().o43_1, 5, MarginTemplateSerializer_getInstance().l17());
                else {
                  if (index === 6)
                    compartment = composite.ao(Companion_getInstance_24().o43_1, 6, Companion_getInstance_25().l17());
                  else {
                    if (index === -1)
                      break loop;
                    else {
                      var message = 'Unexpected index: ' + index;
                      throw IllegalStateException_init_$Create$(toString(message));
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    var result = new BoundItemTemplate(dimension, id, type, layer, margin, padding, compartment);
    composite.on(descriptor);
    return result;
  };
  protoOf(Companion_18).p43 = function (encoder, value) {
    var enc = encoder.nn(this.o43_1);
    enc.cp(this.o43_1, 0, value.id);
    enc.cp(this.o43_1, 1, value.type);
    enc.cp(this.o43_1, 2, value.layer);
    var tmp0_safe_receiver = value.dimension;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      enc.ep(Companion_getInstance_24().o43_1, 3, Companion_getInstance_28().l17(), tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = value.margin;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      enc.ep(Companion_getInstance_24().o43_1, 4, MarginTemplateSerializer_getInstance().l17(), tmp1_safe_receiver);
    }
    var tmp2_safe_receiver = value.padding;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      enc.ep(Companion_getInstance_24().o43_1, 5, MarginTemplateSerializer_getInstance().l17(), tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = value.compartment;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      enc.ep(Companion_getInstance_24().o43_1, 6, Companion_getInstance_25().l17(), tmp3_safe_receiver);
    }
    enc.on(this.o43_1);
  };
  protoOf(Companion_18).pk = function (encoder, value) {
    return this.p43(encoder, value instanceof BoundItemTemplate ? value : THROW_CCE());
  };
  protoOf(Companion_18).l17 = function () {
    return Companion_getInstance_24();
  };
  var Companion_instance_23;
  function Companion_getInstance_24() {
    if (Companion_instance_23 == null)
      new Companion_18();
    return Companion_instance_23;
  }
  function BoundItemTemplate(dimension, id, type, layer, margin, padding, compartment, sourceTemplateId) {
    Companion_getInstance_24();
    dimension = dimension === VOID ? null : dimension;
    type = type === VOID ? 'box' : type;
    layer = layer === VOID ? 'collision' : layer;
    margin = margin === VOID ? null : margin;
    padding = padding === VOID ? null : padding;
    compartment = compartment === VOID ? null : compartment;
    sourceTemplateId = sourceTemplateId === VOID ? '' : sourceTemplateId;
    this.dimension = dimension;
    this.id = id;
    this.type = type;
    this.layer = layer;
    this.margin = margin;
    this.padding = padding;
    this.compartment = compartment;
    this.sourceTemplateId = sourceTemplateId;
    this.k3y_1 = 0;
  }
  protoOf(BoundItemTemplate).q43 = function () {
    return this.dimension;
  };
  protoOf(BoundItemTemplate).s1k = function () {
    return this.id;
  };
  protoOf(BoundItemTemplate).a1x = function () {
    return this.type;
  };
  protoOf(BoundItemTemplate).j3a = function () {
    return this.layer;
  };
  protoOf(BoundItemTemplate).p39 = function () {
    return this.margin;
  };
  protoOf(BoundItemTemplate).r43 = function () {
    return this.padding;
  };
  protoOf(BoundItemTemplate).s43 = function () {
    return this.compartment;
  };
  protoOf(BoundItemTemplate).t43 = function (_set____db54di) {
    this.sourceTemplateId = _set____db54di;
  };
  protoOf(BoundItemTemplate).u43 = function () {
    return this.sourceTemplateId;
  };
  protoOf(BoundItemTemplate).getPolyhedronsForSize = function (size) {
    var tmp;
    if (this.type === 'frame') {
      var tmp_0 = PolyhedronUtils_getInstance();
      var tmp0_safe_receiver = this.margin;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toMargin();
      var tmp_1 = tmp1_elvis_lhs == null ? new Margin() : tmp1_elvis_lhs;
      var tmp_2 = ensureNotNull(this.padding).toMargin();
      var tmp2_safe_receiver = this.compartment;
      var tmp_3;
      if (tmp2_safe_receiver == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.template.BoundItemTemplate.getPolyhedronsForSize.<anonymous>' call
        var tmp0_elvis_lhs = tmp2_safe_receiver.width;
        var tmp_4 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
        var tmp1_elvis_lhs_0 = tmp2_safe_receiver.height;
        tmp_3 = new Size(tmp_4, tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0);
      }
      var tmp_5 = tmp_0.createFramePolyhedrons(size, tmp_1, tmp_2, tmp_3);
      tmp = isArray(tmp_5) ? tmp_5 : THROW_CCE();
    } else {
      var tmp_6;
      if (this.dimension == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.template.BoundItemTemplate.getPolyhedronsForSize.<anonymous>' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_6 = [this.dimension.getPolyhedronForSize(size)];
      }
      var tmp7_elvis_lhs = tmp_6;
      var tmp_7;
      if (tmp7_elvis_lhs == null) {
        // Inline function 'kotlin.arrayOf' call
        var tmp4_width = size.s2e_1;
        var tmp5_height = size.t2e_1;
        var tmp6_depth = size.u2e_1;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_7 = [(new Dimension(VOID, VOID, tmp6_depth, VOID, tmp5_height, VOID, VOID, VOID, tmp4_width)).getPolyhedronForSize(size)];
      } else {
        tmp_7 = tmp7_elvis_lhs;
      }
      tmp = tmp_7;
    }
    return tmp;
  };
  protoOf(BoundItemTemplate).getPolyhedronForSize = function (size) {
    var tmp;
    if (this.dimension == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.template.BoundItemTemplate.getPolyhedronForSize.<anonymous>' call
      tmp = this.dimension.getPolyhedronForSize(size);
    }
    var tmp4_elvis_lhs = tmp;
    var tmp_0;
    if (tmp4_elvis_lhs == null) {
      var tmp1_width = size.s2e_1;
      var tmp2_height = size.t2e_1;
      var tmp3_depth = size.u2e_1;
      tmp_0 = (new Dimension(VOID, VOID, tmp3_depth, VOID, tmp2_height, VOID, VOID, VOID, tmp1_width)).getPolyhedronForSize(size);
    } else {
      tmp_0 = tmp4_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(BoundItemTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof BoundItemTemplate))
      THROW_CCE();
    if (!equals(this.dimension, other.dimension))
      return false;
    if (!(this.id === other.id))
      return false;
    return true;
  };
  protoOf(BoundItemTemplate).hashCode = function () {
    if (this.k3y_1 === 0) {
      var tmp = this;
      var tmp0_safe_receiver = this.dimension;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
      tmp.k3y_1 = imul(31, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + getStringHashCode(this.id) | 0;
    }
    return this.k3y_1;
  };
  protoOf(BoundItemTemplate).clone = function () {
    var tmp0_safe_receiver = this.dimension;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.clone();
    var tmp1_safe_receiver = this.margin;
    var tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.clone();
    var tmp2_safe_receiver = this.padding;
    var tmp_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.clone();
    var tmp3_safe_receiver = this.compartment;
    var tmp_2;
    if (tmp3_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.template.BoundItemTemplate.clone.<anonymous>' call
      tmp_2 = new Compartment(tmp3_safe_receiver.width, tmp3_safe_receiver.height);
    }
    return new BoundItemTemplate(tmp, this.id, this.type, this.layer, tmp_0, tmp_1, tmp_2, this.sourceTemplateId);
  };
  protoOf(BoundItemTemplate).af = function () {
    return this.dimension;
  };
  protoOf(BoundItemTemplate).bf = function () {
    return this.id;
  };
  protoOf(BoundItemTemplate).g1k = function () {
    return this.type;
  };
  protoOf(BoundItemTemplate).h1k = function () {
    return this.layer;
  };
  protoOf(BoundItemTemplate).i1k = function () {
    return this.margin;
  };
  protoOf(BoundItemTemplate).j1k = function () {
    return this.padding;
  };
  protoOf(BoundItemTemplate).k1k = function () {
    return this.compartment;
  };
  protoOf(BoundItemTemplate).p1z = function () {
    return this.sourceTemplateId;
  };
  protoOf(BoundItemTemplate).v43 = function (dimension, id, type, layer, margin, padding, compartment, sourceTemplateId) {
    return new BoundItemTemplate(dimension, id, type, layer, margin, padding, compartment, sourceTemplateId);
  };
  protoOf(BoundItemTemplate).copy = function (dimension, id, type, layer, margin, padding, compartment, sourceTemplateId, $super) {
    dimension = dimension === VOID ? this.dimension : dimension;
    id = id === VOID ? this.id : id;
    type = type === VOID ? this.type : type;
    layer = layer === VOID ? this.layer : layer;
    margin = margin === VOID ? this.margin : margin;
    padding = padding === VOID ? this.padding : padding;
    compartment = compartment === VOID ? this.compartment : compartment;
    sourceTemplateId = sourceTemplateId === VOID ? this.sourceTemplateId : sourceTemplateId;
    return this.v43(dimension, id, type, layer, margin, padding, compartment, sourceTemplateId);
  };
  protoOf(BoundItemTemplate).toString = function () {
    return 'BoundItemTemplate(dimension=' + this.dimension + ', id=' + this.id + ', type=' + this.type + ', layer=' + this.layer + ', margin=' + this.margin + ', padding=' + this.padding + ', compartment=' + this.compartment + ', sourceTemplateId=' + this.sourceTemplateId + ')';
  };
  function getPolyhedronForSize(_this__u8e3s4, size) {
    try {
      var tmp;
      if (size.equals(new Size())) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.mutableListOf' call
        var ids = ArrayList_init_$Create$_0();
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination = ArrayList_init_$Create$_0();
        var inductionVariable = 0;
        var last = _this__u8e3s4.length;
        while (inductionVariable < last) {
          var element = _this__u8e3s4[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.template.getPolyhedronForSize.<anonymous>' call
          var b = toList(element.getPolyhedronsForSize(size));
          if (b.n() > 1) {
            var inductionVariable_0 = 1;
            var last_0 = b.n();
            if (inductionVariable_0 <= last_0)
              do {
                var i = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                ids.q(element.id + ':' + i);
              }
               while (!(i === last_0));
          } else {
            ids.q(element.id);
          }
          var list = b;
          addAll(destination, list);
        }
        var polyhedra = copyToArray(destination);
        var tmp_0;
        // Inline function 'kotlin.collections.isEmpty' call
        if (polyhedra.length === 0) {
          tmp_0 = null;
        } else {
          if (polyhedra.length === 1) {
            tmp_0 = polyhedra[0];
          } else {
            tmp_0 = merge(polyhedra);
          }
        }
        var polyhedron = tmp_0;
        var tmp_1;
        if (polyhedron == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.dynamic.template.getPolyhedronForSize.<anonymous>' call
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp$ret$6 = copyToArray(ids);
          tmp_1 = new Pair(polyhedron, tmp$ret$6);
        }
        return tmp_1;
      }
      return tmp;
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        // Inline function 'kotlin.error' call
        var message = 'Specification of bounds not valid';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        throw $p;
      }
    }
  }
  function getBoundIds(_this__u8e3s4) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(_this__u8e3s4.length);
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    while (inductionVariable < last) {
      var item = _this__u8e3s4[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.getBoundIds.<anonymous>' call
      item.type;
      var tmp$ret$0 = item.id;
      destination.q(tmp$ret$0);
    }
    return copyToArray(destination);
  }
  function inherit(_this__u8e3s4, extendedBounds) {
    var tmp;
    if (extendedBounds == null) {
      tmp = _this__u8e3s4;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$_0();
      var inductionVariable = 0;
      var last = extendedBounds.length;
      while (inductionVariable < last) {
        var element = extendedBounds[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.template.inherit.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.none' call
          var inductionVariable_0 = 0;
          var last_0 = _this__u8e3s4.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = _this__u8e3s4[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.range.dynamic.template.inherit.<anonymous>.<anonymous>' call
            if (element_0.id === element.id) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          destination.q(element);
        }
      }
      tmp = plus_2(_this__u8e3s4, destination);
    }
    return tmp;
  }
  function Compartment$Companion$descriptor$lambda($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.cl('width', PrimitiveSerialDescriptor('width', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('height', PrimitiveSerialDescriptor('height', DOUBLE_getInstance()));
    return Unit_instance;
  }
  function Companion_19() {
    Companion_instance_24 = this;
    var tmp = this;
    tmp.n43_1 = buildClassSerialDescriptor('Compartment', [], Compartment$Companion$descriptor$lambda);
  }
  protoOf(Companion_19).ok = function () {
    return this.n43_1;
  };
  protoOf(Companion_19).w43 = function (encoder, value) {
    var enc = encoder.nn(this.n43_1);
    if (value.width == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (!isNaN_0(value.width)) {
        enc.ap(Companion_getInstance_25().n43_1, 0, value.width);
        tmp = Unit_instance;
      }
    }
    if (value.height == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (!isNaN_0(value.height)) {
        enc.ap(Companion_getInstance_25().n43_1, 1, value.height);
        tmp_0 = Unit_instance;
      }
    }
    enc.on(this.n43_1);
  };
  protoOf(Companion_19).pk = function (encoder, value) {
    return this.w43(encoder, value instanceof Compartment ? value : THROW_CCE());
  };
  protoOf(Companion_19).qk = function (decoder) {
    var tmp0_desc = this.n43_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.nn(tmp0_desc);
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.bo(tmp0_desc, 0, DoubleSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.bo(tmp0_desc, 1, DoubleSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.bo(tmp0_desc, 0, DoubleSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.bo(tmp0_desc, 1, DoubleSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    if (!(0 === (0 & tmp3_bitMask0))) {
      throwMissingFieldException(tmp3_bitMask0, 0, tmp0_desc);
    }
    if (0 === (tmp3_bitMask0 & 1)) {
      tmp4_local0 = NaN;
    }
    if (0 === (tmp3_bitMask0 & 2)) {
      tmp5_local1 = NaN;
    }
    return new Compartment(tmp4_local0, tmp5_local1);
  };
  protoOf(Companion_19).l17 = function () {
    return Companion_getInstance_25();
  };
  var Companion_instance_24;
  function Companion_getInstance_25() {
    if (Companion_instance_24 == null)
      new Companion_19();
    return Companion_instance_24;
  }
  function Compartment(width, height) {
    Companion_getInstance_25();
    var tmp;
    if (width === VOID) {
      tmp = NaN;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      tmp_0 = NaN;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    this.width = width;
    this.height = height;
  }
  protoOf(Compartment).u2b = function () {
    return this.width;
  };
  protoOf(Compartment).v2b = function () {
    return this.height;
  };
  protoOf(Compartment).af = function () {
    return this.width;
  };
  protoOf(Compartment).bf = function () {
    return this.height;
  };
  protoOf(Compartment).x43 = function (width, height) {
    return new Compartment(width, height);
  };
  protoOf(Compartment).copy = function (width, height, $super) {
    width = width === VOID ? this.width : width;
    height = height === VOID ? this.height : height;
    return this.x43(width, height);
  };
  protoOf(Compartment).toString = function () {
    return 'Compartment(width=' + this.width + ', height=' + this.height + ')';
  };
  protoOf(Compartment).hashCode = function () {
    var result = this.width == null ? 0 : getNumberHashCode(this.width);
    result = imul(result, 31) + (this.height == null ? 0 : getNumberHashCode(this.height)) | 0;
    return result;
  };
  protoOf(Compartment).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Compartment))
      return false;
    var tmp0_other_with_cast = other instanceof Compartment ? other : THROW_CCE();
    if (!equals(this.width, tmp0_other_with_cast.width))
      return false;
    if (!equals(this.height, tmp0_other_with_cast.height))
      return false;
    return true;
  };
  function Companion_20() {
    Companion_instance_25 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y43_1 = [new ReferenceArraySerializer(getKClass(BoundItemTemplate), Companion_getInstance_24()), new ReferenceArraySerializer(getKClass(BoundItemTemplate), Companion_getInstance_24()), new ReferenceArraySerializer(getKClass(ConnectorItemTemplate), Companion_getInstance_27()), null, null, null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().t7(), new ReferenceArraySerializer(PrimitiveClasses_getInstance().q7(), IntSerializer_getInstance())), null, null, null, null, null, null, null, null, null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonElementSerializer_getInstance()), null, null, null, null, null, null, null, null, null, null, null, new ReferenceArraySerializer(getKClass(ProductStructureItemTemplate), $serializer_getInstance_23())];
  }
  protoOf(Companion_20).extendMeta = function (primary, secondary) {
    if (primary == null)
      return secondary;
    if (secondary == null)
      return primary;
    return plus_1(secondary, primary);
  };
  protoOf(Companion_20).l17 = function () {
    return $serializer_getInstance_16();
  };
  var Companion_instance_25;
  function Companion_getInstance_26() {
    if (Companion_instance_25 == null)
      new Companion_20();
    return Companion_instance_25;
  }
  function $serializer_12() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.ComponentsTemplate', this, 31);
    tmp0_serialDesc.cv('bounds', true);
    tmp0_serialDesc.cv('functionalZones', true);
    tmp0_serialDesc.cv('connectors', true);
    tmp0_serialDesc.cv('assembly', true);
    tmp0_serialDesc.cv('selectable', true);
    tmp0_serialDesc.cv('outlineable', true);
    tmp0_serialDesc.cv('draggable', true);
    tmp0_serialDesc.cv('allowedDoorPairs', true);
    tmp0_serialDesc.cv('autoAdaptHost', true);
    tmp0_serialDesc.cv('communicationSize', true);
    tmp0_serialDesc.cv('door', true);
    tmp0_serialDesc.cv('doorFront', true);
    tmp0_serialDesc.cv('handle', true);
    tmp0_serialDesc.cv('drawer', true);
    tmp0_serialDesc.cv('frame', true);
    tmp0_serialDesc.cv('leg', true);
    tmp0_serialDesc.cv('light', true);
    tmp0_serialDesc.cv('outlined', true);
    tmp0_serialDesc.cv('meta', true);
    tmp0_serialDesc.cv('propping', true);
    tmp0_serialDesc.cv('alwaysHangDown', true);
    tmp0_serialDesc.cv('serializeEntity', true);
    tmp0_serialDesc.cv('placementZoneByHeight', true);
    tmp0_serialDesc.cv('functionalMargin', true);
    tmp0_serialDesc.cv('recommendedInitialPositionFromFloor', true);
    tmp0_serialDesc.cv('visualLightSource', true);
    tmp0_serialDesc.cv('model3D', true);
    tmp0_serialDesc.cv('product', true);
    tmp0_serialDesc.cv('dragSurfaces', true);
    tmp0_serialDesc.cv('dragProjectionPoint', true);
    tmp0_serialDesc.cv('productStructure', true);
    this.z43_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).ok = function () {
    return this.z43_1;
  };
  protoOf($serializer_12).rv = function () {
    var tmp0_cached = Companion_getInstance_26().y43_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0]), get_nullable(tmp0_cached[1]), get_nullable(tmp0_cached[2]), get_nullable($serializer_getInstance_15()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(tmp0_cached[7]), get_nullable(CustomSerializer_getInstance_0()), get_nullable($serializer_getInstance_0()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_18()), get_nullable(BooleanSerializer_getInstance()), get_nullable(tmp0_cached[18]), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_20()), get_nullable(MarginTemplateSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable($serializer_getInstance_21()), get_nullable($serializer_getInstance_19()), get_nullable($serializer_getInstance_13()), get_nullable(CustomSerializer_getInstance_1()), get_nullable(PositionTemplateSerializer_getInstance()), get_nullable(tmp0_cached[30])];
  };
  protoOf($serializer_12).qk = function (decoder) {
    var tmp0_desc = this.z43_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_local21 = null;
    var tmp26_local22 = null;
    var tmp27_local23 = null;
    var tmp28_local24 = null;
    var tmp29_local25 = null;
    var tmp30_local26 = null;
    var tmp31_local27 = null;
    var tmp32_local28 = null;
    var tmp33_local29 = null;
    var tmp34_local30 = null;
    var tmp36_input = decoder.nn(tmp0_desc);
    var tmp37_cached = Companion_getInstance_26().y43_1;
    if (tmp36_input.do()) {
      tmp4_local0 = tmp36_input.bo(tmp0_desc, 0, tmp37_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp36_input.bo(tmp0_desc, 1, tmp37_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp36_input.bo(tmp0_desc, 2, tmp37_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp36_input.bo(tmp0_desc, 3, $serializer_getInstance_15(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp36_input.bo(tmp0_desc, 4, BooleanSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp36_input.bo(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp36_input.bo(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp36_input.bo(tmp0_desc, 7, tmp37_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp36_input.bo(tmp0_desc, 8, CustomSerializer_getInstance_0(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp36_input.bo(tmp0_desc, 9, $serializer_getInstance_0(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp36_input.bo(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp36_input.bo(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp36_input.bo(tmp0_desc, 12, BooleanSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp36_input.bo(tmp0_desc, 13, BooleanSerializer_getInstance(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp36_input.bo(tmp0_desc, 14, BooleanSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp36_input.bo(tmp0_desc, 15, BooleanSerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp36_input.bo(tmp0_desc, 16, $serializer_getInstance_18(), tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp36_input.bo(tmp0_desc, 17, BooleanSerializer_getInstance(), tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp36_input.bo(tmp0_desc, 18, tmp37_cached[18], tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp36_input.bo(tmp0_desc, 19, BooleanSerializer_getInstance(), tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp36_input.bo(tmp0_desc, 20, BooleanSerializer_getInstance(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp36_input.bo(tmp0_desc, 21, BooleanSerializer_getInstance(), tmp25_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp36_input.bo(tmp0_desc, 22, $serializer_getInstance_20(), tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp36_input.bo(tmp0_desc, 23, MarginTemplateSerializer_getInstance(), tmp27_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp28_local24 = tmp36_input.bo(tmp0_desc, 24, IntSerializer_getInstance(), tmp28_local24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
      tmp29_local25 = tmp36_input.bo(tmp0_desc, 25, $serializer_getInstance_21(), tmp29_local25);
      tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
      tmp30_local26 = tmp36_input.bo(tmp0_desc, 26, $serializer_getInstance_19(), tmp30_local26);
      tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
      tmp31_local27 = tmp36_input.bo(tmp0_desc, 27, $serializer_getInstance_13(), tmp31_local27);
      tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
      tmp32_local28 = tmp36_input.bo(tmp0_desc, 28, CustomSerializer_getInstance_1(), tmp32_local28);
      tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
      tmp33_local29 = tmp36_input.bo(tmp0_desc, 29, PositionTemplateSerializer_getInstance(), tmp33_local29);
      tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
      tmp34_local30 = tmp36_input.bo(tmp0_desc, 30, tmp37_cached[30], tmp34_local30);
      tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp36_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp36_input.bo(tmp0_desc, 0, tmp37_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp36_input.bo(tmp0_desc, 1, tmp37_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp36_input.bo(tmp0_desc, 2, tmp37_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp36_input.bo(tmp0_desc, 3, $serializer_getInstance_15(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp36_input.bo(tmp0_desc, 4, BooleanSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp36_input.bo(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp36_input.bo(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp36_input.bo(tmp0_desc, 7, tmp37_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp36_input.bo(tmp0_desc, 8, CustomSerializer_getInstance_0(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp36_input.bo(tmp0_desc, 9, $serializer_getInstance_0(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp36_input.bo(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp36_input.bo(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp36_input.bo(tmp0_desc, 12, BooleanSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp36_input.bo(tmp0_desc, 13, BooleanSerializer_getInstance(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp36_input.bo(tmp0_desc, 14, BooleanSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp36_input.bo(tmp0_desc, 15, BooleanSerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp36_input.bo(tmp0_desc, 16, $serializer_getInstance_18(), tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp36_input.bo(tmp0_desc, 17, BooleanSerializer_getInstance(), tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp36_input.bo(tmp0_desc, 18, tmp37_cached[18], tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp36_input.bo(tmp0_desc, 19, BooleanSerializer_getInstance(), tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp36_input.bo(tmp0_desc, 20, BooleanSerializer_getInstance(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp36_input.bo(tmp0_desc, 21, BooleanSerializer_getInstance(), tmp25_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp36_input.bo(tmp0_desc, 22, $serializer_getInstance_20(), tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp36_input.bo(tmp0_desc, 23, MarginTemplateSerializer_getInstance(), tmp27_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp28_local24 = tmp36_input.bo(tmp0_desc, 24, IntSerializer_getInstance(), tmp28_local24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          case 25:
            tmp29_local25 = tmp36_input.bo(tmp0_desc, 25, $serializer_getInstance_21(), tmp29_local25);
            tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
            break;
          case 26:
            tmp30_local26 = tmp36_input.bo(tmp0_desc, 26, $serializer_getInstance_19(), tmp30_local26);
            tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
            break;
          case 27:
            tmp31_local27 = tmp36_input.bo(tmp0_desc, 27, $serializer_getInstance_13(), tmp31_local27);
            tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
            break;
          case 28:
            tmp32_local28 = tmp36_input.bo(tmp0_desc, 28, CustomSerializer_getInstance_1(), tmp32_local28);
            tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
            break;
          case 29:
            tmp33_local29 = tmp36_input.bo(tmp0_desc, 29, PositionTemplateSerializer_getInstance(), tmp33_local29);
            tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
            break;
          case 30:
            tmp34_local30 = tmp36_input.bo(tmp0_desc, 30, tmp37_cached[30], tmp34_local30);
            tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp36_input.on(tmp0_desc);
    return ComponentsTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, tmp30_local26, tmp31_local27, tmp32_local28, tmp33_local29, tmp34_local30, null);
  };
  protoOf($serializer_12).a44 = function (encoder, value) {
    var tmp0_desc = this.z43_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_26().y43_1;
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !(value.bounds == null)) {
      tmp1_output.gp(tmp0_desc, 0, tmp2_cached[0], value.bounds);
    }
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.functionalZones == null)) {
      tmp1_output.gp(tmp0_desc, 1, tmp2_cached[1], value.functionalZones);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.connectors == null)) {
      tmp1_output.gp(tmp0_desc, 2, tmp2_cached[2], value.connectors);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.assembly == null)) {
      tmp1_output.gp(tmp0_desc, 3, $serializer_getInstance_15(), value.assembly);
    }
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.selectable == null)) {
      tmp1_output.gp(tmp0_desc, 4, BooleanSerializer_getInstance(), value.selectable);
    }
    if (tmp1_output.kp(tmp0_desc, 5) ? true : !(value.outlineable == null)) {
      tmp1_output.gp(tmp0_desc, 5, BooleanSerializer_getInstance(), value.outlineable);
    }
    if (tmp1_output.kp(tmp0_desc, 6) ? true : !(value.draggable == null)) {
      tmp1_output.gp(tmp0_desc, 6, BooleanSerializer_getInstance(), value.draggable);
    }
    if (tmp1_output.kp(tmp0_desc, 7) ? true : !(value.allowedDoorPairs == null)) {
      tmp1_output.gp(tmp0_desc, 7, tmp2_cached[7], value.allowedDoorPairs);
    }
    if (tmp1_output.kp(tmp0_desc, 8) ? true : !(value.autoAdaptHost == null)) {
      tmp1_output.gp(tmp0_desc, 8, CustomSerializer_getInstance_0(), value.autoAdaptHost);
    }
    if (tmp1_output.kp(tmp0_desc, 9) ? true : !(value.communicationSize == null)) {
      tmp1_output.gp(tmp0_desc, 9, $serializer_getInstance_0(), value.communicationSize);
    }
    if (tmp1_output.kp(tmp0_desc, 10) ? true : !(value.door == null)) {
      tmp1_output.gp(tmp0_desc, 10, BooleanSerializer_getInstance(), value.door);
    }
    if (tmp1_output.kp(tmp0_desc, 11) ? true : !(value.doorFront == null)) {
      tmp1_output.gp(tmp0_desc, 11, BooleanSerializer_getInstance(), value.doorFront);
    }
    if (tmp1_output.kp(tmp0_desc, 12) ? true : !(value.handle == null)) {
      tmp1_output.gp(tmp0_desc, 12, BooleanSerializer_getInstance(), value.handle);
    }
    if (tmp1_output.kp(tmp0_desc, 13) ? true : !(value.drawer == null)) {
      tmp1_output.gp(tmp0_desc, 13, BooleanSerializer_getInstance(), value.drawer);
    }
    if (tmp1_output.kp(tmp0_desc, 14) ? true : !(value.frame == null)) {
      tmp1_output.gp(tmp0_desc, 14, BooleanSerializer_getInstance(), value.frame);
    }
    if (tmp1_output.kp(tmp0_desc, 15) ? true : !(value.leg == null)) {
      tmp1_output.gp(tmp0_desc, 15, BooleanSerializer_getInstance(), value.leg);
    }
    if (tmp1_output.kp(tmp0_desc, 16) ? true : !(value.light == null)) {
      tmp1_output.gp(tmp0_desc, 16, $serializer_getInstance_18(), value.light);
    }
    if (tmp1_output.kp(tmp0_desc, 17) ? true : !(value.outlined == null)) {
      tmp1_output.gp(tmp0_desc, 17, BooleanSerializer_getInstance(), value.outlined);
    }
    if (tmp1_output.kp(tmp0_desc, 18) ? true : !(value.meta == null)) {
      tmp1_output.gp(tmp0_desc, 18, tmp2_cached[18], value.meta);
    }
    if (tmp1_output.kp(tmp0_desc, 19) ? true : !(value.propping == null)) {
      tmp1_output.gp(tmp0_desc, 19, BooleanSerializer_getInstance(), value.propping);
    }
    if (tmp1_output.kp(tmp0_desc, 20) ? true : !(value.alwaysHangDown == null)) {
      tmp1_output.gp(tmp0_desc, 20, BooleanSerializer_getInstance(), value.alwaysHangDown);
    }
    if (tmp1_output.kp(tmp0_desc, 21) ? true : !(value.serializeEntity == null)) {
      tmp1_output.gp(tmp0_desc, 21, BooleanSerializer_getInstance(), value.serializeEntity);
    }
    if (tmp1_output.kp(tmp0_desc, 22) ? true : !(value.placementZoneByHeight == null)) {
      tmp1_output.gp(tmp0_desc, 22, $serializer_getInstance_20(), value.placementZoneByHeight);
    }
    if (tmp1_output.kp(tmp0_desc, 23) ? true : !(value.functionalMargin == null)) {
      tmp1_output.gp(tmp0_desc, 23, MarginTemplateSerializer_getInstance(), value.functionalMargin);
    }
    if (tmp1_output.kp(tmp0_desc, 24) ? true : !(value.recommendedInitialPositionFromFloor == null)) {
      tmp1_output.gp(tmp0_desc, 24, IntSerializer_getInstance(), value.recommendedInitialPositionFromFloor);
    }
    if (tmp1_output.kp(tmp0_desc, 25) ? true : !(value.visualLightSource == null)) {
      tmp1_output.gp(tmp0_desc, 25, $serializer_getInstance_21(), value.visualLightSource);
    }
    if (tmp1_output.kp(tmp0_desc, 26) ? true : !(value.model3D == null)) {
      tmp1_output.gp(tmp0_desc, 26, $serializer_getInstance_19(), value.model3D);
    }
    if (tmp1_output.kp(tmp0_desc, 27) ? true : !(value.product == null)) {
      tmp1_output.gp(tmp0_desc, 27, $serializer_getInstance_13(), value.product);
    }
    if (tmp1_output.kp(tmp0_desc, 28) ? true : !(value.dragSurfaces == null)) {
      tmp1_output.gp(tmp0_desc, 28, CustomSerializer_getInstance_1(), value.dragSurfaces);
    }
    if (tmp1_output.kp(tmp0_desc, 29) ? true : !(value.dragProjectionPoint == null)) {
      tmp1_output.gp(tmp0_desc, 29, PositionTemplateSerializer_getInstance(), value.dragProjectionPoint);
    }
    if (tmp1_output.kp(tmp0_desc, 30) ? true : !(value.productStructure == null)) {
      tmp1_output.gp(tmp0_desc, 30, tmp2_cached[30], value.productStructure);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_12).pk = function (encoder, value) {
    return this.a44(encoder, value instanceof ComponentsTemplate ? value : THROW_CCE());
  };
  var $serializer_instance_12;
  function $serializer_getInstance_16() {
    if ($serializer_instance_12 == null)
      new $serializer_12();
    return $serializer_instance_12;
  }
  function ComponentsTemplate_init_$Init$(seen1, bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_16().z43_1);
    }
    if (0 === (seen1 & 1))
      $this.bounds = null;
    else
      $this.bounds = bounds;
    if (0 === (seen1 & 2))
      $this.functionalZones = null;
    else
      $this.functionalZones = functionalZones;
    if (0 === (seen1 & 4))
      $this.connectors = null;
    else
      $this.connectors = connectors;
    if (0 === (seen1 & 8))
      $this.assembly = null;
    else
      $this.assembly = assembly;
    if (0 === (seen1 & 16))
      $this.selectable = null;
    else
      $this.selectable = selectable;
    if (0 === (seen1 & 32))
      $this.outlineable = null;
    else
      $this.outlineable = outlineable;
    if (0 === (seen1 & 64))
      $this.draggable = null;
    else
      $this.draggable = draggable;
    if (0 === (seen1 & 128))
      $this.allowedDoorPairs = null;
    else
      $this.allowedDoorPairs = allowedDoorPairs;
    if (0 === (seen1 & 256))
      $this.autoAdaptHost = null;
    else
      $this.autoAdaptHost = autoAdaptHost;
    if (0 === (seen1 & 512))
      $this.communicationSize = null;
    else
      $this.communicationSize = communicationSize;
    if (0 === (seen1 & 1024))
      $this.door = null;
    else
      $this.door = door;
    if (0 === (seen1 & 2048))
      $this.doorFront = null;
    else
      $this.doorFront = doorFront;
    if (0 === (seen1 & 4096))
      $this.handle = null;
    else
      $this.handle = handle;
    if (0 === (seen1 & 8192))
      $this.drawer = null;
    else
      $this.drawer = drawer;
    if (0 === (seen1 & 16384))
      $this.frame = null;
    else
      $this.frame = frame;
    if (0 === (seen1 & 32768))
      $this.leg = null;
    else
      $this.leg = leg;
    if (0 === (seen1 & 65536))
      $this.light = null;
    else
      $this.light = light;
    if (0 === (seen1 & 131072))
      $this.outlined = null;
    else
      $this.outlined = outlined;
    if (0 === (seen1 & 262144))
      $this.meta = null;
    else
      $this.meta = meta;
    if (0 === (seen1 & 524288))
      $this.propping = null;
    else
      $this.propping = propping;
    if (0 === (seen1 & 1048576))
      $this.alwaysHangDown = null;
    else
      $this.alwaysHangDown = alwaysHangDown;
    if (0 === (seen1 & 2097152))
      $this.serializeEntity = null;
    else
      $this.serializeEntity = serializeEntity;
    if (0 === (seen1 & 4194304))
      $this.placementZoneByHeight = null;
    else
      $this.placementZoneByHeight = placementZoneByHeight;
    if (0 === (seen1 & 8388608))
      $this.functionalMargin = null;
    else
      $this.functionalMargin = functionalMargin;
    if (0 === (seen1 & 16777216))
      $this.recommendedInitialPositionFromFloor = null;
    else
      $this.recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor;
    if (0 === (seen1 & 33554432))
      $this.visualLightSource = null;
    else
      $this.visualLightSource = visualLightSource;
    if (0 === (seen1 & 67108864))
      $this.model3D = null;
    else
      $this.model3D = model3D;
    if (0 === (seen1 & 134217728))
      $this.product = null;
    else
      $this.product = product;
    if (0 === (seen1 & 268435456))
      $this.dragSurfaces = null;
    else
      $this.dragSurfaces = dragSurfaces;
    if (0 === (seen1 & 536870912))
      $this.dragProjectionPoint = null;
    else
      $this.dragProjectionPoint = dragProjectionPoint;
    if (0 === (seen1 & 1073741824))
      $this.productStructure = null;
    else
      $this.productStructure = productStructure;
    $this.n3x_1 = 0;
    return $this;
  }
  function ComponentsTemplate_init_$Create$(seen1, bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure, serializationConstructorMarker) {
    return ComponentsTemplate_init_$Init$(seen1, bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure, serializationConstructorMarker, objectCreate(protoOf(ComponentsTemplate)));
  }
  function ComponentsTemplate(bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure) {
    Companion_getInstance_26();
    bounds = bounds === VOID ? null : bounds;
    functionalZones = functionalZones === VOID ? null : functionalZones;
    connectors = connectors === VOID ? null : connectors;
    assembly = assembly === VOID ? null : assembly;
    selectable = selectable === VOID ? null : selectable;
    outlineable = outlineable === VOID ? null : outlineable;
    draggable = draggable === VOID ? null : draggable;
    allowedDoorPairs = allowedDoorPairs === VOID ? null : allowedDoorPairs;
    autoAdaptHost = autoAdaptHost === VOID ? null : autoAdaptHost;
    communicationSize = communicationSize === VOID ? null : communicationSize;
    door = door === VOID ? null : door;
    doorFront = doorFront === VOID ? null : doorFront;
    handle = handle === VOID ? null : handle;
    drawer = drawer === VOID ? null : drawer;
    frame = frame === VOID ? null : frame;
    leg = leg === VOID ? null : leg;
    light = light === VOID ? null : light;
    outlined = outlined === VOID ? null : outlined;
    meta = meta === VOID ? null : meta;
    propping = propping === VOID ? null : propping;
    alwaysHangDown = alwaysHangDown === VOID ? null : alwaysHangDown;
    serializeEntity = serializeEntity === VOID ? null : serializeEntity;
    placementZoneByHeight = placementZoneByHeight === VOID ? null : placementZoneByHeight;
    functionalMargin = functionalMargin === VOID ? null : functionalMargin;
    recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor === VOID ? null : recommendedInitialPositionFromFloor;
    visualLightSource = visualLightSource === VOID ? null : visualLightSource;
    model3D = model3D === VOID ? null : model3D;
    product = product === VOID ? null : product;
    dragSurfaces = dragSurfaces === VOID ? null : dragSurfaces;
    dragProjectionPoint = dragProjectionPoint === VOID ? null : dragProjectionPoint;
    productStructure = productStructure === VOID ? null : productStructure;
    this.bounds = bounds;
    this.functionalZones = functionalZones;
    this.connectors = connectors;
    this.assembly = assembly;
    this.selectable = selectable;
    this.outlineable = outlineable;
    this.draggable = draggable;
    this.allowedDoorPairs = allowedDoorPairs;
    this.autoAdaptHost = autoAdaptHost;
    this.communicationSize = communicationSize;
    this.door = door;
    this.doorFront = doorFront;
    this.handle = handle;
    this.drawer = drawer;
    this.frame = frame;
    this.leg = leg;
    this.light = light;
    this.outlined = outlined;
    this.meta = meta;
    this.propping = propping;
    this.alwaysHangDown = alwaysHangDown;
    this.serializeEntity = serializeEntity;
    this.placementZoneByHeight = placementZoneByHeight;
    this.functionalMargin = functionalMargin;
    this.recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor;
    this.visualLightSource = visualLightSource;
    this.model3D = model3D;
    this.product = product;
    this.dragSurfaces = dragSurfaces;
    this.dragProjectionPoint = dragProjectionPoint;
    this.productStructure = productStructure;
    this.n3x_1 = 0;
  }
  protoOf(ComponentsTemplate).b44 = function (_set____db54di) {
    this.bounds = _set____db54di;
  };
  protoOf(ComponentsTemplate).c44 = function () {
    return this.bounds;
  };
  protoOf(ComponentsTemplate).d44 = function (_set____db54di) {
    this.functionalZones = _set____db54di;
  };
  protoOf(ComponentsTemplate).e44 = function () {
    return this.functionalZones;
  };
  protoOf(ComponentsTemplate).f44 = function (_set____db54di) {
    this.connectors = _set____db54di;
  };
  protoOf(ComponentsTemplate).a1y = function () {
    return this.connectors;
  };
  protoOf(ComponentsTemplate).g44 = function (_set____db54di) {
    this.assembly = _set____db54di;
  };
  protoOf(ComponentsTemplate).h44 = function () {
    return this.assembly;
  };
  protoOf(ComponentsTemplate).i44 = function (_set____db54di) {
    this.selectable = _set____db54di;
  };
  protoOf(ComponentsTemplate).j44 = function () {
    return this.selectable;
  };
  protoOf(ComponentsTemplate).k44 = function (_set____db54di) {
    this.outlineable = _set____db54di;
  };
  protoOf(ComponentsTemplate).l44 = function () {
    return this.outlineable;
  };
  protoOf(ComponentsTemplate).m44 = function (_set____db54di) {
    this.draggable = _set____db54di;
  };
  protoOf(ComponentsTemplate).n44 = function () {
    return this.draggable;
  };
  protoOf(ComponentsTemplate).o44 = function (_set____db54di) {
    this.allowedDoorPairs = _set____db54di;
  };
  protoOf(ComponentsTemplate).p44 = function () {
    return this.allowedDoorPairs;
  };
  protoOf(ComponentsTemplate).q44 = function (_set____db54di) {
    this.autoAdaptHost = _set____db54di;
  };
  protoOf(ComponentsTemplate).r44 = function () {
    return this.autoAdaptHost;
  };
  protoOf(ComponentsTemplate).s44 = function (_set____db54di) {
    this.communicationSize = _set____db54di;
  };
  protoOf(ComponentsTemplate).t44 = function () {
    return this.communicationSize;
  };
  protoOf(ComponentsTemplate).u44 = function (_set____db54di) {
    this.door = _set____db54di;
  };
  protoOf(ComponentsTemplate).v44 = function () {
    return this.door;
  };
  protoOf(ComponentsTemplate).w44 = function (_set____db54di) {
    this.doorFront = _set____db54di;
  };
  protoOf(ComponentsTemplate).x44 = function () {
    return this.doorFront;
  };
  protoOf(ComponentsTemplate).y44 = function (_set____db54di) {
    this.handle = _set____db54di;
  };
  protoOf(ComponentsTemplate).z44 = function () {
    return this.handle;
  };
  protoOf(ComponentsTemplate).a45 = function (_set____db54di) {
    this.drawer = _set____db54di;
  };
  protoOf(ComponentsTemplate).b45 = function () {
    return this.drawer;
  };
  protoOf(ComponentsTemplate).c45 = function (_set____db54di) {
    this.frame = _set____db54di;
  };
  protoOf(ComponentsTemplate).d45 = function () {
    return this.frame;
  };
  protoOf(ComponentsTemplate).e45 = function (_set____db54di) {
    this.leg = _set____db54di;
  };
  protoOf(ComponentsTemplate).f45 = function () {
    return this.leg;
  };
  protoOf(ComponentsTemplate).g45 = function (_set____db54di) {
    this.light = _set____db54di;
  };
  protoOf(ComponentsTemplate).h45 = function () {
    return this.light;
  };
  protoOf(ComponentsTemplate).i45 = function (_set____db54di) {
    this.outlined = _set____db54di;
  };
  protoOf(ComponentsTemplate).j45 = function () {
    return this.outlined;
  };
  protoOf(ComponentsTemplate).k45 = function (_set____db54di) {
    this.meta = _set____db54di;
  };
  protoOf(ComponentsTemplate).z3x = function () {
    return this.meta;
  };
  protoOf(ComponentsTemplate).l45 = function (_set____db54di) {
    this.propping = _set____db54di;
  };
  protoOf(ComponentsTemplate).z3e = function () {
    return this.propping;
  };
  protoOf(ComponentsTemplate).m45 = function (_set____db54di) {
    this.alwaysHangDown = _set____db54di;
  };
  protoOf(ComponentsTemplate).n45 = function () {
    return this.alwaysHangDown;
  };
  protoOf(ComponentsTemplate).o45 = function (_set____db54di) {
    this.serializeEntity = _set____db54di;
  };
  protoOf(ComponentsTemplate).p45 = function () {
    return this.serializeEntity;
  };
  protoOf(ComponentsTemplate).q45 = function (_set____db54di) {
    this.placementZoneByHeight = _set____db54di;
  };
  protoOf(ComponentsTemplate).r45 = function () {
    return this.placementZoneByHeight;
  };
  protoOf(ComponentsTemplate).s45 = function (_set____db54di) {
    this.functionalMargin = _set____db54di;
  };
  protoOf(ComponentsTemplate).t45 = function () {
    return this.functionalMargin;
  };
  protoOf(ComponentsTemplate).u45 = function (_set____db54di) {
    this.recommendedInitialPositionFromFloor = _set____db54di;
  };
  protoOf(ComponentsTemplate).v45 = function () {
    return this.recommendedInitialPositionFromFloor;
  };
  protoOf(ComponentsTemplate).w45 = function (_set____db54di) {
    this.visualLightSource = _set____db54di;
  };
  protoOf(ComponentsTemplate).x45 = function () {
    return this.visualLightSource;
  };
  protoOf(ComponentsTemplate).y45 = function (_set____db54di) {
    this.model3D = _set____db54di;
  };
  protoOf(ComponentsTemplate).z45 = function () {
    return this.model3D;
  };
  protoOf(ComponentsTemplate).a46 = function (_set____db54di) {
    this.product = _set____db54di;
  };
  protoOf(ComponentsTemplate).n42 = function () {
    return this.product;
  };
  protoOf(ComponentsTemplate).b46 = function (_set____db54di) {
    this.dragSurfaces = _set____db54di;
  };
  protoOf(ComponentsTemplate).c46 = function () {
    return this.dragSurfaces;
  };
  protoOf(ComponentsTemplate).d46 = function (_set____db54di) {
    this.dragProjectionPoint = _set____db54di;
  };
  protoOf(ComponentsTemplate).e46 = function () {
    return this.dragProjectionPoint;
  };
  protoOf(ComponentsTemplate).f46 = function (_set____db54di) {
    this.productStructure = _set____db54di;
  };
  protoOf(ComponentsTemplate).g46 = function () {
    return this.productStructure;
  };
  protoOf(ComponentsTemplate).inherit = function (extendedComponents) {
    var tmp0_safe_receiver = this.bounds;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : inherit(tmp0_safe_receiver, extendedComponents.bounds);
    var tmp = tmp1_elvis_lhs == null ? extendedComponents.bounds : tmp1_elvis_lhs;
    var tmp2_safe_receiver = this.functionalZones;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : inherit(tmp2_safe_receiver, extendedComponents.functionalZones);
    var tmp_0 = tmp3_elvis_lhs == null ? extendedComponents.functionalZones : tmp3_elvis_lhs;
    var tmp4_safe_receiver = this.connectors;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : inherit_0(tmp4_safe_receiver, extendedComponents.connectors);
    var tmp_1 = tmp5_elvis_lhs == null ? extendedComponents.connectors : tmp5_elvis_lhs;
    var tmp6_safe_receiver = this.assembly;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.inherit(extendedComponents.assembly);
    var tmp_2 = tmp7_elvis_lhs == null ? extendedComponents.assembly : tmp7_elvis_lhs;
    var tmp8_elvis_lhs = this.selectable;
    var tmp_3 = tmp8_elvis_lhs == null ? extendedComponents.selectable : tmp8_elvis_lhs;
    var tmp9_elvis_lhs = this.outlineable;
    var tmp_4 = tmp9_elvis_lhs == null ? extendedComponents.outlineable : tmp9_elvis_lhs;
    var tmp10_elvis_lhs = this.draggable;
    var tmp_5 = tmp10_elvis_lhs == null ? extendedComponents.draggable : tmp10_elvis_lhs;
    var tmp11_elvis_lhs = this.allowedDoorPairs;
    var tmp_6 = tmp11_elvis_lhs == null ? extendedComponents.allowedDoorPairs : tmp11_elvis_lhs;
    var tmp12_elvis_lhs = this.autoAdaptHost;
    var tmp_7 = tmp12_elvis_lhs == null ? extendedComponents.autoAdaptHost : tmp12_elvis_lhs;
    var tmp13_elvis_lhs = this.communicationSize;
    var tmp_8 = tmp13_elvis_lhs == null ? extendedComponents.communicationSize : tmp13_elvis_lhs;
    var tmp14_elvis_lhs = this.door;
    var tmp_9 = tmp14_elvis_lhs == null ? extendedComponents.door : tmp14_elvis_lhs;
    var tmp15_elvis_lhs = this.doorFront;
    var tmp_10 = tmp15_elvis_lhs == null ? extendedComponents.doorFront : tmp15_elvis_lhs;
    var tmp16_elvis_lhs = this.handle;
    var tmp_11 = tmp16_elvis_lhs == null ? extendedComponents.handle : tmp16_elvis_lhs;
    var tmp17_elvis_lhs = this.drawer;
    var tmp_12 = tmp17_elvis_lhs == null ? extendedComponents.drawer : tmp17_elvis_lhs;
    var tmp18_elvis_lhs = this.frame;
    var tmp_13 = tmp18_elvis_lhs == null ? extendedComponents.frame : tmp18_elvis_lhs;
    var tmp19_elvis_lhs = this.leg;
    var tmp_14 = tmp19_elvis_lhs == null ? extendedComponents.leg : tmp19_elvis_lhs;
    var tmp20_elvis_lhs = this.light;
    var tmp_15 = tmp20_elvis_lhs == null ? extendedComponents.light : tmp20_elvis_lhs;
    var tmp21_elvis_lhs = this.outlined;
    var tmp_16 = tmp21_elvis_lhs == null ? extendedComponents.outlined : tmp21_elvis_lhs;
    var tmp_17 = Companion_getInstance_26().extendMeta(this.meta, extendedComponents.meta);
    var tmp22_elvis_lhs = this.propping;
    var tmp_18 = tmp22_elvis_lhs == null ? extendedComponents.propping : tmp22_elvis_lhs;
    var tmp23_elvis_lhs = this.alwaysHangDown;
    var tmp_19 = tmp23_elvis_lhs == null ? extendedComponents.alwaysHangDown : tmp23_elvis_lhs;
    var tmp24_elvis_lhs = this.serializeEntity;
    var tmp_20 = tmp24_elvis_lhs == null ? extendedComponents.serializeEntity : tmp24_elvis_lhs;
    var tmp25_elvis_lhs = this.placementZoneByHeight;
    var tmp_21 = tmp25_elvis_lhs == null ? extendedComponents.placementZoneByHeight : tmp25_elvis_lhs;
    var tmp26_elvis_lhs = this.functionalMargin;
    var tmp_22 = tmp26_elvis_lhs == null ? extendedComponents.functionalMargin : tmp26_elvis_lhs;
    var tmp27_elvis_lhs = this.recommendedInitialPositionFromFloor;
    var tmp_23 = tmp27_elvis_lhs == null ? extendedComponents.recommendedInitialPositionFromFloor : tmp27_elvis_lhs;
    var tmp28_elvis_lhs = this.visualLightSource;
    var tmp_24 = tmp28_elvis_lhs == null ? extendedComponents.visualLightSource : tmp28_elvis_lhs;
    var tmp29_elvis_lhs = this.dragSurfaces;
    var tmp_25 = tmp29_elvis_lhs == null ? extendedComponents.dragSurfaces : tmp29_elvis_lhs;
    var tmp30_elvis_lhs = this.dragProjectionPoint;
    return new ComponentsTemplate(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, VOID, VOID, tmp_25, tmp30_elvis_lhs == null ? extendedComponents.dragProjectionPoint : tmp30_elvis_lhs);
  };
  protoOf(ComponentsTemplate).equals = function (other) {
    return other === this;
  };
  protoOf(ComponentsTemplate).hashCode = function () {
    if (this.n3x_1 === 0) {
      var tmp = this;
      var tmp2_safe_receiver = this.communicationSize;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
      var tmp_0 = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
      var tmp0_safe_receiver = this.product;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
      tmp.n3x_1 = (tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0) + 1 | 0;
    }
    return this.n3x_1;
  };
  protoOf(ComponentsTemplate).getPolyhedronForSize = function (size) {
    var tmp0_safe_receiver = this.bounds;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : getPolyhedronForSize(tmp0_safe_receiver, size);
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ye_1;
  };
  protoOf(ComponentsTemplate).af = function () {
    return this.bounds;
  };
  protoOf(ComponentsTemplate).bf = function () {
    return this.functionalZones;
  };
  protoOf(ComponentsTemplate).g1k = function () {
    return this.connectors;
  };
  protoOf(ComponentsTemplate).h1k = function () {
    return this.assembly;
  };
  protoOf(ComponentsTemplate).i1k = function () {
    return this.selectable;
  };
  protoOf(ComponentsTemplate).j1k = function () {
    return this.outlineable;
  };
  protoOf(ComponentsTemplate).k1k = function () {
    return this.draggable;
  };
  protoOf(ComponentsTemplate).p1z = function () {
    return this.allowedDoorPairs;
  };
  protoOf(ComponentsTemplate).q1z = function () {
    return this.autoAdaptHost;
  };
  protoOf(ComponentsTemplate).r1z = function () {
    return this.communicationSize;
  };
  protoOf(ComponentsTemplate).s1z = function () {
    return this.door;
  };
  protoOf(ComponentsTemplate).t1z = function () {
    return this.doorFront;
  };
  protoOf(ComponentsTemplate).s21 = function () {
    return this.handle;
  };
  protoOf(ComponentsTemplate).t21 = function () {
    return this.drawer;
  };
  protoOf(ComponentsTemplate).h46 = function () {
    return this.frame;
  };
  protoOf(ComponentsTemplate).i46 = function () {
    return this.leg;
  };
  protoOf(ComponentsTemplate).j46 = function () {
    return this.light;
  };
  protoOf(ComponentsTemplate).k46 = function () {
    return this.outlined;
  };
  protoOf(ComponentsTemplate).l46 = function () {
    return this.meta;
  };
  protoOf(ComponentsTemplate).m46 = function () {
    return this.propping;
  };
  protoOf(ComponentsTemplate).n46 = function () {
    return this.alwaysHangDown;
  };
  protoOf(ComponentsTemplate).o46 = function () {
    return this.serializeEntity;
  };
  protoOf(ComponentsTemplate).p46 = function () {
    return this.placementZoneByHeight;
  };
  protoOf(ComponentsTemplate).q46 = function () {
    return this.functionalMargin;
  };
  protoOf(ComponentsTemplate).r46 = function () {
    return this.recommendedInitialPositionFromFloor;
  };
  protoOf(ComponentsTemplate).s46 = function () {
    return this.visualLightSource;
  };
  protoOf(ComponentsTemplate).t46 = function () {
    return this.model3D;
  };
  protoOf(ComponentsTemplate).u46 = function () {
    return this.product;
  };
  protoOf(ComponentsTemplate).v46 = function () {
    return this.dragSurfaces;
  };
  protoOf(ComponentsTemplate).w46 = function () {
    return this.dragProjectionPoint;
  };
  protoOf(ComponentsTemplate).x46 = function () {
    return this.productStructure;
  };
  protoOf(ComponentsTemplate).y46 = function (bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure) {
    return new ComponentsTemplate(bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure);
  };
  protoOf(ComponentsTemplate).copy = function (bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure, $super) {
    bounds = bounds === VOID ? this.bounds : bounds;
    functionalZones = functionalZones === VOID ? this.functionalZones : functionalZones;
    connectors = connectors === VOID ? this.connectors : connectors;
    assembly = assembly === VOID ? this.assembly : assembly;
    selectable = selectable === VOID ? this.selectable : selectable;
    outlineable = outlineable === VOID ? this.outlineable : outlineable;
    draggable = draggable === VOID ? this.draggable : draggable;
    allowedDoorPairs = allowedDoorPairs === VOID ? this.allowedDoorPairs : allowedDoorPairs;
    autoAdaptHost = autoAdaptHost === VOID ? this.autoAdaptHost : autoAdaptHost;
    communicationSize = communicationSize === VOID ? this.communicationSize : communicationSize;
    door = door === VOID ? this.door : door;
    doorFront = doorFront === VOID ? this.doorFront : doorFront;
    handle = handle === VOID ? this.handle : handle;
    drawer = drawer === VOID ? this.drawer : drawer;
    frame = frame === VOID ? this.frame : frame;
    leg = leg === VOID ? this.leg : leg;
    light = light === VOID ? this.light : light;
    outlined = outlined === VOID ? this.outlined : outlined;
    meta = meta === VOID ? this.meta : meta;
    propping = propping === VOID ? this.propping : propping;
    alwaysHangDown = alwaysHangDown === VOID ? this.alwaysHangDown : alwaysHangDown;
    serializeEntity = serializeEntity === VOID ? this.serializeEntity : serializeEntity;
    placementZoneByHeight = placementZoneByHeight === VOID ? this.placementZoneByHeight : placementZoneByHeight;
    functionalMargin = functionalMargin === VOID ? this.functionalMargin : functionalMargin;
    recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor === VOID ? this.recommendedInitialPositionFromFloor : recommendedInitialPositionFromFloor;
    visualLightSource = visualLightSource === VOID ? this.visualLightSource : visualLightSource;
    model3D = model3D === VOID ? this.model3D : model3D;
    product = product === VOID ? this.product : product;
    dragSurfaces = dragSurfaces === VOID ? this.dragSurfaces : dragSurfaces;
    dragProjectionPoint = dragProjectionPoint === VOID ? this.dragProjectionPoint : dragProjectionPoint;
    productStructure = productStructure === VOID ? this.productStructure : productStructure;
    return this.y46(bounds, functionalZones, connectors, assembly, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, communicationSize, door, doorFront, handle, drawer, frame, leg, light, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, model3D, product, dragSurfaces, dragProjectionPoint, productStructure);
  };
  protoOf(ComponentsTemplate).toString = function () {
    return 'ComponentsTemplate(bounds=' + toString(this.bounds) + ', functionalZones=' + toString(this.functionalZones) + ', connectors=' + toString(this.connectors) + ', assembly=' + this.assembly + ', selectable=' + this.selectable + ', outlineable=' + this.outlineable + ', draggable=' + this.draggable + ', allowedDoorPairs=' + toString(this.allowedDoorPairs) + ', autoAdaptHost=' + this.autoAdaptHost + ', communicationSize=' + this.communicationSize + ', door=' + this.door + ', doorFront=' + this.doorFront + ', handle=' + this.handle + ', drawer=' + this.drawer + ', frame=' + this.frame + ', leg=' + this.leg + ', light=' + this.light + ', outlined=' + this.outlined + ', meta=' + this.meta + ', propping=' + this.propping + ', alwaysHangDown=' + this.alwaysHangDown + ', serializeEntity=' + this.serializeEntity + ', placementZoneByHeight=' + this.placementZoneByHeight + ', functionalMargin=' + this.functionalMargin + ', recommendedInitialPositionFromFloor=' + this.recommendedInitialPositionFromFloor + ', visualLightSource=' + this.visualLightSource + ', model3D=' + this.model3D + ', product=' + this.product + ', dragSurfaces=' + this.dragSurfaces + ', dragProjectionPoint=' + this.dragProjectionPoint + ', productStructure=' + toString(this.productStructure) + ')';
  };
  function ConnectorItemTemplate$Companion$descriptor$lambda($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.cl('name', PrimitiveSerialDescriptor('name', STRING_getInstance()));
    $this$buildClassSerialDescriptor.cl('type', PrimitiveSerialDescriptor('type', STRING_getInstance()));
    $this$buildClassSerialDescriptor.cl('position', PositionTemplateSerializer_getInstance().a47_1);
    $this$buildClassSerialDescriptor.cl('lastPosition', PositionTemplateSerializer_getInstance().a47_1);
    $this$buildClassSerialDescriptor.cl('spacing', PrimitiveSerialDescriptor('type', STRING_getInstance()));
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer = serializer(StringCompanionObject_instance);
    var tmp$ret$0 = ArraySerializer(PrimitiveClasses_getInstance().u7(), elementSerializer);
    $this$buildClassSerialDescriptor.cl('offers', tmp$ret$0.ok());
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer_0 = serializer(StringCompanionObject_instance);
    var tmp$ret$1 = ArraySerializer(PrimitiveClasses_getInstance().u7(), elementSerializer_0);
    $this$buildClassSerialDescriptor.cl('demands', tmp$ret$1.ok());
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer_1 = serializer(StringCompanionObject_instance);
    var tmp$ret$2 = ArraySerializer(PrimitiveClasses_getInstance().u7(), elementSerializer_1);
    $this$buildClassSerialDescriptor.cl('tags', tmp$ret$2.ok());
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer_2 = PositionTemplateSerializer_getInstance().l17();
    var tmp$ret$3 = ArraySerializer(getKClass(PositionTemplate), elementSerializer_2);
    $this$buildClassSerialDescriptor.cl('vertices', tmp$ret$3.ok());
    $this$buildClassSerialDescriptor.cl('required', PrimitiveSerialDescriptor('required', BOOLEAN_getInstance()));
    $this$buildClassSerialDescriptor.cl('priority', PrimitiveSerialDescriptor('priority', INT_getInstance()));
    $this$buildClassSerialDescriptor.cl('activationDistance', PrimitiveSerialDescriptor('activationDistance', INT_getInstance()));
    $this$buildClassSerialDescriptor.cl('requireUpwardParent', PrimitiveSerialDescriptor('requireUpwardParent', BOOLEAN_getInstance()));
    $this$buildClassSerialDescriptor.cl('requireDownwardParent', PrimitiveSerialDescriptor('requireDownwardParent', BOOLEAN_getInstance()));
    $this$buildClassSerialDescriptor.cl('rotationDegreeOfFreedom', PrimitiveSerialDescriptor('type', STRING_getInstance()));
    return Unit_instance;
  }
  function _get_allPositions__bakiw2($this) {
    return $this.l3y_1;
  }
  function _get_firstPosition__de1tzc($this) {
    return $this.m3y_1;
  }
  function createConnector($this, type, size) {
    var tmp5_key = $this.name;
    var tmp6_transform = new Transform(Companion_getInstance_3().ZERO, _get_firstPosition__de1tzc($this).rotation);
    var tmp1_safe_receiver = $this.activationDistance;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp_0;
      if (type === 1) {
        tmp_0 = 0.0;
      } else {
        tmp_0 = 200.0;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var tmp7_activationDistance = tmp;
    var tmp0_elvis_lhs = $this.priority;
    var tmp8_priority = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp3_subject = $this.rotationDegreeOfFreedom.toUpperCase();
    var tmp_1;
    if (tmp3_subject === RotationDegreeOfFreedom_NONE_getInstance().toString()) {
      tmp_1 = RotationDegreeOfFreedom_NONE_getInstance().x9_1;
    } else if (tmp3_subject === RotationDegreeOfFreedom_ONE_getInstance().toString()) {
      tmp_1 = RotationDegreeOfFreedom_ONE_getInstance().x9_1;
    } else {
      throw new NotImplementedError($this.rotationDegreeOfFreedom);
    }
    var tmp9_rotationalDegreeOfFreedom = tmp_1;
    var tmp4_elvis_lhs = $this.required;
    var tmp10_required = tmp4_elvis_lhs == null ? false : tmp4_elvis_lhs;
    var pointConnector = new PointConnector(tmp5_key, type, tmp6_transform, tmp8_priority, tmp7_activationDistance, VOID, VOID, VOID, VOID, VOID, tmp9_rotationalDegreeOfFreedom, tmp10_required);
    return createRepositionedConnector($this, pointConnector, size);
  }
  function createSeriesConnector($this, type, size) {
    var tmp = Companion_getInstance_3().ZERO;
    var tmp_0 = Companion_getInstance_3().UP;
    var tmp_1 = _get_firstPosition__de1tzc($this).absoluteTransform.rotation;
    var tmp0_elvis_lhs = $this.priority;
    var tmp_2 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_safe_receiver = $this.activationDistance;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
    var tmp_3;
    if (tmp2_elvis_lhs == null) {
      var tmp_4;
      if (type === 1) {
        tmp_4 = 0.0;
      } else {
        tmp_4 = 200.0;
      }
      tmp_3 = tmp_4;
    } else {
      tmp_3 = tmp2_elvis_lhs;
    }
    var tmp_5 = tmp_3;
    var tmp_6 = ensureNotNull($this.spacing);
    var tmp3_elvis_lhs = $this.required;
    var seriesConnector = new PointSeriesConnector($this.name, type, tmp, tmp_0, tmp_1, tmp_2, tmp_5, VOID, VOID, VOID, VOID, VOID, tmp_6, tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs);
    return createRepositionedConnector($this, seriesConnector, size);
  }
  function createEdgeConnector($this, type, size) {
    var tmp = Companion_getInstance_3().ZERO;
    var tmp_0 = Companion_getInstance_3().UP;
    var tmp_1 = _get_firstPosition__de1tzc($this).absoluteTransform.rotation;
    var tmp0_elvis_lhs = $this.priority;
    var tmp_2 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_safe_receiver = $this.activationDistance;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
    var tmp_3;
    if (tmp2_elvis_lhs == null) {
      var tmp_4;
      if (type === 1) {
        tmp_4 = 0.0;
      } else {
        tmp_4 = 200.0;
      }
      tmp_3 = tmp_4;
    } else {
      tmp_3 = tmp2_elvis_lhs;
    }
    var tmp_5 = tmp_3;
    var tmp3_elvis_lhs = $this.required;
    var edgeConnector = new EdgeConnector($this.name, type, tmp, tmp_0, tmp_1, tmp_2, tmp_5, VOID, VOID, VOID, VOID, tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs);
    return createRepositionedConnector($this, edgeConnector, size);
  }
  function createSurfaceConnector($this, type, size) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = _get_allPositions__bakiw2($this);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.createSurfaceConnector.<anonymous>' call
        if (!element.rotation.equals(Companion_getInstance_2().IDENTITY)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    if (tmp$ret$1) {
      var tmp = Companion_getInstance_27().logger;
      tmp.warn(ConnectorItemTemplate$createSurfaceConnector$lambda);
    }
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [Companion_getInstance_3().LEFT, Companion_getInstance_3().UP, Companion_getInstance_3().RIGHT];
    var tmp0_elvis_lhs = $this.priority;
    var tmp_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_safe_receiver = $this.activationDistance;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
    var tmp_2;
    if (tmp2_elvis_lhs == null) {
      var tmp_3;
      if (type === 1) {
        tmp_3 = 0.0;
      } else {
        tmp_3 = 200.0;
      }
      tmp_2 = tmp_3;
    } else {
      tmp_2 = tmp2_elvis_lhs;
    }
    var tmp_4 = tmp_2;
    var tmp3_elvis_lhs = $this.required;
    var surfaceConnector = new SurfaceConnector($this.name, type, tmp_0, tmp_1, tmp_4, VOID, VOID, VOID, VOID, tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs);
    var tmp_5 = createRepositionedConnector($this, surfaceConnector, size);
    var tmp4_elvis_lhs = tmp_5 instanceof SurfaceConnector ? tmp_5 : null;
    var tmp_6;
    if (tmp4_elvis_lhs == null) {
      var message = 'A surface connector cannot not magically transform itself to a non SurfaceConnector';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_6 = tmp4_elvis_lhs;
    }
    surfaceConnector = tmp_6;
    if (surfaceConnector.vertices.length > 3) {
      var vertices = surfaceConnector.vertices;
      var plane = Companion_instance_2.createFromPoints(vertices[0], vertices[1], vertices[2]);
      var inductionVariable_0 = 3;
      var last_0 = _get_allPositions__bakiw2($this).length;
      if (inductionVariable_0 < last_0)
        do {
          var i = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var point = vertices[i];
          if (!plane.contains(point, 0.1)) {
            var tmp_7 = Companion_getInstance_27().logger;
            tmp_7.error(ConnectorItemTemplate$createSurfaceConnector$lambda_0(vertices, plane, point));
          }
        }
         while (inductionVariable_0 < last_0);
    }
    return surfaceConnector;
  }
  function createRepositionedConnector($this, connector, size) {
    var relativeConnectorInfo = $this.createRelativeConnectorData(size);
    var aabbFromSize = Companion_getInstance_0().fromSize(size.vector);
    return RelativeConnectorRepositioner_instance.repositionConnector(connector, relativeConnectorInfo, aabbFromSize);
  }
  function addTags($this, connector, tags) {
    if (tags == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tags.length;
      while (inductionVariable < last) {
        var element = tags[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.addTags.<anonymous>' call
        connector.withTag(element);
      }
    }
  }
  function addConnectorTags($this, connector, comSize, family, templateRef) {
    var tmp0_safe_receiver = $this.demands;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.addConnectorTags.<anonymous>' call
      connector.setDemands(convertMagicLabels($this, tmp0_safe_receiver, comSize, family, templateRef).slice());
    }
    var tmp1_safe_receiver = $this.offers;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.addConnectorTags.<anonymous>' call
      connector.setOffers(convertMagicLabels($this, tmp1_safe_receiver, comSize, family, templateRef).slice());
    }
    if (!($this.requireUpwardParent == null) ? $this.requireUpwardParent : false) {
      connector.withTag('requireUpwardParent');
    }
    if (!($this.requireDownwardParent == null) ? $this.requireDownwardParent : false) {
      connector.withTag('requireDownwardParent');
    }
    return connector;
  }
  function convertMagicLabels($this, labels, comSize, family, templateRef) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = labels.length;
    while (inductionVariable < last) {
      var element = labels[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.convertMagicLabels.<anonymous>' call
      switch (element) {
        case 'surface':
          var tmp$ret$0 = null;
          break;
        case 'family':
          tmp$ret$0 = 'family:' + family;
          break;
        case 'id':
          tmp$ret$0 = 'id:' + templateRef;
          break;
        case 'w':
          tmp$ret$0 = 'w:' + numberToInt(comSize.s2e_1);
          break;
        case 'h':
          tmp$ret$0 = 'h:' + numberToInt(comSize.t2e_1);
          break;
        case 'd':
          tmp$ret$0 = 'd:' + numberToInt(comSize.u2e_1);
          break;
        default:
          tmp$ret$0 = element;
          break;
      }
      var tmp0_safe_receiver = tmp$ret$0;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.q(tmp0_safe_receiver);
      }
    }
    return copyToArray(destination);
  }
  function Companion_21() {
    Companion_instance_26 = this;
    this.logger = LoggerState_getInstance().m1m('ConnectorItemTemplate');
    var tmp = this;
    tmp.d47_1 = buildClassSerialDescriptor('ConnectorItemTemplate', [], ConnectorItemTemplate$Companion$descriptor$lambda);
  }
  protoOf(Companion_21).x1i = function () {
    return this.logger;
  };
  protoOf(Companion_21).ok = function () {
    return this.d47_1;
  };
  protoOf(Companion_21).qk = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.d47_1;
    var composite = decoder.nn(descriptor);
    // Inline function 'com.ikea.range.dynamic.template.Companion.deserialize.<anonymous>' call
    var name = '';
    var type = 'internal';
    var position = PositionTemplateSerializer_getInstance().IDENTITY;
    var lastPosition = null;
    var spacing = null;
    var offers = null;
    var demands = null;
    var tags = null;
    var vertices = null;
    var required = false;
    var priority = null;
    var activationDistance = null;
    var requireUpwardParent = false;
    var requireDownwardParent = false;
    var rotationDegreeOfFreedom = RotationDegreeOfFreedom_NONE_getInstance().toString();
    loop: while (true) {
      var index = composite.eo(Companion_getInstance_27().d47_1);
      if (index === 0)
        name = composite.xn(Companion_getInstance_27().d47_1, 0);
      else {
        if (index === 1)
          type = composite.xn(Companion_getInstance_27().d47_1, 1);
        else {
          if (index === 2)
            position = composite.ao(Companion_getInstance_27().d47_1, 2, PositionTemplateSerializer_getInstance().l17());
          else {
            if (index === 3)
              lastPosition = composite.ao(Companion_getInstance_27().d47_1, 3, PositionTemplateSerializer_getInstance().l17());
            else {
              if (index === 4)
                spacing = composite.vn(Companion_getInstance_27().d47_1, 4);
              else {
                if (index === 5) {
                  var tmp = Companion_getInstance_27().d47_1;
                  // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
                  var elementSerializer = serializer(StringCompanionObject_instance);
                  var tmp$ret$0 = ArraySerializer(PrimitiveClasses_getInstance().u7(), elementSerializer);
                  offers = composite.ao(tmp, 5, tmp$ret$0);
                } else {
                  if (index === 6) {
                    var tmp_0 = Companion_getInstance_27().d47_1;
                    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
                    var elementSerializer_0 = serializer(StringCompanionObject_instance);
                    var tmp$ret$1 = ArraySerializer(PrimitiveClasses_getInstance().u7(), elementSerializer_0);
                    demands = composite.ao(tmp_0, 6, tmp$ret$1);
                  } else {
                    if (index === 7) {
                      var tmp_1 = Companion_getInstance_27().d47_1;
                      // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
                      var elementSerializer_1 = serializer(StringCompanionObject_instance);
                      var tmp$ret$2 = ArraySerializer(PrimitiveClasses_getInstance().u7(), elementSerializer_1);
                      tags = composite.ao(tmp_1, 7, tmp$ret$2);
                    } else {
                      if (index === 8) {
                        var tmp_2 = Companion_getInstance_27().d47_1;
                        // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
                        var elementSerializer_2 = PositionTemplateSerializer_getInstance().l17();
                        var tmp$ret$3 = ArraySerializer(getKClass(PositionTemplate), elementSerializer_2);
                        vertices = composite.ao(tmp_2, 8, tmp$ret$3);
                      } else {
                        if (index === 9)
                          required = composite.pn(Companion_getInstance_27().d47_1, 9);
                        else {
                          if (index === 10)
                            priority = composite.sn(Companion_getInstance_27().d47_1, 10);
                          else {
                            if (index === 11)
                              activationDistance = composite.sn(Companion_getInstance_27().d47_1, 11);
                            else {
                              if (index === 12)
                                requireUpwardParent = composite.pn(Companion_getInstance_27().d47_1, 12);
                              else {
                                if (index === 13)
                                  requireDownwardParent = composite.pn(Companion_getInstance_27().d47_1, 13);
                                else {
                                  if (index === 14)
                                    rotationDegreeOfFreedom = composite.xn(Companion_getInstance_27().d47_1, 14);
                                  else {
                                    if (index === -1)
                                      break loop;
                                    else {
                                      var message = 'Unexpected index: ' + index;
                                      throw IllegalStateException_init_$Create$(toString(message));
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    var result = new ConnectorItemTemplate(lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, VOID, VOID, required, requireUpwardParent, requireDownwardParent, VOID, rotationDegreeOfFreedom);
    composite.on(descriptor);
    return result;
  };
  protoOf(Companion_21).e47 = function (encoder, value) {
    var enc = encoder.nn(this.d47_1);
    enc.cp(this.d47_1, 0, value.name);
    enc.cp(this.d47_1, 1, value.type);
    if (value.vertices == null) {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var it = value.position;
      enc.ep(Companion_getInstance_27().d47_1, 2, PositionTemplateSerializer_getInstance().l17(), it);
      var tmp0_safe_receiver = value.lastPosition;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        enc.ep(Companion_getInstance_27().d47_1, 3, PositionTemplateSerializer_getInstance().l17(), tmp0_safe_receiver);
      }
      if (value.spacing == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (value.spacing > 0.0) {
          enc.ap(Companion_getInstance_27().d47_1, 4, value.spacing);
          tmp = Unit_instance;
        }
      }
    }
    var tmp2_safe_receiver = value.offers;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0 = Companion_getInstance_27().d47_1;
      // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
      var elementSerializer = serializer(StringCompanionObject_instance);
      var tmp$ret$3 = ArraySerializer(PrimitiveClasses_getInstance().u7(), elementSerializer);
      enc.ep(tmp_0, 5, tmp$ret$3, tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = value.demands;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_1 = Companion_getInstance_27().d47_1;
      // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
      var elementSerializer_0 = serializer(StringCompanionObject_instance);
      var tmp$ret$5 = ArraySerializer(PrimitiveClasses_getInstance().u7(), elementSerializer_0);
      enc.ep(tmp_1, 6, tmp$ret$5, tmp3_safe_receiver);
    }
    var tmp4_safe_receiver = value.tags;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_2 = Companion_getInstance_27().d47_1;
      // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
      var elementSerializer_1 = serializer(StringCompanionObject_instance);
      var tmp$ret$7 = ArraySerializer(PrimitiveClasses_getInstance().u7(), elementSerializer_1);
      enc.ep(tmp_2, 7, tmp$ret$7, tmp4_safe_receiver);
    }
    var tmp5_safe_receiver = value.vertices;
    if (tmp5_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_3 = Companion_getInstance_27().d47_1;
      // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
      var elementSerializer_2 = PositionTemplateSerializer_getInstance().l17();
      var tmp$ret$9 = ArraySerializer(getKClass(PositionTemplate), elementSerializer_2);
      enc.ep(tmp_3, 8, tmp$ret$9, tmp5_safe_receiver);
    }
    var tmp6_safe_receiver = value.required;
    if (tmp6_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_4;
      if (tmp6_safe_receiver) {
        enc.uo(Companion_getInstance_27().d47_1, 9, tmp6_safe_receiver);
        tmp_4 = Unit_instance;
      }
    }
    var tmp7_safe_receiver = value.priority;
    if (tmp7_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_5;
      if (!(tmp7_safe_receiver === 0)) {
        enc.xo(Companion_getInstance_27().d47_1, 10, tmp7_safe_receiver);
        tmp_5 = Unit_instance;
      }
    }
    var tmp8_safe_receiver = value.activationDistance;
    if (tmp8_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_6;
      if (value.type === 'host' ? !(tmp8_safe_receiver === 0) : false) {
        enc.xo(Companion_getInstance_27().d47_1, 11, tmp8_safe_receiver);
        tmp_6 = Unit_instance;
      } else if (value.type === 'guest' ? !(tmp8_safe_receiver === 200) : false) {
        enc.xo(Companion_getInstance_27().d47_1, 11, tmp8_safe_receiver);
        tmp_6 = Unit_instance;
      } else {
        enc.xo(Companion_getInstance_27().d47_1, 11, tmp8_safe_receiver);
        tmp_6 = Unit_instance;
      }
    }
    enc.cp(this.d47_1, 14, value.rotationDegreeOfFreedom);
    enc.on(this.d47_1);
  };
  protoOf(Companion_21).pk = function (encoder, value) {
    return this.e47(encoder, value instanceof ConnectorItemTemplate ? value : THROW_CCE());
  };
  protoOf(Companion_21).l17 = function () {
    return Companion_getInstance_27();
  };
  var Companion_instance_26;
  function Companion_getInstance_27() {
    if (Companion_instance_26 == null)
      new Companion_21();
    return Companion_instance_26;
  }
  function ConnectorItemTemplate$createSurfaceConnector$lambda() {
    return 'Rotation was specified on one or more vertices that defines a surface. A surface connector will determine its rotation by the normal of the surface, therefor the rotation implicitly specified will be ignored.';
  }
  function ConnectorItemTemplate$createSurfaceConnector$lambda_0($vertices, $plane, $point) {
    return function () {
      return 'All vertices specified for a surface was not in the same plane ' + $vertices + ' plane ' + $plane + ', point ' + $point;
    };
  }
  function ConnectorItemTemplate(lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, axis, angle, required, requireUpwardParent, requireDownwardParent, sourceTemplateId, rotationDegreeOfFreedom) {
    Companion_getInstance_27();
    lastPosition = lastPosition === VOID ? null : lastPosition;
    position = position === VOID ? PositionTemplateSerializer_getInstance().IDENTITY : position;
    vertices = vertices === VOID ? null : vertices;
    priority = priority === VOID ? null : priority;
    spacing = spacing === VOID ? null : spacing;
    activationDistance = activationDistance === VOID ? null : activationDistance;
    tags = tags === VOID ? null : tags;
    demands = demands === VOID ? null : demands;
    offers = offers === VOID ? null : offers;
    type = type === VOID ? 'internal' : type;
    axis = axis === VOID ? 'Y' : axis;
    angle = angle === VOID ? 0.0 : angle;
    required = required === VOID ? false : required;
    requireUpwardParent = requireUpwardParent === VOID ? false : requireUpwardParent;
    requireDownwardParent = requireDownwardParent === VOID ? false : requireDownwardParent;
    sourceTemplateId = sourceTemplateId === VOID ? '' : sourceTemplateId;
    rotationDegreeOfFreedom = rotationDegreeOfFreedom === VOID ? RotationDegreeOfFreedom_NONE_getInstance().toString() : rotationDegreeOfFreedom;
    this.lastPosition = lastPosition;
    this.name = name;
    this.position = position;
    this.vertices = vertices;
    this.priority = priority;
    this.spacing = spacing;
    this.activationDistance = activationDistance;
    this.tags = tags;
    this.demands = demands;
    this.offers = offers;
    this.type = type;
    this.axis = axis;
    this.angle = angle;
    this.required = required;
    this.requireUpwardParent = requireUpwardParent;
    this.requireDownwardParent = requireDownwardParent;
    this.sourceTemplateId = sourceTemplateId;
    this.rotationDegreeOfFreedom = rotationDegreeOfFreedom;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.l3y_1 = [];
    this.m3y_1 = new PositionTemplate(new OriginTemplate(new RelationOrigin(), OriginRelativeTo_SIZE_getInstance()));
    var tmp_0 = this;
    var tmp_1;
    if (!(this.vertices == null)) {
      tmp_1 = this.vertices;
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      var mutablePositions = ArrayList_init_$Create$_0();
      mutablePositions.q(this.position);
      if (!(this.lastPosition == null)) {
        mutablePositions.q(this.lastPosition);
      }
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_1 = copyToArray(mutablePositions);
    }
    tmp_0.l3y_1 = tmp_1;
    var tmp_2 = this;
    var tmp0_elvis_lhs = firstOrNull(this.l3y_1);
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      var message = 'IllegalState: A connector requires position or vertexPositions';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    tmp_2.m3y_1 = tmp_3;
    this.n3y_1 = 0;
  }
  protoOf(ConnectorItemTemplate).f47 = function () {
    return this.lastPosition;
  };
  protoOf(ConnectorItemTemplate).mb = function () {
    return this.name;
  };
  protoOf(ConnectorItemTemplate).ct = function () {
    return this.position;
  };
  protoOf(ConnectorItemTemplate).b23 = function () {
    return this.vertices;
  };
  protoOf(ConnectorItemTemplate).v1v = function () {
    return this.priority;
  };
  protoOf(ConnectorItemTemplate).g47 = function () {
    return this.spacing;
  };
  protoOf(ConnectorItemTemplate).l1x = function () {
    return this.activationDistance;
  };
  protoOf(ConnectorItemTemplate).c1y = function () {
    return this.tags;
  };
  protoOf(ConnectorItemTemplate).r3e = function () {
    return this.demands;
  };
  protoOf(ConnectorItemTemplate).h47 = function () {
    return this.offers;
  };
  protoOf(ConnectorItemTemplate).a1x = function () {
    return this.type;
  };
  protoOf(ConnectorItemTemplate).q2b = function () {
    return this.axis;
  };
  protoOf(ConnectorItemTemplate).r2b = function () {
    return this.angle;
  };
  protoOf(ConnectorItemTemplate).b1x = function () {
    return this.required;
  };
  protoOf(ConnectorItemTemplate).i47 = function () {
    return this.requireUpwardParent;
  };
  protoOf(ConnectorItemTemplate).j47 = function () {
    return this.requireDownwardParent;
  };
  protoOf(ConnectorItemTemplate).t43 = function (_set____db54di) {
    this.sourceTemplateId = _set____db54di;
  };
  protoOf(ConnectorItemTemplate).u43 = function () {
    return this.sourceTemplateId;
  };
  protoOf(ConnectorItemTemplate).k47 = function () {
    return this.rotationDegreeOfFreedom;
  };
  protoOf(ConnectorItemTemplate).isHost = function () {
    return this.type === 'host';
  };
  protoOf(ConnectorItemTemplate).isRelativeToBounds = function () {
    return _get_firstPosition__de1tzc(this).origin.kotlinRelativeTo.equals(OriginRelativeTo_BOUND_getInstance());
  };
  protoOf(ConnectorItemTemplate).getConnectorForSize = function (size, applyLabels) {
    var tmp;
    switch (this.type) {
      case 'guest':
        tmp = createConnector(this, 0, size);
        break;
      case 'host':
        var tmp_0;
        if (!(this.vertices == null)) {
          tmp_0 = createSurfaceConnector(this, 1, size);
        } else if (!(this.lastPosition == null) ? !(this.spacing == null) : false) {
          tmp_0 = createSeriesConnector(this, 1, size);
        } else if (!(this.lastPosition == null) ? this.spacing == null : false) {
          tmp_0 = createEdgeConnector(this, 1, size);
        } else {
          tmp_0 = createConnector(this, 1, size);
        }

        tmp = tmp_0;
        break;
      case 'align':
        var tmp_1;
        if (this.lastPosition == null) {
          tmp_1 = createConnector(this, 2, size);
        } else if (this.spacing == null) {
          tmp_1 = createEdgeConnector(this, 2, size);
        } else {
          tmp_1 = createSeriesConnector(this, 2, size);
        }

        tmp = tmp_1;
        break;
      case 'internal':
        tmp = createConnector(this, 3, size);
        break;
      default:
        var message = 'Connection type ' + this.type + ' not implemented';
        throw IllegalStateException_init_$Create$(toString(message));
    }
    var connector = tmp;
    applyLabels(connector);
    addTags(this, connector, this.tags);
    return connector;
  };
  protoOf(ConnectorItemTemplate).applyMagicLabels = function (connector, comSize, family, templateRef) {
    addConnectorTags(this, connector, comSize, family, templateRef);
  };
  protoOf(ConnectorItemTemplate).createRelativeConnectorData = function (size) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = _get_allPositions__bakiw2(this);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.ConnectorItemTemplate.createRelativeConnectorData.<anonymous>' call
      var position = item.relativeTransform.getPosition(size);
      var tmp$ret$0 = new RelativeBoxOffset(item.origin.relation, position);
      destination.q(tmp$ret$0);
    }
    var relativePositions = copyToArray(destination);
    return new RelativeConnectorData(this.name, relativePositions);
  };
  protoOf(ConnectorItemTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ConnectorItemTemplate))
      THROW_CCE();
    if (!(this.name === other.name))
      return false;
    if (!this.position.equals(other.position))
      return false;
    return true;
  };
  protoOf(ConnectorItemTemplate).hashCode = function () {
    if (this.n3y_1 === 0) {
      this.n3y_1 = imul(31, getStringHashCode(this.name)) + this.position.hashCode() | 0;
    }
    return this.n3y_1;
  };
  protoOf(ConnectorItemTemplate).af = function () {
    return this.lastPosition;
  };
  protoOf(ConnectorItemTemplate).bf = function () {
    return this.name;
  };
  protoOf(ConnectorItemTemplate).g1k = function () {
    return this.position;
  };
  protoOf(ConnectorItemTemplate).h1k = function () {
    return this.vertices;
  };
  protoOf(ConnectorItemTemplate).i1k = function () {
    return this.priority;
  };
  protoOf(ConnectorItemTemplate).j1k = function () {
    return this.spacing;
  };
  protoOf(ConnectorItemTemplate).k1k = function () {
    return this.activationDistance;
  };
  protoOf(ConnectorItemTemplate).p1z = function () {
    return this.tags;
  };
  protoOf(ConnectorItemTemplate).q1z = function () {
    return this.demands;
  };
  protoOf(ConnectorItemTemplate).r1z = function () {
    return this.offers;
  };
  protoOf(ConnectorItemTemplate).s1z = function () {
    return this.type;
  };
  protoOf(ConnectorItemTemplate).t1z = function () {
    return this.axis;
  };
  protoOf(ConnectorItemTemplate).s21 = function () {
    return this.angle;
  };
  protoOf(ConnectorItemTemplate).t21 = function () {
    return this.required;
  };
  protoOf(ConnectorItemTemplate).h46 = function () {
    return this.requireUpwardParent;
  };
  protoOf(ConnectorItemTemplate).i46 = function () {
    return this.requireDownwardParent;
  };
  protoOf(ConnectorItemTemplate).j46 = function () {
    return this.sourceTemplateId;
  };
  protoOf(ConnectorItemTemplate).k46 = function () {
    return this.rotationDegreeOfFreedom;
  };
  protoOf(ConnectorItemTemplate).l47 = function (lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, axis, angle, required, requireUpwardParent, requireDownwardParent, sourceTemplateId, rotationDegreeOfFreedom) {
    return new ConnectorItemTemplate(lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, axis, angle, required, requireUpwardParent, requireDownwardParent, sourceTemplateId, rotationDegreeOfFreedom);
  };
  protoOf(ConnectorItemTemplate).copy = function (lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, axis, angle, required, requireUpwardParent, requireDownwardParent, sourceTemplateId, rotationDegreeOfFreedom, $super) {
    lastPosition = lastPosition === VOID ? this.lastPosition : lastPosition;
    name = name === VOID ? this.name : name;
    position = position === VOID ? this.position : position;
    vertices = vertices === VOID ? this.vertices : vertices;
    priority = priority === VOID ? this.priority : priority;
    spacing = spacing === VOID ? this.spacing : spacing;
    activationDistance = activationDistance === VOID ? this.activationDistance : activationDistance;
    tags = tags === VOID ? this.tags : tags;
    demands = demands === VOID ? this.demands : demands;
    offers = offers === VOID ? this.offers : offers;
    type = type === VOID ? this.type : type;
    axis = axis === VOID ? this.axis : axis;
    angle = angle === VOID ? this.angle : angle;
    required = required === VOID ? this.required : required;
    requireUpwardParent = requireUpwardParent === VOID ? this.requireUpwardParent : requireUpwardParent;
    requireDownwardParent = requireDownwardParent === VOID ? this.requireDownwardParent : requireDownwardParent;
    sourceTemplateId = sourceTemplateId === VOID ? this.sourceTemplateId : sourceTemplateId;
    rotationDegreeOfFreedom = rotationDegreeOfFreedom === VOID ? this.rotationDegreeOfFreedom : rotationDegreeOfFreedom;
    return this.l47(lastPosition, name, position, vertices, priority, spacing, activationDistance, tags, demands, offers, type, axis, angle, required, requireUpwardParent, requireDownwardParent, sourceTemplateId, rotationDegreeOfFreedom);
  };
  protoOf(ConnectorItemTemplate).toString = function () {
    return 'ConnectorItemTemplate(lastPosition=' + this.lastPosition + ', name=' + this.name + ', position=' + this.position + ', vertices=' + toString(this.vertices) + ', priority=' + this.priority + ', spacing=' + this.spacing + ', activationDistance=' + this.activationDistance + ', tags=' + toString(this.tags) + ', demands=' + toString(this.demands) + ', offers=' + toString(this.offers) + ', type=' + this.type + ', axis=' + this.axis + ', angle=' + this.angle + ', required=' + this.required + ', requireUpwardParent=' + this.requireUpwardParent + ', requireDownwardParent=' + this.requireDownwardParent + ', sourceTemplateId=' + this.sourceTemplateId + ', rotationDegreeOfFreedom=' + this.rotationDegreeOfFreedom + ')';
  };
  function getConnectorsForSize(_this__u8e3s4, size, comSize, family, templateRef) {
    var tmp;
    // Inline function 'kotlin.collections.isEmpty' call
    if (_this__u8e3s4.length === 0) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(_this__u8e3s4.length);
      var inductionVariable = 0;
      var last = _this__u8e3s4.length;
      while (inductionVariable < last) {
        var item = _this__u8e3s4[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.template.getConnectorsForSize.<anonymous>' call
        var tmp$ret$2 = item.getConnectorForSize(size, getConnectorsForSize$lambda(item, comSize, family, templateRef));
        destination.q(tmp$ret$2);
      }
      tmp = copyToArray(destination);
    }
    return tmp;
  }
  function inherit_0(_this__u8e3s4, extendedConnectors) {
    var tmp;
    if (extendedConnectors == null) {
      tmp = _this__u8e3s4;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$_0();
      var inductionVariable = 0;
      var last = extendedConnectors.length;
      while (inductionVariable < last) {
        var element = extendedConnectors[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.template.inherit.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.none' call
          var inductionVariable_0 = 0;
          var last_0 = _this__u8e3s4.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = _this__u8e3s4[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.range.dynamic.template.inherit.<anonymous>.<anonymous>' call
            if (element_0.name === element.name) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
          tmp$ret$1 = true;
        }
        if (tmp$ret$1) {
          destination.q(element);
        }
      }
      tmp = plus_2(_this__u8e3s4, destination);
    }
    return tmp;
  }
  function getConnectorsForSize$lambda($connectorItem, $comSize, $family, $templateRef) {
    return function (it) {
      $connectorItem.applyMagicLabels(it, $comSize, $family, $templateRef);
      return Unit_instance;
    };
  }
  function calculateAxis($this, max, min, length, maxLength) {
    return (isNaN_0(max) ? isNaN_0(min) : false) ? 0.0 : isNaN_0(max) ? -maxLength / 2.0 + length / 2.0 + min : maxLength / 2.0 - length / 2.0 - max;
  }
  function Dimension$Companion$descriptor$lambda($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.cl('width', PrimitiveSerialDescriptor('width', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('left', PrimitiveSerialDescriptor('left', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('right', PrimitiveSerialDescriptor('right', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('height', PrimitiveSerialDescriptor('height', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('top', PrimitiveSerialDescriptor('top', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('bottom', PrimitiveSerialDescriptor('bottom', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('depth', PrimitiveSerialDescriptor('depth', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('front', PrimitiveSerialDescriptor('front', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('back', PrimitiveSerialDescriptor('back', DOUBLE_getInstance()));
    return Unit_instance;
  }
  function Companion_22() {
    Companion_instance_27 = this;
    var tmp = this;
    tmp.j43_1 = buildClassSerialDescriptor('Dimension', [], Dimension$Companion$descriptor$lambda);
  }
  protoOf(Companion_22).ok = function () {
    return this.j43_1;
  };
  protoOf(Companion_22).qk = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.j43_1;
    var composite = decoder.nn(descriptor);
    // Inline function 'com.ikea.range.dynamic.template.Companion.deserialize.<anonymous>' call
    var width = NaN;
    var left = NaN;
    var right = NaN;
    var height = NaN;
    var top = NaN;
    var bottom = NaN;
    var depth = NaN;
    var front = NaN;
    var back = NaN;
    loop: while (true) {
      var index = composite.eo(Companion_getInstance_28().j43_1);
      if (index === 0)
        width = composite.vn(Companion_getInstance_28().j43_1, 0);
      else {
        if (index === 1)
          left = composite.vn(Companion_getInstance_28().j43_1, 1);
        else {
          if (index === 2)
            right = composite.vn(Companion_getInstance_28().j43_1, 2);
          else {
            if (index === 3)
              height = composite.vn(Companion_getInstance_28().j43_1, 3);
            else {
              if (index === 4)
                top = composite.vn(Companion_getInstance_28().j43_1, 4);
              else {
                if (index === 5)
                  bottom = composite.vn(Companion_getInstance_28().j43_1, 5);
                else {
                  if (index === 6)
                    depth = composite.vn(Companion_getInstance_28().j43_1, 6);
                  else {
                    if (index === 7)
                      front = composite.vn(Companion_getInstance_28().j43_1, 7);
                    else {
                      if (index === 8)
                        back = composite.vn(Companion_getInstance_28().j43_1, 8);
                      else {
                        if (index === -1)
                          break loop;
                        else {
                          var message = 'Unexpected index: ' + index;
                          throw IllegalStateException_init_$Create$(toString(message));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    if (isNaN_0(width) ? isNaN_0(left) : false)
      left = 0.0;
    if (isNaN_0(width) ? isNaN_0(right) : false)
      right = 0.0;
    if (isNaN_0(height) ? isNaN_0(top) : false)
      top = 0.0;
    if (isNaN_0(height) ? isNaN_0(bottom) : false)
      bottom = 0.0;
    if (isNaN_0(depth) ? isNaN_0(front) : false)
      front = 0.0;
    if (isNaN_0(depth) ? isNaN_0(back) : false)
      back = 0.0;
    var result = new Dimension(back, bottom, depth, front, height, left, right, top, width);
    composite.on(descriptor);
    return result;
  };
  protoOf(Companion_22).m47 = function (encoder, value) {
    var enc = encoder.nn(this.j43_1);
    if (!isNaN_0(value.width)) {
      enc.ap(this.j43_1, 0, value.width);
    }
    if (!isNaN_0(value.left)) {
      enc.ap(this.j43_1, 1, value.left);
    }
    if (!isNaN_0(value.right)) {
      enc.ap(this.j43_1, 2, value.right);
    }
    if (!isNaN_0(value.height)) {
      enc.ap(this.j43_1, 3, value.height);
    }
    if (!isNaN_0(value.top)) {
      enc.ap(this.j43_1, 4, value.top);
    }
    if (!isNaN_0(value.bottom)) {
      enc.ap(this.j43_1, 5, value.bottom);
    }
    if (!isNaN_0(value.depth)) {
      enc.ap(this.j43_1, 6, value.depth);
    }
    if (!isNaN_0(value.front)) {
      enc.ap(this.j43_1, 7, value.front);
    }
    if (!isNaN_0(value.back)) {
      enc.ap(this.j43_1, 8, value.back);
    }
    enc.on(this.j43_1);
  };
  protoOf(Companion_22).pk = function (encoder, value) {
    return this.m47(encoder, value instanceof Dimension ? value : THROW_CCE());
  };
  protoOf(Companion_22).l17 = function () {
    return Companion_getInstance_28();
  };
  var Companion_instance_27;
  function Companion_getInstance_28() {
    if (Companion_instance_27 == null)
      new Companion_22();
    return Companion_instance_27;
  }
  function Dimension$lambda(this$0) {
    return function () {
      return "Properties 'width' (" + this$0.width + "), 'left' (" + this$0.left + ") and 'right' (" + this$0.right + ') are conflicting';
    };
  }
  function Dimension$lambda_0(this$0) {
    return function () {
      return "Properties 'height' (" + this$0.height + "), 'top' (" + this$0.top + ") and 'bottom' (" + this$0.bottom + ') are conflicting';
    };
  }
  function Dimension$lambda_1(this$0) {
    return function () {
      return "Properties 'depth' (" + this$0.depth + "), 'front' (" + this$0.front + ") and 'back' (" + this$0.back + ') are conflicting';
    };
  }
  function Dimension(back, bottom, depth, front, height, left, right, top, width) {
    Companion_getInstance_28();
    var tmp;
    if (back === VOID) {
      tmp = NaN;
    } else {
      tmp = back;
    }
    back = tmp;
    var tmp_0;
    if (bottom === VOID) {
      tmp_0 = NaN;
    } else {
      tmp_0 = bottom;
    }
    bottom = tmp_0;
    var tmp_1;
    if (depth === VOID) {
      tmp_1 = NaN;
    } else {
      tmp_1 = depth;
    }
    depth = tmp_1;
    var tmp_2;
    if (front === VOID) {
      tmp_2 = NaN;
    } else {
      tmp_2 = front;
    }
    front = tmp_2;
    var tmp_3;
    if (height === VOID) {
      tmp_3 = NaN;
    } else {
      tmp_3 = height;
    }
    height = tmp_3;
    var tmp_4;
    if (left === VOID) {
      tmp_4 = NaN;
    } else {
      tmp_4 = left;
    }
    left = tmp_4;
    var tmp_5;
    if (right === VOID) {
      tmp_5 = NaN;
    } else {
      tmp_5 = right;
    }
    right = tmp_5;
    var tmp_6;
    if (top === VOID) {
      tmp_6 = NaN;
    } else {
      tmp_6 = top;
    }
    top = tmp_6;
    var tmp_7;
    if (width === VOID) {
      tmp_7 = NaN;
    } else {
      tmp_7 = width;
    }
    width = tmp_7;
    this.back = back;
    this.bottom = bottom;
    this.depth = depth;
    this.front = front;
    this.height = height;
    this.left = left;
    this.right = right;
    this.top = top;
    this.width = width;
    this.n47_1 = LoggerState_getInstance().m1m('Dimension');
    if ((!isNaN_0(this.width) ? !isNaN_0(this.left) : false) ? !isNaN_0(this.right) : false) {
      this.n47_1.warn(Dimension$lambda(this));
    }
    if ((!isNaN_0(this.height) ? !isNaN_0(this.top) : false) ? !isNaN_0(this.bottom) : false) {
      this.n47_1.warn(Dimension$lambda_0(this));
    }
    if ((!isNaN_0(this.depth) ? !isNaN_0(this.front) : false) ? !isNaN_0(this.back) : false) {
      this.n47_1.warn(Dimension$lambda_1(this));
    }
  }
  protoOf(Dimension).g2c = function () {
    return this.back;
  };
  protoOf(Dimension).e2c = function () {
    return this.bottom;
  };
  protoOf(Dimension).w2b = function () {
    return this.depth;
  };
  protoOf(Dimension).h2c = function () {
    return this.front;
  };
  protoOf(Dimension).v2b = function () {
    return this.height;
  };
  protoOf(Dimension).f2c = function () {
    return this.left;
  };
  protoOf(Dimension).d2c = function () {
    return this.right;
  };
  protoOf(Dimension).c2c = function () {
    return this.top;
  };
  protoOf(Dimension).u2b = function () {
    return this.width;
  };
  protoOf(Dimension).getPolyhedronForSize = function (size) {
    var w = isNaN_0(this.width) ? size.s2e_1 - this.right - this.left : this.width;
    var h = isNaN_0(this.height) ? size.t2e_1 - this.top - this.bottom : this.height;
    var d = isNaN_0(this.depth) ? size.u2e_1 - this.back - this.front : this.depth;
    var x = calculateAxis(Companion_getInstance_28(), this.right, this.left, w, size.s2e_1);
    var y = calculateAxis(Companion_getInstance_28(), this.top, this.bottom, h, size.t2e_1);
    var z = -calculateAxis(Companion_getInstance_28(), this.back, this.front, d, size.u2e_1);
    return CuboidFromSizeAndCenter(new Vector(w, h, d), new Vector(x, y, z));
  };
  protoOf(Dimension).clone = function () {
    return this.copy();
  };
  protoOf(Dimension).af = function () {
    return this.back;
  };
  protoOf(Dimension).bf = function () {
    return this.bottom;
  };
  protoOf(Dimension).g1k = function () {
    return this.depth;
  };
  protoOf(Dimension).h1k = function () {
    return this.front;
  };
  protoOf(Dimension).i1k = function () {
    return this.height;
  };
  protoOf(Dimension).j1k = function () {
    return this.left;
  };
  protoOf(Dimension).k1k = function () {
    return this.right;
  };
  protoOf(Dimension).p1z = function () {
    return this.top;
  };
  protoOf(Dimension).q1z = function () {
    return this.width;
  };
  protoOf(Dimension).o47 = function (back, bottom, depth, front, height, left, right, top, width) {
    return new Dimension(back, bottom, depth, front, height, left, right, top, width);
  };
  protoOf(Dimension).copy = function (back, bottom, depth, front, height, left, right, top, width, $super) {
    back = back === VOID ? this.back : back;
    bottom = bottom === VOID ? this.bottom : bottom;
    depth = depth === VOID ? this.depth : depth;
    front = front === VOID ? this.front : front;
    height = height === VOID ? this.height : height;
    left = left === VOID ? this.left : left;
    right = right === VOID ? this.right : right;
    top = top === VOID ? this.top : top;
    width = width === VOID ? this.width : width;
    return this.o47(back, bottom, depth, front, height, left, right, top, width);
  };
  protoOf(Dimension).toString = function () {
    return 'Dimension(back=' + this.back + ', bottom=' + this.bottom + ', depth=' + this.depth + ', front=' + this.front + ', height=' + this.height + ', left=' + this.left + ', right=' + this.right + ', top=' + this.top + ', width=' + this.width + ')';
  };
  protoOf(Dimension).hashCode = function () {
    var result = getNumberHashCode(this.back);
    result = imul(result, 31) + getNumberHashCode(this.bottom) | 0;
    result = imul(result, 31) + getNumberHashCode(this.depth) | 0;
    result = imul(result, 31) + getNumberHashCode(this.front) | 0;
    result = imul(result, 31) + getNumberHashCode(this.height) | 0;
    result = imul(result, 31) + getNumberHashCode(this.left) | 0;
    result = imul(result, 31) + getNumberHashCode(this.right) | 0;
    result = imul(result, 31) + getNumberHashCode(this.top) | 0;
    result = imul(result, 31) + getNumberHashCode(this.width) | 0;
    return result;
  };
  protoOf(Dimension).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Dimension))
      return false;
    var tmp0_other_with_cast = other instanceof Dimension ? other : THROW_CCE();
    if (!equals(this.back, tmp0_other_with_cast.back))
      return false;
    if (!equals(this.bottom, tmp0_other_with_cast.bottom))
      return false;
    if (!equals(this.depth, tmp0_other_with_cast.depth))
      return false;
    if (!equals(this.front, tmp0_other_with_cast.front))
      return false;
    if (!equals(this.height, tmp0_other_with_cast.height))
      return false;
    if (!equals(this.left, tmp0_other_with_cast.left))
      return false;
    if (!equals(this.right, tmp0_other_with_cast.right))
      return false;
    if (!equals(this.top, tmp0_other_with_cast.top))
      return false;
    if (!equals(this.width, tmp0_other_with_cast.width))
      return false;
    return true;
  };
  function get_logger() {
    _init_properties_DragSurfaceTemplate_kt__pafc5d();
    return logger;
  }
  var logger;
  function createPolyhedronFromVertices($this, vertices, size) {
    var aabbFromSize = Companion_getInstance_0().fromSize(size.vector);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(vertices.length);
    var inductionVariable = 0;
    var last = vertices.length;
    while (inductionVariable < last) {
      var item = vertices[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.createPolyhedronFromVertices.<anonymous>' call
      var position = item.relativeTransform.getPosition(size);
      var tmp$ret$0 = new RelativeBoxOffset(item.origin.relation, position);
      destination.q(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var item_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.createPolyhedronFromVertices.<anonymous>' call
      var tmp$ret$3 = item_0.applyToBox(aabbFromSize);
      destination_0.q(tmp$ret$3);
    }
    var absoluteVertices = copyToArray(destination_0);
    return PolyhedronUtils_getInstance().singleSidedPolyhedronFromPolygon(absoluteVertices);
  }
  function Companion_23() {
    Companion_instance_28 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p47_1 = [null, null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().u7(), StringSerializer_getInstance()), new ReferenceArraySerializer(getKClass(PositionTemplate), PositionTemplateSerializer_getInstance())];
  }
  protoOf(Companion_23).l17 = function () {
    return $serializer_getInstance_17();
  };
  var Companion_instance_28;
  function Companion_getInstance_29() {
    if (Companion_instance_28 == null)
      new Companion_23();
    return Companion_instance_28;
  }
  function $serializer_13() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.DragSurfaceTemplate', this, 5);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('type', true);
    tmp0_serialDesc.cv('dimension', true);
    tmp0_serialDesc.cv('connectors', true);
    tmp0_serialDesc.cv('vertices', true);
    this.q47_1 = tmp0_serialDesc;
  }
  protoOf($serializer_13).ok = function () {
    return this.q47_1;
  };
  protoOf($serializer_13).rv = function () {
    var tmp0_cached = Companion_getInstance_29().p47_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(Companion_getInstance_28()), get_nullable(tmp0_cached[3]), get_nullable(tmp0_cached[4])];
  };
  protoOf($serializer_13).qk = function (decoder) {
    var tmp0_desc = this.q47_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.nn(tmp0_desc);
    var tmp10_cached = Companion_getInstance_29().p47_1;
    if (tmp9_input.do()) {
      tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.bo(tmp0_desc, 2, Companion_getInstance_28(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.bo(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.bo(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.bo(tmp0_desc, 2, Companion_getInstance_28(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.bo(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.bo(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.on(tmp0_desc);
    return DragSurfaceTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_13).r47 = function (encoder, value) {
    var tmp0_desc = this.q47_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_29().p47_1;
    tmp1_output.cp(tmp0_desc, 0, value.id);
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.type === 'box')) {
      tmp1_output.gp(tmp0_desc, 1, StringSerializer_getInstance(), value.type);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.dimension == null)) {
      tmp1_output.gp(tmp0_desc, 2, Companion_getInstance_28(), value.dimension);
    }
    if (tmp1_output.kp(tmp0_desc, 3) ? true : !(value.connectors == null)) {
      tmp1_output.gp(tmp0_desc, 3, tmp2_cached[3], value.connectors);
    }
    if (tmp1_output.kp(tmp0_desc, 4) ? true : !(value.vertices == null)) {
      tmp1_output.gp(tmp0_desc, 4, tmp2_cached[4], value.vertices);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_13).pk = function (encoder, value) {
    return this.r47(encoder, value instanceof DragSurfaceTemplate ? value : THROW_CCE());
  };
  var $serializer_instance_13;
  function $serializer_getInstance_17() {
    if ($serializer_instance_13 == null)
      new $serializer_13();
    return $serializer_instance_13;
  }
  function DragSurfaceTemplate_init_$Init$(seen1, id, type, dimension, connectors, vertices, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_17().q47_1);
    }
    $this.id = id;
    if (0 === (seen1 & 2))
      $this.type = 'box';
    else
      $this.type = type;
    if (0 === (seen1 & 4))
      $this.dimension = null;
    else
      $this.dimension = dimension;
    if (0 === (seen1 & 8))
      $this.connectors = null;
    else
      $this.connectors = connectors;
    if (0 === (seen1 & 16))
      $this.vertices = null;
    else
      $this.vertices = vertices;
    return $this;
  }
  function DragSurfaceTemplate_init_$Create$(seen1, id, type, dimension, connectors, vertices, serializationConstructorMarker) {
    return DragSurfaceTemplate_init_$Init$(seen1, id, type, dimension, connectors, vertices, serializationConstructorMarker, objectCreate(protoOf(DragSurfaceTemplate)));
  }
  function DragSurfaceTemplate$generateDragSurface$lambda() {
    return 'No vertices was specified for type=surface';
  }
  function DragSurfaceTemplate$generateDragSurface$lambda_0(this$0) {
    return function () {
      return 'Unsupported type ' + this$0.type;
    };
  }
  function DragSurfaceTemplate(id, type, dimension, connectors, vertices) {
    Companion_getInstance_29();
    type = type === VOID ? 'box' : type;
    dimension = dimension === VOID ? null : dimension;
    connectors = connectors === VOID ? null : connectors;
    vertices = vertices === VOID ? null : vertices;
    this.id = id;
    this.type = type;
    this.dimension = dimension;
    this.connectors = connectors;
    this.vertices = vertices;
  }
  protoOf(DragSurfaceTemplate).s1k = function () {
    return this.id;
  };
  protoOf(DragSurfaceTemplate).a1x = function () {
    return this.type;
  };
  protoOf(DragSurfaceTemplate).q43 = function () {
    return this.dimension;
  };
  protoOf(DragSurfaceTemplate).a1y = function () {
    return this.connectors;
  };
  protoOf(DragSurfaceTemplate).b23 = function () {
    return this.vertices;
  };
  protoOf(DragSurfaceTemplate).generateDragSurface = function (size) {
    var tmp;
    switch (this.type) {
      case 'box':
        var tmp_0;
        if (this.dimension == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.generateDragSurface.<anonymous>' call
          tmp_0 = this.dimension.getPolyhedronForSize(size);
        }

        var tmp5_elvis_lhs = tmp_0;
        var tmp_1;
        if (tmp5_elvis_lhs == null) {
          var tmp2_width = size.s2e_1;
          var tmp3_height = size.t2e_1;
          var tmp4_depth = size.u2e_1;
          tmp_1 = (new Dimension(VOID, VOID, tmp4_depth, VOID, tmp3_height, VOID, VOID, VOID, tmp2_width)).getPolyhedronForSize(size);
        } else {
          tmp_1 = tmp5_elvis_lhs;
        }

        tmp = tmp_1;
        break;
      case 'surface':
        var tmp$ret$5;
        $l$block: {
          // Inline function 'com.ikea.core.utils.orElse' call
          var tmp_2;
          if (this.vertices == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.generateDragSurface.<anonymous>' call
            tmp_2 = createPolyhedronFromVertices(this, this.vertices, size);
          }
          var this_0 = tmp_2;
          if (this_0 == null) {
            // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.generateDragSurface.<anonymous>' call
            var tmp_3 = get_logger();
            tmp_3.error(DragSurfaceTemplate$generateDragSurface$lambda);
            tmp$ret$5 = null;
            break $l$block;
          }
          tmp$ret$5 = this_0;
        }

        tmp = tmp$ret$5;
        break;
      default:
        var tmp_4 = get_logger();
        tmp_4.error(DragSurfaceTemplate$generateDragSurface$lambda_0(this));
        tmp = null;
        break;
    }
    var polyhedron = tmp;
    var tmp_5;
    if (polyhedron == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.dynamic.template.DragSurfaceTemplate.generateDragSurface.<anonymous>' call
      tmp_5 = new DragSurface(polyhedron, this.connectors);
    }
    return tmp_5;
  };
  protoOf(DragSurfaceTemplate).af = function () {
    return this.id;
  };
  protoOf(DragSurfaceTemplate).bf = function () {
    return this.type;
  };
  protoOf(DragSurfaceTemplate).g1k = function () {
    return this.dimension;
  };
  protoOf(DragSurfaceTemplate).h1k = function () {
    return this.connectors;
  };
  protoOf(DragSurfaceTemplate).i1k = function () {
    return this.vertices;
  };
  protoOf(DragSurfaceTemplate).s47 = function (id, type, dimension, connectors, vertices) {
    return new DragSurfaceTemplate(id, type, dimension, connectors, vertices);
  };
  protoOf(DragSurfaceTemplate).copy = function (id, type, dimension, connectors, vertices, $super) {
    id = id === VOID ? this.id : id;
    type = type === VOID ? this.type : type;
    dimension = dimension === VOID ? this.dimension : dimension;
    connectors = connectors === VOID ? this.connectors : connectors;
    vertices = vertices === VOID ? this.vertices : vertices;
    return this.s47(id, type, dimension, connectors, vertices);
  };
  protoOf(DragSurfaceTemplate).toString = function () {
    return 'DragSurfaceTemplate(id=' + this.id + ', type=' + this.type + ', dimension=' + this.dimension + ', connectors=' + toString(this.connectors) + ', vertices=' + toString(this.vertices) + ')';
  };
  protoOf(DragSurfaceTemplate).hashCode = function () {
    var result = getStringHashCode(this.id);
    result = imul(result, 31) + (this.type == null ? 0 : getStringHashCode(this.type)) | 0;
    result = imul(result, 31) + (this.dimension == null ? 0 : this.dimension.hashCode()) | 0;
    result = imul(result, 31) + (this.connectors == null ? 0 : hashCode(this.connectors)) | 0;
    result = imul(result, 31) + (this.vertices == null ? 0 : hashCode(this.vertices)) | 0;
    return result;
  };
  protoOf(DragSurfaceTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DragSurfaceTemplate))
      return false;
    var tmp0_other_with_cast = other instanceof DragSurfaceTemplate ? other : THROW_CCE();
    if (!(this.id === tmp0_other_with_cast.id))
      return false;
    if (!(this.type == tmp0_other_with_cast.type))
      return false;
    if (!equals(this.dimension, tmp0_other_with_cast.dimension))
      return false;
    if (!equals(this.connectors, tmp0_other_with_cast.connectors))
      return false;
    if (!equals(this.vertices, tmp0_other_with_cast.vertices))
      return false;
    return true;
  };
  function CustomSerializer_1() {
    CustomSerializer_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlinx.serialization.descriptors.listSerialDescriptor' call
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer_0(createKType(getKClass(DragSurfaceTemplate), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_0, KSerializer) ? this_0 : THROW_CCE();
    tmp.t47_1 = listSerialDescriptor(tmp$ret$1.ok());
  }
  protoOf(CustomSerializer_1).ok = function () {
    return this.t47_1;
  };
  protoOf(CustomSerializer_1).qk = function (decoder) {
    try {
      var sameAsCollider = decoder.an();
      return new DragSurfacesTemplate(sameAsCollider);
    } catch ($p) {
      if ($p instanceof SerializationException) {
        var e = $p;
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.t47_1;
        var composite = decoder.nn(descriptor);
        // Inline function 'com.ikea.range.dynamic.template.CustomSerializer.deserialize.<anonymous>' call
        // Inline function 'kotlin.collections.mutableListOf' call
        var surfaces = ArrayList_init_$Create$_0();
        loop: while (true) {
          var index = composite.eo(CustomSerializer_getInstance_1().t47_1);
          if (index === -1)
            break loop;
          else {
            surfaces.q(composite.ao(CustomSerializer_getInstance_1().t47_1, index, Companion_getInstance_29().l17()));
          }
        }
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$1 = copyToArray(surfaces);
        var result = new DragSurfacesTemplate(false, tmp$ret$1);
        composite.on(descriptor);
        return result;
      } else {
        throw $p;
      }
    }
  };
  protoOf(CustomSerializer_1).u47 = function (encoder, value) {
    if (value.sameAsCollider) {
      encoder.jo(true);
    } else {
      var enc = encoder.nn(this.t47_1);
      var tmp0_safe_receiver = value.surfaces;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.template.CustomSerializer.serialize.<anonymous>' call
          var tmp1 = index;
          index = tmp1 + 1 | 0;
          enc.ep(CustomSerializer_getInstance_1().t47_1, tmp1, Companion_getInstance_29().l17(), item);
        }
      }
      enc.on(this.t47_1);
    }
  };
  protoOf(CustomSerializer_1).pk = function (encoder, value) {
    return this.u47(encoder, value instanceof DragSurfacesTemplate ? value : THROW_CCE());
  };
  protoOf(CustomSerializer_1).l17 = function () {
    return CustomSerializer_getInstance_1();
  };
  var CustomSerializer_instance_1;
  function CustomSerializer_getInstance_1() {
    if (CustomSerializer_instance_1 == null)
      new CustomSerializer_1();
    return CustomSerializer_instance_1;
  }
  function DragSurfacesTemplate(sameAsCollider, surfaces) {
    CustomSerializer_getInstance_1();
    surfaces = surfaces === VOID ? null : surfaces;
    this.sameAsCollider = sameAsCollider;
    this.surfaces = surfaces;
  }
  protoOf(DragSurfacesTemplate).v47 = function () {
    return this.sameAsCollider;
  };
  protoOf(DragSurfacesTemplate).l23 = function () {
    return this.surfaces;
  };
  protoOf(DragSurfacesTemplate).generateDragSurface = function (size, collider) {
    var tmp;
    if (this.sameAsCollider) {
      var tmp_0;
      if (collider == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.template.DragSurfacesTemplate.generateDragSurface.<anonymous>' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = [new DragSurface(collider, null)];
      }
      tmp = tmp_0;
    } else {
      var tmp1_safe_receiver = this.surfaces;
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList_init_$Create$_0();
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
          // Inline function 'com.ikea.range.dynamic.template.DragSurfacesTemplate.generateDragSurface.<anonymous>' call
          var tmp0_safe_receiver = element.generateDragSurface(size);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.q(tmp0_safe_receiver);
          }
        }
        tmp_1 = destination;
      }
      var tmp2_safe_receiver = tmp_1;
      var tmp_2;
      if (tmp2_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp_2 = copyToArray(tmp2_safe_receiver);
      }
      var tmp3_elvis_lhs = tmp_2;
      var tmp_3;
      if (tmp3_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_3 = [];
      } else {
        tmp_3 = tmp3_elvis_lhs;
      }
      var polyhedronForSurfaces = tmp_3;
      var tmp_4;
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (!(polyhedronForSurfaces.length === 0)) {
        tmp_4 = polyhedronForSurfaces;
      } else {
        tmp_4 = null;
      }
      tmp = tmp_4;
    }
    return tmp;
  };
  protoOf(DragSurfacesTemplate).af = function () {
    return this.sameAsCollider;
  };
  protoOf(DragSurfacesTemplate).bf = function () {
    return this.surfaces;
  };
  protoOf(DragSurfacesTemplate).w47 = function (sameAsCollider, surfaces) {
    return new DragSurfacesTemplate(sameAsCollider, surfaces);
  };
  protoOf(DragSurfacesTemplate).copy = function (sameAsCollider, surfaces, $super) {
    sameAsCollider = sameAsCollider === VOID ? this.sameAsCollider : sameAsCollider;
    surfaces = surfaces === VOID ? this.surfaces : surfaces;
    return this.w47(sameAsCollider, surfaces);
  };
  protoOf(DragSurfacesTemplate).toString = function () {
    return 'DragSurfacesTemplate(sameAsCollider=' + this.sameAsCollider + ', surfaces=' + toString(this.surfaces) + ')';
  };
  protoOf(DragSurfacesTemplate).hashCode = function () {
    var result = getBooleanHashCode(this.sameAsCollider);
    result = imul(result, 31) + (this.surfaces == null ? 0 : hashCode(this.surfaces)) | 0;
    return result;
  };
  protoOf(DragSurfacesTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DragSurfacesTemplate))
      return false;
    var tmp0_other_with_cast = other instanceof DragSurfacesTemplate ? other : THROW_CCE();
    if (!(this.sameAsCollider === tmp0_other_with_cast.sameAsCollider))
      return false;
    if (!equals(this.surfaces, tmp0_other_with_cast.surfaces))
      return false;
    return true;
  };
  var properties_initialized_DragSurfaceTemplate_kt_d8qnnn;
  function _init_properties_DragSurfaceTemplate_kt__pafc5d() {
    if (!properties_initialized_DragSurfaceTemplate_kt_d8qnnn) {
      properties_initialized_DragSurfaceTemplate_kt_d8qnnn = true;
      logger = LoggerState_getInstance().m1m('DragSurfaceTemplate');
    }
  }
  function DynamicRangeUtils$Companion$StrictPretty$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    return Unit_instance;
  }
  function DynamicRangeUtils$Companion$AssemblyPretty$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    $this$Json.c16_1 = false;
    return Unit_instance;
  }
  function DynamicRangeUtils$Companion$createConnector$lambda($template, $comSize, $family, $templateId) {
    return function (it) {
      $template.applyMagicLabels(it, new Size($comSize[0], $comSize[1], $comSize[2]), $family, $templateId);
      return Unit_instance;
    };
  }
  function Companion_24() {
    Companion_instance_29 = this;
    var tmp = this;
    tmp.x47_1 = Json(VOID, DynamicRangeUtils$Companion$StrictPretty$lambda);
    var tmp_0 = this;
    tmp_0.y47_1 = Json(VOID, DynamicRangeUtils$Companion$AssemblyPretty$lambda);
  }
  protoOf(Companion_24).createConnector = function (connectorJson, size, comSize, family, templateId) {
    // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
    var this_0 = this.x47_1;
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.co();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_1(this_1, createKType(getKClass(ConnectorItemTemplate), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var template = this_0.j15(tmp$ret$1, connectorJson);
    var tmp = new Size(size[0], size[1], size[2]);
    return template.getConnectorForSize(tmp, DynamicRangeUtils$Companion$createConnector$lambda(template, comSize, family, templateId));
  };
  protoOf(Companion_24).arrayToMargin = function (margin) {
    var tmp0_top = margin[0];
    var tmp1_bottom = margin[1];
    var tmp2_left = margin[2];
    var tmp3_right = margin[3];
    var tmp4_front = margin[4];
    var tmp5_back = margin[5];
    return new Margin(tmp0_top, tmp3_right, tmp1_bottom, tmp2_left, tmp5_back, tmp4_front);
  };
  protoOf(Companion_24).assemblyToJson = function (assembly) {
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = this.y47_1;
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.co();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_1(this_1, createKType(getKClass(AssemblyTemplate), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    return this_0.i15(tmp$ret$1, assembly);
  };
  protoOf(Companion_24).boundsToJson = function (bounds) {
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer = Companion_getInstance_24().l17();
    var tmp$ret$0 = ArraySerializer(getKClass(BoundItemTemplate), elementSerializer);
    return this.x47_1.i15(tmp$ret$0, bounds);
  };
  protoOf(Companion_24).connectorsToJson = function (connectors) {
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer = Companion_getInstance_27();
    var tmp$ret$0 = ArraySerializer(getKClass(ConnectorItemTemplate), elementSerializer);
    return this.x47_1.i15(tmp$ret$0, connectors);
  };
  protoOf(Companion_24).jsonToAssembly = function (json) {
    return Default_getInstance().j15(Companion_getInstance_23().l17(), json);
  };
  protoOf(Companion_24).jsonToBounds = function (json) {
    var tmp = Default_getInstance();
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer = Companion_getInstance_24().l17();
    var tmp$ret$0 = ArraySerializer(getKClass(BoundItemTemplate), elementSerializer);
    return tmp.j15(tmp$ret$0, json);
  };
  protoOf(Companion_24).jsonToConnectors = function (json) {
    var tmp = Default_getInstance();
    // Inline function 'kotlinx.serialization.builtins.ArraySerializer' call
    var elementSerializer = Companion_getInstance_27().l17();
    var tmp$ret$0 = ArraySerializer(getKClass(ConnectorItemTemplate), elementSerializer);
    return tmp.j15(tmp$ret$0, json);
  };
  protoOf(Companion_24).productTemplateToJson = function (template) {
    try {
      return this.x47_1.i15(Companion_getInstance_12().l17(), template);
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        // Inline function 'kotlin.error' call
        var message = toString_0(e.message);
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        throw $p;
      }
    }
  };
  var Companion_instance_29;
  function Companion_getInstance_30() {
    if (Companion_instance_29 == null)
      new Companion_24();
    return Companion_instance_29;
  }
  function DynamicRangeUtils() {
    Companion_getInstance_30();
  }
  function Companion_25() {
  }
  protoOf(Companion_25).l17 = function () {
    return $serializer_getInstance_18();
  };
  var Companion_instance_30;
  function Companion_getInstance_31() {
    return Companion_instance_30;
  }
  function $serializer_14() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.LightTemplate', this, 1);
    tmp0_serialDesc.cv('type', true);
    this.z47_1 = tmp0_serialDesc;
  }
  protoOf($serializer_14).ok = function () {
    return this.z47_1;
  };
  protoOf($serializer_14).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_14).qk = function (decoder) {
    var tmp0_desc = this.z47_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.nn(tmp0_desc);
    if (tmp5_input.do()) {
      tmp4_local0 = tmp5_input.bo(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.bo(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.on(tmp0_desc);
    return LightTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_14).a48 = function (encoder, value) {
    var tmp0_desc = this.z47_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !(value.type == null)) {
      tmp1_output.gp(tmp0_desc, 0, StringSerializer_getInstance(), value.type);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_14).pk = function (encoder, value) {
    return this.a48(encoder, value instanceof LightTemplate ? value : THROW_CCE());
  };
  var $serializer_instance_14;
  function $serializer_getInstance_18() {
    if ($serializer_instance_14 == null)
      new $serializer_14();
    return $serializer_instance_14;
  }
  function LightTemplate_init_$Init$(seen1, type, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_18().z47_1);
    }
    if (0 === (seen1 & 1))
      $this.type = null;
    else
      $this.type = type;
    return $this;
  }
  function LightTemplate_init_$Create$(seen1, type, serializationConstructorMarker) {
    return LightTemplate_init_$Init$(seen1, type, serializationConstructorMarker, objectCreate(protoOf(LightTemplate)));
  }
  function LightTemplate(type) {
    type = type === VOID ? null : type;
    this.type = type;
  }
  protoOf(LightTemplate).a1x = function () {
    return this.type;
  };
  protoOf(LightTemplate).af = function () {
    return this.type;
  };
  protoOf(LightTemplate).b48 = function (type) {
    return new LightTemplate(type);
  };
  protoOf(LightTemplate).copy = function (type, $super) {
    type = type === VOID ? this.type : type;
    return this.b48(type);
  };
  protoOf(LightTemplate).toString = function () {
    return 'LightTemplate(type=' + this.type + ')';
  };
  protoOf(LightTemplate).hashCode = function () {
    return this.type == null ? 0 : getStringHashCode(this.type);
  };
  protoOf(LightTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LightTemplate))
      return false;
    var tmp0_other_with_cast = other instanceof LightTemplate ? other : THROW_CCE();
    if (!(this.type == tmp0_other_with_cast.type))
      return false;
    return true;
  };
  function d(_this__u8e3s4, $this, key) {
    var tmp0_safe_receiver = _this__u8e3s4.o17(key);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : get_double(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
  }
  function encodeNonZeroDoubleElement(_this__u8e3s4, $this, descriptor, index, value) {
    if (!(value === 0.0)) {
      _this__u8e3s4.ap(descriptor, index, value);
    }
  }
  function MarginTemplate$MarginTemplateSerializer$descriptor$lambda($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.cl('top', PrimitiveSerialDescriptor('top', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('bottom', PrimitiveSerialDescriptor('bottom', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('left', PrimitiveSerialDescriptor('left', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('right', PrimitiveSerialDescriptor('right', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('front', PrimitiveSerialDescriptor('front', DOUBLE_getInstance()));
    $this$buildClassSerialDescriptor.cl('back', PrimitiveSerialDescriptor('back', DOUBLE_getInstance()));
    return Unit_instance;
  }
  function MarginTemplateSerializer() {
    MarginTemplateSerializer_instance = this;
    var tmp = this;
    tmp.m43_1 = buildClassSerialDescriptor('MarginTemplate', [], MarginTemplate$MarginTemplateSerializer$descriptor$lambda);
  }
  protoOf(MarginTemplateSerializer).qk = function (decoder) {
    var element = decoder.mn(Companion_instance_3.l17());
    var tmp;
    if (element instanceof JsonObject) {
      var top = d(element, this, 'top');
      var bottom = d(element, this, 'bottom');
      var left = d(element, this, 'left');
      var right = d(element, this, 'right');
      var front = d(element, this, 'front');
      var back = d(element, this, 'back');
      tmp = new MarginTemplate(top, bottom, left, right, front, back);
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = get_jsonArray(element);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        // Inline function 'com.ikea.range.dynamic.template.MarginTemplateSerializer.deserialize.<anonymous>' call
        var tmp$ret$0 = get_double(get_jsonPrimitive(item));
        destination.q(tmp$ret$0);
      }
      var array = destination;
      tmp = new MarginTemplate(array.f1(0), array.f1(1), array.f1(2), array.f1(3), array.f1(4), array.f1(5));
    }
    return tmp;
  };
  protoOf(MarginTemplateSerializer).ok = function () {
    return this.m43_1;
  };
  protoOf(MarginTemplateSerializer).c48 = function (encoder, value) {
    var enc = encoder.nn(this.m43_1);
    encodeNonZeroDoubleElement(enc, this, this.m43_1, 0, value.top);
    encodeNonZeroDoubleElement(enc, this, this.m43_1, 1, value.bottom);
    encodeNonZeroDoubleElement(enc, this, this.m43_1, 2, value.left);
    encodeNonZeroDoubleElement(enc, this, this.m43_1, 3, value.right);
    encodeNonZeroDoubleElement(enc, this, this.m43_1, 4, value.front);
    encodeNonZeroDoubleElement(enc, this, this.m43_1, 5, value.back);
    enc.on(this.m43_1);
  };
  protoOf(MarginTemplateSerializer).pk = function (encoder, value) {
    return this.c48(encoder, value instanceof MarginTemplate ? value : THROW_CCE());
  };
  protoOf(MarginTemplateSerializer).l17 = function () {
    return MarginTemplateSerializer_getInstance();
  };
  var MarginTemplateSerializer_instance;
  function MarginTemplateSerializer_getInstance() {
    if (MarginTemplateSerializer_instance == null)
      new MarginTemplateSerializer();
    return MarginTemplateSerializer_instance;
  }
  function MarginTemplate(top, bottom, left, right, front, back) {
    MarginTemplateSerializer_getInstance();
    top = top === VOID ? 0.0 : top;
    bottom = bottom === VOID ? 0.0 : bottom;
    left = left === VOID ? 0.0 : left;
    right = right === VOID ? 0.0 : right;
    front = front === VOID ? 0.0 : front;
    back = back === VOID ? 0.0 : back;
    this.top = top;
    this.bottom = bottom;
    this.left = left;
    this.right = right;
    this.front = front;
    this.back = back;
  }
  protoOf(MarginTemplate).c2c = function () {
    return this.top;
  };
  protoOf(MarginTemplate).e2c = function () {
    return this.bottom;
  };
  protoOf(MarginTemplate).f2c = function () {
    return this.left;
  };
  protoOf(MarginTemplate).d2c = function () {
    return this.right;
  };
  protoOf(MarginTemplate).h2c = function () {
    return this.front;
  };
  protoOf(MarginTemplate).g2c = function () {
    return this.back;
  };
  protoOf(MarginTemplate).toMargin = function () {
    return new Margin(this.top, this.right, this.bottom, this.left, this.back, this.front);
  };
  protoOf(MarginTemplate).clone = function () {
    return this.copy();
  };
  protoOf(MarginTemplate).af = function () {
    return this.top;
  };
  protoOf(MarginTemplate).bf = function () {
    return this.bottom;
  };
  protoOf(MarginTemplate).g1k = function () {
    return this.left;
  };
  protoOf(MarginTemplate).h1k = function () {
    return this.right;
  };
  protoOf(MarginTemplate).i1k = function () {
    return this.front;
  };
  protoOf(MarginTemplate).j1k = function () {
    return this.back;
  };
  protoOf(MarginTemplate).i2c = function (top, bottom, left, right, front, back) {
    return new MarginTemplate(top, bottom, left, right, front, back);
  };
  protoOf(MarginTemplate).copy = function (top, bottom, left, right, front, back, $super) {
    top = top === VOID ? this.top : top;
    bottom = bottom === VOID ? this.bottom : bottom;
    left = left === VOID ? this.left : left;
    right = right === VOID ? this.right : right;
    front = front === VOID ? this.front : front;
    back = back === VOID ? this.back : back;
    return this.i2c(top, bottom, left, right, front, back);
  };
  protoOf(MarginTemplate).toString = function () {
    return 'MarginTemplate(top=' + this.top + ', bottom=' + this.bottom + ', left=' + this.left + ', right=' + this.right + ', front=' + this.front + ', back=' + this.back + ')';
  };
  protoOf(MarginTemplate).hashCode = function () {
    var result = getNumberHashCode(this.top);
    result = imul(result, 31) + getNumberHashCode(this.bottom) | 0;
    result = imul(result, 31) + getNumberHashCode(this.left) | 0;
    result = imul(result, 31) + getNumberHashCode(this.right) | 0;
    result = imul(result, 31) + getNumberHashCode(this.front) | 0;
    result = imul(result, 31) + getNumberHashCode(this.back) | 0;
    return result;
  };
  protoOf(MarginTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MarginTemplate))
      return false;
    var tmp0_other_with_cast = other instanceof MarginTemplate ? other : THROW_CCE();
    if (!equals(this.top, tmp0_other_with_cast.top))
      return false;
    if (!equals(this.bottom, tmp0_other_with_cast.bottom))
      return false;
    if (!equals(this.left, tmp0_other_with_cast.left))
      return false;
    if (!equals(this.right, tmp0_other_with_cast.right))
      return false;
    if (!equals(this.front, tmp0_other_with_cast.front))
      return false;
    if (!equals(this.back, tmp0_other_with_cast.back))
      return false;
    return true;
  };
  function Companion_26() {
  }
  protoOf(Companion_26).l17 = function () {
    return $serializer_getInstance_19();
  };
  var Companion_instance_31;
  function Companion_getInstance_32() {
    return Companion_instance_31;
  }
  function $serializer_15() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.Model3DTemplate', this, 3);
    tmp0_serialDesc.cv('modelURI', false);
    tmp0_serialDesc.cv('modelRootURL', true);
    tmp0_serialDesc.cv('modelTransform', true);
    this.d48_1 = tmp0_serialDesc;
  }
  protoOf($serializer_15).ok = function () {
    return this.d48_1;
  };
  protoOf($serializer_15).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_1())];
  };
  protoOf($serializer_15).qk = function (decoder) {
    var tmp0_desc = this.d48_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.bo(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.bo(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return Model3DTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_15).e48 = function (encoder, value) {
    var tmp0_desc = this.d48_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.modelURI);
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.modelRootURL == null)) {
      tmp1_output.gp(tmp0_desc, 1, StringSerializer_getInstance(), value.modelRootURL);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.modelTransform == null)) {
      tmp1_output.gp(tmp0_desc, 2, $serializer_getInstance_1(), value.modelTransform);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_15).pk = function (encoder, value) {
    return this.e48(encoder, value instanceof Model3DTemplate ? value : THROW_CCE());
  };
  var $serializer_instance_15;
  function $serializer_getInstance_19() {
    if ($serializer_instance_15 == null)
      new $serializer_15();
    return $serializer_instance_15;
  }
  function Model3DTemplate_init_$Init$(seen1, modelURI, modelRootURL, modelTransform, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_19().d48_1);
    }
    $this.modelURI = modelURI;
    if (0 === (seen1 & 2))
      $this.modelRootURL = null;
    else
      $this.modelRootURL = modelRootURL;
    if (0 === (seen1 & 4))
      $this.modelTransform = null;
    else
      $this.modelTransform = modelTransform;
    return $this;
  }
  function Model3DTemplate_init_$Create$(seen1, modelURI, modelRootURL, modelTransform, serializationConstructorMarker) {
    return Model3DTemplate_init_$Init$(seen1, modelURI, modelRootURL, modelTransform, serializationConstructorMarker, objectCreate(protoOf(Model3DTemplate)));
  }
  function Model3DTemplate(modelURI, modelRootURL, modelTransform) {
    modelRootURL = modelRootURL === VOID ? null : modelRootURL;
    modelTransform = modelTransform === VOID ? null : modelTransform;
    this.modelURI = modelURI;
    this.modelRootURL = modelRootURL;
    this.modelTransform = modelTransform;
  }
  protoOf(Model3DTemplate).t3x = function () {
    return this.modelURI;
  };
  protoOf(Model3DTemplate).f48 = function () {
    return this.modelRootURL;
  };
  protoOf(Model3DTemplate).h40 = function () {
    return this.modelTransform;
  };
  protoOf(Model3DTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof Model3DTemplate))
      THROW_CCE();
    if (!(this.modelURI === other.modelURI))
      return false;
    if (!(this.modelRootURL == other.modelRootURL))
      return false;
    return true;
  };
  protoOf(Model3DTemplate).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.modelRootURL;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(Model3DTemplate).af = function () {
    return this.modelURI;
  };
  protoOf(Model3DTemplate).bf = function () {
    return this.modelRootURL;
  };
  protoOf(Model3DTemplate).g1k = function () {
    return this.modelTransform;
  };
  protoOf(Model3DTemplate).g48 = function (modelURI, modelRootURL, modelTransform) {
    return new Model3DTemplate(modelURI, modelRootURL, modelTransform);
  };
  protoOf(Model3DTemplate).copy = function (modelURI, modelRootURL, modelTransform, $super) {
    modelURI = modelURI === VOID ? this.modelURI : modelURI;
    modelRootURL = modelRootURL === VOID ? this.modelRootURL : modelRootURL;
    modelTransform = modelTransform === VOID ? this.modelTransform : modelTransform;
    return this.g48(modelURI, modelRootURL, modelTransform);
  };
  protoOf(Model3DTemplate).toString = function () {
    return 'Model3DTemplate(modelURI=' + this.modelURI + ', modelRootURL=' + this.modelRootURL + ', modelTransform=' + this.modelTransform + ')';
  };
  function parseRelativeTo($this, element) {
    var tmp = "Could not parse field 'relativeTo' as OriginRelativeTo from object: " + element;
    return parseAndCatch(tmp, OriginTemplate$CustomSerializer$parseRelativeTo$lambda(element));
  }
  function parseOrigin($this, element) {
    var tmp = "Could not parse field 'relation' as RelationOrigin from object: " + element;
    return parseAndCatch(tmp, OriginTemplate$CustomSerializer$parseOrigin$lambda(element));
  }
  function parseSimpleOrigin($this, element) {
    var tmp = 'Could not parse origin as RelationOrigin from object: ' + element;
    return parseAndCatch(tmp, OriginTemplate$CustomSerializer$parseSimpleOrigin$lambda(element));
  }
  function OriginTemplate$CustomSerializer$jsonParser$lambda($this$Json) {
    $this$Json.f16_1 = true;
    return Unit_instance;
  }
  function OriginTemplate$CustomSerializer$parseRelativeTo$lambda($element) {
    return function () {
      return CustomSerializer_getInstance_2().jsonParser.j15(Companion_getInstance_37().l17(), toString_0($element.o17('relativeTo')));
    };
  }
  function OriginTemplate$CustomSerializer$parseOrigin$lambda($element) {
    return function () {
      return CustomSerializer_getInstance_2().jsonParser.j15(RelationOriginSerializer_getInstance(), toString_0($element.o17('relation')));
    };
  }
  function OriginTemplate$CustomSerializer$parseSimpleOrigin$lambda($element) {
    return function () {
      return CustomSerializer_getInstance_2().jsonParser.j15(RelationOriginSerializer_getInstance(), $element.toString());
    };
  }
  function OriginTemplate$CustomSerializer$descriptor$lambda($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.cl('relation', Companion_getInstance_4().l17().ok());
    $this$buildClassSerialDescriptor.cl('relativeTo', Companion_getInstance_1().l17().ok());
    return Unit_instance;
  }
  function CustomSerializer_2() {
    CustomSerializer_instance_2 = this;
    var tmp = this;
    tmp.jsonParser = Json(VOID, OriginTemplate$CustomSerializer$jsonParser$lambda);
    var tmp_0 = this;
    tmp_0.h48_1 = buildClassSerialDescriptor('OriginTemplate', [], OriginTemplate$CustomSerializer$descriptor$lambda);
  }
  protoOf(CustomSerializer_2).q3y = function () {
    return this.jsonParser;
  };
  protoOf(CustomSerializer_2).qk = function (decoder) {
    var element = decoder.mn(Companion_instance_3.l17());
    var tmp;
    if (element instanceof JsonObject) {
      tmp = new OriginTemplate(parseOrigin(this, element), parseRelativeTo(this, element));
    } else {
      if (element instanceof JsonPrimitive) {
        tmp = new OriginTemplate(parseSimpleOrigin(this, element), OriginRelativeTo_SIZE_getInstance());
      } else {
        var message = 'Origin malformed in JSON: ' + element;
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    return tmp;
  };
  protoOf(CustomSerializer_2).ok = function () {
    return this.h48_1;
  };
  protoOf(CustomSerializer_2).j48 = function (encoder, value) {
    if (!value.relation.equals(new RelationOrigin()) ? !value.kotlinRelativeTo.equals(OriginRelativeTo_SIZE_getInstance()) : false) {
      var comp = encoder.nn(this.h48_1);
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = value.kotlinRelativeTo.toString().toLowerCase();
      comp.cp(this.h48_1, 1, tmp$ret$1);
      comp.cp(this.h48_1, 0, value.relation.toString());
      comp.on(this.h48_1);
    } else if (!value.kotlinRelativeTo.equals(OriginRelativeTo_SIZE_getInstance())) {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = value.kotlinRelativeTo.toString().toLowerCase();
      encoder.ro(tmp$ret$3);
    } else if (!value.relation.equals(new RelationOrigin())) {
      encoder.ro(value.relation.toString());
    }
  };
  protoOf(CustomSerializer_2).pk = function (encoder, value) {
    return this.j48(encoder, value instanceof OriginTemplate ? value : THROW_CCE());
  };
  protoOf(CustomSerializer_2).l17 = function () {
    return CustomSerializer_getInstance_2();
  };
  var CustomSerializer_instance_2;
  function CustomSerializer_getInstance_2() {
    if (CustomSerializer_instance_2 == null)
      new CustomSerializer_2();
    return CustomSerializer_instance_2;
  }
  function OriginTemplate(relation, relativeTo) {
    CustomSerializer_getInstance_2();
    this.relation = relation;
    this.kotlinRelativeTo = relativeTo;
    this.isDefault = this.relation.equals(new RelationOrigin()) ? this.kotlinRelativeTo.equals(OriginRelativeTo_SIZE_getInstance()) : false;
  }
  protoOf(OriginTemplate).k48 = function () {
    return this.relation;
  };
  protoOf(OriginTemplate).l48 = function () {
    return this.kotlinRelativeTo;
  };
  protoOf(OriginTemplate).m48 = function () {
    return this.isDefault;
  };
  protoOf(OriginTemplate).q2d = function () {
    return this.kotlinRelativeTo.x9_1;
  };
  protoOf(OriginTemplate).af = function () {
    return this.relation;
  };
  protoOf(OriginTemplate).bf = function () {
    return this.kotlinRelativeTo;
  };
  protoOf(OriginTemplate).n48 = function (relation, relativeTo) {
    return new OriginTemplate(relation, relativeTo);
  };
  protoOf(OriginTemplate).copy = function (relation, relativeTo, $super) {
    relation = relation === VOID ? this.relation : relation;
    relativeTo = relativeTo === VOID ? this.kotlinRelativeTo : relativeTo;
    return this.n48(relation, relativeTo);
  };
  protoOf(OriginTemplate).toString = function () {
    return 'OriginTemplate(relation=' + this.relation + ', relativeTo=' + this.kotlinRelativeTo + ')';
  };
  protoOf(OriginTemplate).hashCode = function () {
    var result = this.relation.hashCode();
    result = imul(result, 31) + this.kotlinRelativeTo.hashCode() | 0;
    return result;
  };
  protoOf(OriginTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OriginTemplate))
      return false;
    var tmp0_other_with_cast = other instanceof OriginTemplate ? other : THROW_CCE();
    if (!this.relation.equals(tmp0_other_with_cast.relation))
      return false;
    if (!this.kotlinRelativeTo.equals(tmp0_other_with_cast.kotlinRelativeTo))
      return false;
    return true;
  };
  function Companion_27() {
  }
  protoOf(Companion_27).l17 = function () {
    return $serializer_getInstance_20();
  };
  var Companion_instance_32;
  function Companion_getInstance_33() {
    return Companion_instance_32;
  }
  function $serializer_16() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.PlacementZoneByHeightTemplate', this, 2);
    tmp0_serialDesc.cv('minY', false);
    tmp0_serialDesc.cv('maxY', false);
    this.o48_1 = tmp0_serialDesc;
  }
  protoOf($serializer_16).ok = function () {
    return this.o48_1;
  };
  protoOf($serializer_16).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_16).qk = function (decoder) {
    var tmp0_desc = this.o48_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.nn(tmp0_desc);
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.sn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.sn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.sn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.sn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return PlacementZoneByHeightTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_16).p48 = function (encoder, value) {
    var tmp0_desc = this.o48_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.xo(tmp0_desc, 0, value.minY);
    tmp1_output.xo(tmp0_desc, 1, value.maxY);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_16).pk = function (encoder, value) {
    return this.p48(encoder, value instanceof PlacementZoneByHeightTemplate ? value : THROW_CCE());
  };
  var $serializer_instance_16;
  function $serializer_getInstance_20() {
    if ($serializer_instance_16 == null)
      new $serializer_16();
    return $serializer_instance_16;
  }
  function PlacementZoneByHeightTemplate_init_$Init$(seen1, minY, maxY, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_20().o48_1);
    }
    $this.minY = minY;
    $this.maxY = maxY;
    return $this;
  }
  function PlacementZoneByHeightTemplate_init_$Create$(seen1, minY, maxY, serializationConstructorMarker) {
    return PlacementZoneByHeightTemplate_init_$Init$(seen1, minY, maxY, serializationConstructorMarker, objectCreate(protoOf(PlacementZoneByHeightTemplate)));
  }
  function PlacementZoneByHeightTemplate(minY, maxY) {
    this.minY = minY;
    this.maxY = maxY;
  }
  protoOf(PlacementZoneByHeightTemplate).b3d = function () {
    return this.minY;
  };
  protoOf(PlacementZoneByHeightTemplate).c3d = function () {
    return this.maxY;
  };
  protoOf(PlacementZoneByHeightTemplate).af = function () {
    return this.minY;
  };
  protoOf(PlacementZoneByHeightTemplate).bf = function () {
    return this.maxY;
  };
  protoOf(PlacementZoneByHeightTemplate).d3d = function (minY, maxY) {
    return new PlacementZoneByHeightTemplate(minY, maxY);
  };
  protoOf(PlacementZoneByHeightTemplate).copy = function (minY, maxY, $super) {
    minY = minY === VOID ? this.minY : minY;
    maxY = maxY === VOID ? this.maxY : maxY;
    return this.d3d(minY, maxY);
  };
  protoOf(PlacementZoneByHeightTemplate).toString = function () {
    return 'PlacementZoneByHeightTemplate(minY=' + this.minY + ', maxY=' + this.maxY + ')';
  };
  protoOf(PlacementZoneByHeightTemplate).hashCode = function () {
    var result = this.minY;
    result = imul(result, 31) + this.maxY | 0;
    return result;
  };
  protoOf(PlacementZoneByHeightTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacementZoneByHeightTemplate))
      return false;
    var tmp0_other_with_cast = other instanceof PlacementZoneByHeightTemplate ? other : THROW_CCE();
    if (!(this.minY === tmp0_other_with_cast.minY))
      return false;
    if (!(this.maxY === tmp0_other_with_cast.maxY))
      return false;
    return true;
  };
  function parseOrigin_0($this, element) {
    var tmp = "Could not parse field 'origin' as OriginTemplate from object: " + element;
    return parseAndCatch(tmp, PositionTemplate$PositionTemplateSerializer$parseOrigin$lambda(element));
  }
  function parseRelativeTransform($this, element) {
    var tmp = "Could not parse field 'transform' as RelativeTransform from object: " + element;
    return parseAndCatch(tmp, PositionTemplate$PositionTemplateSerializer$parseRelativeTransform$lambda(element));
  }
  function parseRelativeTransformAsArray($this, element) {
    var tmp = 'Could not parse RelativeTransform from object: ' + element;
    return parseAndCatch(tmp, PositionTemplate$PositionTemplateSerializer$parseRelativeTransformAsArray$lambda(element));
  }
  function PositionTemplate$PositionTemplateSerializer$jsonParser$lambda($this$Json) {
    $this$Json.f16_1 = true;
    return Unit_instance;
  }
  function PositionTemplate$PositionTemplateSerializer$parseOrigin$lambda($element) {
    return function () {
      return PositionTemplateSerializer_getInstance().z46_1.j15(CustomSerializer_getInstance_2().l17(), toString_0($element.o17('origin')));
    };
  }
  function PositionTemplate$PositionTemplateSerializer$parseRelativeTransform$lambda($element) {
    return function () {
      var tmp;
      try {
        var tmp_0 = RelativeTransformDeserializer_instance;
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = get_jsonArray($element);
        var destination = ArrayList_init_$Create$_0();
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = this_0.t();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.w();
          // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
          // Inline function 'com.ikea.range.dynamic.template.PositionTemplateSerializer.parseRelativeTransform.<anonymous>.<anonymous>' call
          var tmp0_safe_receiver = get_jsonPrimitive(element).p17();
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.q(tmp0_safe_receiver);
          }
        }
        tmp = tmp_0.deserialize(destination);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Exception) {
          var e = $p;
          tmp_1 = NamedTransformObjectDeserializer_instance.deserialize(get_jsonObject($element));
        } else {
          throw $p;
        }
        tmp = tmp_1;
      }
      return tmp;
    };
  }
  function PositionTemplate$PositionTemplateSerializer$parseRelativeTransformAsArray$lambda($element) {
    return function () {
      var tmp = RelativeTransformDeserializer_instance;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_0 = get_jsonArray($element);
      var destination = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.range.dynamic.template.PositionTemplateSerializer.parseRelativeTransformAsArray.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver = get_jsonPrimitive(element).p17();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.q(tmp0_safe_receiver);
        }
      }
      return tmp.deserialize(destination);
    };
  }
  function PositionTemplate$PositionTemplateSerializer$descriptor$lambda($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.cl('origin', CustomSerializer_getInstance_2().l17().ok());
    $this$buildClassSerialDescriptor.cl('transform', RelativeTransformSerializer_getInstance().l17().ok());
    return Unit_instance;
  }
  function PositionTemplate_init_$Init$(origin, transform, $this) {
    PositionTemplate.call($this, PositionTemplateSerializer_getInstance().z46_1.j15(CustomSerializer_getInstance_2().l17(), origin), RelativeTransformFromVector(transform.position, transform.rotation));
    return $this;
  }
  function PositionTemplateFromString(origin, transform) {
    return PositionTemplate_init_$Init$(origin, transform, objectCreate(protoOf(PositionTemplate)));
  }
  function PositionTemplateSerializer() {
    PositionTemplateSerializer_instance = this;
    this.IDENTITY = new PositionTemplate(new OriginTemplate(new RelationOrigin(), OriginRelativeTo_SIZE_getInstance()), new RelativeTransform());
    var tmp = this;
    tmp.z46_1 = Json(VOID, PositionTemplate$PositionTemplateSerializer$jsonParser$lambda);
    var tmp_0 = this;
    tmp_0.a47_1 = buildClassSerialDescriptor('PositionTemplate', [], PositionTemplate$PositionTemplateSerializer$descriptor$lambda);
  }
  protoOf(PositionTemplateSerializer).x2c = function () {
    return this.IDENTITY;
  };
  protoOf(PositionTemplateSerializer).qk = function (decoder) {
    var element = decoder.mn(Companion_instance_3.l17());
    var tmp;
    if (element instanceof JsonObject) {
      var tmp_0;
      if (element.o17('origin') == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.dynamic.template.PositionTemplateSerializer.deserialize.<anonymous>' call
        var tmp0_safe_receiver = element.o17('transform');
        var tmp_1;
        if (tmp0_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.dynamic.template.PositionTemplateSerializer.deserialize.<anonymous>.<anonymous>' call
          tmp_1 = new PositionTemplate(parseOrigin_0(PositionTemplateSerializer_getInstance(), element), parseRelativeTransform(PositionTemplateSerializer_getInstance(), tmp0_safe_receiver));
        }
        var tmp1_elvis_lhs = tmp_1;
        tmp_0 = tmp1_elvis_lhs == null ? new PositionTemplate(parseOrigin_0(PositionTemplateSerializer_getInstance(), element), new RelativeTransform()) : tmp1_elvis_lhs;
      }
      var tmp2_elvis_lhs = tmp_0;
      var tmp_2;
      if (tmp2_elvis_lhs == null) {
        var tmp1_safe_receiver = element.o17('transform');
        var tmp_3;
        if (tmp1_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.dynamic.template.PositionTemplateSerializer.deserialize.<anonymous>' call
          tmp_3 = new PositionTemplate(new OriginTemplate(new RelationOrigin(), OriginRelativeTo_SIZE_getInstance()), parseRelativeTransform(PositionTemplateSerializer_getInstance(), tmp1_safe_receiver));
        }
        tmp_2 = tmp_3;
      } else {
        tmp_2 = tmp2_elvis_lhs;
      }
      var tmp3_elvis_lhs = tmp_2;
      tmp = tmp3_elvis_lhs == null ? new PositionTemplate(new OriginTemplate(new RelationOrigin(), OriginRelativeTo_SIZE_getInstance()), parseRelativeTransform(this, element)) : tmp3_elvis_lhs;
    } else {
      if (element instanceof JsonArray) {
        tmp = new PositionTemplate(new OriginTemplate(new RelationOrigin(), OriginRelativeTo_SIZE_getInstance()), parseRelativeTransformAsArray(this, element));
      } else {
        tmp = new PositionTemplate(new OriginTemplate(this.z46_1.j15(RelationOriginSerializer_getInstance(), toString(element)), OriginRelativeTo_SIZE_getInstance()), new RelativeTransform());
      }
    }
    return tmp;
  };
  protoOf(PositionTemplateSerializer).ok = function () {
    return this.a47_1;
  };
  protoOf(PositionTemplateSerializer).r48 = function (encoder, value) {
    var transform = (!value.b47_1.position.isOrigin ? true : !value.b47_1.rotation.equals(Companion_getInstance_2().IDENTITY)) ? value.b47_1 : null;
    var origin = !value.origin.isDefault ? value.origin : null;
    if (!(transform == null) ? !(origin == null) : false) {
      var comp = encoder.nn(this.a47_1);
      comp.ep(this.a47_1, 0, CustomSerializer_getInstance_2().l17(), origin);
      comp.ep(this.a47_1, 1, RelativeTransformSerializer_getInstance().l17(), transform);
      comp.on(this.a47_1);
    } else if (!(transform == null)) {
      var desc = ListSerializer(Companion_getInstance_39().l17()).ok();
      var comp_0 = encoder.jp(desc, 6);
      RelativeTransformSerializer_getInstance().encodeToArray(comp_0, desc, transform, 0);
      comp_0.on(this.a47_1);
    } else if (!(origin == null)) {
      if (origin.kotlinRelativeTo.equals(OriginRelativeTo_SIZE_getInstance())) {
        encoder.ro(origin.relation.toString());
      } else {
        var comp_1 = encoder.nn(this.a47_1);
        comp_1.ep(this.a47_1, 0, CustomSerializer_getInstance_2().l17(), origin);
        comp_1.on(this.a47_1);
      }
    } else {
      encoder.ro('center');
    }
  };
  protoOf(PositionTemplateSerializer).pk = function (encoder, value) {
    return this.r48(encoder, value instanceof PositionTemplate ? value : THROW_CCE());
  };
  protoOf(PositionTemplateSerializer).l17 = function () {
    return PositionTemplateSerializer_getInstance();
  };
  var PositionTemplateSerializer_instance;
  function PositionTemplateSerializer_getInstance() {
    if (PositionTemplateSerializer_instance == null)
      new PositionTemplateSerializer();
    return PositionTemplateSerializer_instance;
  }
  function PositionTemplate$absoluteTransform$delegate$lambda(this$0) {
    return function () {
      return new Transform(this$0.b47_1.position.getAbsolutePosition(), this$0.b47_1.rotation);
    };
  }
  function PositionTemplate(origin, transform) {
    PositionTemplateSerializer_getInstance();
    transform = transform === VOID ? new RelativeTransform() : transform;
    this.origin = origin;
    this.b47_1 = transform;
    var tmp = this;
    tmp.c47_1 = lazy(PositionTemplate$absoluteTransform$delegate$lambda(this));
    this.rotation = this.b47_1.rotation;
  }
  protoOf(PositionTemplate).j2h = function () {
    return this.origin;
  };
  protoOf(PositionTemplate).a1k = function () {
    return this.b47_1;
  };
  protoOf(PositionTemplate).x48 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c47_1;
    absoluteTransform$factory();
    return this_0.u2();
  };
  protoOf(PositionTemplate).v1k = function () {
    return this.rotation;
  };
  protoOf(PositionTemplate).applyToBox = function (aabb) {
    var tmp;
    switch (this.origin.relation.xKotlinEnum.x9_1) {
      case 0:
        tmp = aabb.min.X + this.b47_1.position.getRelativePosition(SizeFromVector(aabb.size)).X;
        break;
      case 2:
        tmp = aabb.max.X + this.b47_1.position.getRelativePosition(SizeFromVector(aabb.size)).X;
        break;
      default:
        tmp = this.b47_1.position.getRelativePosition(SizeFromVector(aabb.size)).X;
        break;
    }
    var tmp_0;
    switch (this.origin.relation.yKotlinEnum.x9_1) {
      case 2:
        tmp_0 = aabb.max.Y + this.b47_1.position.getRelativePosition(SizeFromVector(aabb.size)).Y;
        break;
      case 0:
        tmp_0 = aabb.min.Y + this.b47_1.position.getRelativePosition(SizeFromVector(aabb.size)).Y;
        break;
      default:
        tmp_0 = this.b47_1.position.getRelativePosition(SizeFromVector(aabb.size)).Y;
        break;
    }
    var tmp0 = this.origin.relation.zKotlinEnum.x9_1;
    return new Transform(new Vector(tmp, tmp_0, tmp0 === 0 ? aabb.min.Z + this.b47_1.position.getRelativePosition(SizeFromVector(aabb.size)).Z : tmp0 === 2 ? aabb.max.Z + this.b47_1.position.getRelativePosition(SizeFromVector(aabb.size)).Z : this.b47_1.position.getRelativePosition(SizeFromVector(aabb.size)).Z), this.b47_1.rotation);
  };
  protoOf(PositionTemplate).af = function () {
    return this.origin;
  };
  protoOf(PositionTemplate).y48 = function (origin, transform) {
    return new PositionTemplate(origin, transform);
  };
  protoOf(PositionTemplate).copy = function (origin, transform, $super) {
    origin = origin === VOID ? this.origin : origin;
    transform = transform === VOID ? this.b47_1 : transform;
    return this.y48(origin, transform);
  };
  protoOf(PositionTemplate).toString = function () {
    return 'PositionTemplate(origin=' + this.origin + ', transform=' + this.b47_1 + ')';
  };
  protoOf(PositionTemplate).hashCode = function () {
    var result = this.origin.hashCode();
    result = imul(result, 31) + this.b47_1.hashCode() | 0;
    return result;
  };
  protoOf(PositionTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PositionTemplate))
      return false;
    var tmp0_other_with_cast = other instanceof PositionTemplate ? other : THROW_CCE();
    if (!this.origin.equals(tmp0_other_with_cast.origin))
      return false;
    if (!this.b47_1.equals(tmp0_other_with_cast.b47_1))
      return false;
    return true;
  };
  function absoluteTransform$factory() {
    return getPropertyCallableRef('absoluteTransform', 1, KProperty1, function (receiver) {
      return receiver.absoluteTransform;
    }, null);
  }
  function Companion_28() {
  }
  protoOf(Companion_28).l17 = function () {
    return $serializer_getInstance_21();
  };
  var Companion_instance_33;
  function Companion_getInstance_34() {
    return Companion_instance_33;
  }
  function $serializer_17() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.VisualLightSourceTemplate', this, 3);
    tmp0_serialDesc.cv('type', true);
    tmp0_serialDesc.cv('intensity', true);
    tmp0_serialDesc.cv('colorTemperature', true);
    this.z48_1 = tmp0_serialDesc;
  }
  protoOf($serializer_17).ok = function () {
    return this.z48_1;
  };
  protoOf($serializer_17).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
  };
  protoOf($serializer_17).qk = function (decoder) {
    var tmp0_desc = this.z48_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.bo(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.bo(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.bo(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.bo(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return VisualLightSourceTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_17).a49 = function (encoder, value) {
    var tmp0_desc = this.z48_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    if (tmp1_output.kp(tmp0_desc, 0) ? true : !(value.type == null)) {
      tmp1_output.gp(tmp0_desc, 0, StringSerializer_getInstance(), value.type);
    }
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.intensity == null)) {
      tmp1_output.gp(tmp0_desc, 1, IntSerializer_getInstance(), value.intensity);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !(value.colorTemperature == null)) {
      tmp1_output.gp(tmp0_desc, 2, IntSerializer_getInstance(), value.colorTemperature);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_17).pk = function (encoder, value) {
    return this.a49(encoder, value instanceof VisualLightSourceTemplate ? value : THROW_CCE());
  };
  var $serializer_instance_17;
  function $serializer_getInstance_21() {
    if ($serializer_instance_17 == null)
      new $serializer_17();
    return $serializer_instance_17;
  }
  function VisualLightSourceTemplate_init_$Init$(seen1, type, intensity, colorTemperature, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_21().z48_1);
    }
    if (0 === (seen1 & 1))
      $this.type = null;
    else
      $this.type = type;
    if (0 === (seen1 & 2))
      $this.intensity = null;
    else
      $this.intensity = intensity;
    if (0 === (seen1 & 4))
      $this.colorTemperature = null;
    else
      $this.colorTemperature = colorTemperature;
    return $this;
  }
  function VisualLightSourceTemplate_init_$Create$(seen1, type, intensity, colorTemperature, serializationConstructorMarker) {
    return VisualLightSourceTemplate_init_$Init$(seen1, type, intensity, colorTemperature, serializationConstructorMarker, objectCreate(protoOf(VisualLightSourceTemplate)));
  }
  function VisualLightSourceTemplate(type, intensity, colorTemperature) {
    type = type === VOID ? null : type;
    intensity = intensity === VOID ? null : intensity;
    colorTemperature = colorTemperature === VOID ? null : colorTemperature;
    this.type = type;
    this.intensity = intensity;
    this.colorTemperature = colorTemperature;
  }
  protoOf(VisualLightSourceTemplate).a1x = function () {
    return this.type;
  };
  protoOf(VisualLightSourceTemplate).w3z = function () {
    return this.intensity;
  };
  protoOf(VisualLightSourceTemplate).x3z = function () {
    return this.colorTemperature;
  };
  protoOf(VisualLightSourceTemplate).af = function () {
    return this.type;
  };
  protoOf(VisualLightSourceTemplate).bf = function () {
    return this.intensity;
  };
  protoOf(VisualLightSourceTemplate).g1k = function () {
    return this.colorTemperature;
  };
  protoOf(VisualLightSourceTemplate).b49 = function (type, intensity, colorTemperature) {
    return new VisualLightSourceTemplate(type, intensity, colorTemperature);
  };
  protoOf(VisualLightSourceTemplate).copy = function (type, intensity, colorTemperature, $super) {
    type = type === VOID ? this.type : type;
    intensity = intensity === VOID ? this.intensity : intensity;
    colorTemperature = colorTemperature === VOID ? this.colorTemperature : colorTemperature;
    return this.b49(type, intensity, colorTemperature);
  };
  protoOf(VisualLightSourceTemplate).toString = function () {
    return 'VisualLightSourceTemplate(type=' + this.type + ', intensity=' + this.intensity + ', colorTemperature=' + this.colorTemperature + ')';
  };
  protoOf(VisualLightSourceTemplate).hashCode = function () {
    var result = this.type == null ? 0 : getStringHashCode(this.type);
    result = imul(result, 31) + (this.intensity == null ? 0 : this.intensity) | 0;
    result = imul(result, 31) + (this.colorTemperature == null ? 0 : this.colorTemperature) | 0;
    return result;
  };
  protoOf(VisualLightSourceTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VisualLightSourceTemplate))
      return false;
    var tmp0_other_with_cast = other instanceof VisualLightSourceTemplate ? other : THROW_CCE();
    if (!(this.type == tmp0_other_with_cast.type))
      return false;
    if (!(this.intensity == tmp0_other_with_cast.intensity))
      return false;
    if (!(this.colorTemperature == tmp0_other_with_cast.colorTemperature))
      return false;
    return true;
  };
  function Companion_29() {
  }
  protoOf(Companion_29).l17 = function () {
    return $serializer_getInstance_22();
  };
  var Companion_instance_34;
  function Companion_getInstance_35() {
    return Companion_instance_34;
  }
  function $serializer_18() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.hierarchy.ProductStructureConnectionTemplate', this, 3);
    tmp0_serialDesc.cv('offeringPartKey', false);
    tmp0_serialDesc.cv('demandingConnector', false);
    tmp0_serialDesc.cv('offeringConnector', false);
    this.c49_1 = tmp0_serialDesc;
  }
  protoOf($serializer_18).ok = function () {
    return this.c49_1;
  };
  protoOf($serializer_18).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  protoOf($serializer_18).qk = function (decoder) {
    var tmp0_desc = this.c49_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.xn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.xn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return ProductStructureConnectionTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_18).d49 = function (encoder, value) {
    var tmp0_desc = this.c49_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.offeringPartKey);
    tmp1_output.cp(tmp0_desc, 1, value.demandingConnector);
    tmp1_output.cp(tmp0_desc, 2, value.offeringConnector);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_18).pk = function (encoder, value) {
    return this.d49(encoder, value instanceof ProductStructureConnectionTemplate ? value : THROW_CCE());
  };
  var $serializer_instance_18;
  function $serializer_getInstance_22() {
    if ($serializer_instance_18 == null)
      new $serializer_18();
    return $serializer_instance_18;
  }
  function ProductStructureConnectionTemplate_init_$Init$(seen1, offeringPartKey, demandingConnector, offeringConnector, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_22().c49_1);
    }
    $this.offeringPartKey = offeringPartKey;
    $this.demandingConnector = demandingConnector;
    $this.offeringConnector = offeringConnector;
    return $this;
  }
  function ProductStructureConnectionTemplate_init_$Create$(seen1, offeringPartKey, demandingConnector, offeringConnector, serializationConstructorMarker) {
    return ProductStructureConnectionTemplate_init_$Init$(seen1, offeringPartKey, demandingConnector, offeringConnector, serializationConstructorMarker, objectCreate(protoOf(ProductStructureConnectionTemplate)));
  }
  function ProductStructureConnectionTemplate(offeringPartKey, demandingConnector, offeringConnector) {
    this.offeringPartKey = offeringPartKey;
    this.demandingConnector = demandingConnector;
    this.offeringConnector = offeringConnector;
  }
  protoOf(ProductStructureConnectionTemplate).o1m = function () {
    return this.offeringPartKey;
  };
  protoOf(ProductStructureConnectionTemplate).p1m = function () {
    return this.demandingConnector;
  };
  protoOf(ProductStructureConnectionTemplate).q1m = function () {
    return this.offeringConnector;
  };
  function Companion_30() {
  }
  protoOf(Companion_30).l17 = function () {
    return $serializer_getInstance_23();
  };
  var Companion_instance_35;
  function Companion_getInstance_36() {
    return Companion_instance_35;
  }
  function $serializer_19() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.hierarchy.ProductStructureItemTemplate', this, 3);
    tmp0_serialDesc.cv('partKey', false);
    tmp0_serialDesc.cv('snap', true);
    tmp0_serialDesc.cv('transform', true);
    this.e49_1 = tmp0_serialDesc;
  }
  protoOf($serializer_19).ok = function () {
    return this.e49_1;
  };
  protoOf($serializer_19).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable($serializer_getInstance_22()), PositionTemplateSerializer_getInstance()];
  };
  protoOf($serializer_19).qk = function (decoder) {
    var tmp0_desc = this.e49_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, $serializer_getInstance_22(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, PositionTemplateSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.bo(tmp0_desc, 1, $serializer_getInstance_22(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, PositionTemplateSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return ProductStructureItemTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_19).f49 = function (encoder, value) {
    var tmp0_desc = this.e49_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.partKey);
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.snap == null)) {
      tmp1_output.gp(tmp0_desc, 1, $serializer_getInstance_22(), value.snap);
    }
    if (tmp1_output.kp(tmp0_desc, 2) ? true : !value.transform.equals(PositionTemplateSerializer_getInstance().IDENTITY)) {
      tmp1_output.ep(tmp0_desc, 2, PositionTemplateSerializer_getInstance(), value.transform);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_19).pk = function (encoder, value) {
    return this.f49(encoder, value instanceof ProductStructureItemTemplate ? value : THROW_CCE());
  };
  var $serializer_instance_19;
  function $serializer_getInstance_23() {
    if ($serializer_instance_19 == null)
      new $serializer_19();
    return $serializer_instance_19;
  }
  function ProductStructureItemTemplate_init_$Init$(seen1, partKey, snap, transform, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_23().e49_1);
    }
    $this.partKey = partKey;
    if (0 === (seen1 & 2))
      $this.snap = null;
    else
      $this.snap = snap;
    if (0 === (seen1 & 4))
      $this.transform = PositionTemplateSerializer_getInstance().IDENTITY;
    else
      $this.transform = transform;
    return $this;
  }
  function ProductStructureItemTemplate_init_$Create$(seen1, partKey, snap, transform, serializationConstructorMarker) {
    return ProductStructureItemTemplate_init_$Init$(seen1, partKey, snap, transform, serializationConstructorMarker, objectCreate(protoOf(ProductStructureItemTemplate)));
  }
  function ProductStructureItemTemplate(partKey, snap, transform) {
    snap = snap === VOID ? null : snap;
    transform = transform === VOID ? PositionTemplateSerializer_getInstance().IDENTITY : transform;
    this.partKey = partKey;
    this.snap = snap;
    this.transform = transform;
  }
  protoOf(ProductStructureItemTemplate).z1j = function () {
    return this.partKey;
  };
  protoOf(ProductStructureItemTemplate).s1m = function () {
    return this.snap;
  };
  protoOf(ProductStructureItemTemplate).d1x = function () {
    return this.transform;
  };
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.i48_1.u2();
  }
  function OriginRelativeTo$Companion$_anonymous__8s7o4e() {
    var tmp = values();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = ['bound', 'size'];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [null, null];
    return createAnnotatedEnumSerializer('com.ikea.range.dynamic.template.objects.OriginRelativeTo', tmp, tmp_0, tmp$ret$5, null);
  }
  var OriginRelativeTo_BOUND_instance;
  var OriginRelativeTo_SIZE_instance;
  function Companion_31() {
    Companion_instance_36 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i48_1 = lazy_0(tmp_0, OriginRelativeTo$Companion$_anonymous__8s7o4e);
  }
  protoOf(Companion_31).l17 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion_31).ew = function (typeParamsSerializers) {
    return this.l17();
  };
  var Companion_instance_36;
  function Companion_getInstance_37() {
    OriginRelativeTo_initEntries();
    if (Companion_instance_36 == null)
      new Companion_31();
    return Companion_instance_36;
  }
  function values() {
    return [OriginRelativeTo_BOUND_getInstance(), OriginRelativeTo_SIZE_getInstance()];
  }
  function valueOf_0(value) {
    switch (value) {
      case 'BOUND':
        return OriginRelativeTo_BOUND_getInstance();
      case 'SIZE':
        return OriginRelativeTo_SIZE_getInstance();
      default:
        OriginRelativeTo_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var OriginRelativeTo_entriesInitialized;
  function OriginRelativeTo_initEntries() {
    if (OriginRelativeTo_entriesInitialized)
      return Unit_instance;
    OriginRelativeTo_entriesInitialized = true;
    OriginRelativeTo_BOUND_instance = new OriginRelativeTo('BOUND', 0);
    OriginRelativeTo_SIZE_instance = new OriginRelativeTo('SIZE', 1);
    Companion_getInstance_37();
  }
  function OriginRelativeTo(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function OriginRelativeTo_BOUND_getInstance() {
    OriginRelativeTo_initEntries();
    return OriginRelativeTo_BOUND_instance;
  }
  function OriginRelativeTo_SIZE_getInstance() {
    OriginRelativeTo_initEntries();
    return OriginRelativeTo_SIZE_instance;
  }
  function OriginRelativeToImpostor() {
    OriginRelativeToImpostor_instance = this;
    this.BOUND = 0;
    this.SIZE = 1;
    this.i49_1 = values();
  }
  protoOf(OriginRelativeToImpostor).j49 = function () {
    return this.BOUND;
  };
  protoOf(OriginRelativeToImpostor).k49 = function () {
    return this.SIZE;
  };
  protoOf(OriginRelativeToImpostor).toEnum = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.first' call
      var indexedObject = this.i49_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.template.objects.OriginRelativeToImpostor.toEnum.<anonymous>' call
        if (element.x9_1 === value) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$('Array contains no element matching the predicate.');
    }
    return tmp$ret$1;
  };
  var OriginRelativeToImpostor_instance;
  function OriginRelativeToImpostor_getInstance() {
    if (OriginRelativeToImpostor_instance == null)
      new OriginRelativeToImpostor();
    return OriginRelativeToImpostor_instance;
  }
  var PositionType_ABSOLUTE_instance;
  var PositionType_PERCENTAGE_RELATIVE_SIZE_instance;
  function Companion_32() {
    Companion_instance_37 = this;
    this.l49_1 = values_0();
  }
  protoOf(Companion_32).getByValue = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.first' call
      var indexedObject = this.l49_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.dynamic.template.objects.Companion.getByValue.<anonymous>' call
        if (element.x9_1 === value) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$('Array contains no element matching the predicate.');
    }
    return tmp$ret$1;
  };
  var Companion_instance_37;
  function Companion_getInstance_38() {
    PositionType_initEntries();
    if (Companion_instance_37 == null)
      new Companion_32();
    return Companion_instance_37;
  }
  function values_0() {
    return [PositionType_ABSOLUTE_getInstance(), PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance()];
  }
  function valueOf_1(value) {
    switch (value) {
      case 'ABSOLUTE':
        return PositionType_ABSOLUTE_getInstance();
      case 'PERCENTAGE_RELATIVE_SIZE':
        return PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance();
      default:
        PositionType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var PositionType_entriesInitialized;
  function PositionType_initEntries() {
    if (PositionType_entriesInitialized)
      return Unit_instance;
    PositionType_entriesInitialized = true;
    PositionType_ABSOLUTE_instance = new PositionType('ABSOLUTE', 0);
    PositionType_PERCENTAGE_RELATIVE_SIZE_instance = new PositionType('PERCENTAGE_RELATIVE_SIZE', 1);
    Companion_getInstance_38();
  }
  function PositionType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PositionType_ABSOLUTE_getInstance() {
    PositionType_initEntries();
    return PositionType_ABSOLUTE_instance;
  }
  function PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance() {
    PositionType_initEntries();
    return PositionType_PERCENTAGE_RELATIVE_SIZE_instance;
  }
  function PositionTypeImpostor() {
    this.ABSOLUTE = 0;
    this.PERCENTAGE_RELATIVE_SIZE = 1;
  }
  protoOf(PositionTypeImpostor).o49 = function () {
    return this.ABSOLUTE;
  };
  protoOf(PositionTypeImpostor).p49 = function () {
    return this.PERCENTAGE_RELATIVE_SIZE;
  };
  var PositionTypeImpostor_instance;
  function PositionTypeImpostor_getInstance() {
    return PositionTypeImpostor_instance;
  }
  function Companion_33() {
    Companion_instance_38 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w48_1 = [null, createSimpleEnumSerializer('com.ikea.range.dynamic.template.objects.PositionType', values_0())];
  }
  protoOf(Companion_33).fromString = function (s) {
    var tmp;
    if (s == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.filter' call
      // Inline function 'kotlin.text.filterTo' call
      var destination = StringBuilder_init_$Create$();
      var inductionVariable = 0;
      var last = charSequenceLength(s);
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var element = charSequenceGet(s, index);
          // Inline function 'com.ikea.range.dynamic.template.objects.Companion.fromString.<anonymous>' call
          if (!(element === _Char___init__impl__6a9atx(37))) {
            destination.z5(element);
          }
        }
         while (inductionVariable < last);
      tmp = destination.toString();
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toDouble(tmp1_safe_receiver);
    return new PositionValue(tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs, (!(s == null) ? contains_0(s, _Char___init__impl__6a9atx(37)) : false) ? PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance() : PositionType_ABSOLUTE_getInstance());
  };
  protoOf(Companion_33).l17 = function () {
    return $serializer_getInstance_24();
  };
  var Companion_instance_38;
  function Companion_getInstance_39() {
    if (Companion_instance_38 == null)
      new Companion_33();
    return Companion_instance_38;
  }
  function $serializer_20() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.objects.PositionValue', this, 2);
    tmp0_serialDesc.cv('value', false);
    tmp0_serialDesc.cv('type', true);
    this.q49_1 = tmp0_serialDesc;
  }
  protoOf($serializer_20).ok = function () {
    return this.q49_1;
  };
  protoOf($serializer_20).rv = function () {
    var tmp0_cached = Companion_getInstance_39().w48_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [DoubleSerializer_getInstance(), tmp0_cached[1]];
  };
  protoOf($serializer_20).qk = function (decoder) {
    var tmp0_desc = this.q49_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.nn(tmp0_desc);
    var tmp7_cached = Companion_getInstance_39().w48_1;
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.vn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.vn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return PositionValue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_20).r49 = function (encoder, value) {
    var tmp0_desc = this.q49_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_39().w48_1;
    tmp1_output.ap(tmp0_desc, 0, value.value);
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !value.typeKotlin.equals(PositionType_ABSOLUTE_getInstance())) {
      tmp1_output.ep(tmp0_desc, 1, tmp2_cached[1], value.typeKotlin);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_20).pk = function (encoder, value) {
    return this.r49(encoder, value instanceof PositionValue ? value : THROW_CCE());
  };
  var $serializer_instance_20;
  function $serializer_getInstance_24() {
    if ($serializer_instance_20 == null)
      new $serializer_20();
    return $serializer_instance_20;
  }
  function PositionValue_init_$Init$(seen1, value, type, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_24().q49_1);
    }
    $this.value = value;
    if (0 === (seen1 & 2))
      $this.typeKotlin = PositionType_ABSOLUTE_getInstance();
    else
      $this.typeKotlin = type;
    return $this;
  }
  function PositionValue_init_$Create$(seen1, value, type, serializationConstructorMarker) {
    return PositionValue_init_$Init$(seen1, value, type, serializationConstructorMarker, objectCreate(protoOf(PositionValue)));
  }
  function PositionValue(value, type) {
    Companion_getInstance_39();
    type = type === VOID ? PositionType_ABSOLUTE_getInstance() : type;
    this.value = value;
    this.typeKotlin = type;
  }
  protoOf(PositionValue).u2 = function () {
    return this.value;
  };
  protoOf(PositionValue).s49 = function () {
    return this.typeKotlin;
  };
  protoOf(PositionValue).a1x = function () {
    return this.typeKotlin.x9_1;
  };
  protoOf(PositionValue).af = function () {
    return this.value;
  };
  protoOf(PositionValue).bf = function () {
    return this.typeKotlin;
  };
  protoOf(PositionValue).t49 = function (value, type) {
    return new PositionValue(value, type);
  };
  protoOf(PositionValue).copy = function (value, type, $super) {
    value = value === VOID ? this.value : value;
    type = type === VOID ? this.typeKotlin : type;
    return this.t49(value, type);
  };
  protoOf(PositionValue).toString = function () {
    return 'PositionValue(value=' + this.value + ', type=' + this.typeKotlin + ')';
  };
  protoOf(PositionValue).hashCode = function () {
    var result = getNumberHashCode(this.value);
    result = imul(result, 31) + this.typeKotlin.hashCode() | 0;
    return result;
  };
  protoOf(PositionValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PositionValue))
      return false;
    var tmp0_other_with_cast = other instanceof PositionValue ? other : THROW_CCE();
    if (!equals(this.value, tmp0_other_with_cast.value))
      return false;
    if (!this.typeKotlin.equals(tmp0_other_with_cast.typeKotlin))
      return false;
    return true;
  };
  function RelativePosition$Companion$descriptor$lambda($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.cl('x', Companion_getInstance_39().l17().ok());
    $this$buildClassSerialDescriptor.cl('y', Companion_getInstance_39().l17().ok());
    $this$buildClassSerialDescriptor.cl('z', Companion_getInstance_39().l17().ok());
    return Unit_instance;
  }
  function RelativePosition_init_$Init$(position, $this) {
    RelativePosition.call($this, new PositionValue(position.X), new PositionValue(position.Y), new PositionValue(position.Z));
    return $this;
  }
  function RelativePositionFromPosition(position) {
    return RelativePosition_init_$Init$(position, objectCreate(protoOf(RelativePosition)));
  }
  function _get_hasAnyPercentage__wplq75($this) {
    return ($this.s48_1.typeKotlin.equals(PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance()) ? true : $this.t48_1.typeKotlin.equals(PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance())) ? true : $this.u48_1.typeKotlin.equals(PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance());
  }
  function Companion_34() {
    Companion_instance_39 = this;
    this.logger = LoggerState_getInstance().m1m('RelativePosition');
    var tmp = this;
    tmp.u49_1 = buildClassSerialDescriptor('RelativePosition', [], RelativePosition$Companion$descriptor$lambda);
  }
  protoOf(Companion_34).x1i = function () {
    return this.logger;
  };
  protoOf(Companion_34).v49 = function (encoder, descriptor, position, startIndex) {
    this.encodePositionValue(encoder, descriptor, position.s48_1, startIndex);
    this.encodePositionValue(encoder, descriptor, position.t48_1, startIndex + 1 | 0);
    this.encodePositionValue(encoder, descriptor, position.u48_1, startIndex + 2 | 0);
  };
  protoOf(Companion_34).encodeToArray = function (encoder, descriptor, position, startIndex, $super) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    return this.v49(encoder, descriptor, position, startIndex);
  };
  protoOf(Companion_34).encodePositionValue = function (encoder, descriptor, position, index) {
    if (position.typeKotlin.equals(PositionType_ABSOLUTE_getInstance())) {
      encoder.ap(descriptor, index, position.value);
    } else {
      encoder.cp(descriptor, index, '' + position.value + '%');
    }
  };
  protoOf(Companion_34).ok = function () {
    return this.u49_1;
  };
  protoOf(Companion_34).w49 = function (encoder, value) {
    var enc = encoder.nn(this.u49_1);
    if (!(value.s48_1.value === 0.0)) {
      this.encodePositionValue(enc, this.u49_1, value.s48_1, 0);
    }
    if (!(value.t48_1.value === 0.0)) {
      this.encodePositionValue(enc, this.u49_1, value.t48_1, 1);
    }
    if (!(value.u48_1.value === 0.0)) {
      this.encodePositionValue(enc, this.u49_1, value.u48_1, 2);
    }
    enc.on(this.u49_1);
  };
  protoOf(Companion_34).pk = function (encoder, value) {
    return this.w49(encoder, value instanceof RelativePosition ? value : THROW_CCE());
  };
  protoOf(Companion_34).qk = function (decoder) {
    var tmp0_desc = this.u49_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp9_input = decoder.nn(tmp0_desc);
    if (!tmp9_input.do())
      while (tmp1_flag) {
        tmp2_index = tmp9_input.eo(tmp0_desc);
        if (tmp2_index === -1)
          tmp1_flag = false;
        else
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    tmp9_input.on(tmp0_desc);
    if (!(0 === (0 & 0))) {
      throwMissingFieldException(0, 0, tmp0_desc);
    }
    return new RelativePosition(null, null, null);
  };
  protoOf(Companion_34).l17 = function () {
    return Companion_getInstance_40();
  };
  var Companion_instance_39;
  function Companion_getInstance_40() {
    if (Companion_instance_39 == null)
      new Companion_34();
    return Companion_instance_39;
  }
  function RelativePosition$getAbsolutePosition$lambda() {
    return "Can't use absolute position on a transform defined with relative axes";
  }
  function RelativePosition(x, y, z) {
    Companion_getInstance_40();
    this.s48_1 = x;
    this.t48_1 = y;
    this.u48_1 = z;
    this.v48_1 = new Vector(this.s48_1.value, this.t48_1.value, this.u48_1.value);
    this.isOrigin = (this.s48_1.value === 0.0 ? this.t48_1.value === 0.0 : false) ? this.u48_1.value === 0.0 : false;
  }
  protoOf(RelativePosition).getAbsolutePosition = function () {
    if (_get_hasAnyPercentage__wplq75(this)) {
      var tmp = Companion_getInstance_40().logger;
      tmp.error(RelativePosition$getAbsolutePosition$lambda);
    }
    return this.v48_1;
  };
  protoOf(RelativePosition).x49 = function () {
    return this.isOrigin;
  };
  protoOf(RelativePosition).getRelativePosition = function (size) {
    var tmp;
    switch (this.s48_1.typeKotlin.x9_1) {
      case 0:
        tmp = this.v48_1.X;
        break;
      case 1:
        tmp = size.s2e_1 * 0.01 * this.v48_1.X;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_0 = tmp;
    var tmp_1;
    switch (this.t48_1.typeKotlin.x9_1) {
      case 0:
        tmp_1 = this.v48_1.Y;
        break;
      case 1:
        tmp_1 = size.t2e_1 * 0.01 * this.v48_1.Y;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_2 = tmp_1;
    var tmp_3;
    switch (this.u48_1.typeKotlin.x9_1) {
      case 0:
        tmp_3 = this.v48_1.Z;
        break;
      case 1:
        tmp_3 = size.u2e_1 * 0.01 * this.v48_1.Z;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return new Vector(tmp_0, tmp_2, tmp_3);
  };
  protoOf(RelativePosition).y49 = function (x, y, z) {
    return new RelativePosition(x, y, z);
  };
  protoOf(RelativePosition).copy = function (x, y, z, $super) {
    x = x === VOID ? this.s48_1 : x;
    y = y === VOID ? this.t48_1 : y;
    z = z === VOID ? this.u48_1 : z;
    return this.y49(x, y, z);
  };
  protoOf(RelativePosition).toString = function () {
    return 'RelativePosition(x=' + this.s48_1 + ', y=' + this.t48_1 + ', z=' + this.u48_1 + ')';
  };
  protoOf(RelativePosition).hashCode = function () {
    var result = this.s48_1.hashCode();
    result = imul(result, 31) + this.t48_1.hashCode() | 0;
    result = imul(result, 31) + this.u48_1.hashCode() | 0;
    return result;
  };
  protoOf(RelativePosition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativePosition))
      return false;
    var tmp0_other_with_cast = other instanceof RelativePosition ? other : THROW_CCE();
    if (!this.s48_1.equals(tmp0_other_with_cast.s48_1))
      return false;
    if (!this.t48_1.equals(tmp0_other_with_cast.t48_1))
      return false;
    if (!this.u48_1.equals(tmp0_other_with_cast.u48_1))
      return false;
    return true;
  };
  function RelativeTransform_init_$Init$(position, rotation, $this) {
    RelativeTransform.call($this, RelativePositionFromPosition(position), rotation);
    return $this;
  }
  function RelativeTransformFromVector(position, rotation) {
    return RelativeTransform_init_$Init$(position, rotation, objectCreate(protoOf(RelativeTransform)));
  }
  function RelativeTransformSerializer() {
    RelativeTransformSerializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.dynamic.template.objects.RelativeTransform', null, 2);
    tmp0_serialDesc.cv('position', true);
    tmp0_serialDesc.cv('rotation', true);
    this.q48_1 = tmp0_serialDesc;
  }
  protoOf(RelativeTransformSerializer).z49 = function (encoder, descriptor, transform, startIndex) {
    Companion_getInstance_40().encodeToArray(encoder, descriptor, transform.position, startIndex);
    this.encodeRotationToArray(encoder, descriptor, transform.rotation, startIndex + 3 | 0);
  };
  protoOf(RelativeTransformSerializer).encodeToArray = function (encoder, descriptor, transform, startIndex, $super) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    return this.z49(encoder, descriptor, transform, startIndex);
  };
  protoOf(RelativeTransformSerializer).a4a = function (encoder, descriptor, rotation, startIndex) {
    var rotationEuler = rotation.toEulerDegrees();
    encoder.ap(descriptor, startIndex + 3 | 0, round(rotationEuler.X * 1000) / 1000);
    encoder.ap(descriptor, startIndex + 3 | 0, round(rotationEuler.Y * 1000) / 1000);
    encoder.ap(descriptor, startIndex + 3 | 0, round(rotationEuler.Z * 1000) / 1000);
  };
  protoOf(RelativeTransformSerializer).encodeRotationToArray = function (encoder, descriptor, rotation, startIndex, $super) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    return this.a4a(encoder, descriptor, rotation, startIndex);
  };
  protoOf(RelativeTransformSerializer).b4a = function (encoder, value) {
    var desc = ListSerializer(Companion_getInstance_39().l17()).ok();
    var comp = encoder.jp(desc, 6);
    this.encodeToArray(comp, desc, value, 0);
    comp.on(this.q48_1);
  };
  protoOf(RelativeTransformSerializer).pk = function (encoder, value) {
    return this.b4a(encoder, value instanceof RelativeTransform ? value : THROW_CCE());
  };
  protoOf(RelativeTransformSerializer).ok = function () {
    return this.q48_1;
  };
  protoOf(RelativeTransformSerializer).qk = function (decoder) {
    var tmp0_desc = this.q48_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.nn(tmp0_desc);
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, Companion_getInstance_40(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_2(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, Companion_getInstance_40(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_2(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    if (!(0 === (0 & tmp3_bitMask0))) {
      throwMissingFieldException(tmp3_bitMask0, 0, tmp0_desc);
    }
    if (0 === (tmp3_bitMask0 & 1))
      tmp4_local0 = RelativePositionFromPosition(Companion_getInstance_3().ZERO);
    if (0 === (tmp3_bitMask0 & 2))
      tmp5_local1 = Companion_getInstance_2().IDENTITY;
    return new RelativeTransform(tmp4_local0, tmp5_local1);
  };
  protoOf(RelativeTransformSerializer).l17 = function () {
    return RelativeTransformSerializer_getInstance();
  };
  var RelativeTransformSerializer_instance;
  function RelativeTransformSerializer_getInstance() {
    if (RelativeTransformSerializer_instance == null)
      new RelativeTransformSerializer();
    return RelativeTransformSerializer_instance;
  }
  function RelativeTransform(position, rotation) {
    RelativeTransformSerializer_getInstance();
    position = position === VOID ? RelativePositionFromPosition(Companion_getInstance_3().ZERO) : position;
    rotation = rotation === VOID ? Companion_getInstance_2().IDENTITY : rotation;
    this.position = position;
    this.rotation = rotation;
  }
  protoOf(RelativeTransform).ct = function () {
    return this.position;
  };
  protoOf(RelativeTransform).v1k = function () {
    return this.rotation;
  };
  protoOf(RelativeTransform).getPosition = function (size) {
    return this.position.getRelativePosition(size);
  };
  protoOf(RelativeTransform).af = function () {
    return this.position;
  };
  protoOf(RelativeTransform).bf = function () {
    return this.rotation;
  };
  protoOf(RelativeTransform).c4a = function (position, rotation) {
    return new RelativeTransform(position, rotation);
  };
  protoOf(RelativeTransform).copy = function (position, rotation, $super) {
    position = position === VOID ? this.position : position;
    rotation = rotation === VOID ? this.rotation : rotation;
    return this.c4a(position, rotation);
  };
  protoOf(RelativeTransform).toString = function () {
    return 'RelativeTransform(position=' + this.position + ', rotation=' + this.rotation + ')';
  };
  protoOf(RelativeTransform).hashCode = function () {
    var result = this.position.hashCode();
    result = imul(result, 31) + this.rotation.hashCode() | 0;
    return result;
  };
  protoOf(RelativeTransform).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativeTransform))
      return false;
    var tmp0_other_with_cast = other instanceof RelativeTransform ? other : THROW_CCE();
    if (!this.position.equals(tmp0_other_with_cast.position))
      return false;
    if (!this.rotation.equals(tmp0_other_with_cast.rotation))
      return false;
    return true;
  };
  function getPositionValue(_this__u8e3s4, $this, key) {
    var tmp = Companion_getInstance_39();
    var tmp0_safe_receiver = _this__u8e3s4.o17(key);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    return tmp.fromString(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.p17());
  }
  function getDegrees(_this__u8e3s4, $this, key) {
    var tmp0_safe_receiver = _this__u8e3s4.o17(key);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : get_doubleOrNull(tmp1_safe_receiver);
    return new Degrees(tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs);
  }
  function NamedTransformObjectDeserializer() {
  }
  protoOf(NamedTransformObjectDeserializer).deserialize = function (jo) {
    return new RelativeTransform(new RelativePosition(getPositionValue(jo, this, 'x'), getPositionValue(jo, this, 'y'), getPositionValue(jo, this, 'z')), Companion_getInstance_2().fromEulerDegrees(getDegrees(jo, this, 'rx'), getDegrees(jo, this, 'ry'), getDegrees(jo, this, 'rz')));
  };
  var NamedTransformObjectDeserializer_instance;
  function NamedTransformObjectDeserializer_getInstance() {
    return NamedTransformObjectDeserializer_instance;
  }
  function RelationOriginSerializer() {
    RelationOriginSerializer_instance = this;
    this.d4a_1 = PrimitiveSerialDescriptor('Origin', STRING_getInstance());
  }
  protoOf(RelationOriginSerializer).ok = function () {
    return this.d4a_1;
  };
  protoOf(RelationOriginSerializer).l2e = function (encoder, value) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = value.xKotlinEnum.w9_1.toLowerCase();
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = value.yKotlinEnum.w9_1.toLowerCase();
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = value.zKotlinEnum.w9_1.toLowerCase();
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = listOf([tmp, tmp_0, tmp$ret$5]);
    var destination = ArrayList_init_$Create$_0();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.template.serializers.RelationOriginSerializer.serialize.<anonymous>' call
      if (!(element === 'center')) {
        destination.q(element);
      }
    }
    encoder.ro(joinToString(destination, '-'));
  };
  protoOf(RelationOriginSerializer).pk = function (encoder, value) {
    return this.l2e(encoder, value instanceof RelationOrigin ? value : THROW_CCE());
  };
  protoOf(RelationOriginSerializer).qk = function (decoder) {
    var text = decoder.in();
    return new RelationOrigin(contains_1(text, 'left') ? RelationOriginAlongX_LEFT_getInstance() : contains_1(text, 'right') ? RelationOriginAlongX_RIGHT_getInstance() : RelationOriginAlongX_CENTER_getInstance(), contains_1(text, 'top') ? RelationOriginAlongY_TOP_getInstance() : contains_1(text, 'bottom') ? RelationOriginAlongY_BOTTOM_getInstance() : RelationOriginAlongY_CENTER_getInstance(), contains_1(text, 'front') ? RelationOriginAlongZ_FRONT_getInstance() : contains_1(text, 'back') ? RelationOriginAlongZ_BACK_getInstance() : RelationOriginAlongZ_CENTER_getInstance());
  };
  var RelationOriginSerializer_instance;
  function RelationOriginSerializer_getInstance() {
    if (RelationOriginSerializer_instance == null)
      new RelationOriginSerializer();
    return RelationOriginSerializer_instance;
  }
  function RelativeTransformDeserializer() {
  }
  protoOf(RelativeTransformDeserializer).deserialize = function (elements) {
    var relativePosition = new RelativePosition(Companion_getInstance_39().fromString(elements.f1(0)), Companion_getInstance_39().fromString(elements.f1(1)), Companion_getInstance_39().fromString(elements.f1(2)));
    var rotation = Companion_getInstance_2().fromEulerDegrees(new Degrees(toDouble(elements.f1(3))), new Degrees(toDouble(elements.f1(4))), new Degrees(toDouble(elements.f1(5))));
    return new RelativeTransform(relativePosition, rotation);
  };
  var RelativeTransformDeserializer_instance;
  function RelativeTransformDeserializer_getInstance() {
    return RelativeTransformDeserializer_instance;
  }
  function RotationDegreeOfFreedomSerializer() {
    RotationDegreeOfFreedomSerializer_instance = this;
    var tmp = this;
    // Inline function 'kotlinx.serialization.descriptors.serialDescriptor' call
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer_0(createKType(PrimitiveClasses_getInstance().u7(), arrayOf([]), false));
    tmp.e4a_1 = (isInterface(this_0, KSerializer) ? this_0 : THROW_CCE()).ok();
  }
  protoOf(RotationDegreeOfFreedomSerializer).ok = function () {
    return this.e4a_1;
  };
  protoOf(RotationDegreeOfFreedomSerializer).qk = function (decoder) {
    var s = decoder.in();
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = s.toUpperCase();
    return valueOf(tmp$ret$1);
  };
  protoOf(RotationDegreeOfFreedomSerializer).f4a = function (encoder, value) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = value.w9_1.toLowerCase();
    encoder.ro(tmp$ret$1);
  };
  protoOf(RotationDegreeOfFreedomSerializer).pk = function (encoder, value) {
    return this.f4a(encoder, value instanceof RotationDegreeOfFreedom ? value : THROW_CCE());
  };
  var RotationDegreeOfFreedomSerializer_instance;
  function RotationDegreeOfFreedomSerializer_getInstance() {
    if (RotationDegreeOfFreedomSerializer_instance == null)
      new RotationDegreeOfFreedomSerializer();
    return RotationDegreeOfFreedomSerializer_instance;
  }
  function get_logger_0() {
    _init_properties_Serializers_kt__wkoiy7();
    return logger_0;
  }
  var logger_0;
  function DynamicRangeParseError(msg, cause) {
    Exception_init_$Init$(msg, cause, this);
    captureStack(this, DynamicRangeParseError);
  }
  function parseAndCatch(errorMsg, parseCallback) {
    _init_properties_Serializers_kt__wkoiy7();
    try {
      return parseCallback();
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        var tmp = get_logger_0();
        tmp.error(parseAndCatch$lambda(errorMsg));
        throw new DynamicRangeParseError(errorMsg, e);
      } else {
        throw $p;
      }
    }
  }
  function parseAndCatch$lambda($errorMsg) {
    return function () {
      return $errorMsg;
    };
  }
  var properties_initialized_Serializers_kt_i0ph73;
  function _init_properties_Serializers_kt__wkoiy7() {
    if (!properties_initialized_Serializers_kt_i0ph73) {
      properties_initialized_Serializers_kt_i0ph73 = true;
      logger_0 = LoggerState_getInstance().m1m('DynamicRangeSerializers');
    }
  }
  function SizeSerializer() {
    SizeSerializer_instance = this;
    this.g4a_1 = ListSerializer(serializer_2(DoubleCompanionObject_instance));
    this.h4a_1 = this.g4a_1.ok();
  }
  protoOf(SizeSerializer).ok = function () {
    return this.h4a_1;
  };
  protoOf(SizeSerializer).r2e = function (encoder, value) {
    var list = listOf([value.s2e_1, value.t2e_1, value.u2e_1]);
    encoder.fp(this.g4a_1, list);
  };
  protoOf(SizeSerializer).pk = function (encoder, value) {
    return this.r2e(encoder, value instanceof Size ? value : THROW_CCE());
  };
  protoOf(SizeSerializer).qk = function (decoder) {
    var list = decoder.mn(this.g4a_1);
    return new Size(list.f1(0), list.f1(1), list.f1(2));
  };
  var SizeSerializer_instance;
  function SizeSerializer_getInstance() {
    if (SizeSerializer_instance == null)
      new SizeSerializer();
    return SizeSerializer_instance;
  }
  function SpacingSerializer() {
    SpacingSerializer_instance = this;
    this.i4a_1 = ListSerializer(serializer_2(DoubleCompanionObject_instance));
    this.j4a_1 = this.i4a_1.ok();
  }
  protoOf(SpacingSerializer).ok = function () {
    return this.j4a_1;
  };
  protoOf(SpacingSerializer).x10 = function (encoder, value) {
    encoder.po(value);
  };
  protoOf(SpacingSerializer).pk = function (encoder, value) {
    return this.x10(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(SpacingSerializer).qk = function (decoder) {
    var jsonDecoder = isInterface(decoder, JsonDecoder) ? decoder : THROW_CCE();
    var jsonData = jsonDecoder.k17();
    var tmp;
    if (jsonData instanceof JsonArray) {
      tmp = (new Vector(get_double(get_jsonPrimitive(jsonData.f1(0))), get_double(get_jsonPrimitive(jsonData.f1(1))), get_double(get_jsonPrimitive(jsonData.f1(2))))).size;
    } else {
      if (jsonData instanceof JsonPrimitive) {
        tmp = get_double(jsonData);
      } else {
        throw SerializationException_init_$Create$('Unexpected JSON value for spacing');
      }
    }
    var value = tmp;
    return value;
  };
  var SpacingSerializer_instance;
  function SpacingSerializer_getInstance() {
    if (SpacingSerializer_instance == null)
      new SpacingSerializer();
    return SpacingSerializer_instance;
  }
  function CatalogGenerator() {
    this.k4a_1 = 0;
  }
  protoOf(CatalogGenerator).resetItemId = function () {
    this.k4a_1 = 0;
  };
  protoOf(CatalogGenerator).nextItemId = function () {
    var tmp1 = this.k4a_1;
    this.k4a_1 = tmp1 + 1 | 0;
    return tmp1;
  };
  protoOf(CatalogGenerator).l4a = function (id, templateId, size) {
    var tmp;
    if (!(size == null)) {
      tmp = trimIndent('\n        "size": {\n            "width": ' + size.s2e_1 + ',\n            "depth": ' + size.u2e_1 + ',\n            "height": ' + size.t2e_1 + '\n         },\n         "comSize": {\n            "width": ' + size.s2e_1 + ',\n            "depth": ' + size.u2e_1 + ',\n            "height": ' + size.t2e_1 + '\n         }\n            ');
    } else {
      tmp = '"size": {\n    "width": 500,\n    "depth": 300,\n    "height": 2100\n },\n "comSize": {\n    "width": 500,\n    "depth": 300,\n    "height": 2100\n }';
    }
    var sizeStr = tmp;
    return trimIndent('\n        {\n            "id": "' + id + '",\n            "template": {\n                "id": "' + templateId + '",\n                 ' + sizeStr + '\n            }\n        }\n        ');
  };
  protoOf(CatalogGenerator).generateProduct = function (id, templateId, size, $super) {
    id = id === VOID ? 'product-' + this.nextItemId() : id;
    size = size === VOID ? null : size;
    return this.l4a(id, templateId, size);
  };
  protoOf(CatalogGenerator).m4a = function (componentsStr, id, inherits) {
    var tmp;
    if (!(inherits == null)) {
      var list = joinToString_0(inherits, '", "', '"', '"');
      tmp = trimIndent('\n            "inherits": [\n                ' + list + '\n            ],\n            ');
    } else {
      tmp = '';
    }
    var inheritsStr = tmp;
    return trimIndent('\n        {\n            "templateId": "' + id + '",\n            "name": "My Test Product",\n            ' + inheritsStr + '\n            "components": {\n                ' + componentsStr + '\n            }\n        }\n        ');
  };
  protoOf(CatalogGenerator).generateTemplate = function (componentsStr, id, inherits, $super) {
    id = id === VOID ? 'template-' + this.nextItemId() : id;
    inherits = inherits === VOID ? null : inherits;
    return this.m4a(componentsStr, id, inherits);
  };
  protoOf(CatalogGenerator).n4a = function (components, id, inherits) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(components.length === 0)) {
      // Inline function 'kotlin.collections.reduce' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (components.length === 0)
        throw UnsupportedOperationException_init_$Create$("Empty array can't be reduced.");
      var accumulator = components[0];
      var inductionVariable = 1;
      var last = get_lastIndex(components);
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.range.dynamic.testutils.CatalogGenerator.generateTemplateFromList.<anonymous>' call
          var acc = accumulator;
          var curr = components[index];
          accumulator = trimIndent('\n            ' + acc + ',\n            ' + curr + '\n                ');
        }
         while (!(index === last));
      tmp = accumulator;
    } else {
      tmp = '';
    }
    var componentsStr = tmp;
    return this.generateTemplate(componentsStr, id, inherits);
  };
  protoOf(CatalogGenerator).generateTemplateFromList = function (components, id, inherits, $super) {
    var tmp;
    if (components === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = components;
    }
    components = tmp;
    id = id === VOID ? 'template-' + this.nextItemId() : id;
    inherits = inherits === VOID ? null : inherits;
    return this.n4a(components, id, inherits);
  };
  protoOf(CatalogGenerator).generateTemplateFile = function (templates) {
    var templatsStr = joinToString_0(templates, ',\n');
    return trimIndent('\n        {\n            "range": "test-range",\n            "schemaVersion": "draft-01",\n            "rangeVersion": "1.0",\n            "templates": [\n                ' + templatsStr + '\n            ]\n        }\n        ');
  };
  protoOf(CatalogGenerator).generateCatalog = function (products) {
    var productsStr = joinToString_0(products, ',\n');
    return trimIndent('\n        {\n            "range": "test-range",\n            "schemaVersion": "draft-01",\n            "rangeVersion": "1.0",\n            "products": [\n                ' + productsStr + '\n            ]\n        }\n        ');
  };
  function parseMeta(data) {
    var result = new parseMeta$result$1();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = data.q2().t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.range.dynamic.components.parseMeta.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.t2();
      // Inline function 'kotlin.collections.component2' call
      var value = element.u2();
      var json = toString(value);
      if (!(json === ''))
        result[key] = JSON.parse(json);
    }
    return result;
  }
  function parseMeta$result$1() {
  }
  //region block: post-declaration
  protoOf($serializer).sv = typeParametersSerializers;
  protoOf(DynamicProductCatalog).createCustomAssembly = createCustomAssembly;
  protoOf(DynamicProductCatalog).createCustomAssemblySpecification = createCustomAssemblySpecification;
  defineProp(protoOf(DynamicProductCatalog), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
    return this.a1m();
  });
  protoOf($serializer_0).sv = typeParametersSerializers;
  protoOf($serializer_1).sv = typeParametersSerializers;
  protoOf($serializer_2).sv = typeParametersSerializers;
  protoOf($serializer_3).sv = typeParametersSerializers;
  protoOf($serializer_4).sv = typeParametersSerializers;
  protoOf(MetaDataComponent).z1k = get_serializable;
  protoOf(MetaDataComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(MetaDataComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(MetaDataComponent), 'id', protoOf(MetaDataComponent).s1k);
  defineProp(protoOf(MetaDataComponent), 'metaData', protoOf(MetaDataComponent).t3z);
  defineProp(protoOf(MetaDataComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(MetaDataComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(VisualLightSourceComponent).z1k = get_serializable;
  protoOf(VisualLightSourceComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(VisualLightSourceComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(VisualLightSourceComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(VisualLightSourceComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf($serializer_5).sv = typeParametersSerializers;
  protoOf($serializer_6).sv = typeParametersSerializers;
  protoOf($serializer_7).sv = typeParametersSerializers;
  protoOf($serializer_8).sv = typeParametersSerializers;
  protoOf($serializer_9).sv = typeParametersSerializers;
  defineProp(protoOf(TemplateEditorConnectorData), 'connectorKey', function () {
    return this.z21();
  });
  defineProp(protoOf(TemplateEditorConnectorData), 'style', function () {
    return this.l3s();
  });
  defineProp(protoOf(TemplateEditorConnectorData), 'selected', function () {
    return this.m3s();
  });
  defineProp(protoOf(TemplateEditorConnectorData), 'visible', function () {
    return this.n3s();
  });
  defineProp(protoOf(TemplateEditorConnectorData), 'active', function () {
    return this.o3s();
  });
  defineProp(protoOf(TemplateEditorConnectorData), 'showActivationDistance', function () {
    return this.p3s();
  }, function (value) {
    this.f41(value);
  });
  defineProp(protoOf(TemplateEditorConnectorData), 'showTransform', function () {
    return this.q3s();
  }, function (value) {
    this.g41(value);
  });
  defineProp(protoOf(DynamicComponentBuilder), 'product', function () {
    return this.n42();
  });
  defineProp(protoOf(DynamicComponentBuilder), 'templateData', function () {
    return this.o42();
  });
  defineProp(protoOf(DynamicComponentBuilder), 'template', function () {
    return this.v3x();
  });
  defineProp(protoOf(DynamicComponentBuilder), 'modelInfo', function () {
    return this.g40();
  });
  defineProp(protoOf(DynamicComponentBuilder), 'family', function () {
    return this.h2h();
  });
  defineProp(protoOf(DynamicComponentBuilder), 'name', function () {
    return this.mb();
  });
  defineProp(protoOf(DynamicComponentBuilder), 'catalog', function () {
    return this.m3x();
  });
  defineProp(protoOf(DynamicAssembly), 'name', function () {
    return this.mb();
  }, function (value) {
    this.p42(value);
  });
  defineProp(protoOf(DynamicShape), 'name', function () {
    return this.mb();
  }, function (value) {
    this.p42(value);
  });
  protoOf($serializer_10).sv = typeParametersSerializers;
  protoOf($serializer_11).sv = typeParametersSerializers;
  protoOf($serializer_12).sv = typeParametersSerializers;
  protoOf($serializer_13).sv = typeParametersSerializers;
  protoOf($serializer_14).sv = typeParametersSerializers;
  protoOf($serializer_15).sv = typeParametersSerializers;
  defineProp(protoOf(OriginTemplate), 'relativeTo', protoOf(OriginTemplate).q2d);
  protoOf($serializer_16).sv = typeParametersSerializers;
  defineProp(protoOf(PositionTemplate), 'relativeTransform', protoOf(PositionTemplate).a1k);
  defineProp(protoOf(PositionTemplate), 'absoluteTransform', protoOf(PositionTemplate).x48);
  protoOf($serializer_17).sv = typeParametersSerializers;
  protoOf($serializer_18).sv = typeParametersSerializers;
  protoOf($serializer_19).sv = typeParametersSerializers;
  defineProp(protoOf(OriginRelativeTo), 'name', protoOf(OriginRelativeTo).mb);
  defineProp(protoOf(OriginRelativeTo), 'ordinal', protoOf(OriginRelativeTo).nb);
  defineProp(protoOf(PositionType), 'name', protoOf(PositionType).mb);
  defineProp(protoOf(PositionType), 'ordinal', protoOf(PositionType).nb);
  protoOf($serializer_20).sv = typeParametersSerializers;
  defineProp(protoOf(PositionValue), 'type', protoOf(PositionValue).a1x);
  //endregion
  //region block: init
  Companion_instance_12 = new Companion_7();
  Companion_instance_13 = new Companion_8();
  Companion_instance_15 = new Companion_10();
  Companion_instance_16 = new Companion_11();
  Companion_instance_19 = new Companion_14();
  Companion_instance_20 = new Companion_15();
  Companion_instance_30 = new Companion_25();
  Companion_instance_31 = new Companion_26();
  Companion_instance_32 = new Companion_27();
  Companion_instance_33 = new Companion_28();
  Companion_instance_34 = new Companion_29();
  Companion_instance_35 = new Companion_30();
  PositionTypeImpostor_instance = new PositionTypeImpostor();
  NamedTransformObjectDeserializer_instance = new NamedTransformObjectDeserializer();
  RelativeTransformDeserializer_instance = new RelativeTransformDeserializer();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$catalog = $com$ikea$range$dynamic.catalog || ($com$ikea$range$dynamic.catalog = {});
    $com$ikea$range$dynamic$catalog.AutoAdaptGroup = AutoAdaptGroup;
    defineProp($com$ikea$range$dynamic$catalog.AutoAdaptGroup, 'CustomSerializer', CustomSerializer_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$catalog = $com$ikea$range$dynamic.catalog || ($com$ikea$range$dynamic.catalog = {});
    $com$ikea$range$dynamic$catalog.DynamicComponentResolver = DynamicComponentResolver;
    defineProp($com$ikea$range$dynamic$catalog.DynamicComponentResolver, 'Companion', Companion_getInstance_5);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$catalog = $com$ikea$range$dynamic.catalog || ($com$ikea$range$dynamic.catalog = {});
    $com$ikea$range$dynamic$catalog.DynamicProduct = DynamicProduct;
    defineProp($com$ikea$range$dynamic$catalog.DynamicProduct, 'Companion', Companion_getInstance_6);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$catalog = $com$ikea$range$dynamic.catalog || ($com$ikea$range$dynamic.catalog = {});
    $com$ikea$range$dynamic$catalog.DynamicProductCatalog = DynamicProductCatalog;
    defineProp($com$ikea$range$dynamic$catalog.DynamicProductCatalog, 'Companion', Companion_getInstance_7);
    $com$ikea$range$dynamic$catalog.PackedProductData = PackedProductData;
    defineProp($com$ikea$range$dynamic$catalog.PackedProductData, 'Companion', Companion_getInstance_8);
    $com$ikea$range$dynamic$catalog.DynamicProductData = DynamicProductData;
    defineProp($com$ikea$range$dynamic$catalog.DynamicProductData, 'Companion', Companion_getInstance_9);
    $com$ikea$range$dynamic$catalog.DynamicTemplateData = DynamicTemplateData;
    defineProp($com$ikea$range$dynamic$catalog.DynamicTemplateData, 'Companion', Companion_getInstance_10);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$catalog = $com$ikea$range$dynamic.catalog || ($com$ikea$range$dynamic.catalog = {});
    $com$ikea$range$dynamic$catalog.PackedProduct = PackedProduct;
    defineProp($com$ikea$range$dynamic$catalog.PackedProduct, 'Companion', Companion_getInstance_11);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$catalog = $com$ikea$range$dynamic.catalog || ($com$ikea$range$dynamic.catalog = {});
    $com$ikea$range$dynamic$catalog.ProductTemplate = ProductTemplate;
    defineProp($com$ikea$range$dynamic$catalog.ProductTemplate, 'Companion', Companion_getInstance_12);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$components = $com$ikea$range$dynamic.components || ($com$ikea$range$dynamic.components = {});
    $com$ikea$range$dynamic$components.MetaDataComponent = MetaDataComponent;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$components = $com$ikea$range$dynamic.components || ($com$ikea$range$dynamic.components = {});
    $com$ikea$range$dynamic$components.VisualLightSourceComponent = VisualLightSourceComponent;
    defineProp($com$ikea$range$dynamic$components.VisualLightSourceComponent, 'Companion', Companion_getInstance_13);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$productdata = $com$ikea$range$dynamic.productdata || ($com$ikea$range$dynamic.productdata = {});
    $com$ikea$range$dynamic$productdata.Bounds = Bounds;
    defineProp($com$ikea$range$dynamic$productdata.Bounds, 'Companion', Companion_getInstance_14);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$productdata = $com$ikea$range$dynamic.productdata || ($com$ikea$range$dynamic.productdata = {});
    $com$ikea$range$dynamic$productdata.CatalogTemplateData = CatalogTemplateData;
    defineProp($com$ikea$range$dynamic$productdata.CatalogTemplateData, 'Companion', Companion_getInstance_15);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$productdata = $com$ikea$range$dynamic.productdata || ($com$ikea$range$dynamic.productdata = {});
    $com$ikea$range$dynamic$productdata.ModelRenderInfo = ModelRenderInfo;
    defineProp($com$ikea$range$dynamic$productdata.ModelRenderInfo, 'Companion', Companion_getInstance_16);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$productdata = $com$ikea$range$dynamic.productdata || ($com$ikea$range$dynamic.productdata = {});
    $com$ikea$range$dynamic$productdata.Part = Part;
    defineProp($com$ikea$range$dynamic$productdata.Part, 'Companion', Companion_getInstance_17);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$productdata = $com$ikea$range$dynamic.productdata || ($com$ikea$range$dynamic.productdata = {});
    $com$ikea$range$dynamic$productdata.ProductComponent = ProductComponent;
    defineProp($com$ikea$range$dynamic$productdata.ProductComponent, 'Companion', Companion_getInstance_18);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$service = $com$ikea$range$dynamic.service || ($com$ikea$range$dynamic.service = {});
    $com$ikea$range$dynamic$service.TemplateEditorConnectorData = TemplateEditorConnectorData;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$service = $com$ikea$range$dynamic.service || ($com$ikea$range$dynamic.service = {});
    $com$ikea$range$dynamic$service.ProductTemplateDTO = ProductTemplateDTO;
    $com$ikea$range$dynamic$service.TemplateEditorService = TemplateEditorService;
    defineProp($com$ikea$range$dynamic$service.TemplateEditorService, 'Companion', Companion_getInstance_19);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$shape = $com$ikea$range$dynamic.shape || ($com$ikea$range$dynamic.shape = {});
    $com$ikea$range$dynamic$shape.DynamicAssembly = DynamicAssembly;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$shape = $com$ikea$range$dynamic.shape || ($com$ikea$range$dynamic.shape = {});
    $com$ikea$range$dynamic$shape.DynamicComponentBuilder = DynamicComponentBuilder;
    defineProp($com$ikea$range$dynamic$shape.DynamicComponentBuilder, 'Companion', Companion_getInstance_20);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$shape = $com$ikea$range$dynamic.shape || ($com$ikea$range$dynamic.shape = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$shape = $com$ikea$range$dynamic.shape || ($com$ikea$range$dynamic.shape = {});
    $com$ikea$range$dynamic$shape.DynamicShape = DynamicShape;
    defineProp($com$ikea$range$dynamic$shape.DynamicShape, 'Companion', Companion_getInstance_21);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.AssemblyChild = AssemblyChild;
    defineProp($com$ikea$range$dynamic$template.AssemblyChild, 'Companion', Companion_getInstance_22);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.AssemblyTemplate = AssemblyTemplate;
    defineProp($com$ikea$range$dynamic$template.AssemblyTemplate, 'Companion', Companion_getInstance_23);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.AutoAdaptHostTemplate = AutoAdaptHostTemplate;
    defineProp($com$ikea$range$dynamic$template.AutoAdaptHostTemplate, 'CustomSerializer', CustomSerializer_getInstance_0);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.BoundItemTemplate = BoundItemTemplate;
    defineProp($com$ikea$range$dynamic$template.BoundItemTemplate, 'Companion', Companion_getInstance_24);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.Compartment = Compartment;
    defineProp($com$ikea$range$dynamic$template.Compartment, 'Companion', Companion_getInstance_25);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.ComponentsTemplate = ComponentsTemplate;
    defineProp($com$ikea$range$dynamic$template.ComponentsTemplate, 'Companion', Companion_getInstance_26);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.ConnectorItemTemplate = ConnectorItemTemplate;
    defineProp($com$ikea$range$dynamic$template.ConnectorItemTemplate, 'Companion', Companion_getInstance_27);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.getConnectorsForSize = getConnectorsForSize;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.Dimension = Dimension;
    defineProp($com$ikea$range$dynamic$template.Dimension, 'Companion', Companion_getInstance_28);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.DragSurfaceTemplate = DragSurfaceTemplate;
    defineProp($com$ikea$range$dynamic$template.DragSurfaceTemplate, 'Companion', Companion_getInstance_29);
    $com$ikea$range$dynamic$template.DragSurfacesTemplate = DragSurfacesTemplate;
    defineProp($com$ikea$range$dynamic$template.DragSurfacesTemplate, 'CustomSerializer', CustomSerializer_getInstance_1);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.DynamicRangeUtils = DynamicRangeUtils;
    defineProp($com$ikea$range$dynamic$template.DynamicRangeUtils, 'Companion', Companion_getInstance_30);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.LightTemplate = LightTemplate;
    defineProp($com$ikea$range$dynamic$template.LightTemplate, 'Companion', Companion_getInstance_31);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.MarginTemplate = MarginTemplate;
    defineProp($com$ikea$range$dynamic$template.MarginTemplate, 'MarginTemplateSerializer', MarginTemplateSerializer_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.Model3DTemplate = Model3DTemplate;
    defineProp($com$ikea$range$dynamic$template.Model3DTemplate, 'Companion', Companion_getInstance_32);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.OriginTemplate = OriginTemplate;
    defineProp($com$ikea$range$dynamic$template.OriginTemplate, 'CustomSerializer', CustomSerializer_getInstance_2);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.PlacementZoneByHeightTemplate = PlacementZoneByHeightTemplate;
    defineProp($com$ikea$range$dynamic$template.PlacementZoneByHeightTemplate, 'Companion', Companion_getInstance_33);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.PositionTemplate = PositionTemplate;
    $com$ikea$range$dynamic$template.PositionTemplate.PositionTemplateFromString = PositionTemplateFromString;
    defineProp($com$ikea$range$dynamic$template.PositionTemplate, 'PositionTemplateSerializer', PositionTemplateSerializer_getInstance);
    $com$ikea$range$dynamic$template.absoluteTransform$factory = absoluteTransform$factory;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    $com$ikea$range$dynamic$template.VisualLightSourceTemplate = VisualLightSourceTemplate;
    defineProp($com$ikea$range$dynamic$template.VisualLightSourceTemplate, 'Companion', Companion_getInstance_34);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$hierarchy = $com$ikea$range$dynamic$template.hierarchy || ($com$ikea$range$dynamic$template.hierarchy = {});
    $com$ikea$range$dynamic$template$hierarchy.ProductStructureConnectionTemplate = ProductStructureConnectionTemplate;
    defineProp($com$ikea$range$dynamic$template$hierarchy.ProductStructureConnectionTemplate, 'Companion', Companion_getInstance_35);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$hierarchy = $com$ikea$range$dynamic$template.hierarchy || ($com$ikea$range$dynamic$template.hierarchy = {});
    $com$ikea$range$dynamic$template$hierarchy.ProductStructureItemTemplate = ProductStructureItemTemplate;
    defineProp($com$ikea$range$dynamic$template$hierarchy.ProductStructureItemTemplate, 'Companion', Companion_getInstance_36);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$objects = $com$ikea$range$dynamic$template.objects || ($com$ikea$range$dynamic$template.objects = {});
    $com$ikea$range$dynamic$template$objects.OriginRelativeTo = OriginRelativeTo;
    $com$ikea$range$dynamic$template$objects.OriginRelativeTo.values = values;
    $com$ikea$range$dynamic$template$objects.OriginRelativeTo.valueOf = valueOf_0;
    defineProp($com$ikea$range$dynamic$template$objects.OriginRelativeTo, 'BOUND', OriginRelativeTo_BOUND_getInstance);
    defineProp($com$ikea$range$dynamic$template$objects.OriginRelativeTo, 'SIZE', OriginRelativeTo_SIZE_getInstance);
    defineProp($com$ikea$range$dynamic$template$objects.OriginRelativeTo, 'Companion', Companion_getInstance_37);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$objects = $com$ikea$range$dynamic$template.objects || ($com$ikea$range$dynamic$template.objects = {});
    defineProp($com$ikea$range$dynamic$template$objects, 'OriginRelativeToImpostor', OriginRelativeToImpostor_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$objects = $com$ikea$range$dynamic$template.objects || ($com$ikea$range$dynamic$template.objects = {});
    $com$ikea$range$dynamic$template$objects.PositionType = PositionType;
    $com$ikea$range$dynamic$template$objects.PositionType.values = values_0;
    $com$ikea$range$dynamic$template$objects.PositionType.valueOf = valueOf_1;
    defineProp($com$ikea$range$dynamic$template$objects.PositionType, 'ABSOLUTE', PositionType_ABSOLUTE_getInstance);
    defineProp($com$ikea$range$dynamic$template$objects.PositionType, 'PERCENTAGE_RELATIVE_SIZE', PositionType_PERCENTAGE_RELATIVE_SIZE_getInstance);
    defineProp($com$ikea$range$dynamic$template$objects.PositionType, 'Companion', Companion_getInstance_38);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$objects = $com$ikea$range$dynamic$template.objects || ($com$ikea$range$dynamic$template.objects = {});
    defineProp($com$ikea$range$dynamic$template$objects, 'PositionTypeImpostor', PositionTypeImpostor_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$objects = $com$ikea$range$dynamic$template.objects || ($com$ikea$range$dynamic$template.objects = {});
    $com$ikea$range$dynamic$template$objects.PositionValue = PositionValue;
    defineProp($com$ikea$range$dynamic$template$objects.PositionValue, 'Companion', Companion_getInstance_39);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$objects = $com$ikea$range$dynamic$template.objects || ($com$ikea$range$dynamic$template.objects = {});
    $com$ikea$range$dynamic$template$objects.RelativePosition = RelativePosition;
    $com$ikea$range$dynamic$template$objects.RelativePosition.RelativePositionFromPosition = RelativePositionFromPosition;
    defineProp($com$ikea$range$dynamic$template$objects.RelativePosition, 'Companion', Companion_getInstance_40);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$objects = $com$ikea$range$dynamic$template.objects || ($com$ikea$range$dynamic$template.objects = {});
    $com$ikea$range$dynamic$template$objects.RelativeTransform = RelativeTransform;
    $com$ikea$range$dynamic$template$objects.RelativeTransform.RelativeTransformFromVector = RelativeTransformFromVector;
    defineProp($com$ikea$range$dynamic$template$objects.RelativeTransform, 'RelativeTransformSerializer', RelativeTransformSerializer_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$serializers = $com$ikea$range$dynamic$template.serializers || ($com$ikea$range$dynamic$template.serializers = {});
    defineProp($com$ikea$range$dynamic$template$serializers, 'NamedTransformObjectDeserializer', NamedTransformObjectDeserializer_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$serializers = $com$ikea$range$dynamic$template.serializers || ($com$ikea$range$dynamic$template.serializers = {});
    defineProp($com$ikea$range$dynamic$template$serializers, 'RelationOriginSerializer', RelationOriginSerializer_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$serializers = $com$ikea$range$dynamic$template.serializers || ($com$ikea$range$dynamic$template.serializers = {});
    defineProp($com$ikea$range$dynamic$template$serializers, 'RelativeTransformDeserializer', RelativeTransformDeserializer_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$serializers = $com$ikea$range$dynamic$template.serializers || ($com$ikea$range$dynamic$template.serializers = {});
    defineProp($com$ikea$range$dynamic$template$serializers, 'RotationDegreeOfFreedomSerializer', RotationDegreeOfFreedomSerializer_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$serializers = $com$ikea$range$dynamic$template.serializers || ($com$ikea$range$dynamic$template.serializers = {});
    $com$ikea$range$dynamic$template$serializers.DynamicRangeParseError = DynamicRangeParseError;
    $com$ikea$range$dynamic$template$serializers.parseAndCatch = parseAndCatch;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$serializers = $com$ikea$range$dynamic$template.serializers || ($com$ikea$range$dynamic$template.serializers = {});
    defineProp($com$ikea$range$dynamic$template$serializers, 'SizeSerializer', SizeSerializer_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$template = $com$ikea$range$dynamic.template || ($com$ikea$range$dynamic.template = {});
    var $com$ikea$range$dynamic$template$serializers = $com$ikea$range$dynamic$template.serializers || ($com$ikea$range$dynamic$template.serializers = {});
    defineProp($com$ikea$range$dynamic$template$serializers, 'SpacingSerializer', SpacingSerializer_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$range = $com$ikea.range || ($com$ikea.range = {});
    var $com$ikea$range$dynamic = $com$ikea$range.dynamic || ($com$ikea$range.dynamic = {});
    var $com$ikea$range$dynamic$testutils = $com$ikea$range$dynamic.testutils || ($com$ikea$range$dynamic.testutils = {});
    $com$ikea$range$dynamic$testutils.CatalogGenerator = CatalogGenerator;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = DynamicProductCatalog;
  _.$_$.b = DynamicProduct;
  _.$_$.c = ProductTemplate;
  _.$_$.d = MetaDataComponent;
  _.$_$.e = VisualLightSourceComponent;
  _.$_$.f = CatalogTemplateData;
  _.$_$.g = ModelRenderInfo;
  _.$_$.h = Part;
  _.$_$.i = TemplateEditorService;
  _.$_$.j = ProductStructureItemTemplate;
  _.$_$.k = PositionValue;
  _.$_$.l = RelativePosition;
  _.$_$.m = RelativeTransform;
  _.$_$.n = BoundItemTemplate;
  _.$_$.o = Compartment;
  _.$_$.p = ConnectorItemTemplate;
  _.$_$.q = Dimension;
  _.$_$.r = OriginTemplate;
  _.$_$.s = PositionTemplate;
  _.$_$.t = CatalogGenerator;
  _.$_$.u = CustomSerializer_getInstance;
  _.$_$.v = $serializer_getInstance_12;
  _.$_$.w = $serializer_getInstance_23;
  _.$_$.x = OriginRelativeToImpostor_getInstance;
  _.$_$.y = Companion_getInstance_38;
  _.$_$.z = PositionTypeImpostor_instance;
  _.$_$.a1 = CustomSerializer_getInstance_0;
  _.$_$.b1 = Companion_getInstance_27;
  _.$_$.c1 = Companion_getInstance_28;
  _.$_$.d1 = CustomSerializer_getInstance_1;
  _.$_$.e1 = Companion_getInstance_30;
  _.$_$.f1 = MarginTemplateSerializer_getInstance;
  _.$_$.g1 = $serializer_getInstance_20;
  _.$_$.h1 = PositionTemplateSerializer_getInstance;
  _.$_$.i1 = $serializer_getInstance_21;
  //endregion
  return _;
}));

//# sourceMappingURL=core-core-range-dynamic-range.js.map
